import type { FileTreeNode } from '../types/wizard';


const terraformDemoFileTree: FileTreeNode[] = [
    {
      name: '.claude',
      path: '.claude',
      type: 'directory',
      children: [
        {
          name: 'rules',
          path: '.claude/rules',
          type: 'directory',
          children: [
            {
              name: 'common',
              path: '.claude/rules/common',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/common/coding-style.md', type: 'file' },
                { name: 'git-workflow.md', path: '.claude/rules/common/git-workflow.md', type: 'file' },
                { name: 'security.md', path: '.claude/rules/common/security.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/common/testing.md', type: 'file' },
              ],
            },
            {
              name: 'golang',
              path: '.claude/rules/golang',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/golang/coding-style.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/golang/testing.md', type: 'file' },
              ],
            },
          ],
        },
        { name: 'settings.json', path: '.claude/settings.json', type: 'file' },
      ],
    },
    { name: '.editorconfig', path: '.editorconfig', type: 'file' },
    { name: '.gitattributes', path: '.gitattributes', type: 'file' },
    {
      name: '.github',
      path: '.github',
      type: 'directory',
      children: [
        { name: 'CODEOWNERS', path: '.github/CODEOWNERS', type: 'file' },
        {
          name: 'ISSUE_TEMPLATE',
          path: '.github/ISSUE_TEMPLATE',
          type: 'directory',
          children: [
            { name: 'ai_task.md', path: '.github/ISSUE_TEMPLATE/ai_task.md', type: 'file' },
            { name: 'bug_report.md', path: '.github/ISSUE_TEMPLATE/bug_report.md', type: 'file' },
            { name: 'feature_request.md', path: '.github/ISSUE_TEMPLATE/feature_request.md', type: 'file' },
          ],
        },
        { name: 'PULL_REQUEST_TEMPLATE.md', path: '.github/PULL_REQUEST_TEMPLATE.md', type: 'file' },
        {
          name: 'workflows',
          path: '.github/workflows',
          type: 'directory',
          children: [
            { name: 'ai-code-audit.yml', path: '.github/workflows/ai-code-audit.yml', type: 'file' },
            { name: 'ci.yml', path: '.github/workflows/ci.yml', type: 'file' },
            { name: 'deploy-production.yml', path: '.github/workflows/deploy-production.yml', type: 'file' },
            { name: 'deploy-staging.yml', path: '.github/workflows/deploy-staging.yml', type: 'file' },
          ],
        },
      ],
    },
    { name: '.gitignore', path: '.gitignore', type: 'file' },
    { name: '.mcp.json', path: '.mcp.json', type: 'file' },
    { name: 'CLAUDE.md', path: 'CLAUDE.md', type: 'file' },
    { name: 'README.md', path: 'README.md', type: 'file' },
    {
      name: 'docs',
      path: 'docs',
      type: 'directory',
      children: [
        { name: 'AI-USAGE-POLICY.md', path: 'docs/AI-USAGE-POLICY.md', type: 'file' },
        { name: 'ARCHITECTURE.md', path: 'docs/ARCHITECTURE.md', type: 'file' },
        { name: 'CONTRIBUTING.md', path: 'docs/CONTRIBUTING.md', type: 'file' },
        { name: 'ONBOARDING.md', path: 'docs/ONBOARDING.md', type: 'file' },
      ],
    },
    {
      name: 'git-hooks',
      path: 'git-hooks',
      type: 'directory',
      children: [
        { name: 'commit-msg', path: 'git-hooks/commit-msg', type: 'file' },
        { name: 'pre-commit', path: 'git-hooks/pre-commit', type: 'file' },
        { name: 'pre-push', path: 'git-hooks/pre-push', type: 'file' },
      ],
    },
    { name: 'install.sh', path: 'install.sh', type: 'file' },
    {
      name: 'mock-mcp-servers',
      path: 'mock-mcp-servers',
      type: 'directory',
      children: [
        { name: 'README.md', path: 'mock-mcp-servers/README.md', type: 'file' },
        { name: 'github-server.mjs', path: 'mock-mcp-servers/github-server.mjs', type: 'file' },
        { name: 'jira-server.mjs', path: 'mock-mcp-servers/jira-server.mjs', type: 'file' },
        { name: 'package.json', path: 'mock-mcp-servers/package.json', type: 'file' },
      ],
    },
    {
      name: 'playbook',
      path: 'playbook',
      type: 'directory',
      children: [
        { name: 'PLAYBOOK.md', path: 'playbook/PLAYBOOK.md', type: 'file' },
        {
          name: 'claude-overrides',
          path: 'playbook/claude-overrides',
          type: 'directory',
          children: [
            { name: '01-discovery.claude.md', path: 'playbook/claude-overrides/01-discovery.claude.md', type: 'file' },
            { name: '02-architecture.claude.md', path: 'playbook/claude-overrides/02-architecture.claude.md', type: 'file' },
            { name: '03-foundation.claude.md', path: 'playbook/claude-overrides/03-foundation.claude.md', type: 'file' },
            { name: '04-core-implementation.claude.md', path: 'playbook/claude-overrides/04-core-implementation.claude.md', type: 'file' },
            { name: '05-integration-hardening.claude.md', path: 'playbook/claude-overrides/05-integration-hardening.claude.md', type: 'file' },
            { name: '06-testing-quality.claude.md', path: 'playbook/claude-overrides/06-testing-quality.claude.md', type: 'file' },
            { name: '07-launch.claude.md', path: 'playbook/claude-overrides/07-launch.claude.md', type: 'file' },
          ],
        },
        { name: 'codeforge-phase.sh', path: 'playbook/codeforge-phase.sh', type: 'file' },
        { name: 'current-phase.json', path: 'playbook/current-phase.json', type: 'file' },
        {
          name: 'phases',
          path: 'playbook/phases',
          type: 'directory',
          children: [
            { name: '01-discovery.md', path: 'playbook/phases/01-discovery.md', type: 'file' },
            { name: '02-architecture.md', path: 'playbook/phases/02-architecture.md', type: 'file' },
            { name: '03-foundation.md', path: 'playbook/phases/03-foundation.md', type: 'file' },
            { name: '04-core-implementation.md', path: 'playbook/phases/04-core-implementation.md', type: 'file' },
            { name: '05-integration-hardening.md', path: 'playbook/phases/05-integration-hardening.md', type: 'file' },
            { name: '06-testing-quality.md', path: 'playbook/phases/06-testing-quality.md', type: 'file' },
            { name: '07-launch.md', path: 'playbook/phases/07-launch.md', type: 'file' },
          ],
        },
        {
          name: 'prompts',
          path: 'playbook/prompts',
          type: 'directory',
          children: [
            {
              name: '01',
              path: 'playbook/prompts/01',
              type: 'directory',
              children: [
                { name: 'gather-requirements.md', path: 'playbook/prompts/01/gather-requirements.md', type: 'file' },
                { name: 'nfr-checklist.md', path: 'playbook/prompts/01/nfr-checklist.md', type: 'file' },
                { name: 'user-stories.md', path: 'playbook/prompts/01/user-stories.md', type: 'file' },
              ],
            },
            {
              name: '02',
              path: 'playbook/prompts/02',
              type: 'directory',
              children: [
                { name: 'adr-generator.md', path: 'playbook/prompts/02/adr-generator.md', type: 'file' },
                { name: 'api-design.md', path: 'playbook/prompts/02/api-design.md', type: 'file' },
                { name: 'data-model-design.md', path: 'playbook/prompts/02/data-model-design.md', type: 'file' },
              ],
            },
            {
              name: '03',
              path: 'playbook/prompts/03',
              type: 'directory',
              children: [
                { name: 'ci-pipeline.md', path: 'playbook/prompts/03/ci-pipeline.md', type: 'file' },
                { name: 'iac-setup.md', path: 'playbook/prompts/03/iac-setup.md', type: 'file' },
                { name: 'project-scaffold.md', path: 'playbook/prompts/03/project-scaffold.md', type: 'file' },
              ],
            },
            {
              name: '04',
              path: 'playbook/prompts/04',
              type: 'directory',
              children: [
                { name: 'auth-implementation.md', path: 'playbook/prompts/04/auth-implementation.md', type: 'file' },
                { name: 'crud-generator.md', path: 'playbook/prompts/04/crud-generator.md', type: 'file' },
                { name: 'feature-implementation.md', path: 'playbook/prompts/04/feature-implementation.md', type: 'file' },
              ],
            },
            {
              name: '05',
              path: 'playbook/prompts/05',
              type: 'directory',
              children: [
                { name: 'integration-adapter.md', path: 'playbook/prompts/05/integration-adapter.md', type: 'file' },
                { name: 'observability-setup.md', path: 'playbook/prompts/05/observability-setup.md', type: 'file' },
                { name: 'security-hardening.md', path: 'playbook/prompts/05/security-hardening.md', type: 'file' },
              ],
            },
            {
              name: '06',
              path: 'playbook/prompts/06',
              type: 'directory',
              children: [
                { name: 'e2e-test-generator.md', path: 'playbook/prompts/06/e2e-test-generator.md', type: 'file' },
                { name: 'load-test.md', path: 'playbook/prompts/06/load-test.md', type: 'file' },
                { name: 'test-suite-generator.md', path: 'playbook/prompts/06/test-suite-generator.md', type: 'file' },
              ],
            },
            {
              name: '07',
              path: 'playbook/prompts/07',
              type: 'directory',
              children: [
                { name: 'go-live-checklist.md', path: 'playbook/prompts/07/go-live-checklist.md', type: 'file' },
                { name: 'monitoring-setup.md', path: 'playbook/prompts/07/monitoring-setup.md', type: 'file' },
                { name: 'runbook-generator.md', path: 'playbook/prompts/07/runbook-generator.md', type: 'file' },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'plugin',
      path: 'plugin',
      type: 'directory',
      children: [
        {
          name: 'codeforge-aws-platform-iac',
          path: 'plugin/codeforge-aws-platform-iac',
          type: 'directory',
          children: [
            {
              name: '.claude-plugin',
              path: 'plugin/codeforge-aws-platform-iac/.claude-plugin',
              type: 'directory',
              children: [
                { name: 'plugin.json', path: 'plugin/codeforge-aws-platform-iac/.claude-plugin/plugin.json', type: 'file' },
              ],
            },
            { name: 'README.md', path: 'plugin/codeforge-aws-platform-iac/README.md', type: 'file' },
            {
              name: 'agents',
              path: 'plugin/codeforge-aws-platform-iac/agents',
              type: 'directory',
              children: [
                { name: 'architect.md', path: 'plugin/codeforge-aws-platform-iac/agents/architect.md', type: 'file' },
                { name: 'build-error-resolver.md', path: 'plugin/codeforge-aws-platform-iac/agents/build-error-resolver.md', type: 'file' },
                { name: 'code-reviewer.md', path: 'plugin/codeforge-aws-platform-iac/agents/code-reviewer.md', type: 'file' },
                { name: 'planner.md', path: 'plugin/codeforge-aws-platform-iac/agents/planner.md', type: 'file' },
                { name: 'tdd-guide.md', path: 'plugin/codeforge-aws-platform-iac/agents/tdd-guide.md', type: 'file' },
              ],
            },
            {
              name: 'commands',
              path: 'plugin/codeforge-aws-platform-iac/commands',
              type: 'directory',
              children: [
                { name: 'build-fix.md', path: 'plugin/codeforge-aws-platform-iac/commands/build-fix.md', type: 'file' },
                { name: 'code-review.md', path: 'plugin/codeforge-aws-platform-iac/commands/code-review.md', type: 'file' },
                { name: 'phase.md', path: 'plugin/codeforge-aws-platform-iac/commands/phase.md', type: 'file' },
                { name: 'plan.md', path: 'plugin/codeforge-aws-platform-iac/commands/plan.md', type: 'file' },
                { name: 'tdd.md', path: 'plugin/codeforge-aws-platform-iac/commands/tdd.md', type: 'file' },
                { name: 'verify.md', path: 'plugin/codeforge-aws-platform-iac/commands/verify.md', type: 'file' },
              ],
            },
            {
              name: 'hooks',
              path: 'plugin/codeforge-aws-platform-iac/hooks',
              type: 'directory',
              children: [
                { name: 'hooks.json', path: 'plugin/codeforge-aws-platform-iac/hooks/hooks.json', type: 'file' },
              ],
            },
            {
              name: 'skills',
              path: 'plugin/codeforge-aws-platform-iac/skills',
              type: 'directory',
              children: [
                {
                  name: 'build-fix',
                  path: 'plugin/codeforge-aws-platform-iac/skills/build-fix',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-aws-platform-iac/skills/build-fix/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'code-review',
                  path: 'plugin/codeforge-aws-platform-iac/skills/code-review',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-aws-platform-iac/skills/code-review/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'phase',
                  path: 'plugin/codeforge-aws-platform-iac/skills/phase',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-aws-platform-iac/skills/phase/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'plan',
                  path: 'plugin/codeforge-aws-platform-iac/skills/plan',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-aws-platform-iac/skills/plan/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'tdd',
                  path: 'plugin/codeforge-aws-platform-iac/skills/tdd',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-aws-platform-iac/skills/tdd/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'verify',
                  path: 'plugin/codeforge-aws-platform-iac/skills/verify',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-aws-platform-iac/skills/verify/SKILL.md', type: 'file' },
                  ],
                },
              ],
            },
          ],
        },
        { name: 'marketplace.json.example', path: 'plugin/marketplace.json.example', type: 'file' },
      ],
    },
];

const terraformDemoFileContents: Record<string, string> = {
  '.claude/rules/common/coding-style.md': `# Coding Style — All Languages

Rules for Go, Python, and Terraform (HCL) code across the entire repository.

## File & Function Size

- Keep files under 250 lines; split into focused modules when approaching the limit
- Keep functions/methods under 50 lines with a single, clear responsibility
- Extract complex conditionals into well-named helper functions

## Naming Conventions

- Use \`snake_case\` for all file names across every language
- Use \`SCREAMING_SNAKE_CASE\` for constants and environment variable references
- Use \`camelCase\` for Go variables and function names per Go convention
- Choose descriptive, unambiguous names — avoid abbreviations unless domain-standard (e.g., \`vpc\`, \`rds\`, \`iam\`)

## DRY & Reusability

- Never copy-paste logic; extract shared code into reusable modules, packages, or functions
- Terraform shared patterns belong in \`modules/\`; Go shared logic belongs in internal packages
- Reference existing utilities in \`scripts/\` and \`cmd/\` before writing new ones

## Comments & Documentation

- Explain **why** a decision was made, not **what** the code does
- Never commit commented-out code; use version control history instead
- Add a brief doc comment to every exported function, module, and public interface

## Error Handling

- Handle every error explicitly — never discard with \`_\` (Go) or bare \`except\` (Python)
- Return actionable error messages that include context (resource name, operation, input)
- Fail fast and loudly; do not silently swallow errors or continue in degraded state

## Dependencies & Magic Values

- Follow the conservative dependency policy — use approved dependencies only; request review for additions
- Pin all dependency versions to exact patch (Go modules, Python requirements, Terraform providers)
- Replace magic numbers and strings with named constants defined at the top of the file

## Formatting

- Run the appropriate formatter before every commit: \`gofmt\`, \`ruff format\`, \`terraform fmt\`
- Run linters locally before pushing: \`golangci-lint run\`, \`ruff check\`, \`tflint\`, \`tfsec\`
- Resolve all linter warnings — do not suppress without a justifying comment`,

  '.claude/rules/common/git-workflow.md': `# Git Workflow

- Use GitHub Flow: branch from \`main\`, open PR, merge back to \`main\`
- Name branches as \`type/TICKET-desc\` — e.g., \`feat/INFRA-123-add-rds-module\`, \`fix/INFRA-456-vpc-cidr\`
- Valid branch types: \`feat\`, \`fix\`, \`chore\`, \`docs\`, \`refactor\`, \`test\`, \`ci\`
- Write conventional commits: \`feat: add RDS module with multi-AZ support\`, \`fix: correct VPC CIDR allocation\`
- Include ticket reference in commit body when applicable: \`Refs: INFRA-123\`
- Sign all commits with GPG or SSH — unsigned commits will be rejected
- Never push directly to \`main\` — it is a protected branch
- Open a PR for every change, no matter how small
- Require at least 2 approvals before merging any PR
- Ensure all PR checks pass before merge: \`tflint\`, \`tfsec\`, \`terraform validate\`, \`terraform fmt -check\`, \`go test ./...\`
- Use squash merge when merging to \`main\` — keep history clean
- Delete the source branch immediately after merge
- Tag releases with semantic versioning: \`v1.2.3\`
- Bump major version for breaking module interface changes, minor for new resources/features, patch for fixes
- Require explicit manual approval in GitHub Actions for any \`terraform apply\` targeting \`environments/production/\`
- Mark AI-generated or AI-assisted commits with \`[ai-assisted]\` in the commit body
- Reference the CODEOWNERS file — changes to \`modules/security/*\` and \`environments/production/*\` require security team review`,

  '.claude/rules/common/security.md': `# Security Rules

- Never hardcode secrets, credentials, API keys, or passwords in Terraform code, Go source, Python scripts, or any committed file
- Store all secrets in AWS Secrets Manager or SSM Parameter Store with KMS encryption; reference them via \`data\` sources or dynamic lookups
- Never commit \`*.tfvars\` files containing secrets, \`*.pem\` files, \`.env*\` files, or AWS credential files; verify \`.gitignore\` covers these patterns
- Use IAM managed policies exclusively; never define inline IAM policies on roles, users, or groups
- Apply least privilege on every IAM role and policy; scope permissions to specific resources and actions, never use \`"*"\` for both
- Enable encryption at rest for all data stores: RDS (KMS), S3 (SSE-KMS), EBS, ElastiCache, ECS task storage
- Enforce encryption in transit: require TLS on ALB listeners, RDS connections (\`require_ssl\`), S3 bucket policies, and ElastiCache
- Configure security groups as deny-by-default; allow only required ports and source CIDRs; never use \`0.0.0.0/0\` for ingress except public ALBs on 443
- Set \`aws_s3_bucket_public_access_block\` on every bucket; enable versioning and server-side encryption; require \`ssl_only\` in bucket policies
- RDS instances must have \`publicly_accessible = false\`, reside in private subnets, and enforce SSL via parameter groups
- Run \`tfsec\` and \`checkov\` in CI on every pull request; treat HIGH and CRITICAL findings as blocking failures
- Tag all AWS resources with \`project\`, \`environment\`, \`team\`, \`cost-center\`, and \`compliance\` tags for audit traceability
- Maintain SOC 2 and ISO 27001 compliance: log all infrastructure changes via CloudTrail, enable Config rules, retain audit logs for 365+ days
- Treat these paths as sensitive and require 2 approvals from \`@infra-security\` reviewers: \`modules/security/*\`, \`environments/production/*\`, \`*.tfvars\`
- Enable VPC Flow Logs on all VPCs and subnets; ship logs to CloudWatch Log Groups with KMS encryption and retention policies
- Pin all Terraform provider versions to exact patch versions to prevent supply-chain drift
- Never disable \`terraform plan\` diff review before \`terraform apply\`; production applies require manual approval in CI`,

  '.claude/rules/common/testing.md': `# Testing Standards

- Write Terratest integration tests in Go for every Terraform module under \`modules/\`; place tests in \`tests/\` mirroring the module path
- Name Go tests as \`TestModuleName_Scenario\` (e.g., \`TestVpc_CreatesPrivateSubnets\`) and Python tests as \`test_function_scenario\`
- Use table-driven tests for all Go unit tests; keep each test case self-documenting with a \`name\` field
- Maintain minimum 70% code coverage for Go (\`go test -coverprofile\`) and Python (\`pytest --cov\`); fail CI below threshold
- Run \`terraform validate\` and \`terraform plan\` as smoke tests for every module before deeper integration tests
- Use pytest with fixtures for all Python scripts under \`scripts/\` and \`lambdas/\`; isolate setup/teardown in \`conftest.py\`
- Mock AWS services with localstack (Go/Terraform integration tests) or moto (Python unit tests); never make calls to real AWS in unit tests
- Never run any test against production AWS accounts; use dedicated sandbox accounts with \`environment = "test"\` tags
- Ensure all infrastructure tests are idempotent: create resources, validate, then destroy via \`defer terraform.Destroy(t, opts)\` in Terratest
- Run CI stages in strict order: lint → \`terraform validate\` → unit tests → integration tests; fail fast on any stage
- Tag all test-created AWS resources with \`project = "aws-platform-iac"\`, \`environment = "test"\`, \`team = "sre"\`, and \`cost-center = "testing"\` per tagging policy
- Make tests deterministic: use fixed CIDR ranges, unique name prefixes with \`random.UniqueId()\`, and avoid time-dependent assertions
- Run \`tflint\`, \`tfsec\`, and \`checkov\` as part of the lint stage before any test execution
- Keep test files under 250 lines; split complex scenarios into separate test functions
- Store shared test helpers and fixtures in \`tests/helpers/\` to avoid duplication across module tests`,

  '.claude/rules/golang/coding-style.md': `# Go Coding Style

- Format all code with \`gofmt\`; CI enforces this via \`golangci-lint run\`
- Run \`golangci-lint\` with errcheck, gosec, govet, staticcheck, and ineffassign enabled
- Add godoc comments to every exported type, function, and constant
- Wrap errors with context: \`fmt.Errorf("fetch cluster config: %w", err)\` — never return bare errors
- Never discard errors with blank identifier \`_\`; handle or propagate every error
- Pass \`context.Context\` as the first parameter to any function that accepts it
- Use \`camelCase\` for unexported identifiers, \`PascalCase\` for exported, \`SCREAMING_SNAKE_CASE\` for constants
- Avoid abbreviations in names; prefer \`clusterConfig\` over \`clsCfg\`
- Place binaries in \`cmd/\`, private packages in \`internal/\`, shared libraries in \`pkg/\`
- Keep interfaces small (1-3 methods) and define them at the consumer side, not the implementation
- Avoid \`init()\` functions except for database driver registration
- Prefer dependency injection over package-level globals; pass dependencies via struct constructors
- Use \`testify/assert\` and \`testify/require\` for test assertions
- Write table-driven tests with descriptive subtest names: \`t.Run("returns error when cluster not found", ...)\`
- Keep files under 250 lines; split into focused files by responsibility
- Pin all module dependencies in \`go.mod\`; run \`go mod tidy\` before committing
- Structure Lambda handlers in \`lambdas/\` with a \`main.go\` entry point and \`handler.go\` for logic
- Use \`slog\` (structured logging) for all log output; never use \`fmt.Println\` in production code`,

  '.claude/rules/golang/testing.md': `- Place test files (\`*_test.go\`) adjacent to source files in the same package
- Use table-driven tests with descriptive case names: \`TestFunctionName_Scenario\` (e.g., \`TestVPCModule_CreatesSubnets\`, \`TestCostReporter_HandlesEmptyResponse\`)
- Use \`testify/assert\` for non-fatal checks and \`testify/require\` for fatal preconditions — do not use bare \`if\` comparisons
- Call \`t.Parallel()\` at the start of every test and subtest that has no shared mutable state
- Use \`t.Cleanup()\` for teardown logic instead of \`defer\` in test helpers — ensures cleanup runs even when \`t.FailNow()\` is called
- Tag integration tests with \`//go:build integration\` and place Terratest suites under \`tests/\` — run with \`go test -tags=integration ./tests/...\`
- Write Terratest tests for every Terraform module: call \`terraform.InitAndApply\`, validate outputs, then \`terraform.Destroy\` in \`t.Cleanup()\`
- Verify all AWS resources created by Terratest carry required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
- Mock AWS dependencies using interfaces or localstack — never call real AWS APIs in unit tests
- Maintain 70% minimum coverage: measure with \`go test -coverprofile=coverage.out ./...\` and enforce in CI
- Never use \`time.Sleep\` in tests — poll with exponential backoff using \`retry.DoWithRetry\` (Terratest) or custom helpers
- Benchmark performance-critical paths (CLI commands, Lambda handlers) with \`BenchmarkFunctionName\` functions
- Run \`go test -race ./...\` in CI to detect data races in concurrent code
- Keep individual test functions under 50 lines — extract shared setup into helper functions prefixed with \`test\` (unexported)`,

  '.claude/settings.json': `{
  "permissions": {
    "allow": [
      "Bash(terraform init*)",
      "Bash(terraform plan*)",
      "Bash(terraform apply -target*)",
      "Bash(terraform fmt*)",
      "Bash(terraform validate*)",
      "Bash(terraform output*)",
      "Bash(terraform state list*)",
      "Bash(terraform state show*)",
      "Bash(terraform workspace*)",
      "Bash(terraform-docs*)",
      "Bash(go test ./...)",
      "Bash(go test -v*)",
      "Bash(go test -run*)",
      "Bash(go build ./...)",
      "Bash(go build -o*)",
      "Bash(go mod tidy)",
      "Bash(go mod download)",
      "Bash(go vet ./...)",
      "Bash(go fmt ./...)",
      "Bash(golangci-lint run*)",
      "Bash(python3 scripts/*)",
      "Bash(python3 -m pytest*)",
      "Bash(python3 -m ruff*)",
      "Bash(ruff check*)",
      "Bash(ruff format*)",
      "Bash(pip install -r*)",
      "Bash(tflint*)",
      "Bash(tfsec*)",
      "Bash(checkov*)",
      "Bash(make *)",
      "Bash(make)",
      "Bash(git status)",
      "Bash(git diff*)",
      "Bash(git log*)",
      "Bash(git add *)",
      "Bash(git commit *)",
      "Bash(git branch*)",
      "Bash(git checkout*)",
      "Bash(git switch*)",
      "Bash(git stash*)",
      "Bash(git fetch*)",
      "Bash(git pull*)",
      "Bash(git push origin*)",
      "Bash(git merge*)",
      "Bash(git rebase*)",
      "Bash(aws sts get-caller-identity)",
      "Bash(aws s3 ls*)",
      "Bash(aws ecs describe*)",
      "Bash(aws ecs list*)",
      "Bash(aws rds describe*)",
      "Bash(aws ec2 describe*)",
      "Bash(aws cloudwatch get*)",
      "Bash(aws cloudwatch list*)",
      "Bash(aws cloudwatch describe*)",
      "Bash(aws logs describe*)",
      "Bash(aws logs get*)",
      "Bash(aws logs filter*)",
      "Bash(docker build*)",
      "Bash(docker compose*)",
      "Bash(helm template*)",
      "Bash(helm lint*)",
      "Bash(helm diff*)",
      "Bash(kubectl get*)",
      "Bash(kubectl describe*)",
      "Bash(kubectl logs*)",
      "Bash(cat *)",
      "Bash(ls *)",
      "Bash(find *)",
      "Bash(grep *)",
      "Bash(head *)",
      "Bash(tail *)",
      "Bash(wc *)",
      "Bash(tree *)",
      "Bash(jq *)",
      "Bash(yq *)",
      "Bash(echo *)",
      "Bash(mkdir -p *)",
      "Read",
      "Write",
      "Edit",
      "Glob",
      "Grep"
    ],
    "deny": [
      "Bash(rm -rf *)",
      "Bash(rm -r *)",
      "Bash(git push --force*)",
      "Bash(git push -f*)",
      "Bash(git reset --hard*)",
      "Bash(terraform destroy*)",
      "Bash(terraform apply -auto-approve*)",
      "Bash(terraform state rm*)",
      "Bash(terraform state mv*)",
      "Bash(terraform import*)",
      "Bash(terraform taint*)",
      "Bash(terraform untaint*)",
      "Bash(aws iam delete*)",
      "Bash(aws iam remove*)",
      "Bash(aws iam detach*)",
      "Bash(aws s3 rm*)",
      "Bash(aws s3 rb*)",
      "Bash(aws ec2 terminate*)",
      "Bash(aws rds delete*)",
      "Bash(aws ecs delete*)",
      "Bash(aws ecs deregister*)",
      "Bash(aws route53 delete*)",
      "Bash(aws logs delete*)",
      "Bash(kubectl delete*)",
      "Bash(kubectl apply*)",
      "Bash(helm install*)",
      "Bash(helm upgrade*)",
      "Bash(helm uninstall*)",
      "Bash(docker push*)",
      "Bash(chmod 777*)",
      "Bash(curl * | bash*)",
      "Bash(wget * | bash*)"
    ]
  }
}`,

  '.editorconfig': `root = true

[*]
charset = utf-8
end_of_line = lf
indent_style = space
indent_size = 2
trim_trailing_whitespace = true
insert_final_newline = true

[*.go]
indent_style = tab
indent_size = 4

[*.py]
indent_size = 4

[*.{tf,tfvars}]
indent_size = 2

[*.{hcl,json}]
indent_size = 2

[*.{yml,yaml}]
indent_size = 2

[*.{sh,bash}]
indent_size = 2

[Makefile]
indent_style = tab

[*.md]
trim_trailing_whitespace = false

[*.{mod,sum}]
indent_style = tab

[Dockerfile*]
indent_size = 4

[*.helmignore]
indent_size = 2`,

  '.gitattributes': `* text=auto

# Terraform
*.tf text diff=hcl
*.tfvars text diff=hcl
*.tfstate binary
*.tfstate.backup binary
.terraform.lock.hcl text linguist-generated

# Go
*.go text diff=golang
go.sum text linguist-generated
go.mod text

# Python
*.py text diff=python
requirements*.txt text
Pipfile.lock text linguist-generated
poetry.lock text linguist-generated

# Shell scripts
*.sh text eol=lf
*.bash text eol=lf

# Data / Config
*.yml text diff=yaml
*.yaml text diff=yaml
*.json text diff=json
*.toml text
*.hcl text diff=hcl
*.ini text
*.cfg text
*.conf text

# Documentation
*.md text diff=markdown
*.txt text
LICENSE text
CHANGELOG text

# Docker
Dockerfile text
*.dockerignore text

# Helm charts
Chart.yaml text diff=yaml
Chart.lock text linguist-generated
values.yaml text diff=yaml

# GitHub Actions
.github/**/*.yml text diff=yaml linguist-detectable

# CI/CD
Makefile text eol=lf
Taskfile.yml text diff=yaml

# Certificates and keys (should not be in repo, but prevent corruption if present)
*.pem binary
*.key binary
*.crt binary
*.p12 binary

# Binary / compiled
*.exe binary
*.dll binary
*.so binary
*.dylib binary

# Archives
*.zip binary
*.tar binary
*.tar.gz binary
*.gz binary
*.tgz binary

# Images
*.png binary
*.jpg binary
*.jpeg binary
*.gif binary
*.ico binary
*.svg text

# Fonts
*.woff binary
*.woff2 binary
*.ttf binary
*.eot binary

# Terraform provider plugins (should be in .gitignore, but protect if present)
.terraform/** binary linguist-vendored

# Generated documentation
docs/generated/** linguist-generated

# Vendor directories
vendor/** linguist-vendored`,

  '.github/CODEOWNERS': `# CODEOWNERS — aws-platform-iac
# https://docs.github.com/en/repositories/managing-your-repositorys-settings-and-features/customizing-your-repository/about-code-owners
#
# Default: platform team owns everything
# Sensitive paths require security-lead and/or platform-lead approval
# Enforced via branch protection on main (minimum 2 approvals)

# Default ownership — all files
*                                       @platform-team

# Terraform modules — networking, compute, data
modules/vpc/*                           @platform-team
modules/ecs/*                           @platform-team
modules/rds/*                           @platform-team
modules/monitoring/*                    @platform-team

# Security-sensitive modules — SOC 2 / ISO 27001 compliance scope
modules/security/*                      @security-lead @platform-team
modules/iam/*                           @security-lead @platform-team

# Production environment — requires platform-lead and security-lead sign-off
environments/production/*               @platform-lead @security-lead

# Staging and dev environments
environments/staging/*                  @platform-team
environments/dev/*                      @platform-team

# Variable files may contain environment-specific secrets references
*.tfvars                                @platform-lead

# CI/CD pipeline definitions
.github/workflows/*                     @platform-lead
.github/CODEOWNERS                      @platform-lead

# Claude Code configuration and rules
.claude/*                               @platform-lead
.claude/**/*                            @platform-lead

# Development methodology and playbook
playbook/*                              @platform-lead

# Documentation — architecture, runbooks, ADRs
docs/*                                  @platform-team

# Go CLI tools and custom tooling
cmd/*                                   @platform-team
scripts/*                               @platform-team

# Lambda functions — review for IAM permissions and security posture
lambdas/*                               @platform-team @security-lead

# Helm charts and Kubernetes manifests
charts/*                                @platform-team

# Integration tests (Terratest)
tests/*                                 @platform-team

# Plugin configuration
plugin/*                                @platform-lead`,

  '.github/ISSUE_TEMPLATE/ai_task.md': `---
name: AI Task (Claude Code)
about: Delegate a well-scoped infrastructure task to Claude Code
title: "[AI] "
labels:
  - ai-task
  - needs-review
assignees: []
---

## Task Description

<!-- Clear, specific description of what Claude Code should accomplish. Reference the relevant Terraform module, environment, or tooling component. -->



**Ticket Reference**: <!-- e.g., INFRA-123 -->
**Priority**: <!-- P0 (critical) | P1 (high) | P2 (medium) | P3 (low) -->
**Estimated Complexity**: <!-- trivial | small | medium | large -->

## Acceptance Criteria

<!-- All boxes must be checked before the PR is considered complete. -->

- [ ] \`terraform validate\` passes for all modified modules
- [ ] \`terraform fmt -check\` passes with no diff
- [ ] \`tflint\` reports zero errors
- [ ] \`tfsec\` and \`checkov\` report no HIGH or CRITICAL findings
- [ ] All new/modified modules include \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`
- [ ] \`terraform-docs\` output is current in module README
- [ ] Provider versions pinned to exact patch (e.g., \`= 5.46.0\`, not \`~> 5.46\`)
- [ ] All AWS resources tagged with \`project\`, \`environment\`, \`team\`, \`cost-center\`
- [ ] No inline IAM policies — managed policies only
- [ ] Unit tests pass (\`go test ./tests/unit/...\`)
- [ ] Integration tests pass or are updated (\`go test ./tests/integration/...\`)
- [ ] Coverage ≥ 70% on new Go/Python code
- [ ] Conventional commit messages used (e.g., \`feat:\`, \`fix:\`, \`docs:\`)
- [ ] Files stay under 250 lines; split if necessary
- [ ] AI-generated code marked per CI policy

### Task-Specific Criteria

- [ ] <!-- Add criteria specific to this task -->
- [ ] <!-- Add more as needed -->

## Terraform Modules in Scope

<!-- List only the modules Claude Code is allowed to read and modify. -->

| Module | Path | Access |
|--------|------|--------|
| <!-- e.g., VPC --> | \`modules/vpc/\` | read / modify |
| <!-- e.g., ECS --> | \`modules/ecs/\` | read-only |

**Environment targets**: <!-- dev | staging | dev + staging -->

## Constraints

<!-- Non-negotiable guardrails. Claude Code must respect all of these. -->

- **No production changes**: Do not modify anything under \`environments/production/\`
- **No IAM privilege escalation**: Do not add \`*\` actions, \`iam:*\`, \`sts:AssumeRole\` to new principals, or \`AdministratorAccess\`
- **No security module changes without explicit approval**: \`modules/security/*\` is a sensitive path requiring lead review
- **Cost ceiling**: Changes must not increase monthly AWS spend by more than **$<!-- e.g., 50 -->**/month. Include cost estimate in PR description.
- **No new provider additions**: Only use providers already declared in \`versions.tf\`
- **No secrets in code**: Use AWS Secrets Manager or SSM Parameter Store references; never hardcode credentials, tokens, or keys
- **SOC 2 / ISO 27001 compliance**: All changes must maintain encryption at rest, encryption in transit, audit logging, and least-privilege access patterns

### Additional Constraints

<!-- Add any task-specific constraints here -->

- 

## Context Files to Read

<!-- Files Claude Code should read before starting work to understand current state and conventions. -->

**Project context:**
- \`CLAUDE.md\` — project-wide instructions and conventions
- \`.claude/rules/\` — all active rule files

**Architecture & decisions:**
- \`docs/architecture.md\`
- \`docs/adr/\` — relevant Architecture Decision Records

**Module references:**
- <!-- e.g., modules/vpc/main.tf — current VPC layout -->
- <!-- e.g., modules/ecs/variables.tf — ECS variable conventions -->
- <!-- e.g., environments/staging/main.tf — how modules are composed -->

**Test patterns:**
- \`tests/unit/\` — existing unit test examples
- \`tests/integration/\` — Terratest patterns to follow

**Related PRs/issues:**
- <!-- e.g., #42 — previous work on this module -->

## Expected Outputs

<!-- Specific files Claude Code should create or modify. Be explicit. -->

### Files to Create

| File | Purpose |
|------|---------|
| <!-- e.g., modules/rds/replica.tf --> | <!-- Define read replica configuration --> |
| <!-- e.g., tests/unit/rds_replica_test.go --> | <!-- Unit tests for replica module --> |

### Files to Modify

| File | Change Description |
|------|--------------------|
| <!-- e.g., modules/rds/variables.tf --> | <!-- Add replica_count and replica_instance_class variables --> |
| <!-- e.g., modules/rds/outputs.tf --> | <!-- Export replica endpoints --> |
| <!-- e.g., modules/rds/README.md --> | <!-- Update terraform-docs output --> |

### Files NOT to Touch

<!-- Explicitly list files that must remain unchanged. -->

- \`environments/production/*\`
- \`modules/security/*\`
- <!-- Add others as needed -->

## Branch & PR Instructions

- **Branch from**: \`main\`
- **Branch name**: \`feat/<!-- ticket -->-<!-- short-desc -->\` (e.g., \`feat/INFRA-123-add-rds-replica\`)
- **PR title**: \`feat(<!-- scope -->): <!-- description -->\` (e.g., \`feat(rds): add read replica support\`)
- **PR labels**: \`ai-task\`, \`ai-generated\`, plus relevant module labels
- **Reviewers**: <!-- @username1, @username2 — minimum 2 required -->
- **CODEOWNERS**: Ensure modified paths have coverage in \`.github/CODEOWNERS\`

## Cost Estimate Template

<!-- Claude Code should fill this in on the resulting PR. -->

\`\`\`
Resource              | Current | Proposed | Delta/month
--------------------- | ------- | -------- | -----------
                      |         |          |
                      |         |          |
TOTAL                 |         |          | $0.00
\`\`\`

## Notes

<!-- Any additional context, links to Confluence docs, Slack threads, or related monitoring dashboards. -->

-`,

  '.github/ISSUE_TEMPLATE/bug_report.md': `---
name: Infrastructure Bug Report
about: Report a bug in Terraform modules, AWS resources, or automation tooling
title: "[BUG] "
labels: bug, infrastructure, needs-triage
assignees: ''
---

## Environment

- **AWS Account**: <!-- e.g., dev (123456789012), staging (234567890123), production (345678901234) -->
- **AWS Region**: <!-- e.g., us-east-1, us-west-2 -->
- **Terraform Workspace**: <!-- e.g., dev, staging, production -->
- **Terraform Version**: <!-- output of \`terraform version\` -->
- **Provider Versions**: <!-- relevant provider versions from .terraform.lock.hcl -->

## Module Affected

<!-- Check all that apply -->

- [ ] \`modules/vpc/\`
- [ ] \`modules/ecs/\`
- [ ] \`modules/rds/\`
- [ ] \`modules/monitoring/\`
- [ ] \`modules/security/\`
- [ ] \`modules/iam/\`
- [ ] \`environments/dev/\`
- [ ] \`environments/staging/\`
- [ ] \`environments/production/\`
- [ ] \`lambdas/\`
- [ ] \`charts/\`
- [ ] \`cmd/\` (CLI tooling)
- [ ] \`scripts/\` (automation)
- [ ] Other: <!-- specify -->

## Severity

<!-- Select one -->

- [ ] **P0 — Outage**: Production service down, data loss risk, security incident
- [ ] **P1 — Degraded**: Service partially impaired, failover active, compliance drift detected
- [ ] **P2 — Minor**: Non-critical resource misconfigured, dev/staging only, workaround available
- [ ] **P3 — Cosmetic**: Documentation, tagging, naming, formatting issues

## Expected Behavior

<!-- Describe what should happen when the module or resource is applied correctly -->

## Actual Behavior

<!-- Describe what actually happened, including any error messages -->

## Terraform Plan/Apply Output

<!-- Paste relevant output from \`terraform plan\` or \`terraform apply\`. Redact any secrets, account IDs, or sensitive values. -->

\`\`\`hcl
# Paste output here
\`\`\`

## Steps to Reproduce

1. <!-- e.g., Navigate to \`environments/staging/\` -->
2. <!-- e.g., Run \`terraform init\` -->
3. <!-- e.g., Run \`terraform plan -var-file=staging.tfvars\` -->
4. <!-- e.g., Observe error in module.rds output -->

## Resource Tags on Affected Resources

<!-- If applicable, include the tags on the affected AWS resources to help trace ownership -->

| Tag | Value |
|-----|-------|
| \`project\` | <!-- e.g., aws-platform-iac --> |
| \`environment\` | <!-- e.g., staging --> |
| \`team\` | <!-- e.g., platform-sre --> |
| \`cost-center\` | <!-- e.g., engineering --> |

## CloudWatch / Monitoring Evidence

<!-- Attach or link to relevant CloudWatch alarms, Grafana dashboards, Prometheus alerts, or PagerDuty incidents -->

- **CloudWatch Alarm**: <!-- alarm name or ARN -->
- **Grafana Dashboard**: <!-- link -->
- **PagerDuty Incident**: <!-- link or incident ID -->

## Security & Compliance Impact

<!-- Does this bug affect SOC 2 or ISO 27001 compliance controls? -->

- [ ] IAM policy drift or privilege escalation
- [ ] Security group or NACL misconfiguration
- [ ] Encryption at rest or in transit not enforced
- [ ] Logging or audit trail gap
- [ ] No compliance impact

## State File Information

<!-- If relevant, include details about state file issues. Never paste raw state contents. -->

- **State Backend**: <!-- e.g., S3 bucket name -->
- **State Lock Status**: <!-- locked/unlocked, any lock ID if stuck -->
- **Drift Detected**: <!-- yes/no, output of \`terraform plan\` showing drift -->

## Attempted Fixes

<!-- Describe any troubleshooting steps already taken -->

1. <!-- e.g., Ran \`terraform refresh\` to sync state -->
2. <!-- e.g., Checked tflint and tfsec output — no warnings -->
3. <!-- e.g., Verified provider version pinning in versions.tf -->

## Additional Context

<!-- Any other information: related PRs, recent changes, architecture diagrams, links to ADRs in docs/ -->`,

  '.github/ISSUE_TEMPLATE/feature_request.md': `---
name: Infrastructure Feature Request
about: Propose a new Terraform module, AWS resource, or platform capability
title: "[FEATURE] "
labels: enhancement, infrastructure
assignees: ''
---

## Summary

<!-- One or two sentences describing the infrastructure capability you need. -->

## Use Case

<!-- Describe the problem this solves. Who benefits and why is it needed? -->

**Requesting Team:**
**Environment(s):** <!-- dev / staging / production / all -->
**Priority:** <!-- low / medium / high / critical -->
**Target Date:** <!-- When is this needed by? -->

## Proposed Solution

### Terraform Approach

<!-- Describe how this should be implemented in Terraform. Reference existing modules where applicable. -->

**New module or extension?**
- [ ] New module under \`modules/\`
- [ ] Extension of existing module: <!-- module name -->
- [ ] New environment configuration under \`environments/\`
- [ ] Lambda function under \`lambdas/\`
- [ ] Helm chart under \`charts/\`
- [ ] CLI tooling under \`cmd/\`

**Module structure (if new module):**
\`\`\`
modules/<module-name>/
├── README.md
├── main.tf
├── variables.tf
├── outputs.tf
├── versions.tf
├── locals.tf
└── data.tf
\`\`\`

**Provider version constraints:**
<!-- All providers must be pinned to exact patch versions per project convention. -->

\`\`\`hcl
terraform {
  required_providers {
    aws = {
      source  = "hashicorp/aws"
      version = "= X.Y.Z"
    }
  }
}
\`\`\`

**Workspace strategy:**
<!-- Which Terraform workspaces will this apply to? -->

## AWS Services Involved

<!-- List every AWS service this feature touches. -->

| Service | Purpose | New or Existing |
|---------|---------|-----------------|
| e.g., RDS | PostgreSQL cluster | New |
| e.g., VPC | Subnet allocation | Existing |
| | | |

## Resource Tagging

<!-- All AWS resources must include these tags per project policy. Confirm values. -->

\`\`\`hcl
tags = {
  project      = "aws-platform-iac"
  environment  = var.environment
  team         = "<owning-team>"
  cost-center  = "<cost-center-code>"
  managed-by   = "terraform"
  feature-ref  = "<this-issue-number>"
}
\`\`\`

## Security Considerations

<!-- This project must maintain SOC 2 and ISO 27001 compliance. Address each item. -->

- [ ] No inline IAM policies — all permissions use managed policies
- [ ] Encryption at rest enabled for all data stores
- [ ] Encryption in transit (TLS) for all network communication
- [ ] Least-privilege IAM roles scoped to specific resources
- [ ] No secrets or credentials in Terraform state or code (use AWS Secrets Manager / SSM Parameter Store)
- [ ] VPC security groups restrict ingress to minimum required ports and CIDRs
- [ ] CloudTrail logging covers new resources
- [ ] Changes to \`modules/security/*\` or \`environments/production/*\` require security team review

**Compliance notes:**
<!-- Any specific SOC 2 or ISO 27001 controls this feature impacts. -->

**Does this modify sensitive paths?**
- [ ] \`modules/security/*\`
- [ ] \`environments/production/*\`
- [ ] \`*.tfvars\`
- [ ] IAM roles or policies

## Cost Estimate

<!-- Provide a monthly cost estimate for each environment. Use AWS Pricing Calculator or historical data. -->

| Resource | Environment | Estimated Monthly Cost |
|----------|-------------|----------------------|
| | dev | |
| | staging | |
| | production | |
| **Total** | | |

**Cost optimization notes:**
<!-- Reserved instances, savings plans, auto-scaling policies, scheduled scaling, etc. -->

## Monitoring & Observability

<!-- How will this be monitored? Reference existing CloudWatch dashboards or propose new ones. -->

- [ ] CloudWatch metrics and alarms defined in \`modules/monitoring/\`
- [ ] Prometheus metrics exported
- [ ] Grafana dashboard created or updated
- [ ] PagerDuty alert routing configured
- [ ] Runbook added to \`docs/runbooks/\`

## Alternatives Considered

<!-- What other approaches did you evaluate? Why is the proposed solution preferred? -->

| Alternative | Pros | Cons | Why Not |
|-------------|------|------|---------|
| | | | |
| | | | |

## Implementation Checklist

<!-- The implementing engineer should complete this checklist. -->

- [ ] Branch created: \`feat/INFRA-<number>-<description>\`
- [ ] Module includes \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`
- [ ] \`terraform fmt\` and \`terraform validate\` pass
- [ ] \`tflint\` and \`tfsec\` scans pass with no high/critical findings
- [ ] \`terraform-docs\` generated for module documentation
- [ ] Terratest integration tests added under \`tests/\`
- [ ] Unit test coverage meets 70% threshold
- [ ] \`terraform plan\` output reviewed for all target environments
- [ ] Cost estimate validated against \`terraform plan\` output
- [ ] PR opened with at least 2 approvals and security scan passing
- [ ] CODEOWNERS updated if new paths introduced
- [ ] ADR created in \`docs/adr/\` if this is an architectural decision

## Additional Context

<!-- Architecture diagrams, links to Confluence docs, Slack threads, related issues, or upstream dependencies. -->`,

  '.github/PULL_REQUEST_TEMPLATE.md': `## Summary

<!-- What changed and why? Link to the GitHub Issue. -->

**Issue**: Closes #

**Description**:


**Motivation**:


---

## Type of Change

- [ ] 🆕 New Terraform module
- [ ] 🔄 Module update (non-breaking)
- [ ] 💥 Breaking change (requires state migration or manual intervention)
- [ ] 🐛 Bugfix (resource misconfiguration, drift correction)
- [ ] 🔒 Security (IAM policy, encryption, network ACL, compliance)
- [ ] 📖 Documentation (README, runbook, ADR)
- [ ] ⚙️ CI/CD (GitHub Actions workflow, pipeline config)
- [ ] 🧹 Refactor (no resource changes, code cleanup only)

---

## Terraform Changes

**Modules affected**:
<!-- e.g., modules/vpc, modules/ecs, modules/rds -->
- 

**Environments affected**:
- [ ] dev
- [ ] staging
- [ ] production

**Resource summary**:

| Action    | Resource Type | Resource Name | Notes |
|-----------|--------------|---------------|-------|
| add       |              |               |       |
| change    |              |               |       |
| destroy   |              |               |       |

### \`terraform plan\` output

<details>
<summary>Click to expand plan output</summary>

\`\`\`
# Paste the relevant terraform plan output here.
# Run: terraform plan -no-color 2>&1 | tee plan-output.txt
#
# Plan: X to add, Y to change, Z to destroy.
\`\`\`

</details>

**State operations required**:
- [ ] None
- [ ] \`terraform import\` (detail below)
- [ ] \`terraform state mv\` (detail below)
- [ ] \`terraform state rm\` (detail below)

<!-- If state operations are needed, list exact commands: -->
\`\`\`bash
# terraform state mv module.old_name module.new_name
\`\`\`

---

## Testing

### Validation

- [ ] \`terraform fmt -check -recursive\` passes
- [ ] \`terraform validate\` passes for all affected environments
- [ ] \`tflint\` passes with no errors
- [ ] \`tfsec\` passes with no critical or high findings
- [ ] \`checkov\` passes with no failed checks
- [ ] \`terraform-docs\` regenerated for modified modules

### Tests

- [ ] Unit tests pass (\`cd tests && go test -v -tags=unit ./...\`)
- [ ] Integration tests pass against dev environment (\`go test -v -tags=integration -timeout 30m ./...\`)
- [ ] Terratest validates resource creation and connectivity
- [ ] Existing tests unaffected (no regressions)

### Manual verification

- [ ] Applied to **dev** environment successfully
- [ ] Applied to **staging** environment successfully
- [ ] Verified resource behavior in AWS Console / CLI
- [ ] Monitoring confirms no anomalies post-apply

---

## Security Checklist

> Required for SOC 2 and ISO 27001 compliance.

- [ ] IAM follows least-privilege principle — no \`*\` actions or resources without justification
- [ ] No inline IAM policies — all policies are managed (\`aws_iam_policy\` resources)
- [ ] No hardcoded secrets, credentials, or account IDs in \`.tf\` files
- [ ] Sensitive variables marked with \`sensitive = true\`
- [ ] No secrets in \`*.tfvars\` files (secrets sourced from AWS Secrets Manager or SSM Parameter Store)
- [ ] Encryption at rest enabled for all data stores (RDS, S3, ElastiCache, EBS)
- [ ] Encryption in transit enabled (TLS/SSL for ALB listeners, RDS connections, Redis)
- [ ] Security groups follow least-privilege — no \`0.0.0.0/0\` ingress without justification
- [ ] VPC resources placed in private subnets where appropriate
- [ ] CloudWatch logging enabled for new resources
- [ ] All resources tagged per policy:
  - [ ] \`project = "aws-platform-iac"\`
  - [ ] \`environment\` (dev/staging/production)
  - [ ] \`team\`
  - [ ] \`cost-center\`
  - [ ] \`managed-by = "terraform"\`

---

## Rollback Plan

<!-- How do we revert if this causes issues in production? -->

**Rollback strategy**:
- [ ] Revert commit and re-apply previous state
- [ ] Run \`terraform apply\` with previous module version
- [ ] Manual state intervention required (detail below)
- [ ] No rollback needed (additive/non-destructive change)

**Rollback steps**:
1. 
2. 
3. 

**Estimated rollback time**: 

**Data loss risk**: None / Possible (explain)

---

## Architecture Diagrams

<!-- Attach diagrams if this PR changes network topology, adds new services, or modifies data flow. -->
<!-- Use draw.io, Lucidchart, or Mermaid diagrams. -->

<details>
<summary>Before / After diagrams</summary>

\`\`\`mermaid
graph TD
    A[Change description] --> B[Affected components]
\`\`\`

</details>

---

## Cost Impact

<!-- Estimate monthly cost change using AWS Pricing Calculator or infracost. -->

- **Estimated monthly cost change**: +$0.00 / -$0.00
- [ ] \`infracost diff\` output reviewed
- [ ] Cost-center tag applied for chargeback

<details>
<summary>infracost output</summary>

\`\`\`
# Paste infracost diff output here
# Run: infracost diff --path .
\`\`\`

</details>

---

## Reviewer Notes

<!-- Anything reviewers should pay special attention to? -->
<!-- Call out risky changes, areas where you want specific feedback, or known limitations. -->

- 

---

> **AI Disclosure**: Was any part of this PR generated or assisted by AI tools?
> - [ ] No AI assistance
> - [ ] Yes — AI-assisted (sections marked with \`<!-- AI-generated -->\` comments)`,

  '.github/workflows/ai-code-audit.yml': `name: AI Code Audit

on:
  pull_request:
    types: [opened, synchronize, labeled]
    paths:
      - 'modules/**'
      - 'environments/**'
      - 'lambdas/**'

permissions:
  contents: read
  pull-requests: write
  id-token: write

jobs:
  detect:
    runs-on: ubuntu-latest
    outputs:
      is_ai: \${{ steps.check.outputs.ai_generated }}
    steps:
      - uses: actions/checkout@v4
      - id: check
        run: |
          AI_LABEL=$(echo '\${{ toJSON(github.event.pull_request.labels.*.name) }}' | jq -r 'map(select(. == "ai-generated")) | length')
          AI_MARKERS=$(grep -rl "AI-generated\\|Generated by Claude\\|claude-code" --include="*.tf" --include="*.go" --include="*.py" modules/ environments/ lambdas/ 2>/dev/null | wc -l)
          if [[ "$AI_LABEL" -gt 0 || "$AI_MARKERS" -gt 0 ]]; then
            echo "ai_generated=true" >> "$GITHUB_OUTPUT"
          else
            echo "ai_generated=false" >> "$GITHUB_OUTPUT"
          fi

  security-review:
    needs: detect
    if: needs.detect.outputs.is_ai == 'true'
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - name: tfsec strict scan
        uses: aquasecurity/tfsec-action@v1.0.3
        with:
          additional_args: --minimum-severity HIGH --soft-fail false
      - name: checkov IAM privilege escalation check
        uses: bridgecrewio/checkov-action@v12
        with:
          directory: .
          check: CKV_AWS_61,CKV_AWS_62,CKV_AWS_63,CKV_AWS_274,CKV_AWS_111,CKV_AWS_110,CKV_AWS_109
          framework: terraform
          soft_fail: false

  cost-estimate:
    needs: detect
    if: needs.detect.outputs.is_ai == 'true'
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - uses: infracost/actions/setup@v3
        with:
          api-key: \${{ secrets.INFRACOST_API_KEY }}
      - run: |
          infracost diff --path=. --format=json --out-file=/tmp/infracost.json
          DIFF=$(jq -r '.diffTotalMonthlyCost // "0"' /tmp/infracost.json)
          echo "cost_diff=$DIFF" >> "$GITHUB_ENV"
          if (( $(echo "$DIFF > 500" | bc -l) )); then
            echo "::error::AI-generated code increases monthly cost by \\$$DIFF (threshold: \\$500)"
            exit 1
          fi

  compliance:
    needs: detect
    if: needs.detect.outputs.is_ai == 'true'
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - name: Verify resource tagging (project, environment, team, cost-center)
        run: |
          UNTAGGED=$(grep -rl 'resource "aws_' modules/ environments/ --include="*.tf" | xargs grep -L 'tags' || true)
          if [[ -n "$UNTAGGED" ]]; then
            echo "::error::Missing tags in: $UNTAGGED"
            exit 1
          fi
          for tag in project environment team cost-center; do
            MISSING=$(grep -rl 'tags' modules/ environments/ --include="*.tf" | xargs grep -L "$tag" || true)
            [[ -n "$MISSING" ]] && echo "::warning::Missing '$tag' tag in: $MISSING"
          done
      - name: Check no public endpoints or unencrypted resources
        run: |
          grep -rn 'publicly_accessible\\s*=\\s*true' modules/ environments/ --include="*.tf" && { echo "::error::Public endpoints detected in AI code"; exit 1; } || true
          grep -rn 'encrypted\\s*=\\s*false\\|storage_encrypted\\s*=\\s*false' modules/ environments/ --include="*.tf" && { echo "::error::Unencrypted resources in AI code (SOC 2 / ISO 27001 violation)"; exit 1; } || true
      - name: Check no inline IAM policies
        run: |
          grep -rn 'inline_policy' modules/ environments/ --include="*.tf" && { echo "::error::Inline IAM policies detected — use managed policies per project standards"; exit 1; } || true

  comment:
    needs: [detect, security-review, cost-estimate, compliance]
    if: always() && needs.detect.outputs.is_ai == 'true'
    runs-on: ubuntu-latest
    steps:
      - name: Post audit summary
        uses: actions/github-script@v7
        with:
          script: |
            const sec = '\${{ needs.security-review.result }}';
            const cost = '\${{ needs.cost-estimate.result }}';
            const comp = '\${{ needs.compliance.result }}';
            const icon = (r) => r === 'success' ? '✅' : r === 'skipped' ? '⏭️' : '❌';
            const body = [
              '## 🤖 AI Code Audit Summary',
              '',
              '| Check | Result |',
              '|-------|--------|',
              \`| Security (tfsec + checkov) | \${icon(sec)} \${sec} |\`,
              \`| Cost Estimate (infracost) | \${icon(cost)} \${cost} |\`,
              \`| Compliance (tags, encryption, IAM) | \${icon(comp)} \${comp} |\`,
              '',
              '> This PR was flagged as AI-generated. SOC 2 / ISO 27001 compliance requires manual review.',
              '> Ref: \`.claude/rules/\` for AI code standards.'
            ].join('\\n');
            await github.rest.issues.createComment({
              owner: context.repo.owner, repo: context.repo.repo,
              issue_number: context.issue.number, body
            });`,

  '.github/workflows/ci.yml': `name: CI Pipeline

on:
  push:
    branches: [main]
  pull_request:
    branches: [main]

env:
  GO_VERSION: "1.22"
  TERRAFORM_VERSION: "1.7.5"
  PYTHON_VERSION: "3.12"
  TF_PLUGIN_CACHE_DIR: \${{ github.workspace }}/.terraform.d/plugin-cache

permissions:
  contents: read
  pull-requests: write
  security-events: write

jobs:
  lint:
    name: Lint
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true
      - uses: hashicorp/setup-terraform@v3
        with:
          terraform_version: \${{ env.TERRAFORM_VERSION }}
      - uses: actions/setup-python@v5
        with:
          python-version: \${{ env.PYTHON_VERSION }}

      - name: Go lint
        uses: golangci/golangci-lint-action@v4
        with:
          version: v1.56
          args: --timeout=5m

      - name: Python lint
        run: |
          pip install ruff
          ruff check lambdas/ scripts/ --output-format=github

      - name: Terraform fmt check
        run: terraform fmt -check -recursive -diff

      - name: TFLint
        run: |
          curl -s https://raw.githubusercontent.com/terraform-linters/tflint/master/install_linux.sh | bash
          for dir in modules/*/; do
            echo "::group::tflint \${dir}"
            tflint --chdir="\${dir}" --init
            tflint --chdir="\${dir}" --format=compact
            echo "::endgroup::"
          done

  security:
    name: Security Scan
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4

      - name: tfsec
        uses: aquasecurity/tfsec-action@v1.0.3
        with:
          additional_args: --minimum-severity HIGH --soft-fail

      - name: Checkov
        uses: bridgecrewio/checkov-action@v12
        with:
          directory: modules/
          framework: terraform
          output_format: cli,sarif
          output_file_path: console,results.sarif
          soft_fail: false
          check: CKV_AWS_18,CKV_AWS_19,CKV_AWS_20,CKV_AWS_145,CKV_AWS_144

      - name: Upload SARIF
        if: always()
        uses: github/codeql-action/upload-sarif@v3
        with:
          sarif_file: results.sarif

      - name: Secret scan
        uses: trufflesecurity/trufflehog@main
        with:
          extra_args: --only-verified --fail

  validate:
    name: Terraform Validate
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - uses: hashicorp/setup-terraform@v3
        with:
          terraform_version: \${{ env.TERRAFORM_VERSION }}

      - name: Create plugin cache dir
        run: mkdir -p $TF_PLUGIN_CACHE_DIR

      - name: Cache Terraform plugins
        uses: actions/cache@v4
        with:
          path: \${{ env.TF_PLUGIN_CACHE_DIR }}
          key: terraform-plugins-\${{ hashFiles('modules/**/versions.tf') }}

      - name: Validate modules
        run: |
          status=0
          for dir in modules/*/; do
            echo "::group::validate \${dir}"
            terraform -chdir="\${dir}" init -backend=false
            terraform -chdir="\${dir}" validate || status=1
            echo "::endgroup::"
          done
          exit $status

      - name: Check terraform-docs freshness
        run: |
          pip install terraform-docs || true
          for dir in modules/*/; do
            if [ ! -f "\${dir}README.md" ]; then
              echo "::error file=\${dir}::Missing README.md — all modules require documentation"
              exit 1
            fi
          done

  test-go:
    name: Go Tests
    runs-on: ubuntu-latest
    needs: [lint, validate]
    steps:
      - uses: actions/checkout@v4
      - uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true

      - name: Run unit tests
        run: |
          go test ./cmd/... ./lambdas/... ./scripts/... \\
            -v -race -count=1 \\
            -coverprofile=coverage.out \\
            -covermode=atomic \\
            -tags=unit

      - name: Check coverage threshold
        run: |
          total=$(go tool cover -func=coverage.out | grep total | awk '{print substr($3, 1, length($3)-1)}')
          echo "Total coverage: \${total}%"
          threshold=70
          if (( $(echo "$total < $threshold" | bc -l) )); then
            echo "::error::Coverage \${total}% is below threshold \${threshold}%"
            exit 1
          fi

      - name: Upload coverage
        if: github.event_name == 'pull_request'
        uses: actions/upload-artifact@v4
        with:
          name: go-coverage
          path: coverage.out

  test-terraform:
    name: Terratest Integration
    runs-on: ubuntu-latest
    if: github.event_name == 'pull_request'
    needs: [lint, security, validate]
    steps:
      - uses: actions/checkout@v4
      - uses: actions/setup-go@v5
        with:
          go-version: \${{ env.GO_VERSION }}
          cache: true
      - uses: hashicorp/setup-terraform@v3
        with:
          terraform_version: \${{ env.TERRAFORM_VERSION }}
          terraform_wrapper: false

      - name: Run Terratest
        working-directory: tests/
        run: go test -v -timeout 30m -tags=integration ./...
        env:
          AWS_DEFAULT_REGION: us-east-1

  ai-label:
    name: AI Code Check
    runs-on: ubuntu-latest
    if: github.event_name == 'pull_request'
    steps:
      - uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check for AI-generated markers
        run: |
          if git diff origin/main...HEAD | grep -qiE '(generated by|co-authored-by:.*claude|ai-generated)'; then
            echo "ai_generated=true" >> "$GITHUB_ENV"
          fi

      - name: Apply ai-generated label
        if: env.ai_generated == 'true'
        uses: actions/github-script@v7
        with:
          script: |
            github.rest.issues.addLabels({
              owner: context.repo.owner,
              repo: context.repo.repo,
              issue_number: context.issue.number,
              labels: ['ai-generated']
            })`,

  '.github/workflows/deploy-production.yml': `name: Deploy Production Infrastructure

on:
  workflow_dispatch:
    inputs:
      confirm_environment:
        description: 'Type "production" to confirm'
        required: true
        type: string
      change_ticket:
        description: 'Change ticket (e.g., INFRA-456)'
        required: true
        type: string

concurrency:
  group: deploy-production
  cancel-in-progress: false

permissions:
  id-token: write
  contents: read
  pull-requests: read

env:
  TF_VERSION: "1.7.5"
  WORKING_DIR: environments/production
  AWS_REGION: us-east-1

jobs:
  plan:
    name: Terraform Plan
    runs-on: ubuntu-latest
    if: github.event.inputs.confirm_environment == 'production'
    environment: production-plan
    outputs:
      resource_count: \${{ steps.summary.outputs.resource_count }}
      changes_add: \${{ steps.summary.outputs.adds }}
      changes_change: \${{ steps.summary.outputs.changes }}
      changes_destroy: \${{ steps.summary.outputs.destroys }}
    steps:
      - uses: actions/checkout@v4
      - uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}
      - uses: hashicorp/setup-terraform@v3
        with:
          terraform_version: \${{ env.TF_VERSION }}
          terraform_wrapper: false

      - name: Terraform Init
        working-directory: \${{ env.WORKING_DIR }}
        run: terraform init -input=false

      - name: Terraform Validate
        working-directory: \${{ env.WORKING_DIR }}
        run: terraform validate

      - name: Security Scan
        working-directory: \${{ env.WORKING_DIR }}
        run: |
          tfsec . --minimum-severity HIGH --format json > /tmp/tfsec-results.json
          checkov -d . --framework terraform --check HIGH --compact

      - name: Terraform Plan
        working-directory: \${{ env.WORKING_DIR }}
        run: terraform plan -input=false -out=tfplan -detailed-exitcode 2>&1 | tee /tmp/plan-output.txt
        env:
          TF_VAR_change_ticket: \${{ github.event.inputs.change_ticket }}

      - name: Plan Summary
        id: summary
        working-directory: \${{ env.WORKING_DIR }}
        run: |
          terraform show -json tfplan > /tmp/plan.json
          ADDS=$(jq '[.resource_changes[] | select(.change.actions[] == "create")] | length' /tmp/plan.json)
          CHANGES=$(jq '[.resource_changes[] | select(.change.actions[] == "update")] | length' /tmp/plan.json)
          DESTROYS=$(jq '[.resource_changes[] | select(.change.actions[] == "delete")] | length' /tmp/plan.json)
          echo "adds=$ADDS" >> "$GITHUB_OUTPUT"
          echo "changes=$CHANGES" >> "$GITHUB_OUTPUT"
          echo "destroys=$DESTROYS" >> "$GITHUB_OUTPUT"
          echo "resource_count=$(terraform state list | wc -l)" >> "$GITHUB_OUTPUT"

      - uses: actions/upload-artifact@v4
        with:
          name: tfplan-production
          path: \${{ env.WORKING_DIR }}/tfplan
          retention-days: 1

  apply:
    name: Terraform Apply
    needs: plan
    runs-on: ubuntu-latest
    # Requires manual approval via GitHub environment protection rules
    environment: production
    steps:
      - uses: actions/checkout@v4
      - uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}
      - uses: hashicorp/setup-terraform@v3
        with:
          terraform_version: \${{ env.TF_VERSION }}
          terraform_wrapper: false

      - name: Terraform Init
        working-directory: \${{ env.WORKING_DIR }}
        run: terraform init -input=false

      - uses: actions/download-artifact@v4
        with:
          name: tfplan-production
          path: \${{ env.WORKING_DIR }}

      # Rollback: If apply fails, run \`terraform apply -target=<resource> -refresh-only\`
      # or revert to previous state with \`terraform state push <backup-state>\`
      # See docs/runbooks/production-rollback.md
      - name: Terraform Apply
        working-directory: \${{ env.WORKING_DIR }}
        run: terraform apply -input=false -auto-approve tfplan

  verify:
    name: Post-Deploy Verification
    needs: [plan, apply]
    runs-on: ubuntu-latest
    environment: production
    steps:
      - uses: actions/checkout@v4
      - uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Check CloudWatch Alarms
        run: |
          ALARMS=$(aws cloudwatch describe-alarms --state-value ALARM \\
            --alarm-name-prefix "aws-platform-iac-production" \\
            --query 'MetricAlarms[].AlarmName' --output json)
          if [ "$ALARMS" != "[]" ]; then
            echo "::error::Active alarms detected: $ALARMS"
            exit 1
          fi

      - name: Health Checks
        run: |
          python3 scripts/verify_deployment.py \\
            --environment production \\
            --expected-resources \${{ needs.plan.outputs.resource_count }} \\
            --region \${{ env.AWS_REGION }}

  notify:
    name: Slack Notification
    needs: [plan, apply, verify]
    if: always()
    runs-on: ubuntu-latest
    steps:
      - name: Post Deployment Summary
        uses: slackapi/slack-github-action@v1.26.0
        with:
          channel-id: \${{ secrets.SLACK_INFRA_CHANNEL_ID }}
          payload: |
            {
              "text": "Production Deploy: \${{ needs.verify.result == 'success' && '✅ Success' || '🚨 Failed' }}",
              "blocks": [
                {
                  "type": "section",
                  "text": {
                    "type": "mrkdwn",
                    "text": "*Production Infrastructure Deploy*\\n*Status:* \${{ needs.verify.result == 'success' && '✅ Success' || '🚨 Failed' }}\\n*Ticket:* \`\${{ github.event.inputs.change_ticket }}\`\\n*Changes:* +\${{ needs.plan.outputs.changes_add }} ~\${{ needs.plan.outputs.changes_change }} -\${{ needs.plan.outputs.changes_destroy }}\\n*Actor:* \${{ github.actor }}\\n*Run:* <\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}|View>"
                  }
                }
              ]
            }
        env:
          SLACK_BOT_TOKEN: \${{ secrets.SLACK_BOT_TOKEN }}`,

  '.github/workflows/deploy-staging.yml': `name: Deploy Staging Infrastructure

on:
  push:
    branches: [main]
    paths:
      - 'modules/**'
      - 'environments/staging/**'
      - 'scripts/**'

concurrency:
  group: deploy-staging
  cancel-in-progress: false

permissions:
  id-token: write
  contents: read

env:
  TF_VERSION: "1.7.5"
  AWS_REGION: "us-east-1"
  WORKING_DIR: "environments/staging"

jobs:
  plan:
    name: Terraform Plan
    runs-on: ubuntu-latest
    outputs:
      has_changes: \${{ steps.plan.outputs.has_changes }}
    steps:
      - uses: actions/checkout@v4

      - uses: hashicorp/setup-terraform@v3
        with:
          terraform_version: \${{ env.TF_VERSION }}
          terraform_wrapper: false

      - name: Configure AWS Credentials (OIDC)
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_STAGING_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Terraform Init
        working-directory: \${{ env.WORKING_DIR }}
        run: terraform init -input=false

      - name: Terraform Plan
        id: plan
        working-directory: \${{ env.WORKING_DIR }}
        run: |
          terraform plan -input=false -out=staging.tfplan -detailed-exitcode 2>&1 | tee plan_output.txt
          EXIT_CODE=\${PIPESTATUS[0]}
          if [ $EXIT_CODE -eq 2 ]; then
            echo "has_changes=true" >> "$GITHUB_OUTPUT"
          elif [ $EXIT_CODE -eq 0 ]; then
            echo "has_changes=false" >> "$GITHUB_OUTPUT"
          else
            exit 1
          fi

      - name: Upload Plan Artifact
        if: steps.plan.outputs.has_changes == 'true'
        uses: actions/upload-artifact@v4
        with:
          name: staging-tfplan-\${{ github.sha }}
          path: |
            \${{ env.WORKING_DIR }}/staging.tfplan
            \${{ env.WORKING_DIR }}/plan_output.txt
          retention-days: 3

  apply:
    name: Terraform Apply
    needs: plan
    if: needs.plan.outputs.has_changes == 'true'
    runs-on: ubuntu-latest
    environment: staging
    steps:
      - uses: actions/checkout@v4

      - uses: hashicorp/setup-terraform@v3
        with:
          terraform_version: \${{ env.TF_VERSION }}
          terraform_wrapper: false

      - name: Configure AWS Credentials (OIDC)
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_STAGING_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Download Plan Artifact
        uses: actions/download-artifact@v4
        with:
          name: staging-tfplan-\${{ github.sha }}
          path: \${{ env.WORKING_DIR }}

      - name: Terraform Init
        working-directory: \${{ env.WORKING_DIR }}
        run: terraform init -input=false

      - name: Terraform Apply
        working-directory: \${{ env.WORKING_DIR }}
        run: terraform apply -input=false -auto-approve staging.tfplan

  smoke-test:
    name: Post-Deploy Smoke Tests
    needs: apply
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4

      - name: Configure AWS Credentials (OIDC)
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_STAGING_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Check ALB Health
        run: |
          ALB_DNS=$(aws elbv2 describe-load-balancers --names "staging-platform-alb" --query 'LoadBalancers[0].DNSName' --output text)
          for i in {1..10}; do
            STATUS=$(curl -s -o /dev/null -w "%{http_code}" "http://\${ALB_DNS}/health" || true)
            [ "$STATUS" = "200" ] && echo "ALB healthy" && break
            echo "Attempt $i: ALB returned $STATUS, retrying in 15s..."
            sleep 15
          done
          [ "$STATUS" != "200" ] && echo "ALB health check failed" && exit 1

      - name: Check ECS Tasks Running
        run: |
          RUNNING=$(aws ecs describe-services --cluster staging-platform --services platform-api --query 'services[0].runningCount' --output text)
          DESIRED=$(aws ecs describe-services --cluster staging-platform --services platform-api --query 'services[0].desiredCount' --output text)
          echo "ECS tasks: $RUNNING running / $DESIRED desired"
          [ "$RUNNING" -ge "$DESIRED" ] && [ "$DESIRED" -gt 0 ] || exit 1

      - name: Check RDS Connectivity
        run: |
          STATUS=$(aws rds describe-db-clusters --db-cluster-identifier staging-platform-db --query 'DBClusters[0].Status' --output text)
          echo "RDS cluster status: $STATUS"
          [ "$STATUS" = "available" ] || exit 1

  notify:
    name: Slack Notification
    needs: [plan, apply, smoke-test]
    if: always()
    runs-on: ubuntu-latest
    steps:
      - name: Send Slack Notification
        uses: slackapi/slack-github-action@v1.26.0
        with:
          payload: |
            {
              "text": "\${{ contains(needs.*.result, 'failure') && '🔴' || '🟢' }} Staging Deploy: \${{ contains(needs.*.result, 'failure') && 'FAILED' || (needs.plan.outputs.has_changes == 'false' && 'No changes' || 'SUCCESS') }}",
              "blocks": [
                {
                  "type": "section",
                  "text": {
                    "type": "mrkdwn",
                    "text": "\${{ contains(needs.*.result, 'failure') && '🔴' || '🟢' }} *Staging Deploy* — <\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}|View Run>\\nCommit: \`\${{ github.sha }}\` by \${{ github.actor }}"
                  }
                }
              ]
            }
        env:
          SLACK_WEBHOOK_URL: \${{ secrets.SLACK_DEPLOY_WEBHOOK_URL }}
          SLACK_WEBHOOK_TYPE: INCOMING_WEBHOOK`,

  '.gitignore': `# =============================================================================
# Terraform
# =============================================================================
.terraform/
*.tfstate
*.tfstate.*
*.tfstate.backup
crash.log
crash.*.log
override.tf
override.tf.json
*_override.tf
*_override.tf.json
*.tfplan
*.tfplan.binary

# Sensitive variable files — never commit secrets
*.tfvars
!*.tfvars.example
!*.tfvars.template

# Uncomment if lock file should not be committed (we commit it for reproducibility)
# .terraform.lock.hcl

# terraform-docs generated (regenerated in CI)
.terraform-docs.yml.lock

# =============================================================================
# Go
# =============================================================================
bin/
vendor/
*.exe
*.exe~
*.dll
*.so
*.dylib
*.test
*.out
*.prof
coverage.out
coverage.html
cmd/*/cmd
cmd/provisioner/provisioner
cmd/cost-reporter/cost-reporter

# =============================================================================
# Python
# =============================================================================
__pycache__/
*.py[cod]
*$py.class
*.pyo
.venv/
venv/
env/
.Python
dist/
build/
*.egg-info/
*.egg
.eggs/
pip-log.txt
pip-delete-this-directory.txt
.mypy_cache/
.ruff_cache/
.pytest_cache/
htmlcov/
.coverage
.coverage.*

# =============================================================================
# Secrets & Credentials — SOC 2 / ISO 27001 compliance
# =============================================================================
.env
.env.*
!.env.example
!.env.template
*.pem
*.key
*.p12
*.pfx
*.crt
*.csr
credentials.json
serviceaccount.json
*-credentials.json
*-serviceaccount.json
aws-credentials
.aws/
secrets/
*.secret
*.secrets

# =============================================================================
# Build Artifacts & Coverage
# =============================================================================
dist/
build/
coverage/
out/
tmp/
.cache/
node_modules/
.turbo/

# =============================================================================
# IDE & Editors
# =============================================================================
.idea/
.vscode/
*.swp
*.swo
*.swn
*~
*.bak
*.tmp
.project
.classpath
.settings/
*.sublime-project
*.sublime-workspace
.history/

# =============================================================================
# OS
# =============================================================================
.DS_Store
.DS_Store?
._*
.Spotlight-V100
.Trashes
Thumbs.db
ehthumbs.db
Desktop.ini
$RECYCLE.BIN/

# =============================================================================
# Docker
# =============================================================================
.docker/

# =============================================================================
# Helm
# =============================================================================
charts/**/charts/
charts/**/*.tgz

# =============================================================================
# Lambda packaging
# =============================================================================
lambdas/**/package/
lambdas/**/*.zip

# =============================================================================
# Terratest
# =============================================================================
tests/**/.test-data/
tests/**/terraform.tfstate.d/

# =============================================================================
# Claude / AI
# =============================================================================
.claude/settings.local.json`,

  '.mcp.json': `{
  "mcpServers": {
    "github-issues": {
      "command": "node",
      "args": ["mock-mcp-servers/github-server.mjs"],
      "env": {
        "GITHUB_TOKEN": "",
        "GITHUB_OWNER": "aws-platform-iac",
        "GITHUB_REPO": "aws-platform-iac",
        "GITHUB_LABELS": "terraform,infrastructure,security,compliance,cost-management,monitoring"
      }
    },
    "confluence": {
      "command": "node",
      "args": ["mock-mcp-servers/jira-server.mjs"],
      "env": {
        "CONFLUENCE_TOKEN": "",
        "CONFLUENCE_BASE_URL": "",
        "CONFLUENCE_SPACE_KEY": "INFRA",
        "DOC_PATHS": "docs/architecture,docs/runbooks,docs/adrs"
      }
    },
    "slack": {
      "command": "node",
      "args": ["mock-mcp-servers/slack-server.mjs"],
      "env": {
        "SLACK_BOT_TOKEN": "",
        "SLACK_CHANNELS": "infra-alerts,platform-engineering,incident-response,deploy-notifications"
      }
    },
    "aws-console": {
      "command": "node",
      "args": ["mock-mcp-servers/aws-server.mjs"],
      "env": {
        "AWS_REGION": "us-east-1",
        "AWS_PROFILE": "",
        "AWS_SERVICES": "ecs,rds,vpc,cloudwatch,iam,s3,ecr,alb,route53,elasticache,eks,lambda"
      }
    },
    "monitoring": {
      "command": "node",
      "args": ["mock-mcp-servers/monitoring-server.mjs"],
      "env": {
        "PROMETHEUS_URL": "",
        "GRAFANA_URL": "",
        "GRAFANA_API_KEY": "",
        "PAGERDUTY_API_KEY": "",
        "CLOUDWATCH_NAMESPACE": "aws-platform-iac",
        "ALERT_CHANNELS": "infra-alerts,incident-response"
      }
    }
  }
}`,

  'CLAUDE.md': `# aws-platform-iac

Production-grade AWS infrastructure platform built with Terraform modules, Go tooling, and Python automation. Provisions VPC networking, ECS orchestration, RDS clusters, and CloudWatch monitoring. SOC 2 and ISO 27001 compliant. Monorepo managed with Turborepo.

## Quick Reference

| Action | Command |
|---|---|
| Format & Validate | \`terraform fmt -recursive && terraform validate\` |
| Lint Terraform | \`tflint --recursive && tfsec .\` |
| Plan (env) | \`cd environments/<env> && terraform plan -out=tfplan\` |
| Apply (env) | \`cd environments/<env> && terraform apply tfplan\` |
| Go Tests | \`go test ./... -v -count=1\` |
| Go Lint | \`golangci-lint run ./...\` |
| Python Lint | \`ruff check scripts/ lambdas/\` |
| Integration Tests | \`cd tests && go test -v -tags=integration -timeout 30m\` |
| Generate Docs | \`terraform-docs markdown table --output-file README.md modules/*\` |

## Key Paths

- **\`modules/\`** — Reusable Terraform modules (vpc, ecs, rds, monitoring, security, iam)
- **\`environments/\`** — Per-environment configs (dev, staging, production)
- **\`scripts/\`** — Go/Python automation scripts
- **\`cmd/\`** — Go CLI tools (provisioner, cost-reporter)
- **\`lambdas/\`** — AWS Lambda functions (Go + Python)
- **\`tests/\`** — Terratest integration tests
- **\`charts/\`** — Helm charts for EKS deployments
- **\`docs/\`** — Architecture decisions, runbooks, ADRs
- **\`playbook/\`** — Development methodology phases

## Rules & Plugins

Detailed rules auto-loaded from **\`.claude/rules/\`** — covering Terraform conventions, security policies, tagging requirements, and PR workflow.

Current methodology phase tracked in **\`playbook/current-phase.json\`**.

Agents, commands, and skills are provided by the CodeForge plugin in **\`plugin/codeforge-aws-platform-iac/\`**. Install the plugin: \`claude plugin install ./plugin/codeforge-aws-platform-iac\` or run \`./install.sh\`.`,

  'README.md': `# aws-platform-iac

[![Terraform](https://img.shields.io/badge/Terraform-%3E%3D1.7-purple?logo=terraform)](https://www.terraform.io/)
[![Go](https://img.shields.io/badge/Go-%3E%3D1.22-00ADD8?logo=go)](https://go.dev/)
[![CI](https://github.com/your-org/aws-platform-iac/actions/workflows/ci.yml/badge.svg)](https://github.com/your-org/aws-platform-iac/actions/workflows/ci.yml)
[![Security Scan](https://github.com/your-org/aws-platform-iac/actions/workflows/security.yml/badge.svg)](https://github.com/your-org/aws-platform-iac/actions/workflows/security.yml)
[![License: MIT](https://img.shields.io/badge/License-MIT-yellow.svg)](LICENSE)

Production-grade AWS infrastructure platform built with reusable Terraform modules for VPC networking, ECS container orchestration, RDS PostgreSQL clusters, ElastiCache Redis, and CloudWatch monitoring. Includes Go CLI tooling for self-service provisioning, cost reporting, and security compliance automation aligned with SOC 2 and ISO 27001 requirements.

## Architecture

\`\`\`mermaid
graph TB
    subgraph "AWS Account"
        subgraph "VPC (modules/vpc)"
            ALB[Application Load Balancer]
            subgraph "Private Subnets"
                ECS[ECS Fargate Cluster]
                EKS[EKS Node Groups]
                RDS[(RDS PostgreSQL)]
                Redis[(ElastiCache Redis)]
            end
            subgraph "Public Subnets"
                NAT[NAT Gateway]
            end
        end
        R53[Route53] --> ALB
        ALB --> ECS & EKS
        CW[CloudWatch Dashboards] --> ECS & RDS & Redis
        IAM[IAM Managed Policies] --> ECS & EKS
        S3[S3 / Terraform State]
    end
    GHA[GitHub Actions CI/CD] --> |terraform apply| S3
\`\`\`

## Quick Start

**Prerequisites:** AWS CLI v2, Terraform ≥ 1.7, Go ≥ 1.22, Python ≥ 3.11, Docker, tflint, tfsec

\`\`\`bash
git clone git@github.com:your-org/aws-platform-iac.git
cd aws-platform-iac
aws sso login --profile your-profile

# Install Go tooling and Python dependencies
go mod download
pip install -r scripts/requirements.txt

# Validate and plan the dev environment
cd environments/dev
terraform init
terraform validate
terraform plan -out=tfplan
\`\`\`

## Project Structure

\`\`\`
├── modules/              # Reusable Terraform modules
│   ├── vpc/              # VPC, subnets, NAT, flow logs
│   ├── ecs/              # ECS Fargate cluster and services
│   ├── rds/              # RDS PostgreSQL with read replicas
│   ├── elasticache/      # Redis cluster configuration
│   ├── monitoring/       # CloudWatch dashboards and alarms
│   ├── security/         # Security groups, WAF, GuardDuty
│   └── iam/              # IAM roles and managed policies
├── environments/         # Per-environment Terraform configs
│   ├── dev/
│   ├── staging/
│   └── production/
├── cmd/                  # Go CLI tools (provisioner, cost-reporter)
├── scripts/              # Automation scripts (Go + Python)
├── lambdas/              # AWS Lambda functions
├── charts/               # Helm charts for EKS workloads
├── tests/                # Terratest integration tests
├── docs/                 # ADRs, runbooks, architecture docs
├── .github/              # Actions workflows, PR templates
├── .claude/              # Claude Code rules and settings
├── plugin/               # CodeForge plugin (agents, commands)
└── playbook/             # Development methodology phases
\`\`\`

## Module Inventory

| Module | Description | Status |
|--------|-------------|--------|
| \`modules/vpc\` | Multi-AZ VPC with public/private subnets, NAT, VPC flow logs | ✅ Stable |
| \`modules/ecs\` | ECS Fargate cluster, task definitions, service auto-scaling | ✅ Stable |
| \`modules/rds\` | RDS PostgreSQL with Multi-AZ, automated backups, read replicas | ✅ Stable |
| \`modules/elasticache\` | Redis cluster with encryption at rest and in transit | ✅ Stable |
| \`modules/monitoring\` | CloudWatch dashboards, metric alarms, SNS notifications | ✅ Stable |
| \`modules/security\` | Security groups, WAF rules, GuardDuty, Config rules | 🔒 Restricted |
| \`modules/iam\` | IAM roles, managed policies, service-linked roles | 🔒 Restricted |

Every module includes \`README.md\`, \`variables.tf\`, \`outputs.tf\`, and \`versions.tf\` generated via \`terraform-docs\`.

## Environments

| Environment | Workspace | Auto Deploy | Approvals | State Backend |
|-------------|-----------|-------------|-----------|---------------|
| \`dev\` | \`dev\` | Manual | 1 | \`s3://tfstate-dev\` |
| \`staging\` | \`staging\` | On merge to \`main\` | 2 | \`s3://tfstate-staging\` |
| \`production\` | \`production\` | Manual gate | 2 + SRE lead | \`s3://tfstate-prod\` |

All AWS resources are tagged with \`project\`, \`environment\`, \`team\`, and \`cost-center\`.

## Development Workflow

\`\`\`
1. Branch    → git checkout -b feat/INFRA-123-add-rds-module
2. Code      → Write HCL, Go, or Python; run terraform fmt && terraform validate
3. Lint      → tflint --recursive && tfsec . && golangci-lint run
4. Test      → cd tests && go test -v -timeout 30m ./...
5. Commit    → git commit -s -m "feat: add RDS module with read replica support"
6. PR        → Open PR, require 2 approvals + passing security scan
7. Merge     → Squash merge to main; staging auto-deploys
8. Release   → Manual promotion to production with SRE lead approval
\`\`\`

Commits must be signed and follow [Conventional Commits](https://www.conventionalcommits.org/). See [docs/CONTRIBUTING.md](docs/CONTRIBUTING.md) for full guidelines.

## Claude Code Integration

\`\`\`bash
# Install the CodeForge plugin
claude plugin install codeforge-aws-platform-iac

# Available commands
claude /plan-module       # Scaffold a new Terraform module with required files
claude /review-security   # Audit HCL for SOC 2 / ISO 27001 compliance gaps
claude /generate-tests    # Create Terratest cases for a module
claude /cost-estimate     # Estimate monthly cost for a terraform plan
claude /draft-runbook     # Generate an operational runbook for a module
\`\`\`

Project rules in \`.claude/\` ensure Claude follows the team's conventions for tagging, naming, provider pinning, and managed-policy-only IAM.

## CI/CD Pipeline

GitHub Actions runs on every push and PR:

1. **Lint** — \`terraform fmt -check\`, \`tflint\`, \`ruff check\`, \`golangci-lint run\`
2. **Validate** — \`terraform validate\` across all environments
3. **Security Scan** — \`tfsec\`, \`checkov\`, SAST for Go and Python
4. **Unit Tests** — \`go test ./...\` (70% coverage threshold)
5. **Plan** — \`terraform plan\` with output posted to PR
6. **Staging Deploy** — Auto-apply on merge to \`main\`
7. **Integration Tests** — Terratest against staging infrastructure
8. **Production Deploy** — Manual approval gate with SRE lead sign-off

AI-generated code is flagged in PRs. CODEOWNERS enforces review by module owners.

## Security & Compliance

This repository enforces controls for **SOC 2 Type II** and **ISO 27001**:

- All IAM access uses managed policies — no inline policies permitted
- VPC flow logs and CloudTrail enabled in all environments
- Encryption at rest and in transit for RDS, ElastiCache, and S3
- \`modules/security/*\` and \`environments/production/*\` require SRE lead approval
- \`*.tfvars\` and \`.env*\` are gitignored; secrets managed via AWS Secrets Manager
- \`tfsec\` and \`checkov\` run on every PR with zero-tolerance for HIGH/CRITICAL findings
- Quarterly access reviews automated via \`cmd/cost-reporter\` audit mode

## Contributing

See [docs/CONTRIBUTING.md](docs/CONTRIBUTING.md) for branch naming, commit conventions, module scaffolding requirements, and the PR review checklist.

## License

This project is licensed under the MIT License. See [LICENSE](LICENSE) for details.`,

  'docs/AI-USAGE-POLICY.md': `# AI Usage Policy — aws-platform-iac

**Effective Date:** 2024-01-01
**Owner:** Platform Lead
**Scope:** All contributors using Claude Code or other AI tools on this repository
**Review Cadence:** Quarterly

---

## Purpose

This policy governs the use of AI coding assistants (primarily Claude Code) for infrastructure-as-code development. AI-generated infrastructure code carries elevated risk — a single misconfigured resource can create security vulnerabilities, compliance violations, or unexpected AWS costs. These guidelines ensure AI augments our work safely.

## Allowed Uses

AI tools **may** be used for the following without additional approval:

- **Module scaffolding** — generating \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, and \`README.md\` boilerplate for new modules
- **Documentation** — writing module READMEs, runbooks in \`docs/\`, ADRs, and inline HCL comments
- **Test generation** — creating Terratest cases in \`tests/\` and unit tests for Go CLI tools in \`cmd/\`
- **Code review assistance** — analyzing Terraform plans, identifying drift, suggesting improvements
- **Debugging** — troubleshooting \`terraform plan\` errors, provider issues, and state problems
- **Script authoring** — writing automation scripts in \`scripts/\` for non-production workflows
- **Helm chart templating** — generating chart boilerplate in \`charts/\`

## Restricted Uses — Human Review Required

AI-generated code for the following **must** receive explicit human review from at least one platform lead before merge:

| Category | Examples | Reviewer |
|---|---|---|
| **IAM changes** | Any file in \`modules/security/*\`, \`modules/iam/*\`, managed policies, role trust relationships | Platform Lead + Security |
| **Network security** | Security group rules, NACLs, VPC peering, Route53 records | Platform Lead |
| **Production environments** | Any change to \`environments/production/*\` | 2 Platform Leads |
| **Cost-impacting resources** | New RDS instances, ECS services, EKS node groups, NAT gateways | Platform Lead + Finance tag review |
| **Secrets and encryption** | KMS keys, Secrets Manager resources, SSM parameters | Platform Lead + Security |
| **Compliance-scoped resources** | CloudTrail, Config rules, GuardDuty, audit logging | Platform Lead |

## Cost Controls

- All PRs with AI-generated Terraform code **must** pass an \`infracost\` check in CI (see \`.github/workflows/\`)
- AI-generated code that introduces new resources estimated at **>$100/month** requires written approval from the platform lead in the PR
- AI tools must use the required resource tagging policy (\`project\`, \`environment\`, \`team\`, \`cost-center\`) on every AWS resource — CI will reject untagged resources

## Security Requirements

- AI tools **must never** generate, store, or access AWS credentials, API keys, or secrets
- All AI-generated IAM policies **must** follow least-privilege principles — no \`*\` actions or \`*\` resources
- Never use inline IAM policies; always reference managed policies per project conventions
- AI-generated code **must** pass \`tfsec\` and \`checkov\` scans before merge — no exceptions
- AI tools must not be given access to \`*.tfvars\`, \`.env*\`, or any file containing secrets

## Compliance — SOC 2 & ISO 27001

- AI-generated code is subject to the same SOC 2 and ISO 27001 controls as human-written code
- All AI-generated changes to audit logging, access controls, or encryption configurations require documented justification in the PR description
- AI-generated code must preserve existing compliance controls — removal or weakening of security resources is prohibited without a signed-off ADR in \`docs/\`

## Labeling and Audit Trail

- **PR label:** Every PR containing AI-generated code must carry the \`ai-generated\` label
- **Commit messages:** Use the \`ai:\` trailer in conventional commits — e.g., \`feat(modules): add rds replica support [ai-assisted]\`
- **Code comments:** Non-trivial AI-generated blocks should include \`// AI-generated — reviewed by <engineer>\` or the HCL equivalent
- **CI flag:** The GitHub Actions pipeline marks AI-generated PRs for additional review gates (see \`ai-code-review\` job)
- **Interaction logs:** Claude Code session context relevant to infrastructure decisions should be summarized in PR descriptions

## Escalation

If you encounter any of the following, escalate immediately to the platform lead via Slack (\`#platform-engineering\`):

- AI-generated code that bypasses security scanning
- AI tool requesting or surfacing AWS credentials
- Unexpected infrastructure changes in \`terraform plan\` output from AI-generated code
- Uncertainty about whether an AI-generated change is safe to apply

**Escalation contact:** Platform Lead → \`@platform-lead\` in Slack

---

_This policy is referenced by \`.claude/rules/\` and enforced by CI checks in \`.github/workflows/\`. Violations are tracked as security incidents per our SOC 2 incident response procedure._`,

  'docs/ARCHITECTURE.md': `# Architecture — aws-platform-iac

## Overview

aws-platform-iac is a production-grade AWS infrastructure platform built with reusable Terraform modules. It provisions and manages VPC networking, ECS container orchestration, RDS database clusters, ElastiCache caching, IAM access control, and CloudWatch/Prometheus monitoring across three environments. The platform enforces SOC 2 and ISO 27001 compliance through automated security controls, resource tagging, and audit logging.

## Module Dependency Graph

\`\`\`
                        ┌──────────┐
                        │   vpc    │
                        └────┬─────┘
               ┌─────────┬──┴───┬──────────┐
               ▼         ▼      ▼          ▼
          ┌────────┐ ┌──────┐ ┌─────┐ ┌──────────┐
          │security│ │ ecs  │ │ rds │ │monitoring│
          └───┬────┘ └──┬───┘ └──┬──┘ └────┬─────┘
              │         │        │          │
              ▼         ▼        ▼          ▼
          ┌──────┐  ┌──────┐ ┌───────┐ ┌────────┐
          │ iam  │  │ alb  │ │ redis │ │grafana │
          └──────┘  └──────┘ └───────┘ └────────┘
\`\`\`

| Module | Path | Depends On | Purpose |
|--------|------|------------|---------|
| \`vpc\` | \`modules/vpc/\` | — | Networking foundation |
| \`security\` | \`modules/security/\` | \`vpc\` | Security groups, WAF, KMS |
| \`iam\` | \`modules/iam/\` | \`security\` | Roles, policies, service accounts |
| \`ecs\` | \`modules/ecs/\` | \`vpc\`, \`security\`, \`iam\` | Fargate clusters, services, ALB |
| \`rds\` | \`modules/rds/\` | \`vpc\`, \`security\` | PostgreSQL multi-AZ clusters |
| \`redis\` | \`modules/redis/\` | \`vpc\`, \`security\` | ElastiCache Redis clusters |
| \`monitoring\` | \`modules/monitoring/\` | \`vpc\`, \`ecs\`, \`rds\` | CloudWatch, Prometheus, alerting |

Every module contains \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`main.tf\`, and \`versions.tf\` with pinned provider versions. Documentation is generated via \`terraform-docs\`.

## Environment Structure

\`\`\`
environments/
├── dev/            # Workspace: dev — single-AZ, smaller instances
│   ├── main.tf
│   ├── terraform.tfvars
│   └── backend.tf
├── staging/        # Workspace: staging — mirrors production topology
│   ├── main.tf
│   ├── terraform.tfvars
│   └── backend.tf
└── production/     # Workspace: production — multi-AZ, full redundancy
    ├── main.tf
    ├── terraform.tfvars   # ⚠ Sensitive path — requires 2 approvals
    └── backend.tf
\`\`\`

Each environment has an isolated state file and Terraform workspace. Variable differences (instance sizes, replica counts, scaling thresholds) are captured in per-environment \`terraform.tfvars\`. Production changes require manual approval in CI/CD.

## State Management

All state is stored in S3 with DynamoDB locking to prevent concurrent modifications:

| Component | Resource |
|-----------|----------|
| State bucket | \`s3://aws-platform-iac-tfstate-{account_id}\` |
| Lock table | \`dynamodb://aws-platform-iac-locks\` |
| Encryption | AES-256 (SSE-S3) + KMS for production |
| Versioning | Enabled — allows state rollback |

State files are separated by environment: \`env:/{environment}/terraform.tfstate\`. Access to state is restricted via IAM policies scoped to the DevOps/SRE team.

## Networking — VPC

The \`modules/vpc/\` module provisions a multi-AZ VPC:

- **CIDR**: \`/16\` block per environment (e.g., \`10.0.0.0/16\` dev, \`10.1.0.0/16\` staging, \`10.2.0.0/16\` production)
- **Public subnets**: One per AZ — ALBs, NAT Gateways, bastion hosts
- **Private subnets**: One per AZ — ECS tasks, RDS instances, ElastiCache nodes
- **NAT Gateways**: Single (dev), redundant per-AZ (staging/production)
- **VPC Endpoints**: S3, ECR, CloudWatch Logs, Secrets Manager — reduces NAT costs and keeps traffic private
- **Flow Logs**: Enabled to CloudWatch Logs for SOC 2 audit trail

## Compute — ECS Fargate

The \`modules/ecs/\` module manages containerized workloads:

- **Cluster**: ECS Fargate (no EC2 instance management)
- **Load Balancing**: ALB with HTTPS listeners, ACM certificates, path-based routing
- **Auto-scaling**: Target tracking on CPU (70%) and memory (80%) utilization
- **Service Discovery**: AWS Cloud Map for internal service-to-service communication
- **Container Registry**: ECR with image scanning enabled and lifecycle policies
- **Deployment**: Rolling updates with circuit breaker; blue/green available for production
- **Logging**: Container logs → CloudWatch Logs → optional export to S3

EKS (via \`charts/\`) is available for workloads requiring Kubernetes-native features. Helm charts are deployed through ArgoCD with GitOps reconciliation.

## Data Layer

### RDS PostgreSQL (\`modules/rds/\`)

- **Engine**: PostgreSQL 15.x, parameter group tuned per environment
- **Topology**: Multi-AZ (staging/production), single instance (dev)
- **Storage**: gp3 with auto-scaling, encrypted at rest via KMS
- **Backups**: Automated daily snapshots, 7-day retention (dev), 35-day (production)
- **Networking**: Private subnets only, security group allows ingress from ECS tasks
- **Credentials**: Stored in AWS Secrets Manager, rotated every 90 days

### ElastiCache Redis (\`modules/redis/\`)

- **Engine**: Redis 7.x, cluster mode enabled in production
- **Topology**: Single node (dev), 2-node replica set (staging), 3-node cluster (production)
- **Encryption**: In-transit (TLS) and at-rest (KMS)
- **Networking**: Private subnets, accessible only from ECS security group

## Monitoring & Observability

The \`modules/monitoring/\` module provisions a layered observability stack:

| Layer | Tool | Purpose |
|-------|------|---------|
| Metrics | CloudWatch Metrics + Prometheus | Infrastructure and application metrics |
| Dashboards | CloudWatch Dashboards + Grafana | Visualization per environment |
| Logs | CloudWatch Logs | Centralized log aggregation |
| Alerting | CloudWatch Alarms → SNS → PagerDuty | Incident notification and escalation |
| Tracing | AWS X-Ray | Distributed request tracing |

Key alarms: RDS CPU > 80%, ECS task failures, ALB 5xx spike, Redis evictions, state file lock contention. PagerDuty integration routes alerts by severity — P1 pages on-call, P3 posts to Slack \`#infra-alerts\`.

## Security & Compliance

Security controls are codified in \`modules/security/\` and \`modules/iam/\` (both sensitive paths requiring 2 approvals):

- **IAM**: Least-privilege roles per service. No inline policies — all managed policies attached to roles. Service-linked roles for ECS, RDS, and monitoring.
- **Security Groups**: Default-deny ingress. Explicit rules scoped to CIDR or security group references. No \`0.0.0.0/0\` ingress except ALB port 443.
- **KMS**: Customer-managed keys for RDS, S3 state bucket, Secrets Manager, and EBS volumes. Key rotation enabled.
- **WAF**: AWS WAF v2 on ALB with OWASP Top 10 managed rule groups and rate limiting.
- **GuardDuty**: Enabled for threat detection across all accounts.
- **Config**: AWS Config rules validate tagging compliance and security group rules.
- **CloudTrail**: Enabled in all regions, logs to S3 with integrity validation.

### Resource Tagging Policy

All AWS resources must include these tags (enforced by \`tfsec\` and AWS Config):

\`\`\`hcl
tags = {
  project      = "aws-platform-iac"
  environment  = var.environment        # dev | staging | production
  team         = "platform-engineering"
  cost-center  = var.cost_center
  managed-by   = "terraform"
  compliance   = "soc2-iso27001"
}
\`\`\`

## CI/CD Pipeline

GitHub Actions workflows in \`.github/workflows/\` implement the deployment pipeline:

\`\`\`
Push to branch
  → terraform fmt -check
  → terraform validate
  → tflint (HCL linting)
  → tfsec + checkov (security scanning)
  → go test ./... (unit tests for Go tooling)
  → terraform plan (posted as PR comment)

Merge to main
  → terraform apply -auto-approve  (staging)
  → Terratest integration tests    (tests/)
  → Manual approval gate           (production)
  → terraform apply                (production)
\`\`\`

AI-generated code is flagged with \`# AI-generated\` comments per team policy. CODEOWNERS enforces that \`modules/security/*\`, \`modules/iam/*\`, and \`environments/production/*\` require lead engineer approval.

## Custom Tooling

| Tool | Path | Language | Purpose |
|------|------|----------|---------|
| Provisioner CLI | \`cmd/provisioner/\` | Go | Self-service environment creation |
| Cost Reporter | \`cmd/cost-reporter/\` | Go | Weekly cost breakdown by tag |
| Drift Detector | \`lambdas/drift-detector/\` | Python | Scheduled Lambda checking for state drift |
| Compliance Checker | \`lambdas/compliance-checker/\` | Go | Validates resource compliance on CloudTrail events |

## Decision Records

Architectural decisions are documented in \`docs/adr/\` using the ADR format. Key decisions:

- **ADR-001**: Fargate over EC2 for compute — reduced operational overhead
- **ADR-002**: S3 + DynamoDB for state — team already on AWS, no Terraform Cloud dependency
- **ADR-003**: Managed policies over inline — auditability for SOC 2
- **ADR-004**: Workspace-per-environment over directory-per-environment — simpler module reuse
- **ADR-005**: Prometheus + Grafana alongside CloudWatch — richer dashboards, portability

See [docs/adr/](./adr/) for the full list.`,

  'docs/CONTRIBUTING.md': `# Contributing to aws-platform-iac

## Getting Started

1. Fork and clone the repository
2. Install prerequisites: Terraform >= 1.6, Go >= 1.21, Python >= 3.11, tflint, tfsec, terraform-docs
3. Create a branch from \`main\` using the naming convention: \`type/TICKET-desc\` (e.g., \`feat/INFRA-42-add-elasticache-module\`)
4. Run \`terraform init\` in the relevant environment or module directory

## Module Development

Every Terraform module under \`modules/\` **must** include:

- \`main.tf\` — resource definitions
- \`variables.tf\` — input variables with descriptions and types
- \`outputs.tf\` — exported values
- \`versions.tf\` — pinned provider versions to **exact patch** (e.g., \`= 5.46.0\`)
- \`README.md\` — auto-generated via \`terraform-docs markdown table . > README.md\`

All AWS resources must include these tags:

\`\`\`hcl
tags = {
  project      = var.project
  environment  = var.environment
  team         = var.team
  cost-center  = var.cost_center
}
\`\`\`

Never use inline IAM policies — always create \`aws_iam_policy\` resources or reference managed policies.

## Testing

- Write [Terratest](https://terratest.gruntwork.io/) tests in \`tests/\` for every new module
- Run tests locally: \`go test ./tests/... -v -timeout 30m\`
- Unit tests must pass before opening a PR; integration tests run in CI against a sandbox account
- Maintain minimum **70% coverage** across Go packages: \`go test -cover ./...\`

## Code Style

Run these before committing:

\`\`\`bash
terraform fmt -recursive
terraform validate
gofmt -w .
golangci-lint run ./...
ruff format scripts/ lambdas/
ruff check scripts/ lambdas/
\`\`\`

## Security

- Run \`tfsec .\` and \`checkov -d .\` locally before pushing — fix all HIGH and CRITICAL findings
- Never commit secrets, \`.tfvars\` with credentials, or \`.env\` files (see \`.gitignore\`)
- Changes to \`modules/security/*\`, \`modules/iam/*\`, or \`environments/production/*\` require security team review per CODEOWNERS
- All work must align with **SOC 2** and **ISO 27001** compliance requirements

## Pull Request Process

1. Use **conventional commits**: \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`refactor:\`
2. Sign all commits (GPG or SSH signature required)
3. Ensure CI passes: lint → validate → tfsec → unit tests → \`terraform plan\`
4. Obtain **2 approvals** minimum; production and security paths require designated reviewers
5. AI-assisted code must be flagged per project policy (see \`CLAUDE.md\`)
6. Squash-merge into \`main\`

## Documentation

- Update \`docs/ARCHITECTURE.md\` for any structural changes (new modules, environment topology, networking changes)
- Record significant decisions in \`docs/adr/\` using the ADR template
- Run \`terraform-docs\` to regenerate module READMEs before committing
- Keep runbooks in \`docs/runbooks/\` current when modifying operational procedures`,

  'docs/ONBOARDING.md': `# Onboarding Guide — aws-platform-iac

Welcome to the AWS Platform IaC project. This guide gets you from zero to your first \`terraform plan\` in under an hour.

## Prerequisites

Install the following before proceeding:

| Tool | Version | Install |
|------|---------|---------|
| Terraform | 1.7+ | \`brew install terraform\` |
| Go | 1.22+ | \`brew install go\` |
| Python | 3.12+ | \`brew install python@3.12\` |
| AWS CLI | v2 | \`brew install awscli\` |
| tflint | latest | \`brew install tflint\` |
| tfsec | latest | \`brew install tfsec\` |
| checkov | latest | \`pip install checkov\` |
| golangci-lint | latest | \`brew install golangci-lint\` |
| terraform-docs | latest | \`brew install terraform-docs\` |
| Docker | latest | Docker Desktop or \`brew install --cask docker\` |

## AWS Account Setup

Configure named profiles for each environment in \`~/.aws/config\`:

\`\`\`ini
[profile aws-platform-dev]
sso_start_url = https://yourorg.awsapps.com/start
sso_region = us-east-1
sso_account_id = 111111111111
sso_role_name = DevOpsEngineer

[profile aws-platform-staging]
sso_start_url = https://yourorg.awsapps.com/start
sso_region = us-east-1
sso_account_id = 222222222222
sso_role_name = DevOpsEngineer
\`\`\`

Production access uses assume-role through staging — you will never have direct credentials. Log in with \`aws sso login --profile aws-platform-dev\` and verify with \`aws sts get-caller-identity --profile aws-platform-dev\`.

## Local Development Setup

\`\`\`bash
git clone git@github.com:yourorg/aws-platform-iac.git
cd aws-platform-iac
./install.sh                    # installs pre-commit hooks (fmt, lint, tfsec, signed commit check)
cd environments/dev
terraform init                  # initializes providers and remote state
terraform plan                  # your first plan — confirm it works
\`\`\`

Run \`go mod download\` from the repo root to pull Go dependencies for CLI tools and Terratest.

## Key Commands

\`\`\`bash
# Terraform
terraform fmt -recursive        # format all HCL files
terraform validate              # syntax and config validation
terraform plan -var-file=dev.tfvars
terraform apply -var-file=dev.tfvars
tflint --recursive              # lint all modules
tfsec .                         # security scan

# Go (CLI tools, Lambda functions, tests)
go test ./...                   # run all unit tests
go test ./tests/ -v -timeout 30m  # Terratest integration tests
go build ./cmd/...              # build CLI tools
golangci-lint run ./...         # lint Go code

# Python (automation scripts, Lambda functions)
ruff check scripts/ lambdas/    # lint Python
ruff format scripts/ lambdas/   # format Python

# Documentation
terraform-docs markdown table modules/vpc > modules/vpc/README.md
\`\`\`

## Project Structure Walkthrough

| Directory | Purpose |
|-----------|---------|
| \`modules/\` | Reusable Terraform modules: \`vpc\`, \`ecs\`, \`rds\`, \`monitoring\`, \`security\`, \`iam\`. Each module has \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`. |
| \`environments/\` | Per-environment root configs (\`dev/\`, \`staging/\`, \`production/\`). Each calls modules with environment-specific \`.tfvars\`. |
| \`cmd/\` | Go CLI tools — \`provisioner\` (self-service env creation), \`cost-reporter\` (daily cost summaries). |
| \`scripts/\` | Automation scripts (Go + Python) for drift detection, secret rotation, backup verification. |
| \`lambdas/\` | AWS Lambda function source code in Go and Python. |
| \`charts/\` | Helm charts for EKS workloads, deployed via ArgoCD. |
| \`tests/\` | Terratest integration tests that spin up real infrastructure and validate it. |
| \`docs/\` | Architecture diagrams, runbooks, ADRs. Start with \`docs/architecture.md\`. |
| \`playbook/\` | Development methodology phases. Current phase tracked in \`playbook/current-phase.json\`. |

## Claude Code Setup

\`\`\`bash
claude plugin install ./plugin/codeforge-aws-platform-iac
\`\`\`

This gives you access to slash commands designed for this project's workflow:

| Command | Purpose |
|---------|---------|
| \`/plan\` | Generate a Terraform execution plan with impact analysis |
| \`/tdd\` | Scaffold Terratest tests before writing module code |
| \`/code-review\` | Run a structured review against team conventions and security policies |
| \`/build-fix\` | Diagnose and fix failing CI pipeline steps |
| \`/verify\` | Validate module structure, tagging compliance, and provider pinning |
| \`/phase\` | Check or advance the current playbook phase |

Read \`.claude/rules/\` for the full set of project-specific rules Claude follows. The \`CLAUDE.md\` file at the repo root is the primary instruction set.

## Team Conventions

- **Branching**: GitHub Flow. Branch from \`main\` as \`type/INFRA-XXX-short-desc\` (e.g., \`feat/INFRA-42-add-redis-module\`).
- **Commits**: Conventional commits with signed commits required (\`git config commit.gpgsign true\`).
- **PRs**: Minimum **2 approvals** before merge. All CI checks must pass (lint, tests, security scan).
- **Production changes**: Require security review from a lead engineer. Changes to \`modules/security/*\`, \`environments/production/*\`, or \`*.tfvars\` trigger CODEOWNERS review automatically.
- **Tagging policy**: Every AWS resource must include \`project\`, \`environment\`, \`team\`, and \`cost-center\` tags. The \`/verify\` command checks this.
- **IAM policy**: Never use inline IAM policies — always use managed policies. This is enforced by tfsec and CI.
- **Compliance**: All infrastructure must satisfy SOC 2 and ISO 27001 controls. See \`docs/compliance-mapping.md\`.

## Useful Resources

- **Internal wiki**: Confluence space — search "AWS Platform IaC"
- **Architecture decisions**: \`docs/adr/\` in this repo
- **Runbooks**: \`docs/runbooks/\` — incident response, rollback procedures, scaling guides
- **Monitoring**: Grafana dashboards at \`https://grafana.internal.yourorg.com\`, PagerDuty for on-call
- **AWS docs**: [Terraform AWS Provider](https://registry.terraform.io/providers/hashicorp/aws/latest/docs), [ECS Best Practices](https://docs.aws.amazon.com/AmazonECS/latest/bestpracticesguide)
- **Slack channels**: \`#infra-platform\` (general), \`#infra-alerts\` (PagerDuty), \`#infra-pr-reviews\` (PR notifications)

## First Week Checklist

- [ ] AWS SSO access confirmed for dev and staging accounts
- [ ] Successful \`terraform plan\` in \`environments/dev\`
- [ ] Git hooks installed and signed commits working
- [ ] Claude Code plugin installed and \`/verify\` runs clean
- [ ] Read \`docs/architecture.md\` and \`docs/adr/\` directory
- [ ] Pair with a senior engineer on a module change
- [ ] Join \`#infra-platform\` and \`#infra-alerts\` Slack channels`,

  'git-hooks/commit-msg': `#!/usr/bin/env bash

commit_msg_file="$1"
commit_msg=$(head -1 "$commit_msg_file")

if echo "$commit_msg" | grep -qE "^Merge "; then
  exit 0
fi

if echo "$commit_msg" | grep -qE "^Revert "; then
  exit 0
fi

allowed_types="feat|fix|chore|docs|refactor|test|ci|build|perf"
pattern="^($allowed_types)(\\([a-z0-9_-]+\\))?: [a-z].*$"

if ! echo "$commit_msg" | grep -qE "$pattern"; then
  echo "ERROR: Invalid commit message format."
  echo ""
  echo "  Got:      $commit_msg"
  echo ""
  echo "  Expected: type(scope): description"
  echo "  Types:    feat, fix, chore, docs, refactor, test, ci, build, perf"
  echo "  Rules:    - scope is optional but must be lowercase"
  echo "            - description must start with lowercase"
  echo "            - first line max 72 characters"
  echo ""
  echo "  Examples: feat(vpc): add nat gateway redundancy"
  echo "            fix: correct rds subnet group assignment"
  echo "            chore(ci): update tfsec to v1.28"
  exit 1
fi

if [ \${#commit_msg} -gt 72 ]; then
  echo "ERROR: Commit message first line exceeds 72 characters (\${#commit_msg})."
  echo "  Shorten: $commit_msg"
  exit 1
fi

exit 0`,

  'git-hooks/pre-commit': `#!/usr/bin/env bash
set -e

STAGED_TF=$(git diff --cached --name-only --diff-filter=ACM | grep '\\.tf$' || true)
STAGED_GO=$(git diff --cached --name-only --diff-filter=ACM | grep '\\.go$' || true)
STAGED_PY=$(git diff --cached --name-only --diff-filter=ACM | grep '\\.py$' || true)
STAGED_ALL=$(git diff --cached --name-only --diff-filter=ACM || true)

if [[ -z "$STAGED_TF" && -z "$STAGED_GO" && -z "$STAGED_PY" ]]; then
  exit 0
fi

FAILED=0

# --- Secrets Detection ---
if [[ -n "$STAGED_ALL" ]]; then
  SECRETS_PATTERN='(AKIA[0-9A-Z]{16}|-----BEGIN (RSA |EC |DSA |OPENSSH )?PRIVATE KEY-----|aws_secret_access_key\\s*=\\s*"[^"]+"|password\\s*=\\s*"[^"]+")'
  for file in $STAGED_ALL; do
    if git diff --cached -- "$file" | grep -qEi "$SECRETS_PATTERN"; then
      echo "❌ [secrets] Potential secret detected in $file"
      FAILED=1
    fi
  done
fi

# --- Terraform Checks ---
if [[ -n "$STAGED_TF" ]]; then
  echo "🔍 Running terraform fmt -check..."
  if ! terraform fmt -check -recursive -diff > /dev/null 2>&1; then
    echo "❌ [terraform fmt] Unformatted Terraform files. Run: terraform fmt -recursive"
    FAILED=1
  fi

  TF_DIRS=$(echo "$STAGED_TF" | xargs -I{} dirname {} | sort -u)
  for dir in $TF_DIRS; do
    if [[ -f "$dir/versions.tf" || -f "$dir/main.tf" ]]; then
      echo "🔍 Running terraform validate in $dir..."
      if ! terraform -chdir="$dir" validate -no-color > /dev/null 2>&1; then
        echo "❌ [terraform validate] Validation failed in $dir"
        FAILED=1
      fi

      echo "🔍 Running tflint in $dir..."
      if ! tflint --chdir="$dir" --no-color 2>/dev/null; then
        echo "❌ [tflint] Linting errors in $dir"
        FAILED=1
      fi
    fi
  done
fi

# --- Go Checks ---
if [[ -n "$STAGED_GO" ]]; then
  echo "🔍 Running gofmt check..."
  UNFORMATTED=$(gofmt -l $STAGED_GO 2>/dev/null || true)
  if [[ -n "$UNFORMATTED" ]]; then
    echo "❌ [gofmt] Unformatted Go files:"
    echo "$UNFORMATTED" | sed 's/^/  /'
    echo "  Run: gofmt -w <file>"
    FAILED=1
  fi

  echo "🔍 Running golangci-lint..."
  GO_DIRS=$(echo "$STAGED_GO" | xargs -I{} dirname {} | sort -u)
  for dir in $GO_DIRS; do
    if ! golangci-lint run "./$dir/..." --new-from-rev=HEAD~1 --timeout=2m 2>/dev/null; then
      echo "❌ [golangci-lint] Lint errors in $dir"
      FAILED=1
    fi
  done
fi

# --- Python Checks ---
if [[ -n "$STAGED_PY" ]]; then
  echo "🔍 Running ruff check..."
  if ! ruff check $STAGED_PY 2>/dev/null; then
    echo "❌ [ruff] Linting errors in Python files. Run: ruff check --fix"
    FAILED=1
  fi
fi

if [[ $FAILED -ne 0 ]]; then
  echo ""
  echo "⛔ Pre-commit checks failed. Fix issues above before committing."
  exit 1
fi

echo "✅ All pre-commit checks passed."
exit 0`,

  'git-hooks/pre-push': `#!/usr/bin/env bash
set -e

REMOTE="$1"
URL="$2"
PASS=0
FAIL=0
ERRORS=""

check() {
  local name="$1"
  shift
  if "$@" >/dev/null 2>&1; then
    echo "  ✓ $name"
    ((PASS++))
  else
    echo "  ✗ $name"
    ERRORS="$ERRORS\\n  - $name"
    ((FAIL++))
  fi
}

echo "▸ aws-platform-iac pre-push checks"
echo ""

# Go unit tests
echo "› Unit tests"
check "go test ./..." go test ./...

# Terraform validate on all modules
echo "› Terraform validation"
for dir in modules/*/; do
  [ -f "$dir/main.tf" ] || continue
  mod=$(basename "$dir")
  check "terraform validate modules/$mod" terraform -chdir="$dir" validate
done

# Security scan
echo "› Security scanning"
check "tfsec ." tfsec . --minimum-severity HIGH --soft-fail

# Sensitive file checks
echo "› Sensitive file checks"
STAGED=$(git diff --name-only --cached HEAD 2>/dev/null || git diff --name-only "@{push}" 2>/dev/null || echo "")
TFVARS_SECRETS=$(echo "$STAGED" | grep -E '\\.tfvars$' | grep -ivE 'example|template|sample' || true)
ENV_FILES=$(echo "$STAGED" | grep -E '\\.env($|\\.)' | grep -v '.env.example' || true)

if [ -n "$TFVARS_SECRETS" ]; then
  echo "  ✗ .tfvars files detected: $TFVARS_SECRETS"
  ERRORS="$ERRORS\\n  - Blocked .tfvars: $TFVARS_SECRETS"
  ((FAIL++))
else
  echo "  ✓ No secret .tfvars files"
  ((PASS++))
fi

if [ -n "$ENV_FILES" ]; then
  echo "  ✗ .env files detected: $ENV_FILES"
  ERRORS="$ERRORS\\n  - Blocked .env: $ENV_FILES"
  ((FAIL++))
else
  echo "  ✓ No .env files"
  ((PASS++))
fi

# Main branch protection
while read -r _ _ REMOTE_REF _; do
  if echo "$REMOTE_REF" | grep -qE 'refs/heads/main$'; then
    echo ""
    echo "⚠ Pushing directly to main. This requires review per SOC 2 policy."
    read -r -p "  Type 'confirm' to proceed: " REPLY < /dev/tty
    if [ "$REPLY" != "confirm" ]; then
      echo "  Push to main aborted."
      exit 1
    fi
  fi
done

# Summary
echo ""
echo "▸ Summary: $PASS passed, $FAIL failed"
if [ "$FAIL" -gt 0 ]; then
  echo -e "  Failures:$ERRORS"
  exit 1
fi
exit 0`,

  'install.sh': `#!/usr/bin/env bash
set -euo pipefail

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
BLUE='\\033[0;34m'
NC='\\033[0m'

log_info()  { echo -e "\${BLUE}[INFO]\${NC}  $*"; }
log_ok()    { echo -e "\${GREEN}[OK]\${NC}    $*"; }
log_warn()  { echo -e "\${YELLOW}[WARN]\${NC}  $*"; }
log_error() { echo -e "\${RED}[ERROR]\${NC} $*"; }

SCRIPT_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
cd "$SCRIPT_DIR"

errors=0

check_tool() {
  local cmd="$1" min_version="\${2:-}" install_hint="\${3:-}"
  if ! command -v "$cmd" &>/dev/null; then
    log_error "$cmd not found. \${install_hint}"
    ((errors++))
    return
  fi
  log_ok "$cmd found: $(command -v "$cmd")"
}

echo -e "\\n\${BLUE}═══ aws-platform-iac bootstrap ═══\${NC}\\n"

log_info "Checking prerequisites..."
check_tool terraform    "" "https://developer.hashicorp.com/terraform/install"
check_tool go           "" "https://go.dev/dl/"
check_tool python3      "" "https://www.python.org/downloads/"
check_tool aws          "" "https://docs.aws.amazon.com/cli/latest/userguide/install-cliv2.html"
check_tool tflint       "" "https://github.com/terraform-linters/tflint"
check_tool tfsec        "" "https://github.com/aquasecurity/tfsec"
check_tool golangci-lint "" "https://golangci-lint.run/welcome/install-local/"
check_tool npm          "" "https://nodejs.org/"

if [[ $errors -gt 0 ]]; then
  log_error "$errors prerequisite(s) missing — install them and re-run."
  exit 1
fi
log_ok "All prerequisites satisfied."

# ── Git hooks ──────────────────────────────────────────────
log_info "Installing git hooks..."
if [[ -d git-hooks ]]; then
  git config core.hooksPath git-hooks
  chmod +x git-hooks/*
  log_ok "Git hooks path set to git-hooks/"
else
  log_warn "git-hooks/ directory not found — skipping."
fi

# ── Terraform init per module ──────────────────────────────
log_info "Initializing Terraform modules..."
module_count=0
for mod_dir in modules/*/; do
  [[ -f "\${mod_dir}versions.tf" ]] || continue
  log_info "  terraform init — \${mod_dir}"
  terraform -chdir="$mod_dir" init -backend=false -input=false -no-color >/dev/null 2>&1
  ((module_count++))
done
log_ok "Initialized $module_count Terraform module(s)."

# ── Mock MCP servers ───────────────────────────────────────
log_info "Installing mock MCP server dependencies..."
if [[ -d mock-mcp-servers && -f mock-mcp-servers/package.json ]]; then
  (cd mock-mcp-servers && npm install --no-audit --no-fund --silent)
  log_ok "Mock MCP server dependencies installed."
else
  log_warn "mock-mcp-servers/ not found — skipping."
fi

# ── CodeForge plugin ──────────────────────────────────────
log_info "Installing CodeForge plugin..."
if [[ -d plugin/codeforge-aws-platform-iac ]]; then
  if command -v claude &>/dev/null; then
    claude plugin install "./plugin/codeforge-aws-platform-iac" 2>/dev/null && \\
      log_ok "CodeForge plugin installed." || \\
      log_warn "Plugin install returned non-zero — verify manually with 'claude plugin list'."
  else
    log_warn "claude CLI not found — skipping plugin install."
  fi
else
  log_warn "Plugin directory not found — skipping."
fi

# ── Phase override symlink ─────────────────────────────────
log_info "Setting active playbook phase to 01-discovery..."
mkdir -p .claude/rules
ln -sf "../../playbook/claude-overrides/01-discovery.claude.md" ".claude/rules/active-phase.md"
log_ok "Symlink created: .claude/rules/active-phase.md → 01-discovery."

# ── Initial git commit ─────────────────────────────────────
if [[ ! -d .git ]]; then
  log_info "Initializing git repository..."
  git init -b main >/dev/null
  git add -A
  git commit --no-verify -m "chore: initial scaffold" >/dev/null
  log_ok "Initial commit created on main."
else
  log_ok "Git repository already initialized."
fi

# ── Summary ────────────────────────────────────────────────
echo ""
echo -e "\${GREEN}═══ Bootstrap complete ═══\${NC}"
echo -e "  Modules initialized : \${module_count}"
echo -e "  Git hooks           : git-hooks/"
echo -e "  Active phase        : 01-discovery"
echo -e ""
echo -e "Next steps:"
echo -e "  1. Configure AWS credentials  : \${YELLOW}aws configure --profile aws-platform-iac\${NC}"
echo -e "  2. Review environment configs  : \${YELLOW}ls environments/\${NC}"
echo -e "  3. Run Terraform validation    : \${YELLOW}terraform validate\${NC}"
echo -e "  4. Run full lint suite         : \${YELLOW}tflint && tfsec .\${NC}"
echo -e "  5. Run Go tests                : \${YELLOW}go test ./...\${NC}"`,

  'mock-mcp-servers/README.md': `# Mock MCP Servers

Local mock MCP servers for developing and testing Claude Code integrations without requiring live API credentials.

## What These Are

Lightweight Node.js servers that simulate MCP tool responses for GitHub Issues and Confluence. They return realistic fixture data matching the \`aws-platform-iac\` project context (Terraform modules, infrastructure tickets, runbook pages).

## Installation

\`\`\`bash
cd mock-mcp-servers
npm install
\`\`\`

## Available Servers

| Server | File | Simulates |
|---|---|---|
| GitHub Issues | \`github-server.mjs\` | Issue search, creation, labeling for INFRA-* tickets |
| Confluence | \`jira-server.mjs\` | Page retrieval for runbooks, ADRs, architecture docs |

## Configuration

These servers are referenced in the project root \`.mcp.json\`. Claude Code discovers them automatically when starting a session.

## Switching to Production

When real API tokens are available, update \`.mcp.json\` to point at the official MCP server packages and configure credentials via environment variables. Remove or ignore this directory once the transition is complete.

\`\`\`jsonc
// .mcp.json — swap "command" entries from node ./mock-mcp-servers/*.mjs
// to the published MCP server packages with proper auth
\`\`\``,

  'mock-mcp-servers/github-server.mjs': `import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";
import { z } from "zod";

const MOCK_ISSUES = [
  {
    number: 142,
    title: "Add RDS read replica for reporting queries",
    state: "open",
    labels: ["infra", "rds", "performance"],
    assignee: "sre-lead",
    body: "Reporting queries are impacting primary DB performance. Add a read replica in us-east-1b and update the monitoring module to track replication lag.",
    milestone: "Q3 Platform Hardening",
  },
  {
    number: 138,
    title: "Fix VPC peering timeout between staging and shared-services",
    state: "open",
    labels: ["infra", "networking", "bug"],
    assignee: "devops-eng-2",
    body: "VPC peering connection pcx-0a1b2c3d times out after 30s. Security group rules in modules/security need review. Blocking staging integration tests.",
    milestone: "Q3 Platform Hardening",
  },
  {
    number: 135,
    title: "Upgrade ECS task definitions to Fargate platform 1.4.0",
    state: "open",
    labels: ["infra", "ecs", "security", "soc2"],
    assignee: "sre-lead",
    body: "Fargate 1.4.0 adds EFS support and uses Firecracker. Required for SOC 2 compliance — ephemeral storage encryption at rest. Update modules/ecs/task_definition.tf.",
    milestone: "SOC 2 Remediation",
  },
  {
    number: 131,
    title: "CloudWatch dashboard missing ALB 5xx alarm",
    state: "open",
    labels: ["monitoring", "bug"],
    assignee: "devops-eng-1",
    body: "Production ALB target group alarms are not wired into the monitoring module. Add alarm to modules/monitoring/alb_alarms.tf with PagerDuty SNS integration.",
    milestone: "Q3 Platform Hardening",
  },
  {
    number: 127,
    title: "Implement cost allocation tags across all modules",
    state: "closed",
    labels: ["cost", "infra", "compliance"],
    assignee: "devops-eng-2",
    body: "All AWS resources must carry project, environment, team, and cost-center tags per tagging policy. Audit modules/* and enforce via tfsec custom rules.",
    milestone: "SOC 2 Remediation",
  },
  {
    number: 124,
    title: "Pin AWS provider to 5.31.0 across all environments",
    state: "open",
    labels: ["infra", "security", "dependency"],
    assignee: "sre-lead",
    body: "Provider 5.32.0 introduced a regression in aws_ecs_service. Pin to 5.31.0 in all versions.tf files until upstream fix lands.",
    milestone: null,
  },
];

let nextIssueNumber = 200;

const server = new McpServer({
  name: "github-issues-mock",
  version: "1.0.0",
});

server.tool(
  "list_issues",
  "List GitHub issues for aws-platform-iac repository",
  {
    state: z.enum(["open", "closed", "all"]).optional().default("open"),
    label: z.string().optional(),
  },
  async ({ state, label }) => {
    let filtered = MOCK_ISSUES;
    if (state !== "all") {
      filtered = filtered.filter((i) => i.state === state);
    }
    if (label) {
      filtered = filtered.filter((i) => i.labels.includes(label));
    }
    const summary = filtered.map(({ number, title, state: s, labels, assignee }) => ({
      number, title, state: s, labels, assignee,
    }));
    return { content: [{ type: "text", text: JSON.stringify(summary, null, 2) }] };
  }
);

server.tool(
  "get_issue",
  "Get details of a specific GitHub issue by number",
  { issue_number: z.number().int().positive() },
  async ({ issue_number }) => {
    const issue = MOCK_ISSUES.find((i) => i.number === issue_number);
    if (!issue) {
      return { content: [{ type: "text", text: \`Issue #\${issue_number} not found in aws-platform-iac.\` }] };
    }
    return { content: [{ type: "text", text: JSON.stringify(issue, null, 2) }] };
  }
);

server.tool(
  "create_issue",
  "Create a new GitHub issue in aws-platform-iac",
  {
    title: z.string().min(1),
    body: z.string().optional().default(""),
    labels: z.array(z.string()).optional().default([]),
  },
  async ({ title, body, labels }) => {
    const created = {
      number: nextIssueNumber++,
      title,
      body,
      labels,
      state: "open",
      assignee: null,
      milestone: null,
      html_url: \`https://github.com/org/aws-platform-iac/issues/\${created?.number ?? nextIssueNumber - 1}\`,
    };
    created.html_url = \`https://github.com/org/aws-platform-iac/issues/\${created.number}\`;
    return {
      content: [{ type: "text", text: \`Created issue #\${created.number}: \${title}\\n\${JSON.stringify(created, null, 2)}\` }],
    };
  }
);

const transport = new StdioServerTransport();
await server.connect(transport);`,

  'mock-mcp-servers/jira-server.mjs': `import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";
import { z } from "zod";

const PAGES = {
  "INFRA-DOC-001": {
    id: "INFRA-DOC-001",
    title: "VPC Network Architecture — Production Design",
    space: "Platform Engineering",
    lastUpdated: "2024-11-15",
    author: "platform-team",
    content: \`# VPC Network Architecture\\n\\n## CIDR Allocation\\n- Production: 10.0.0.0/16\\n- Staging: 10.1.0.0/16\\n- Dev: 10.2.0.0/16\\n\\n## Subnet Strategy\\nEach VPC uses 3 AZs with public, private, and isolated subnets.\\nPrivate subnets host ECS tasks and RDS instances.\\nIsolated subnets have no internet access (compliance: SOC 2 CC6.1).\\n\\n## Transit Gateway\\nAll VPCs peer through AWS Transit Gateway for cross-environment access.\\nSee modules/vpc/README.md for Terraform implementation.\\n\\n## Tags Required\\nAll VPC resources must include: project, environment, team, cost-center.\`,
  },
  "INFRA-DOC-002": {
    id: "INFRA-DOC-002",
    title: "ECS Fargate Deployment Guide",
    space: "Platform Engineering",
    lastUpdated: "2024-12-01",
    author: "sre-lead",
    content: \`# ECS Fargate Deployment Guide\\n\\n## Service Definition\\nAll services deploy via the modules/ecs Terraform module.\\nTask definitions are stored in environments/<env>/ecs.tf.\\n\\n## Container Requirements\\n- Images must come from our private ECR registry\\n- Health check endpoint required at /healthz\\n- Resource limits: CPU and memory must be explicitly set\\n\\n## Blue/Green Deployments\\nProduction uses CodeDeploy blue/green via ALB target group switching.\\nRollback is automatic if CloudWatch alarms fire within 5 minutes.\\n\\n## Scaling Policy\\nTarget tracking on CPU (70%) and custom metric (request count per target).\`,
  },
  "INFRA-DOC-003": {
    id: "INFRA-DOC-003",
    title: "RDS PostgreSQL Backup & Recovery Procedures",
    space: "Platform Engineering",
    lastUpdated: "2024-11-28",
    author: "dba-team",
    content: \`# RDS Backup & Recovery\\n\\n## Automated Backups\\n- Retention: 35 days (production), 7 days (staging/dev)\\n- Backup window: 03:00-04:00 UTC\\n- Multi-AZ enabled for production (ISO 27001 A.17.1)\\n\\n## Manual Snapshots\\nRun: scripts/rds_snapshot.py --env production --cluster main\\nSnapshots are cross-region replicated to us-west-2.\\n\\n## Recovery Procedures\\n1. Point-in-time restore: terraform apply with restore_to_point_in_time block\\n2. Snapshot restore: Update environments/production/rds.tf with snapshot_identifier\\n3. RTO target: 30 minutes, RPO target: 5 minutes\\n\\n## Encryption\\nAll instances use AWS KMS with customer-managed keys (modules/security/kms.tf).\`,
  },
  "INFRA-DOC-004": {
    id: "INFRA-DOC-004",
    title: "IAM Policy Standards & Least Privilege Guide",
    space: "Security",
    lastUpdated: "2024-12-03",
    author: "security-lead",
    content: \`# IAM Policy Standards\\n\\n## Core Principles (SOC 2 CC6.3, ISO 27001 A.9.2)\\n- Never use inline policies; always use managed policies via modules/iam\\n- No wildcard (*) actions in production policies\\n- All roles must have a maximum session duration of 1 hour\\n\\n## Service Roles\\nECS task roles are scoped per-service using modules/iam/ecs_task_role.\\nLambda execution roles use modules/iam/lambda_role with least-privilege.\\n\\n## Human Access\\n- SSO via AWS IAM Identity Center\\n- Break-glass accounts stored in Secrets Manager\\n- All access reviewed quarterly (see compliance/access-review.md)\\n\\n## Policy Validation\\ntfsec and checkov run on every PR to catch overly permissive policies.\`,
  },
  "INFRA-DOC-005": {
    id: "INFRA-DOC-005",
    title: "CloudWatch Monitoring & Alerting Runbook",
    space: "SRE",
    lastUpdated: "2024-11-20",
    author: "sre-team",
    content: \`# Monitoring & Alerting\\n\\n## Dashboard\\nProvisioned via modules/monitoring Terraform module.\\nGrafana dashboards auto-sync from charts/grafana-dashboards/.\\n\\n## Key Alarms\\n- ECS CPU > 80% for 5 min → PagerDuty P2\\n- RDS connections > 80% max → PagerDuty P2\\n- ALB 5xx rate > 1% → PagerDuty P1\\n- Lambda error rate > 5% → Slack #platform-alerts\\n\\n## Log Aggregation\\nAll ECS containers log to CloudWatch Log Groups.\\nRetention: 90 days production, 30 days staging, 7 days dev.\\n\\n## Cost Monitoring\\nRun cmd/cost-reporter for daily spend breakdown by cost-center tag.\`,
  },
};

const server = new McpServer({
  name: "confluence-docs",
  version: "1.0.0",
});

server.tool(
  "search_docs",
  "Search Confluence documentation pages for AWS infrastructure topics",
  { query: z.string().describe("Search query for documentation") },
  async ({ query }) => {
    const queryLower = query.toLowerCase();
    const results = Object.values(PAGES)
      .filter(
        (p) =>
          p.title.toLowerCase().includes(queryLower) ||
          p.content.toLowerCase().includes(queryLower)
      )
      .map(({ id, title, space, lastUpdated, author }) => ({
        id,
        title,
        space,
        lastUpdated,
        author,
      }));

    if (results.length === 0) {
      return { content: [{ type: "text", text: "No documentation pages found matching your query. Try searching for: vpc, ecs, rds, iam, monitoring." }] };
    }
    return { content: [{ type: "text", text: JSON.stringify(results, null, 2) }] };
  }
);

server.tool(
  "get_page",
  "Retrieve full content of a Confluence documentation page by ID",
  { page_id: z.string().describe("Page ID (e.g., INFRA-DOC-001)") },
  async ({ page_id }) => {
    const page = PAGES[page_id];
    if (!page) {
      return { content: [{ type: "text", text: \`Page not found: \${page_id}. Available pages: \${Object.keys(PAGES).join(", ")}\` }] };
    }
    return { content: [{ type: "text", text: \`# \${page.title}\\n\\nSpace: \${page.space} | Updated: \${page.lastUpdated} | Author: \${page.author}\\n\\n---\\n\\n\${page.content}\` }] };
  }
);

const transport = new StdioServerTransport();
await server.connect(transport);`,

  'mock-mcp-servers/package.json': `{
  "name": "aws-platform-iac-mock-servers",
  "version": "1.0.0",
  "private": true,
  "type": "module",
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.0.0"
  }
}`,

  'playbook/PLAYBOOK.md': `# AWS Platform IaC — Development Playbook

This playbook defines a **7-phase methodology** for building the \`aws-platform-iac\` production-grade AWS infrastructure platform. Each phase has concrete deliverables, quality gates, and recommended Claude Code prompts to keep work focused and incremental.

## How to Use

\`\`\`bash
# Check current phase and progress
./playbook/codeforge-phase.sh status

# Advance to the next phase (after gates pass)
./playbook/codeforge-phase.sh next

# In Claude Code, use the plugin command
/phase status
/phase next
\`\`\`

Phase state is tracked in \`playbook/current-phase.json\`. When a phase is active, a behavioral rule is symlinked at \`.claude/rules/active-phase.md\` so Claude Code adjusts its guidance to match the current focus area.

See \`plugin/codeforge-aws-platform-iac/commands/phase.md\` for full command details.

## Phase Overview

| # | Phase | Focus | Key Deliverables | Quality Gate |
|---|-------|-------|-------------------|--------------|
| 1 | **Discovery** | Requirements, threat model, cost targets | ADRs in \`docs/adr/\`, compliance matrix (SOC 2 / ISO 27001), cost budget | Stakeholder sign-off on scope and compliance requirements |
| 2 | **Architecture** | Module design, network topology, IAM strategy | Architecture diagrams, module dependency graph, tagging policy, \`modules/\` skeleton with \`README.md\` + \`variables.tf\` + \`outputs.tf\` + \`versions.tf\` per module | Architecture review approved (≥2 leads) |
| 3 | **Foundation** | VPC, IAM baseline, state backend, CI/CD scaffold | \`modules/vpc/\`, \`modules/iam/\`, S3 + DynamoDB state backend, GitHub Actions lint/plan workflows, provider versions pinned | \`terraform plan\` succeeds for \`environments/dev/\`, tflint + tfsec pass clean |
| 4 | **Core Implementation** | ECS, RDS, ElastiCache, monitoring modules | \`modules/ecs/\`, \`modules/rds/\`, \`modules/monitoring/\`, CloudWatch dashboards, Helm charts in \`charts/\` | All modules have Terratest unit tests (\`tests/\`), coverage ≥ 70% |
| 5 | **Integration & Hardening** | Cross-module wiring, security hardening, cost controls | Full \`environments/staging/\` stack, \`modules/security/\` (GuardDuty, Config Rules), managed IAM policies, cost alerts | \`checkov\` scan passes, staging \`terraform apply\` succeeds end-to-end |
| 6 | **Testing & Quality** | Integration tests, chaos scenarios, runbooks | Terratest integration suite, \`docs/runbooks/\`, disaster recovery validation, \`environments/production/\` plan review | Integration tests green, DR runbook executed in staging, security scan passing |
| 7 | **Launch** | Production deploy, monitoring validation, handoff | Production \`terraform apply\`, Grafana/PagerDuty alerts verified, \`docs/\` complete, CODEOWNERS finalized | Production health checks pass, on-call rotation confirmed, SOC 2 evidence collected |

## Phase Rules

Each phase enforces behavioral constraints via \`.claude/rules/active-phase.md\`:

- **Phases 1–2**: Claude prioritizes documentation, ADRs, and design — discourages premature implementation.
- **Phase 3**: Focus on foundational modules only (\`vpc\`, \`iam\`, state backend). No application-layer resources.
- **Phase 4**: Implementation mode — every module must ship with tests and \`terraform-docs\` output.
- **Phase 5**: No new modules. Focus on wiring, hardening, and \`environments/staging/\` convergence.
- **Phase 6**: No feature work. Tests, runbooks, and quality gates only.
- **Phase 7**: Production changes require explicit approval. All PRs need ≥2 approvals + security scan.

## Recommended Prompts by Phase

| Phase | Example Prompt |
|-------|---------------|
| Discovery | *"Draft an ADR for choosing ECS Fargate over EKS for stateless services"* |
| Architecture | *"Design the module dependency graph for vpc → ecs → rds → monitoring"* |
| Foundation | *"Scaffold the VPC module with public/private subnets across 3 AZs"* |
| Core | *"Implement the RDS module with Multi-AZ PostgreSQL and automated backups"* |
| Hardening | *"Add checkov policies for S3 bucket encryption and IAM policy constraints"* |
| Testing | *"Write a Terratest integration test that provisions and destroys the full staging stack"* |
| Launch | *"Generate the production terraform plan and summarize resource changes"* |

## Related Files

- \`playbook/current-phase.json\` — phase state and gate status
- \`playbook/phases/\` — detailed phase documents (one per phase)
- \`.claude/rules/active-phase.md\` — symlink to current phase rules
- \`plugin/codeforge-aws-platform-iac/commands/phase.md\` — \`/phase\` command definition
- \`docs/adr/\` — architecture decision records (populated in phases 1–2)`,

  'playbook/claude-overrides/01-discovery.claude.md': `# Phase 01: Discovery — Active Rules

You are operating in **Discovery Phase**. Your primary role is to gather requirements, understand constraints, and document findings. No infrastructure code should be written yet.

## Context

This is an AWS platform IaC project targeting SOC 2 and ISO 27001 compliance. The team is small (2-5 SRE engineers, mostly senior/lead). All infrastructure runs on AWS using Terraform modules for VPC, ECS, RDS, CloudWatch, IAM, and EKS.

## DO

- Ask clarifying questions about AWS service requirements before assuming anything
- Probe for networking requirements: CIDR ranges, AZ strategy, VPC peering, Transit Gateway needs
- Clarify database sizing, replication, backup/retention, and failover expectations for RDS and ElastiCache
- Identify all compliance constraints — SOC 2 controls, ISO 27001 Annex A mappings, encryption-at-rest/in-transit requirements
- Document cost constraints and tagging strategy (project, environment, team, cost-center)
- Ask about existing AWS accounts, Organization structure, and SSO/IAM boundaries
- Explore disaster recovery requirements: RPO, RTO, multi-region expectations
- Capture environment topology: how many environments, workspace strategy, promotion flow
- Identify integration points: CI/CD pipelines, monitoring (Prometheus/Grafana/CloudWatch/PagerDuty), DNS (Route53)
- Document findings in \`docs/adr/\` as lightweight decision records
- Ask about developer self-service requirements and guardrails
- Clarify EKS vs ECS workload split and container orchestration preferences
- Record open questions in GitHub Issues with the \`discovery\` label
- Reference \`docs/\` for existing architecture docs and runbooks before asking redundant questions

## DON'T

- Write any Terraform HCL, Go code, Python scripts, or Helm charts
- Create or modify files under \`modules/\`, \`environments/\`, \`cmd/\`, \`lambdas/\`, or \`charts/\`
- Make architectural decisions — only surface options with trade-offs for the team to decide
- Assume CIDR ranges, instance sizes, or provider versions without confirmation
- Skip compliance questions — every AWS resource decision has SOC 2/ISO 27001 implications
- Propose solutions before fully understanding the problem space
- Generate \`terraform plan\` or \`terraform apply\` commands
- Create PR branches — discovery outputs are docs and issues only

## Outputs Expected

- Architecture Decision Records in \`docs/adr/\`
- Requirements documents in \`docs/requirements/\`
- GitHub Issues for open questions and decisions needed
- Stakeholder notes summarizing conversations

## Phase Transition

Move to **Phase 02: Architecture** only when:
1. All AWS service requirements are documented
2. Compliance controls are mapped to infrastructure components
3. Environment strategy is agreed upon
4. Cost and tagging policies are confirmed
5. The team has reviewed and approved discovery outputs`,

  'playbook/claude-overrides/02-architecture.claude.md': `# Phase 02: Architecture — Active Rules

> **Phase**: Architecture & Design
> **Goal**: Define module boundaries, AWS service selections, network topology, and security architecture before writing any Terraform code.

## DO

- Create Architecture Decision Records (ADRs) in \`docs/adr/\` for every significant choice (VPC CIDR strategy, ECS vs EKS, RDS engine version, multi-AZ topology)
- Define Terraform module interfaces first: write \`variables.tf\`, \`outputs.tf\`, and \`README.md\` for each module in \`modules/\` before any \`main.tf\`
- Evaluate AWS service options with cost estimates, compliance impact (SOC 2, ISO 27001), and operational complexity
- Design the VPC network topology: CIDR ranges, subnet tiers (public, private, data), AZ distribution, peering, and transit gateway needs
- Map out IAM roles and managed policies using least-privilege principles — document in \`modules/security/\`
- Define the tagging strategy (project, environment, team, cost-center) and enforce it as a module contract
- Specify provider version pins and Terraform state backend configuration per environment
- Document environment promotion flow: dev → staging → production workspace strategy
- Create dependency diagrams showing module composition (e.g., \`ecs\` depends on \`vpc\`, \`rds\` depends on \`vpc\` + \`security\`)
- Review architecture with at least 2 team members before moving to Phase 03
- Define monitoring and alerting boundaries: what CloudWatch alarms, Prometheus metrics, and Grafana dashboards each module exposes
- Establish blast radius boundaries — which modules can be planned/applied independently

## DON'T

- Write \`resource\` or \`data\` blocks in Terraform — interface definitions only (variables, outputs, type signatures)
- Run \`terraform apply\` or \`terraform plan\` against any real AWS account
- Skip writing an ADR because a decision feels obvious — document it anyway
- Use inline IAM policies in any design — always reference managed policies
- Design modules with circular dependencies
- Hardcode CIDR ranges, account IDs, or region names — parameterize everything
- Combine unrelated concerns in a single module (e.g., networking + database in one module)
- Exceed 250 lines in any single design document — split into focused files
- Make production environment architecture decisions without security review
- Choose services outside the approved dependency list without team consensus

## Key Artifacts This Phase Produces

- \`docs/adr/\` — numbered decision records (e.g., \`0001-vpc-topology.md\`)
- \`docs/architecture.md\` — high-level system diagram and module map
- \`modules/*/variables.tf\` + \`modules/*/outputs.tf\` + \`modules/*/README.md\` — interface contracts
- \`docs/tagging-strategy.md\` — required AWS resource tags
- \`docs/iam-design.md\` — role and policy mapping

## Phase Exit Criteria

- [ ] All module interfaces reviewed and approved (PR with 2 approvals)
- [ ] ADRs written for VPC, compute, database, monitoring, and IAM decisions
- [ ] No unresolved security or compliance questions for SOC 2 / ISO 27001
- [ ] Environment promotion strategy documented and agreed upon`,

  'playbook/claude-overrides/03-foundation.claude.md': `# Phase 03: Foundation — Active Rules

> Auto-loaded via \`.claude/rules/active-phase.md\` symlink. These rules govern all Claude Code behavior during Phase 03.

## Current Objective

Scaffold the project structure, configure Terraform state backend, establish CI/CD pipelines, and create foundational modules (VPC, IAM baseline).

## DO

- Create all top-level directories per the project layout: \`modules/\`, \`environments/\`, \`scripts/\`, \`cmd/\`, \`lambdas/\`, \`charts/\`, \`tests/\`, \`docs/\`, \`.github/\`
- Set up the S3 + DynamoDB state backend with encryption and versioning enabled
- Create the base \`modules/vpc/\` module with \`main.tf\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, and \`README.md\`
- Create the base \`modules/iam/\` module with managed policies only — no inline policies
- Pin all provider versions to exact patch (e.g., \`= 5.46.0\`, not \`~> 5.46\`)
- Configure GitHub Actions workflows for lint (\`terraform fmt -check\`, \`tflint\`, \`tfsec\`), validate (\`terraform validate\`), and plan stages
- Add CODEOWNERS file mapping \`modules/security/*\` and \`environments/production/*\` to lead engineers
- Include required tags (\`project\`, \`environment\`, \`team\`, \`cost-center\`) in a shared \`locals\` block or variable definition
- Write Terratest scaffolding in \`tests/\` with at least one smoke test for the VPC module
- Run \`terraform fmt\`, \`terraform validate\`, and \`tflint\` on every module before committing
- Use conventional commits: \`feat: scaffold vpc module\`, \`chore: configure state backend\`
- Tag this phase's completion with \`v0.3.0-foundation\`

## DON'T

- Do NOT implement ECS, RDS, monitoring, or other complex modules — those are Phase 04+
- Do NOT deploy anything to production or create \`environments/production/\` tfvars
- Do NOT skip testing the CI pipeline — verify lint, validate, and plan stages run green
- Do NOT use \`terraform apply\` against any real environment yet — plan only
- Do NOT create IAM users or static credentials; use roles and OIDC for GitHub Actions
- Do NOT hardcode AWS account IDs, regions, or secrets — use variables and SSM/Secrets Manager references
- Do NOT merge to \`main\` without 2 approvals and passing security scan (\`tfsec\`, \`checkov\`)
- Do NOT skip \`README.md\` or \`versions.tf\` in any module — every module must be self-documenting

## Completion Criteria

- [ ] State backend (S3 + DynamoDB) provisioned and tested with \`terraform init\`
- [ ] \`modules/vpc/\` passes \`terraform validate\`, \`tflint\`, and \`tfsec\` with zero errors
- [ ] \`modules/iam/\` baseline roles created with managed policies, SOC 2 least-privilege principle applied
- [ ] GitHub Actions pipeline runs lint → validate → plan successfully on a PR
- [ ] Terratest smoke test for VPC executes in CI
- [ ] All files follow snake_case naming, max 250 lines, and include required documentation`,

  'playbook/claude-overrides/04-core-implementation.claude.md': `# Phase 04: Core Implementation — Active Rules

> **Auto-loaded via \`.claude/rules/active-phase.md\` symlink.**
> These rules govern Claude Code behavior during core module development.

## Context

We are building the primary Terraform modules under \`modules/\` and their corresponding Terratest suites under \`tests/\`. Every module must be production-grade, compliant with SOC 2 / ISO 27001, and follow the conventions defined in \`CLAUDE.md\`.

## DO

- Build core modules in this priority order: \`modules/vpc\`, \`modules/ecs\`, \`modules/rds\`, \`modules/elasticache\`, \`modules/alb\`, \`modules/monitoring\`
- Include \`README.md\`, \`main.tf\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\` in every module
- Pin provider versions to exact patch (e.g., \`= 5.46.0\`), never use \`~>\` or \`>=\`
- Write a Terratest suite in \`tests/<module>_test.go\` for each module before marking it complete
- Tag every AWS resource with \`project\`, \`environment\`, \`team\`, and \`cost-center\` using a shared \`local.common_tags\` map
- Use managed IAM policies exclusively — create them in \`modules/iam/\`
- Validate every module with \`terraform fmt -check\`, \`terraform validate\`, \`tflint\`, and \`tfsec\` before committing
- Generate module docs with \`terraform-docs markdown . > README.md\`
- Keep each \`.tf\` file under 250 lines — split into \`main.tf\`, \`networking.tf\`, \`security.tf\`, etc.
- Use \`snake_case\` for all resource names, variable names, and file names
- Use Terraform workspaces or variable-driven environment separation — never duplicate modules per environment
- Reference \`environments/<env>/terraform.tfvars\` for environment-specific values
- Run \`go test ./tests/... -v -timeout 30m\` to validate Terratest suites
- Use \`SCREAMING_SNAKE_CASE\` for Go constants, \`camelCase\` for Go variables
- Commit with conventional commits: \`feat(modules/ecs): add service autoscaling\`
- Flag AI-generated code with \`# Generated by Claude Code\` header comment

## DON'T

- Do NOT deploy to \`environments/production/\` — staging only during this phase
- Do NOT use inline IAM policies or \`aws_iam_role_policy\` — use \`aws_iam_policy\` + \`aws_iam_role_policy_attachment\`
- Do NOT hardcode AWS account IDs, ARNs, region, or CIDR blocks — expose as variables
- Do NOT skip writing Terratest for a module — no untested modules merge to \`main\`
- Do NOT store secrets in \`.tfvars\` or state files — use AWS Secrets Manager or SSM Parameter Store references
- Do NOT create resources without \`description\` on variables and \`description\` tags on security groups
- Do NOT use \`default = ""\` as a way to make required variables optional — omit the default
- Do NOT modify \`modules/security/*\` without explicit lead approval (sensitive path per CODEOWNERS)
- Do NOT introduce new provider dependencies without team review
- Do NOT write monolithic test functions — one test function per module behavior

## Quality Gates Before Phase Exit

1. All six core modules pass \`terraform validate\` and \`tfsec\` with zero high/critical findings
2. Terratest coverage exists for every module with \`go test\` passing
3. \`terraform-docs\` output is current in each module \`README.md\`
4. At least one successful \`terraform plan\` against \`environments/staging/\`
5. PR approved by 2 reviewers with security scan passing`,

  'playbook/claude-overrides/05-integration-hardening.claude.md': `# Phase 05: Integration & Hardening — Active Rules

This phase wires all Terraform modules together into complete environment stacks, adds defense-in-depth security controls, implements end-to-end observability, and validates SOC 2 / ISO 27001 compliance posture.

## DO

- Wire VPC, ECS, RDS, and monitoring modules together in \`environments/\` root configs
- Add AWS WAF rules to ALB and CloudFront distributions
- Enable GuardDuty, SecurityHub, and Config Rules across all accounts
- Configure VPC Flow Logs to S3 with 90-day retention minimum
- Implement CloudTrail with log file validation and multi-region coverage
- Add KMS encryption for all data-at-rest (RDS, S3, EBS, ElastiCache)
- Enforce TLS 1.2+ for all data-in-transit with ACM certificates
- Wire CloudWatch alarms to SNS topics routed to PagerDuty
- Validate all resources carry required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
- Run \`checkov\` and \`tfsec\` against the full composed environment configs
- Write Terratest integration tests in \`tests/\` covering cross-module dependencies
- Run \`terraform plan\` against staging and diff against expected resource counts
- Validate IAM policies with Access Analyzer — no wildcard actions on production resources
- Add S3 bucket policies enforcing \`aws:SecureTransport\` condition
- Configure RDS automated backups, deletion protection, and IAM authentication
- Enable ECS exec logging and container insights for audit trails
- Document all security controls in \`docs/security-controls.md\`
- Run full integration suite: \`cd tests && go test -v -tags=integration -timeout 30m ./...\`
- Verify \`terraform validate\` and \`terraform fmt -check\` pass on all environments

## DON'T

- Add new Terraform modules or features — only integrate and harden existing ones
- Use inline IAM policies — always reference managed policies in \`modules/iam/\`
- Skip security scan gates — every PR must pass \`tfsec\` and \`checkov\` before merge
- Deploy to production without successful staging integration tests
- Leave security group rules with \`0.0.0.0/0\` ingress on non-ALB resources
- Hard-code secrets or credentials — use SSM Parameter Store or Secrets Manager references
- Disable default encryption on any new S3 buckets or EBS volumes
- Merge without 2 approvals on any change touching \`modules/security/*\` or \`environments/production/*\`
- Ignore Cost Explorer alerts — validate cost tags propagate to billing reports
- Skip updating \`docs/\` and runbooks for newly wired integrations

## Phase Exit Criteria

- All environment stacks (\`dev\`, \`staging\`, \`production\`) compose cleanly with \`terraform plan\`
- Zero critical/high findings from \`tfsec\`, \`checkov\`, and SecurityHub
- Terratest integration suite passes with ≥70% coverage of cross-module wiring
- SOC 2 control mapping documented and reviewed by team lead
- PagerDuty alerting validated end-to-end from CloudWatch through SNS`,

  'playbook/claude-overrides/06-testing-quality.claude.md': `# Phase 06: Testing & Quality — Active Rules

> **Auto-loaded via \`.claude/rules/active-phase.md\` symlink.**
> All behavioral rules below are active for the duration of this phase.

## Context

Phase 06 focuses on comprehensive validation of all Terraform modules, Go tooling, Python lambdas, and infrastructure security posture. Every module, environment, and deployment path must be tested and pass security/compliance gates before promotion to production.

## DO

- Run \`terraform validate\` and \`terraform fmt -check\` on every module and environment configuration before any other testing
- Run \`tflint\` with the AWS ruleset enabled on all \`.tf\` files under \`modules/\` and \`environments/\`
- Run \`tfsec\` and \`checkov\` against all modules; treat HIGH and CRITICAL findings as blocking
- Execute Terratest integration tests in \`tests/\` using \`go test -v -timeout 30m ./tests/...\`
- Run \`golangci-lint run ./...\` on all Go code under \`cmd/\`, \`lambdas/\`, \`scripts/\`, and \`tests/\`
- Run \`ruff check\` and \`ruff format --check\` on all Python code under \`lambdas/\` and \`scripts/\`
- Validate unit test coverage meets the 70% threshold for Go (\`go test -coverprofile\`) and Python (\`pytest --cov\`)
- Run \`infracost breakdown\` and \`infracost diff\` on each environment to catch cost regressions
- Verify all Terraform modules contain \`README.md\`, \`variables.tf\`, \`outputs.tf\`, and \`versions.tf\`
- Run \`terraform-docs\` and confirm generated output matches committed documentation
- Validate that all provider versions are pinned to exact patch versions (no \`~>\` or \`>=\`)
- Confirm every AWS resource includes required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
- Verify no inline IAM policies exist; all policies must be managed policies
- Check \`modules/security/*\` and \`environments/production/*\` changes have at least 2 approvals in PR
- Run \`terraform plan\` against \`environments/dev\` and \`environments/staging\` to confirm no unexpected drift
- Validate SOC 2 and ISO 27001 compliance controls: encryption at rest, encryption in transit, logging enabled, least-privilege IAM
- Ensure all test files follow conventional naming: \`*_test.go\` for Go, \`test_*.py\` for Python
- Use \`go test -race ./...\` to detect race conditions in Go tooling and Lambda functions
- Document any accepted risks or deferred findings in \`docs/adr/\` with a clear rationale and remediation timeline
- Mark all AI-generated test code with the \`// Generated by Claude Code\` or \`# Generated by Claude Code\` comment

## DON'T

- Add new features, modules, or infrastructure resources during this phase
- Skip any test category (unit, integration, security scan, cost estimation, compliance)
- Ignore or suppress tfsec/checkov findings without a documented exception in \`docs/adr/\`
- Merge code with failing \`terraform validate\`, \`tflint\`, or \`tfsec\` checks
- Run \`terraform apply\` against \`environments/production\` during testing — plan only
- Modify \`*.tfvars\` or \`.env*\` files without security review
- Reduce test coverage below the 70% threshold to unblock a merge
- Use \`-target\` in Terraform plans to hide failures in untested resources
- Commit secrets, credentials, or AWS account IDs in test fixtures — use environment variables or SSM parameter references
- Bypass CODEOWNERS review requirements on sensitive paths (\`modules/security/*\`, \`environments/production/*\`)
- Treat cost estimation as optional — \`infracost diff\` regressions must be explained in the PR description`,

  'playbook/claude-overrides/07-launch.claude.md': `# Phase 07: Launch — Active Rules

You are operating in **Phase 07: Launch** of the aws-platform-iac project. All actions must prioritize production stability, observability, and rollback safety.

## DO

- Run the full go-live checklist in \`docs/runbooks/go-live-checklist.md\` before any production \`terraform apply\`
- Require manual approval gates for all \`environments/production/\` deployments via GitHub Actions
- Verify every AWS resource carries required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
- Confirm rollback plan exists and is documented before each production change
- Set up CloudWatch alarms, Prometheus alerts, and PagerDuty escalation policies for all critical paths
- Create or update runbooks in \`docs/runbooks/\` for every new production component
- Validate SLA targets: RDS multi-AZ failover < 60s, ECS service recovery < 120s, ALB health check intervals correct
- Run \`tfsec\` and \`checkov\` scans against \`environments/production/\` with zero high-severity findings
- Pin all provider versions to exact patch in \`versions.tf\` — no ranges in production
- Use \`terraform plan -out=tfplan\` and apply only from saved plans in production
- Verify DNS cutover and Route53 health checks before shifting traffic
- Confirm backup and disaster recovery procedures are tested: RDS snapshots, S3 versioning, ECS task definitions archived
- Tag all commits to \`main\` for production releases with semver (e.g., \`v1.0.0\`)
- Ensure SOC 2 and ISO 27001 evidence artifacts are captured: access logs, change records, approval trails
- Monitor cost dashboards via \`cmd/cost-reporter\` after launch to catch billing anomalies early

## DON'T

- Do not make untested changes to \`modules/security/*\`, \`modules/iam/*\`, or \`environments/production/*\` during launch
- Do not skip the go-live checklist — every item must be explicitly checked off
- Do not deploy without a tested rollback plan including \`terraform plan -destroy\` dry runs
- Do not use \`terraform apply -auto-approve\` in production — ever
- Do not modify \`*.tfvars\` or \`.env*\` files without peer review and at least 2 approvals
- Do not bypass GitHub Actions CI stages — all stages (lint, security scan, integration tests) must pass
- Do not introduce new Terraform modules or provider upgrades during launch week
- Do not hardcode secrets — all sensitive values must come from AWS Secrets Manager or SSM Parameter Store
- Do not remove or weaken CloudWatch alarms or PagerDuty routes post-launch
- Do not merge PRs without signed commits and CODEOWNERS approval

## Context References

- Go-live checklist: \`docs/runbooks/go-live-checklist.md\`
- Production environment: \`environments/production/\`
- Monitoring modules: \`modules/monitoring/\`
- Security modules: \`modules/security/\`
- CI/CD workflows: \`.github/workflows/\`
- Cost reporting: \`cmd/cost-reporter/\``,

  'playbook/codeforge-phase.sh': `#!/usr/bin/env bash
set -euo pipefail

PLAYBOOK_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
PROJECT_ROOT="$(dirname "$PLAYBOOK_DIR")"
STATE_FILE="$PLAYBOOK_DIR/current-phase.json"
SYMLINK_PATH="$PROJECT_ROOT/.claude/rules/active-phase.md"
OVERRIDES_DIR="$PLAYBOOK_DIR/claude-overrides"

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
BLUE='\\033[0;34m'
CYAN='\\033[0;36m'
BOLD='\\033[1m'
NC='\\033[0m'

PHASE_IDS=("discovery" "architecture" "foundation" "core-implementation" "integration-hardening" "testing-quality" "launch")
PHASE_NAMES=("Discovery & Requirements" "Architecture & Design" "Foundation & Scaffolding" "Core Implementation" "Integration & Hardening" "Testing & Quality" "Launch & Handoff")
PHASE_FILES=("01-discovery.claude.md" "02-architecture.claude.md" "03-foundation.claude.md" "04-core-implementation.claude.md" "05-integration-hardening.claude.md" "06-testing-quality.claude.md" "07-launch.claude.md")
PHASE_GATES=(
  "requirements.md exists in docs/;ADR-001 drafted in docs/adr/"
  "modules/ directory structure defined;docs/architecture.md exists"
  "terraform fmt passes;tflint passes on modules/"
  "terraform validate passes on all modules;unit tests exist in tests/"
  "tfsec scan clean;integration tests pass via terratest"
  "coverage >= 70%;checkov scan passes;terraform-docs up to date"
  "environments/production/ plan succeeds;runbooks exist in docs/runbooks/"
)

init_state() {
  if [[ ! -f "$STATE_FILE" ]]; then
    cat > "$STATE_FILE" <<EOF
{"phase_index": 0, "phase_id": "discovery", "paused": false, "started_at": "$(date -u +%Y-%m-%dT%H:%M:%SZ)", "history": []}
EOF
  fi
}

read_state() { python3 -c "import json,sys; d=json.load(open('$STATE_FILE')); print(d.get('$1',''))" 2>/dev/null; }
write_state() { python3 -c "
import json,sys
d=json.load(open('$STATE_FILE'))
d['$1']=$2
d.setdefault('history',[]).append({'action':'$1=$2','at':'$(date -u +%Y-%m-%dT%H:%M:%SZ)'})
json.dump(d,open('$STATE_FILE','w'),indent=2)
"; }

update_symlink() {
  local idx=$1
  mkdir -p "$(dirname "$SYMLINK_PATH")"
  local target="$OVERRIDES_DIR/\${PHASE_FILES[$idx]}"
  if [[ -f "$target" ]]; then
    ln -sf "$target" "$SYMLINK_PATH"
    echo -e "\${GREEN}✓\${NC} Symlink active-phase.md → \${PHASE_FILES[$idx]}"
  else
    echo -e "\${YELLOW}⚠\${NC} Override file not found: \${PHASE_FILES[$idx]} — symlink skipped"
    rm -f "$SYMLINK_PATH"
  fi
}

remove_symlink() { rm -f "$SYMLINK_PATH"; }

show_status() {
  init_state
  local idx; idx=$(read_state phase_index)
  local paused; paused=$(read_state paused)
  local started; started=$(read_state started_at)
  echo -e "\\n\${BOLD}\${CYAN}═══ CodeForge Phase Status ═══\${NC}\\n"
  for i in "\${!PHASE_IDS[@]}"; do
    local marker="  "
    [[ $i -lt $idx ]] && marker="\${GREEN}✓\${NC} "
    [[ $i -eq $idx ]] && marker="\${YELLOW}▶\${NC} "
    echo -e "  \${marker}\${BOLD}$((i+1)).\${NC} \${PHASE_NAMES[$i]} \${DIM:=}(\${PHASE_IDS[$i]})\${NC}"
  done
  echo ""
  echo -e "  \${BOLD}Current:\${NC}  \${PHASE_NAMES[$idx]} (phase $((idx+1))/\${#PHASE_IDS[@]})"
  echo -e "  \${BOLD}Started:\${NC}  $started"
  [[ "$paused" == "True" ]] && echo -e "  \${BOLD}Status:\${NC}   \${RED}PAUSED\${NC}" || echo -e "  \${BOLD}Status:\${NC}   \${GREEN}ACTIVE\${NC}"
  echo -e "\\n  \${BOLD}Quality Gates:\${NC}"
  IFS=';' read -ra gates <<< "\${PHASE_GATES[$idx]}"
  for gate in "\${gates[@]}"; do
    echo -e "    \${BLUE}○\${NC} $gate"
  done
  echo ""
}

cmd_advance() {
  init_state
  local idx; idx=$(read_state phase_index)
  if [[ $idx -ge $((\${#PHASE_IDS[@]} - 1)) ]]; then
    echo -e "\${RED}✗\${NC} Already at final phase: \${PHASE_NAMES[$idx]}"; exit 1
  fi
  echo -e "\${YELLOW}Quality gates for \${PHASE_NAMES[$idx]}:\${NC}"
  IFS=';' read -ra gates <<< "\${PHASE_GATES[$idx]}"
  for gate in "\${gates[@]}"; do echo -e "  \${BLUE}○\${NC} $gate"; done
  read -rp $'\\nConfirm gates met and advance? [y/N] ' confirm
  [[ "$confirm" =~ ^[Yy]$ ]] || { echo "Aborted."; exit 0; }
  local next=$((idx + 1))
  write_state "phase_index" "$next"
  write_state "phase_id" "\\"\${PHASE_IDS[$next]}\\""
  update_symlink "$next"
  echo -e "\${GREEN}✓\${NC} Advanced to phase $((next+1)): \${BOLD}\${PHASE_NAMES[$next]}\${NC}"
}

cmd_set() {
  local n=$1
  if [[ $n -lt 1 || $n -gt \${#PHASE_IDS[@]} ]]; then
    echo -e "\${RED}✗\${NC} Phase must be between 1 and \${#PHASE_IDS[@]}"; exit 1
  fi
  local idx=$((n - 1))
  init_state
  write_state "phase_index" "$idx"
  write_state "phase_id" "\\"\${PHASE_IDS[$idx]}\\""
  write_state "paused" "false"
  update_symlink "$idx"
  echo -e "\${GREEN}✓\${NC} Set to phase $n: \${BOLD}\${PHASE_NAMES[$idx]}\${NC}"
}

cmd_pause() {
  init_state
  write_state "paused" "true"
  remove_symlink
  echo -e "\${YELLOW}⏸\${NC}  Phase tracking paused — active-phase.md symlink removed"
}

cmd_resume() {
  init_state
  local idx; idx=$(read_state phase_index)
  write_state "paused" "false"
  update_symlink "$idx"
  echo -e "\${GREEN}▶\${NC}  Phase tracking resumed at: \${BOLD}\${PHASE_NAMES[$idx]}\${NC}"
}

case "\${1:-help}" in
  status)  show_status ;;
  advance) cmd_advance ;;
  set)     cmd_set "\${2:?Usage: $0 set N}" ;;
  pause)   cmd_pause ;;
  resume)  cmd_resume ;;
  *)       echo -e "Usage: \${BOLD}$0\${NC} {status|advance|set N|pause|resume}" ;;
esac`,

  'playbook/current-phase.json': `{
  "currentPhase": 1,
  "phaseName": "discovery",
  "startedAt": "2025-01-15T00:00:00Z",
  "estimatedCompletion": "2025-01-29T00:00:00Z",
  "project": {
    "name": "aws-platform-iac",
    "repository": "aws-platform-iac",
    "industry": "Technology / SaaS",
    "compliance": ["SOC 2", "ISO 27001"]
  },
  "team": {
    "size": "small",
    "engineers": "2-5 DevOps/SRE",
    "timezone": "Americas"
  },
  "deliverables": {
    "architecture_decision_records": {
      "status": "in_progress",
      "path": "docs/adr/",
      "items": [
        "ADR-001: Terraform module structure and versioning strategy",
        "ADR-002: VPC network topology and CIDR allocation",
        "ADR-003: ECS vs EKS container orchestration selection",
        "ADR-004: RDS PostgreSQL cluster configuration and failover",
        "ADR-005: IAM role and policy management approach",
        "ADR-006: Environment isolation strategy using workspaces"
      ]
    },
    "aws_account_structure": {
      "status": "not_started",
      "path": "docs/architecture/aws-account-structure.md",
      "description": "Multi-account strategy for dev, staging, production"
    },
    "tagging_policy": {
      "status": "not_started",
      "path": "docs/standards/tagging-policy.md",
      "required_tags": ["project", "environment", "team", "cost-center"]
    },
    "module_inventory": {
      "status": "in_progress",
      "path": "docs/architecture/module-inventory.md",
      "modules": [
        "modules/vpc",
        "modules/ecs",
        "modules/rds",
        "modules/monitoring",
        "modules/security",
        "modules/iam"
      ]
    },
    "compliance_requirements": {
      "status": "not_started",
      "path": "docs/compliance/",
      "frameworks": ["SOC 2", "ISO 27001"],
      "description": "Map compliance controls to Terraform resources and tfsec/checkov policies"
    },
    "ci_cd_pipeline_design": {
      "status": "not_started",
      "path": "docs/architecture/ci-cd-pipeline.md",
      "platform": "GitHub Actions",
      "stages": ["lint", "type-check", "unit-tests", "security-scan", "build", "staging-deploy", "integration-tests", "production-deploy"]
    },
    "provider_version_pins": {
      "status": "not_started",
      "path": "modules/versions.tf",
      "description": "Pin all Terraform provider versions to exact patch releases"
    }
  },
  "phases": {
    "1": {
      "name": "discovery",
      "description": "Requirements gathering, architecture decisions, compliance mapping, module inventory"
    },
    "2": {
      "name": "foundation",
      "description": "Core module scaffolding, CI/CD pipeline, provider configuration, state backend setup"
    },
    "3": {
      "name": "build",
      "description": "Implement VPC, IAM, ECS, RDS, monitoring modules with tests using Terratest"
    },
    "4": {
      "name": "integration",
      "description": "Wire modules into environment compositions, deploy dev and staging environments"
    },
    "5": {
      "name": "hardening",
      "description": "Security scanning with tfsec and checkov, SOC 2 / ISO 27001 compliance validation, cost optimization"
    },
    "6": {
      "name": "production",
      "description": "Production deployment, monitoring dashboards, runbooks, PagerDuty alerting, self-service provisioning"
    }
  },
  "blockers": [],
  "notes": "Initial project setup. Discovery phase focuses on architecture decisions, compliance requirements mapping, and defining the Terraform module structure. All decisions documented as ADRs in docs/adr/. Next milestone: complete module inventory and tagging policy before moving to foundation phase.",
  "lastUpdated": "2025-01-15T00:00:00Z",
  "updatedBy": "platform-team"
}`,

  'playbook/phases/01-discovery.md': `# Phase 01: Discovery

## Objective

Map the complete AWS infrastructure requirements for the platform, define Terraform module boundaries, and establish compliance baselines for SOC 2 and ISO 27001. This phase produces the foundational decisions that drive all subsequent module design, environment topology, and security controls. No Terraform code is written in this phase—only specifications and architectural decisions.

## Deliverables

1. **AWS Service Inventory** — Exhaustive list of AWS services required (VPC, ECS, RDS PostgreSQL, ElastiCache Redis, ALB, Route53, CloudWatch, ECR, S3, IAM, KMS, WAF, GuardDuty, Config, CloudTrail) with justification for each.
2. **Module Boundary Map** — Diagram and document defining each Terraform module under \`modules/\` (vpc, ecs, rds, monitoring, security, iam) with explicit input/output contracts between modules.
3. **Environment Topology** — Specification for dev, staging, and production environments under \`environments/\`, including instance sizing, replica counts, and network CIDR allocations.
4. **Compliance Requirements Matrix** — SOC 2 Trust Service Criteria and ISO 27001 Annex A controls mapped to specific AWS services and Terraform resource configurations (encryption at rest, audit logging, access controls, network segmentation).
5. **Non-Functional Requirements (NFRs)** — Documented targets for:
   - Availability: 99.95% uptime SLA for production ECS services
   - RTO/RPO: RDS recovery targets (RPO < 1 hour, RTO < 4 hours)
   - Latency: ALB-to-ECS p99 < 200ms
   - Cost: Monthly budget ceiling per environment with tagging strategy (\`project\`, \`environment\`, \`team\`, \`cost-center\`)
   - Blast radius: Maximum resources per Terraform state file
6. **Tagging Policy** — Finalized required tags for all AWS resources, enforced via \`aws_default_tags\` and validated by tfsec rules.
7. **Provider Version Pins** — Selected and pinned versions for \`hashicorp/aws\`, \`hashicorp/random\`, \`hashicorp/tls\`, and any community providers, documented in a base \`versions.tf\` template.
8. **ADR-001: Module Decomposition** — Architecture Decision Record in \`docs/adr/\` explaining why modules are split the way they are.
9. **ADR-002: State Management Strategy** — Decision on S3 backend configuration, DynamoDB locking table, state file granularity per environment.

## Quality Gates

All gates must pass before advancing to [Phase 02: Architecture](./02-architecture.md):

- [ ] AWS Service Inventory reviewed and approved by at least 2 team leads
- [ ] Module Boundary Map has no circular dependencies between modules
- [ ] Every module has defined inputs (variables) and outputs documented in plain text
- [ ] Compliance matrix covers all SOC 2 CC6 (Logical and Physical Access) and CC7 (System Operations) criteria
- [ ] ISO 27001 Annex A controls A.8 (Asset Management), A.9 (Access Control), and A.12 (Operations Security) are mapped
- [ ] NFR targets are signed off by stakeholders with explicit trade-off acknowledgments
- [ ] Cost estimates generated using \`infracost\` for each environment tier
- [ ] Tagging policy validated against existing organizational SCPs
- [ ] ADRs merged to \`main\` via PR with 2 approvals

## Recommended Prompts

Use the following prompt templates during this phase:

- [\`playbook/prompts/01/gather-aws-requirements.md\`](../prompts/01/gather-aws-requirements.md) — Elicit service requirements from application team
- [\`playbook/prompts/01/map-compliance-controls.md\`](../prompts/01/map-compliance-controls.md) — Generate SOC 2 / ISO 27001 control mappings
- [\`playbook/prompts/01/define-module-boundaries.md\`](../prompts/01/define-module-boundaries.md) — Analyze dependencies and propose module splits
- [\`playbook/prompts/01/estimate-costs.md\`](../prompts/01/estimate-costs.md) — Generate Infracost baseline estimates
- [\`playbook/prompts/01/draft-nfr-targets.md\`](../prompts/01/draft-nfr-targets.md) — Produce NFR document from stakeholder inputs

## Key Commands for This Phase

\`\`\`bash
# Validate provider availability and version constraints
terraform init -backend=false -input=false

# Check that base HCL syntax is valid before any module work begins
terraform validate

# Generate cost estimates from preliminary resource definitions
infracost breakdown --path environments/dev --format table

# Verify AWS account access and identity
aws sts get-caller-identity
aws organizations describe-organization
\`\`\`

## Risks and Mitigations

| Risk | Impact | Mitigation |
|------|--------|------------|
| Incomplete service inventory leads to missing modules in Phase 02 | High — rework across multiple modules | Cross-reference with application team's Docker Compose and ECS task definitions; audit existing AWS Config inventory |
| Underestimated CIDR ranges cause IP exhaustion in production VPC | High — requires VPC rebuild | Allocate /16 per environment with /20 subnets; document expansion plan in ADR |
| Compliance controls mapped too broadly, creating excessive Terraform complexity | Medium — over-engineering | Scope controls to in-scope systems only; use AWS Config conformance packs as baseline |
| Provider version pins become stale before Phase 02 starts | Low — minor rework | Pin to exact patch versions; set calendar reminder to review before coding begins |
| Cost estimates diverge from actuals due to missing data transfer costs | Medium — budget overrun | Include explicit data transfer line items in Infracost config; add 20% buffer to estimates |
| State management strategy chosen without understanding blast radius | High — risky applies in production | Model state splits against the module boundary map; validate with \`terraform state list\` on a prototype |`,

  'playbook/phases/02-architecture.md': `# Phase 02: Architecture

## Objective

Design the foundational architecture for the aws-platform-iac platform, establishing the Terraform module hierarchy, network topology, compute strategy, and data layer patterns. This phase produces Architecture Decision Records (ADRs) and module interface contracts that guide all subsequent implementation. Every decision must account for SOC 2 and ISO 27001 compliance requirements, multi-environment isolation, and cost optimization for a SaaS workload.

## Deliverables

1. **VPC topology diagram** — CIDR allocation for dev/staging/production, subnet tiers (public, private, isolated), NAT gateway strategy, VPC peering or Transit Gateway decision documented in \`docs/architecture/vpc-topology.md\`
2. **Terraform module hierarchy** — dependency graph of \`modules/vpc\`, \`modules/ecs\`, \`modules/rds\`, \`modules/elasticache\`, \`modules/monitoring\`, \`modules/security\`, \`modules/iam\` with defined input/output contracts in each module's \`variables.tf\` and \`outputs.tf\`
3. **Compute decision (ECS vs EKS)** — ADR in \`docs/adr/002-compute-orchestration.md\` evaluating ECS Fargate, ECS EC2, and EKS against team size, operational overhead, and cost
4. **Data layer design** — RDS PostgreSQL cluster topology (multi-AZ, read replicas, parameter groups) and ElastiCache Redis cluster mode configuration documented in \`docs/architecture/data-layer.md\`
5. **State management strategy** — S3 backend configuration, DynamoDB lock table, state file per-environment isolation, and workspace vs directory-based separation documented in \`docs/adr/003-state-management.md\`
6. **Tagging taxonomy** — finalized tag schema (\`project\`, \`environment\`, \`team\`, \`cost-center\`, \`compliance\`, \`managed-by\`) enforced via \`modules/common/tags.tf\`
7. **IAM boundary design** — permission boundaries, service-linked roles, and managed policy structure for SOC 2 least-privilege compliance in \`docs/architecture/iam-design.md\`
8. **Environment promotion model** — how Terraform configurations flow from \`environments/dev/\` → \`environments/staging/\` → \`environments/production/\` with drift detection

## Quality Gates

- [ ] All ADRs reviewed and approved by at least 2 team members (lead + senior)
- [ ] \`terraform validate\` passes on skeleton module structures with placeholder variables
- [ ] \`tfsec\` scan on proposed IAM boundary design returns zero HIGH/CRITICAL findings
- [ ] VPC CIDR ranges verified non-overlapping across all three environments
- [ ] Module dependency graph contains no circular references
- [ ] Every module skeleton includes \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`main.tf\`, and \`versions.tf\`
- [ ] State backend S3 bucket and DynamoDB table provisioned via bootstrap configuration in \`environments/bootstrap/\`
- [ ] Cost estimate for baseline infrastructure reviewed (use \`infracost\` on skeleton plans)
- [ ] Security team sign-off on network segmentation and IAM design for SOC 2 controls CC6.1, CC6.3

## Recommended Prompts

Refer to the following prompt templates for Claude-assisted architecture work:

- \`playbook/prompts/02/design-vpc-topology.md\` — generate VPC module with CIDR calculations and subnet layout
- \`playbook/prompts/02/evaluate-compute-options.md\` — produce ADR comparing ECS Fargate vs EKS for small SRE team
- \`playbook/prompts/02/design-rds-cluster.md\` — define RDS PostgreSQL module with multi-AZ, encryption, and backup policies
- \`playbook/prompts/02/define-module-interfaces.md\` — generate \`variables.tf\` and \`outputs.tf\` contracts for all modules
- \`playbook/prompts/02/create-state-backend.md\` — bootstrap remote state with S3 versioning, encryption, and DynamoDB locking
- \`playbook/prompts/02/design-iam-boundaries.md\` — create managed policy structure aligned with ISO 27001 Annex A.9

## Key Terraform Commands

\`\`\`bash
# Validate module skeletons as you build them
terraform -chdir=modules/vpc validate
terraform -chdir=modules/ecs validate

# Format all HCL before committing
terraform fmt -recursive modules/

# Generate module documentation
terraform-docs markdown table modules/vpc > modules/vpc/README.md

# Bootstrap the state backend (one-time, from local state)
terraform -chdir=environments/bootstrap init
terraform -chdir=environments/bootstrap apply

# Run security scan on proposed module structures
tfsec modules/ --minimum-severity HIGH
checkov -d modules/ --framework terraform

# Estimate costs for the baseline architecture
infracost breakdown --path environments/dev/
\`\`\`

## Risks and Mitigations

| Risk | Impact | Mitigation |
|------|--------|------------|
| VPC CIDR exhaustion as environments scale | Cannot add subnets or peer networks | Allocate /16 per environment with /20 subnets; document expansion plan in VPC ADR |
| EKS operational overhead exceeds team capacity (2-5 engineers) | Toil consumes sprint velocity | Default to ECS Fargate; gate EKS adoption on hiring plan in ADR |
| State file corruption or lock contention | Blocked deployments, potential drift | Enable S3 versioning, enforce DynamoDB locking, separate state per module per environment |
| Over-permissive IAM during rapid prototyping | SOC 2 audit finding, security incident | Enforce permission boundaries from day one; \`tfsec\` in pre-commit hooks |
| Module interface churn during implementation | Cascading refactors across environments | Freeze module contracts at end of this phase; changes require ADR amendment and 2 approvals |
| Terraform provider version drift across modules | Inconsistent behavior, plan failures | Pin exact provider versions in each module's \`versions.tf\`; use \`.terraform.lock.hcl\` |`,

  'playbook/phases/03-foundation.md': `# Phase 03: Foundation

## Objective

Scaffold the complete \`aws-platform-iac\` project structure, configure the Terraform state backend with S3 and DynamoDB locking, establish the CI/CD pipeline in GitHub Actions, and deliver the foundational \`vpc\` and \`iam-baseline\` modules. This phase produces a working dev environment that all subsequent modules build upon.

## Deliverables

1. **Project scaffold** — All top-level directories created (\`modules/\`, \`environments/\`, \`scripts/\`, \`cmd/\`, \`lambdas/\`, \`charts/\`, \`tests/\`, \`docs/\`, \`.github/\`, \`.claude/\`, \`plugin/\`, \`playbook/\`) with placeholder READMEs where appropriate.
2. **State backend** — S3 bucket with versioning and AES-256 encryption, DynamoDB table for state locking, backend configuration in \`environments/dev/backend.tf\` with exact provider version pins.
3. **VPC module** (\`modules/vpc/\`) — Multi-AZ VPC with public, private, and data subnets; NAT gateways; flow logs to CloudWatch; all resources tagged with \`project\`, \`environment\`, \`team\`, and \`cost-center\`. Includes \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`main.tf\`, and \`versions.tf\`.
4. **IAM baseline module** (\`modules/iam-baseline/\`) — Managed policies for admin, developer, and read-only roles; password policy enforcement; no inline policies; CloudTrail integration for audit logging. SOC 2 and ISO 27001 control mappings documented in module README.
5. **Dev environment instantiation** (\`environments/dev/\`) — Calls \`vpc\` and \`iam-baseline\` modules with dev-specific variables; workspace configured as \`dev\`; successful \`terraform apply\` with clean state.
6. **CI/CD pipeline** (\`.github/workflows/terraform.yml\`) — Stages: \`terraform fmt\` check, \`terraform validate\`, \`tflint\`, \`tfsec\`, \`checkov\`, \`terraform plan\` on PR, \`terraform apply\` on merge to \`main\` for staging. CODEOWNERS file enforcing review on \`modules/security/*\`, \`environments/production/*\`, and \`*.tfvars\`.
7. **Terratest scaffold** (\`tests/\`) — Go module initialized, base test helper for spinning up and tearing down Terraform fixtures, one passing integration test for the VPC module validating subnet CIDR allocation.
8. **terraform-docs automation** — Pre-commit hook or CI step that regenerates module READMEs from HCL using \`terraform-docs markdown table\`.

## Quality Gates

- [ ] \`terraform fmt -check -recursive\` passes with zero diff across all directories.
- [ ] \`terraform validate\` succeeds for \`environments/dev/\`.
- [ ] \`tflint\` and \`tfsec\` report zero high-severity findings.
- [ ] \`checkov\` passes with no failed checks on the VPC and IAM baseline modules.
- [ ] VPC module Terratest (\`go test ./tests/vpc_test.go -v -timeout 30m\`) passes in the dev AWS account.
- [ ] State backend S3 bucket has versioning enabled, encryption enforced, and public access blocked.
- [ ] DynamoDB lock table exists and \`terraform plan\` acquires/releases lock correctly.
- [ ] All AWS resources carry required tags: \`project=aws-platform-iac\`, \`environment=dev\`, \`team=platform\`, \`cost-center=engineering\`.
- [ ] GitHub Actions workflow runs successfully on a test PR: lint → validate → security scan → plan.
- [ ] CODEOWNERS file is in place and enforced on the \`main\` branch with 2-approval requirement.
- [ ] Every module directory contains \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\` with pinned provider versions.
- [ ] \`golangci-lint run ./...\` passes on all Go code in \`tests/\` and \`cmd/\`.

## Recommended Prompts

Refer to the following prompt files for Claude-assisted execution of this phase:

- \`playbook/prompts/03/scaffold-project.md\` — Generate the full directory tree and placeholder files.
- \`playbook/prompts/03/state-backend.md\` — Create S3 + DynamoDB backend configuration with encryption.
- \`playbook/prompts/03/vpc-module.md\` — Build the VPC module with multi-AZ subnets and flow logs.
- \`playbook/prompts/03/iam-baseline-module.md\` — Build IAM roles, policies, and compliance mappings.
- \`playbook/prompts/03/ci-pipeline.md\` — Generate the GitHub Actions workflow with all stages.
- \`playbook/prompts/03/terratest-setup.md\` — Initialize Go test module and write VPC integration test.

## Key Terraform Commands

\`\`\`bash
# Initialize state backend (run once, manually)
cd environments/dev && terraform init -backend-config=backend.hcl

# Validate and lint
terraform fmt -check -recursive
terraform validate
tflint --recursive
tfsec .
checkov -d .

# Plan and apply dev environment
terraform workspace select dev
terraform plan -var-file=dev.tfvars -out=dev.tfplan
terraform apply dev.tfplan

# Generate module docs
terraform-docs markdown table modules/vpc/ > modules/vpc/README.md

# Run integration tests
cd tests && go test ./vpc_test.go -v -timeout 30m -count=1
\`\`\`

## Risks and Mitigations

| Risk | Impact | Mitigation |
|------|--------|------------|
| State backend S3 bucket name collision | Blocks all Terraform operations | Use account-id-prefixed bucket name: \`aws-platform-iac-tfstate-{account_id}\` |
| NAT gateway costs in dev | Unnecessary spend for non-production | Use single NAT gateway in dev (multi-AZ NAT only in staging/production) |
| IAM policy too permissive in baseline | SOC 2 / ISO 27001 audit finding | Apply least-privilege from day one; run \`access-analyzer\` policy validation in CI |
| VPC CIDR overlap with future environments | Prevents VPC peering or Transit Gateway | Pre-allocate non-overlapping CIDRs: dev \`10.0.0.0/16\`, staging \`10.1.0.0/16\`, production \`10.2.0.0/16\` |
| Terraform provider drift between engineers | Non-reproducible plans | Pin providers to exact patch versions in \`versions.tf\`; use \`.terraform.lock.hcl\` committed to repo |
| Long Terratest execution time slowing PRs | Developer friction, skipped tests | Run integration tests only on merge to \`main\`; run \`tfsec\`/\`tflint\` on PRs for fast feedback |`,

  'playbook/phases/04-core-implementation.md': `# Phase 04: Core Implementation

## Objective

Build the foundational AWS infrastructure modules that form the platform backbone: compute (ECS), data (RDS, ElastiCache), networking (ALB, security groups), security (IAM, KMS), and observability (CloudWatch). Each module must be independently testable, fully documented, and compliant with SOC 2 / ISO 27001 tagging and access control requirements. All modules follow the conventions established in Phase 03 (VPC/networking foundation).

## Deliverables

1. **ECS Cluster Module** (\`modules/ecs/\`) — Fargate and EC2 capacity providers, task execution roles, service discovery namespace, container insights enabled
2. **RDS PostgreSQL Module** (\`modules/rds/\`) — Multi-AZ Aurora PostgreSQL cluster, automated backups (35-day retention), encryption at rest via KMS, parameter groups, subnet groups
3. **ElastiCache Redis Module** (\`modules/elasticache/\`) — Replication group with automatic failover, encryption in-transit and at-rest, auth token rotation via Secrets Manager
4. **ALB Module** (\`modules/alb/\`) — Application Load Balancer with HTTPS listeners, WAF association, access logging to S3, target group health checks, Route53 alias records
5. **Security Groups Module** (\`modules/security/\`) — Least-privilege ingress/egress rules for each service tier, no \`0.0.0.0/0\` ingress except ALB port 443, flow log integration
6. **IAM Roles Module** (\`modules/iam/\`) — Managed policies only (no inline), ECS task roles, RDS access roles, cross-account assume-role patterns, permission boundaries
7. **KMS Module** (\`modules/kms/\`) — Customer-managed keys for RDS, ElastiCache, S3, ECS secrets; key rotation enabled, key policies scoped to service principals
8. **CloudWatch Foundations** (\`modules/monitoring/\`) — Log groups with retention policies, metric filters for error rates, basic alarms for CPU/memory/disk, SNS topics for alerting
9. **Terratest Suite** (\`tests/\`) — Go integration tests for each module covering create, validate outputs, and destroy cycles
10. **Module Documentation** — \`README.md\` generated via \`terraform-docs\` for every module, including usage examples and input/output tables

## Quality Gates

- [ ] \`terraform validate\` and \`terraform fmt -check\` pass for all modules
- [ ] \`tflint\` reports zero errors across \`modules/\`
- [ ] \`tfsec\` and \`checkov\` scans pass with no HIGH or CRITICAL findings
- [ ] Every module contains \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, \`README.md\`
- [ ] All provider versions pinned to exact patch (e.g., \`= 5.46.0\`)
- [ ] All AWS resources tagged with \`project\`, \`environment\`, \`team\`, \`cost-center\`
- [ ] Terratest passes for each module in isolation (\`go test ./tests/... -v -timeout 30m\`)
- [ ] No inline IAM policies exist anywhere in the codebase
- [ ] KMS encryption enabled for all data-at-rest (RDS, ElastiCache, S3 access logs)
- [ ] Security group rules reviewed and approved by at least 2 team members
- [ ] Test coverage for Go tooling in \`cmd/\` and \`lambdas/\` meets 70% threshold

## Recommended Prompts

- \`playbook/prompts/04/build-ecs-module.md\` — Scaffold ECS cluster with Fargate, service discovery, and container insights
- \`playbook/prompts/04/build-rds-module.md\` — Aurora PostgreSQL with Multi-AZ, KMS encryption, and backup configuration
- \`playbook/prompts/04/build-elasticache-module.md\` — Redis replication group with auth and encryption
- \`playbook/prompts/04/build-alb-module.md\` — ALB with HTTPS, WAF, access logs, and Route53 integration
- \`playbook/prompts/04/build-security-groups.md\` — Tiered security group rules with least-privilege enforcement
- \`playbook/prompts/04/build-iam-roles.md\` — Managed IAM policies with permission boundaries
- \`playbook/prompts/04/build-kms-keys.md\` — Customer-managed KMS keys with rotation and scoped policies
- \`playbook/prompts/04/build-cloudwatch-basics.md\` — Log groups, metric filters, and baseline alarms
- \`playbook/prompts/04/write-terratest.md\` — Integration test patterns for each module

## Key Commands

\`\`\`bash
# Validate and lint all modules
terraform -chdir=modules/ecs validate && terraform -chdir=modules/ecs fmt -check
tflint --recursive --config=.tflint.hcl
tfsec modules/ --minimum-severity HIGH
checkov -d modules/ --framework terraform

# Generate module documentation
terraform-docs markdown table modules/ecs > modules/ecs/README.md

# Run Terratest for a specific module
cd tests && go test -v -run TestEcsModule -timeout 30m
cd tests && go test -v -run TestRdsModule -timeout 45m

# Run all integration tests
cd tests && go test ./... -v -timeout 60m -parallel 2

# Plan against dev environment to verify module composition
terraform -chdir=environments/dev init
terraform -chdir=environments/dev plan -var-file=dev.tfvars
\`\`\`

## Risks and Mitigations

| Risk | Impact | Mitigation |
|------|--------|------------|
| RDS/ElastiCache provisioning takes 15-30 min per test run | Slows CI feedback loop | Run Terratest with \`-parallel 2\`, use \`t.Parallel()\` for independent modules, cache state in dedicated test AWS account |
| Security group circular dependencies between ECS, RDS, ALB | \`terraform apply\` fails with cycle errors | Define security groups in a single module with explicit \`depends_on\`, reference by ID not by resource |
| KMS key deletion window blocks re-creation in test accounts | Terratest cleanup fails, resources orphaned | Set \`deletion_window_in_days = 7\` in test fixtures, use unique key aliases per test run |
| IAM permission boundaries too restrictive for ECS task roles | Services fail to start in staging | Test permission boundaries against actual ECS task definitions in Terratest, validate with \`iam:SimulatePrincipalPolicy\` |
| Provider version drift across modules | Inconsistent behavior between modules | Pin exact versions in each module's \`versions.tf\`, enforce with CI check that compares all \`required_providers\` blocks |
| Cost overrun from long-running test infrastructure | Unexpected AWS bill | Tag all test resources with \`environment = "test"\`, run nightly cleanup Lambda, set AWS Budget alerts at $500 |`,

  'playbook/phases/05-integration-hardening.md': `# Phase 05: Integration & Hardening

## Objective

Wire all Terraform modules together into cohesive environment stacks, implement cross-module dependencies (VPC → ECS → RDS → Monitoring), and layer security hardening controls including WAF, GuardDuty, VPC Flow Logs, and automated backup policies. This phase transforms isolated modules into a production-grade platform that meets SOC 2 and ISO 27001 compliance requirements.

## Deliverables

1. **Environment root modules** in \`environments/dev/\`, \`environments/staging/\`, \`environments/production/\` that compose all child modules with proper dependency ordering
2. **AWS WAF v2 WebACL** attached to ALB with OWASP Top 10 managed rule groups and rate-limiting rules, defined in \`modules/security/waf.tf\`
3. **VPC Flow Logs** enabled on all VPCs, shipping to CloudWatch Log Groups with 90-day retention and S3 archival for compliance
4. **GuardDuty** enabled across all target accounts with SNS → PagerDuty notification pipeline for HIGH/CRITICAL findings
5. **AWS Backup** vault and plans for RDS clusters (daily snapshots, 35-day retention) and EBS volumes, defined in \`modules/security/backup.tf\`
6. **Cost tagging validation** script in \`scripts/validate_tags.go\` that parses \`terraform plan\` JSON output and rejects resources missing required tags (\`project\`, \`environment\`, \`team\`, \`cost-center\`)
7. **Cross-module integration tests** in \`tests/integration/\` using Terratest that deploy a full dev stack and validate connectivity between VPC, ECS, RDS, and monitoring
8. **Remote state data sources** configured so modules reference each other via \`terraform_remote_state\` or SSM Parameter Store lookups instead of hardcoded values
9. **Security Group tightening** — remove all \`0.0.0.0/0\` ingress rules from non-ALB resources, enforce least-privilege network paths between ECS tasks and RDS

## Quality Gates

- [ ] \`terraform plan\` succeeds for all three environments with zero errors
- [ ] \`tfsec\` and \`checkov\` scans pass with no HIGH or CRITICAL findings
- [ ] Cost tag validation script exits 0 against every environment plan output
- [ ] GuardDuty sample findings trigger PagerDuty alerts within 5 minutes
- [ ] WAF blocks OWASP test payloads (SQL injection, XSS) against staging ALB
- [ ] Terratest integration suite passes end-to-end in dev environment (VPC → ECS → RDS connectivity verified)
- [ ] VPC Flow Logs appear in CloudWatch within 10 minutes of deployment
- [ ] AWS Backup completes at least one successful RDS snapshot in dev
- [ ] No inline IAM policies exist — verified by \`scripts/audit_iam.py\`
- [ ] All provider versions remain pinned to exact patch in \`versions.tf\`

## Recommended Prompts

Refer to the following prompt files for Claude Code assistance during this phase:

- \`playbook/prompts/05/compose-environment-root.md\` — Wiring modules together in environment root configs
- \`playbook/prompts/05/waf-rules.md\` — WAF WebACL with managed rule groups and custom rate limits
- \`playbook/prompts/05/guardduty-setup.md\` — GuardDuty with multi-account delegation and alerting
- \`playbook/prompts/05/vpc-flow-logs.md\` — Flow log configuration with CloudWatch and S3 destinations
- \`playbook/prompts/05/backup-policies.md\` — AWS Backup vault, plans, and selections for RDS/EBS
- \`playbook/prompts/05/tag-validation.md\` — Go script to enforce tagging policy on plan output
- \`playbook/prompts/05/integration-tests.md\` — Terratest patterns for cross-module validation

## Key Terraform Commands

\`\`\`bash
# Validate all environment configurations
for env in dev staging production; do
  terraform -chdir=environments/$env init -backend=false
  terraform -chdir=environments/$env validate
done

# Generate plan JSON for tag validation
terraform -chdir=environments/dev plan -out=plan.tfplan
terraform -chdir=environments/dev show -json plan.tfplan > plan.json
go run scripts/validate_tags.go -plan plan.json

# Security scanning
tfsec environments/ --minimum-severity HIGH
checkov -d environments/ --framework terraform --check CKV_AWS

# Run integration tests against dev
cd tests/integration && go test -v -timeout 30m -tags=integration ./...

# Format and lint everything
terraform fmt -recursive .
tflint --recursive
\`\`\`

## Risks and Mitigations

| Risk | Impact | Mitigation |
|------|--------|------------|
| Circular dependencies between modules | \`terraform plan\` fails or produces unstable ordering | Use \`terraform_remote_state\` data sources or SSM parameters; never pass module outputs bidirectionally |
| WAF managed rules block legitimate traffic | Service outage in staging/production | Deploy WAF in COUNT mode first, analyze CloudWatch metrics for 48 hours, then switch to BLOCK |
| GuardDuty generates excessive noise | Alert fatigue, PagerDuty escalation storms | Filter SNS notifications to HIGH/CRITICAL severity only; route MEDIUM to Slack |
| Integration tests are slow and expensive | CI pipeline exceeds 30-minute budget | Use \`t3.micro\` instances in tests, parallelize independent test functions, destroy resources in \`defer\` |
| VPC Flow Logs increase CloudWatch costs | Unexpected AWS bill spike | Set log retention to 90 days, enable S3 archival with Intelligent-Tiering, monitor costs via \`cost-center\` tag |
| Backup retention policies conflict across environments | Unnecessary storage costs in dev | Use variable-driven retention: 7 days for dev, 14 for staging, 35 for production |`,

  'playbook/phases/06-testing-quality.md': `# Phase 06: Testing & Quality

## Objective

Establish a comprehensive testing and quality assurance framework that validates every Terraform module through automated Terratest suites, security scanning, compliance checks, and cost estimation. This phase ensures that all infrastructure changes are provably correct, secure against SOC 2 and ISO 27001 control requirements, and cost-predictable before reaching any environment.

## Deliverables

1. **Terratest suite** covering all modules in \`modules/\` — VPC CIDR validation, ECS task definition correctness, RDS parameter group assertions, IAM policy boundary enforcement, and CloudWatch alarm threshold verification
2. **Unit tests** for each module using \`terraform validate\` and \`terraform plan\` with mock variable files in \`tests/unit/\`
3. **Integration tests** in \`tests/integration/\` that deploy ephemeral infrastructure to a dedicated \`testing\` AWS account, run assertions, and tear down via Terratest's \`defer terraform.Destroy()\`
4. **tfsec pipeline integration** with custom rules for project-specific policies (no inline IAM, mandatory resource tagging with \`project\`, \`environment\`, \`team\`, \`cost-center\`)
5. **checkov scan configuration** in \`.checkov.yml\` enforcing CIS AWS Benchmark, SOC 2 trust service criteria, and ISO 27001 Annex A controls
6. **Infracost integration** generating cost estimates on every PR, with budget thresholds per environment defined in \`environments/*/infracost-budget.yml\`
7. **Drift detection workflow** running nightly \`terraform plan\` against all environments, posting results to \`#infra-drift\` Slack channel and creating GitHub Issues for unresolved drift
8. **Compliance validation suite** in \`tests/compliance/\` asserting encryption-at-rest on RDS and ElastiCache, VPC flow logs enabled, S3 bucket policies deny public access, and ALB access logging to S3
9. **Load testing harness** for the self-service provisioning pipeline — simulating 20 concurrent developer environment requests through the Go CLI in \`cmd/provisioner/\`
10. **Test coverage report** aggregated across Go packages with \`go test -coverprofile\` achieving ≥70% coverage on \`cmd/\`, \`lambdas/\`, and \`scripts/\` Go code

## Quality Gates

- [ ] All Terratest suites pass in CI with zero failures across \`modules/vpc\`, \`modules/ecs\`, \`modules/rds\`, \`modules/monitoring\`, \`modules/security\`, \`modules/iam\`
- [ ] tfsec reports zero HIGH or CRITICAL findings; MEDIUM findings documented with accepted-risk justification in \`docs/security/accepted-risks.md\`
- [ ] checkov passes all CIS AWS Benchmark Level 1 checks and project-custom checks
- [ ] Infracost estimates for production environment are within 15% of approved budget
- [ ] Drift detection runs successfully against \`dev\` and \`staging\` with clean plans (no unexpected changes)
- [ ] Compliance tests validate all SOC 2 CC6.1 (encryption) and CC6.6 (network security) controls
- [ ] Go test coverage ≥70% across all packages in \`cmd/\`, \`lambdas/\`, \`scripts/\`
- [ ] Provisioning pipeline handles 20 concurrent requests without state lock contention or failures
- [ ] All test results are published as GitHub Actions artifacts and summarized in PR comments
- [ ] Security scan results are stored in S3 for audit trail (SOC 2 evidence collection)

## Recommended Prompts

- \`playbook/prompts/06/write-terratest-vpc-module.md\` — Generate Terratest for VPC module with CIDR, subnet, and NAT gateway assertions
- \`playbook/prompts/06/write-terratest-ecs-module.md\` — Generate Terratest for ECS cluster, service, and task definition validation
- \`playbook/prompts/06/write-terratest-rds-module.md\` — Generate Terratest for RDS cluster with encryption, backup, and parameter group checks
- \`playbook/prompts/06/configure-tfsec-custom-rules.md\` — Create tfsec custom rules for tagging policy and IAM constraints
- \`playbook/prompts/06/setup-checkov-pipeline.md\` — Configure checkov with SOC 2 and ISO 27001 policy sets
- \`playbook/prompts/06/setup-infracost-budgets.md\` — Define per-environment cost budgets and PR comment integration
- \`playbook/prompts/06/build-drift-detection-workflow.md\` — GitHub Actions workflow for nightly drift detection with Slack alerts
- \`playbook/prompts/06/write-compliance-tests.md\` — Compliance assertion tests for encryption, logging, and network controls
- \`playbook/prompts/06/load-test-provisioner.md\` — Load test the Go provisioner CLI with concurrent workspace creation

## Key Commands

\`\`\`bash
# Run all Terratest suites
cd tests/ && go test -v -timeout 60m ./...

# Run unit tests for a specific module
cd tests/unit && go test -v -run TestVpcModule -timeout 10m

# Run integration tests (requires AWS_PROFILE=testing)
cd tests/integration && AWS_PROFILE=testing go test -v -timeout 45m ./...

# Security scanning
tfsec modules/ --config-file .tfsec.yml --format json --out reports/tfsec.json
checkov -d modules/ --config-file .checkov.yml --output junitxml > reports/checkov.xml

# Terraform validation across all modules
for dir in modules/*/; do terraform -chdir="$dir" init -backend=false && terraform -chdir="$dir" validate; done

# Cost estimation
infracost breakdown --path environments/production/ --format json --out-file reports/infracost-production.json
infracost diff --path environments/production/ --compare-to infracost-base.json

# Drift detection
terraform -chdir=environments/staging plan -detailed-exitcode -out=drift.tfplan

# Go test coverage
go test -coverprofile=coverage.out ./cmd/... ./lambdas/... ./scripts/...
go tool cover -func=coverage.out | grep total
\`\`\`

## Risks & Mitigations

| Risk | Impact | Mitigation |
|------|--------|------------|
| Terratest integration tests leave orphaned AWS resources on failure | Cost overrun, security exposure | Use \`defer terraform.Destroy()\` as first statement; run nightly cleanup Lambda tagged \`test-ephemeral\`; set AWS Budgets alert on testing account |
| State lock contention during concurrent provisioner load tests | False negatives in load testing | Use DynamoDB state locking with separate state files per test workspace; configure retry with exponential backoff in provisioner |
| tfsec/checkov false positives block PRs | Developer friction, velocity loss | Maintain \`.tfsec-ignore\` and checkov skip annotations with mandatory justification comments; review skip list monthly |
| Infracost estimates diverge from actual spend | Budget surprises in production | Calibrate estimates against 30-day actual spend in Cost Explorer; adjust usage profiles in \`infracost-usage.yml\` |
| Drift detection alerts cause alert fatigue | Real drift gets ignored | Categorize drift by severity (security-critical vs. cosmetic); auto-remediate known-safe drift via \`terraform apply -auto-approve\` for tagged resources |
| Testing AWS account permissions drift from production parity | Tests pass but production deploys fail | Mirror IAM permission boundaries between testing and production accounts using shared \`modules/iam\` with environment-specific SCPs |`,

  'playbook/phases/07-launch.md': `# Phase 07: Launch

## Objective

Deploy the fully validated AWS platform infrastructure to production, establish operational monitoring and alerting, and complete the handover to the operations team. This phase transitions the platform from a tested staging artifact to a live, observable, and maintainable production system with documented runbooks and on-call procedures. All SOC 2 and ISO 27001 controls must be verified and evidenced before go-live.

## Deliverables

1. Production environment deployed via \`environments/production/\` with all Terraform state stored in the designated S3 backend with DynamoDB locking
2. CloudWatch dashboards provisioned through \`modules/monitoring/\` covering ECS task health, RDS connection pools, ALB latency percentiles, and VPC flow log anomalies
3. PagerDuty integration configured with escalation policies mapped to the SRE on-call rotation
4. Alerting rules deployed for critical thresholds: RDS CPU > 80%, ECS task restart count > 3/5min, ALB 5xx rate > 1%, Redis eviction rate > 0
5. Runbooks authored in \`docs/runbooks/\` for every PagerDuty alert, including RDS failover, ECS service recovery, VPC connectivity loss, and certificate rotation
6. Go-live checklist completed and signed off by at least two lead engineers
7. Cost allocation tags (\`project\`, \`environment\`, \`team\`, \`cost-center\`) verified on every provisioned resource via \`scripts/validate_tags.py\`
8. DNS cutover executed through \`modules/route53/\` with health checks and failover routing policies active
9. Backup and disaster recovery validation: RDS automated snapshots confirmed, cross-region replication tested, point-in-time recovery exercised
10. Operational readiness review (ORR) document published to Confluence with evidence artifacts for SOC 2 audit trail

## Quality Gates

- [ ] \`terraform plan\` on \`environments/production/\` shows zero drift from approved state
- [ ] \`tfsec\` and \`checkov\` scans pass with zero HIGH or CRITICAL findings against production configuration
- [ ] All CloudWatch alarms transition to \`OK\` state within 10 minutes of deployment
- [ ] Synthetic health checks return 200 from all ALB target groups for 30 consecutive minutes
- [ ] RDS failover test completes with recovery time under 60 seconds
- [ ] Load test against production infrastructure meets baseline latency SLOs (p99 < 500ms)
- [ ] CODEOWNERS approval from at least two reviewers on the production deployment PR
- [ ] IAM Access Analyzer reports zero public or cross-account findings on production resources
- [ ] All secrets rotated from staging values; no shared credentials between environments
- [ ] ORR sign-off recorded in GitHub Issues with linked evidence

## Recommended Prompts

- \`playbook/prompts/07/deploy-production.md\` — Execute production Terraform apply with approval workflow
- \`playbook/prompts/07/configure-dashboards.md\` — Provision CloudWatch and Grafana dashboards from monitoring module
- \`playbook/prompts/07/setup-alerting.md\` — Deploy alerting rules and PagerDuty escalation chains
- \`playbook/prompts/07/write-runbooks.md\` — Generate runbook templates for each critical alert
- \`playbook/prompts/07/validate-compliance.md\` — Run SOC 2 and ISO 27001 control evidence collection
- \`playbook/prompts/07/dns-cutover.md\` — Execute Route53 DNS migration with rollback plan
- \`playbook/prompts/07/disaster-recovery-test.md\` — Validate RDS failover and backup restoration

## Key Terraform Commands

\`\`\`bash
# Final validation before production apply
cd environments/production
terraform init -backend-config=backend.prod.hcl
terraform validate
terraform plan -out=prod-launch.tfplan -var-file=production.tfvars

# Security scan the plan
tfsec environments/production/ --minimum-severity HIGH
checkov -d environments/production/ --framework terraform

# Apply with explicit approval (never use -auto-approve in production)
terraform apply prod-launch.tfplan

# Verify resource tagging compliance
python scripts/validate_tags.py --environment production --required project,environment,team,cost-center

# Generate documentation for all deployed modules
terraform-docs markdown table modules/monitoring/ > modules/monitoring/README.md

# Confirm state integrity
terraform state list | wc -l
terraform show -json | jq '.values.root_module.resources | length'
\`\`\`

## Risks and Mitigations

| Risk | Impact | Mitigation |
|---|---|---|
| DNS cutover causes downtime during propagation | User-facing outage | Use Route53 weighted routing with 10/90 split, monitor for 30 min, then shift to 0/100 |
| Production Terraform state corruption | Complete infrastructure management loss | S3 versioning enabled, DynamoDB lock table, state backup to separate account before apply |
| CloudWatch alarm storm on initial deployment | Alert fatigue, missed real incidents | Deploy alarms in \`INSUFFICIENT_DATA\` suppression for first 15 minutes, then enable |
| RDS performance differs from staging due to data volume | Latency SLO breach | Run production-scale load test against staging with synthetic dataset before cutover |
| Untagged resources slip through | SOC 2 audit finding, cost attribution gaps | \`validate_tags.py\` runs as post-apply hook; AWS Config rule enforces tagging as guardrail |
| Shared secrets between staging and production | Security compliance violation | Secrets Manager rotation Lambda triggers on deploy; \`scripts/audit_secrets.py\` cross-checks environments |`,

  'playbook/prompts/01/gather-requirements.md': `# Phase 1: Discovery — Gather Infrastructure Requirements

## Purpose

Structured interview prompt for capturing infrastructure requirements before writing any Terraform code. Run this at the start of every new module, environment, or significant infrastructure change.

## Interview Questions

### 1. Scope & Services

- What AWS services does this initiative require? (VPC, ECS, RDS, ElastiCache, ALB, Route53, S3, ECR, EKS, Lambda, CloudWatch, etc.)
- Is this a new module in \`modules/\`, a new environment in \`environments/\`, or a modification to existing infrastructure?
- Which existing modules can be reused? Check \`modules/\` for vpc, ecs, rds, monitoring, security, iam.

### 2. Traffic & Scaling

- What is the expected request rate at launch? (requests/sec)
- What is the projected peak load within 6 months?
- Does the workload require horizontal auto-scaling, scheduled scaling, or fixed capacity?
- What are the ECS task CPU/memory requirements per service?
- What RDS instance class and storage IOPS are needed?

### 3. Availability & Disaster Recovery

- What is the target SLA? (99.9% = ~8.7h downtime/year, 99.95%, 99.99% = ~52min/year)
- How many Availability Zones must the deployment span? (minimum 2 for production)
- What is the acceptable RTO (Recovery Time Objective) and RPO (Recovery Point Objective)?
- Is multi-region failover required?
- What RDS backup retention and replication strategy is needed?

### 4. Data Residency & Compliance

- Which AWS region(s) are permitted? Are there data residency restrictions?
- Does this fall under SOC 2 or ISO 27001 audit scope? (Default: yes for production)
- Are there encryption requirements beyond default? (CMK vs AWS-managed KMS keys)
- Does this handle PII, PHI, or financial data requiring additional controls?
- Are there network isolation requirements? (dedicated subnets, PrivateLink, no public endpoints)

### 5. Integration & Dependencies

- What existing VPCs, peering connections, or Transit Gateway attachments must this connect to?
- Are there external APIs, SaaS services, or on-prem systems that need network access?
- Which Route53 hosted zones and domain names will be used?
- Are there shared resources (S3 buckets, ECR repos, IAM roles) managed by other teams?

### 6. Budget & Cost Constraints

- What is the monthly infrastructure budget for this initiative?
- Are Reserved Instances or Savings Plans already in place?
- Are there cost-center tags beyond the standard set (project, environment, team, cost-center)?
- Should cost alerts be configured? At what thresholds?

### 7. Team Capacity & Timeline

- Who will own this infrastructure post-deployment? (team, on-call rotation)
- What is the target deployment date for staging? For production?
- How many engineers are available for review? (PR requires 2 approvals per CODEOWNERS)
- Are there runbook or documentation requirements for handoff? (update \`docs/runbooks/\`)

## Output Format

After completing the interview, generate a requirements document at \`docs/requirements/<ticket-id>-requirements.md\` with this structure:

\`\`\`markdown
# Requirements: <INFRA-XXX> <Title>

## Summary
<One paragraph describing the initiative>

## Must-Have (P0)
- [ ] <Requirement with specific AWS service, sizing, and region>

## Should-Have (P1)
- [ ] <Requirement that improves reliability or operability>

## Nice-to-Have (P2)
- [ ] <Requirement that can be deferred to a follow-up ticket>

## Constraints
- Budget: $X/month
- Timeline: Staging by <date>, Production by <date>
- Compliance: SOC 2 / ISO 27001 scope: yes/no
- Data residency: <region restrictions>

## Affected Modules
- modules/<name> — new | modified | reused as-is

## Tagging
- project: aws-platform-iac
- environment: <dev|staging|production>
- team: <owning team>
- cost-center: <cost center code>
\`\`\`

## Next Step

Once requirements are approved, proceed to \`playbook/prompts/02/\` for architecture design and module planning. Run \`terraform-docs\` against any modules identified for reuse to verify current interfaces.`,

  'playbook/prompts/01/nfr-checklist.md': `# Phase 1: Discovery — Non-Functional Requirements Checklist

## Prompt Template

You are defining non-functional requirements for the \`aws-platform-iac\` infrastructure platform. Review each category below and fill in concrete targets, measurement methods, and Terraform module references. Every requirement must be testable and traceable to a SOC 2 or ISO 27001 control where applicable.

**Context**: Provide the service name, environment (dev/staging/production), and expected workload profile.

---

## NFR Checklist

### 1. Availability

| Requirement | Target | Measurement | Module |
|---|---|---|---|
| Uptime SLA | 99.95% (prod), 99.9% (staging), 99% (dev) | CloudWatch composite alarms, Route53 health checks | \`modules/monitoring\` |
| Multi-AZ deployment | Minimum 2 AZs (prod), 1 AZ (dev) | \`terraform plan\` output validation | \`modules/vpc\` |
| Health check interval | 10s (ALB), 30s (Route53) | ALB target group config | \`modules/ecs\` |
| Failover automation | Automatic DNS failover < 60s | Route53 failover routing policy | \`modules/vpc\` |

### 2. Performance

| Requirement | Target | Measurement | Module |
|---|---|---|---|
| API response latency (p99) | < 200ms | CloudWatch ALB latency metrics | \`modules/monitoring\` |
| Database query latency (p95) | < 50ms | RDS Performance Insights | \`modules/rds\` |
| Redis cache hit ratio | > 95% | ElastiCache CloudWatch metrics | \`modules/monitoring\` |
| Throughput baseline | 1000 RPS per ECS service | Load testing via \`scripts/load_test.py\` | \`modules/ecs\` |

### 3. Scalability

| Requirement | Target | Measurement | Module |
|---|---|---|---|
| ECS auto-scaling trigger | CPU > 70% or memory > 80% | CloudWatch target tracking policy | \`modules/ecs\` |
| Scale-out time | New task running < 90s | ECS deployment metrics | \`modules/ecs\` |
| RDS read replicas | 0-3 replicas based on read IOPS | RDS CloudWatch \`ReadIOPS\` metric | \`modules/rds\` |
| Max capacity limits | Defined per environment in \`*.tfvars\` | \`terraform plan\` diff review | \`environments/*\` |

### 4. Security

| Requirement | Target | Compliance Control | Module |
|---|---|---|---|
| Encryption at rest | AES-256 (KMS CMK) for all data stores | SOC 2 CC6.1, ISO 27001 A.10.1.1 | \`modules/security\` |
| Encryption in transit | TLS 1.2+ enforced on all endpoints | SOC 2 CC6.7, ISO 27001 A.13.1.1 | \`modules/security\` |
| Network isolation | Private subnets for data/app tiers, no direct internet | SOC 2 CC6.6, ISO 27001 A.13.1.3 | \`modules/vpc\` |
| IAM least privilege | No inline policies, managed policies only | SOC 2 CC6.3, ISO 27001 A.9.2.3 | \`modules/iam\` |
| Secrets management | AWS Secrets Manager, rotation ≤ 90 days | SOC 2 CC6.1, ISO 27001 A.9.4.3 | \`modules/security\` |
| Vulnerability scanning | tfsec + checkov in CI, ECR image scan on push | SOC 2 CC7.1 | \`.github/workflows\` |

### 5. Cost Management

| Requirement | Target | Measurement | Module |
|---|---|---|---|
| Monthly budget (prod) | Defined in \`environments/production/*.tfvars\` | AWS Budgets alert at 80%, 100%, 120% | \`modules/monitoring\` |
| Resource tagging | 100% of resources tagged: \`project\`, \`environment\`, \`team\`, \`cost-center\` | \`tflint\` custom rule + AWS Config rule | All modules |
| Idle resource detection | Alert on < 5% CPU for 72h | CloudWatch anomaly detection | \`modules/monitoring\` |
| Reserved capacity | RDS and ElastiCache RIs evaluated quarterly | Cost Explorer report via \`cmd/cost-reporter\` | — |

### 6. Observability

| Requirement | Target | Measurement | Module |
|---|---|---|---|
| Metrics collection | All ECS services emit custom metrics | CloudWatch embedded metric format | \`modules/monitoring\` |
| Log retention | 90 days hot (CloudWatch), 1 year cold (S3) | Log group retention policy | \`modules/monitoring\` |
| Distributed tracing | X-Ray enabled on all ECS services | X-Ray service map completeness | \`modules/ecs\` |
| Dashboard coverage | One Grafana dashboard per service + platform overview | \`terraform-docs\` output for monitoring module | \`modules/monitoring\` |
| Alerting SLA | P1: PagerDuty < 5min, P2: Slack < 15min | PagerDuty escalation policy audit | \`modules/monitoring\` |

### 7. Disaster Recovery

| Requirement | Target | Measurement | Module |
|---|---|---|---|
| RPO (prod) | < 1 hour | RDS automated backup frequency | \`modules/rds\` |
| RTO (prod) | < 4 hours | DR runbook drill (quarterly) | \`docs/runbooks\` |
| Backup retention | 35 days (prod), 7 days (staging), 1 day (dev) | RDS backup retention period | \`modules/rds\` |
| State file protection | S3 versioning + DynamoDB locking + cross-region replication | Terraform backend config validation | \`environments/*/backend.tf\` |
| Terraform state recovery | < 30 minutes | DR drill documented in \`docs/runbooks/state-recovery.md\` | — |

### 8. Compliance

| Requirement | Target | Control Reference | Validation |
|---|---|---|---|
| Access logging | CloudTrail enabled in all regions | SOC 2 CC7.2, ISO 27001 A.12.4.1 | AWS Config rule |
| Change management | All infra changes via PR with ≥ 2 approvals | SOC 2 CC8.1, ISO 27001 A.12.1.2 | CODEOWNERS + branch protection |
| Drift detection | Weekly \`terraform plan\` on all environments | SOC 2 CC7.1 | \`.github/workflows/drift-check.yml\` |
| Audit trail | AI-generated code flagged, all commits signed | SOC 2 CC7.4 | CI pipeline validation |

---

## Output Instructions

For each row, confirm or adjust the target value, then add:
- **Owner**: Team member responsible
- **Validation frequency**: How often this NFR is verified (continuous, weekly, quarterly)
- **Terratest coverage**: Whether \`tests/\` includes an integration test for this requirement

Reference \`docs/adr/\` for any architectural decisions that influence these targets.`,

  'playbook/prompts/01/user-stories.md': `# Phase 1: Discovery — Infrastructure User Stories

## Purpose

Convert infrastructure requirements into actionable user stories that tie AWS platform capabilities to measurable business value. Each story should be implementable as one or more Terraform modules or automation scripts.

## Story Format

\`\`\`
As a [role],
I want [infrastructure capability],
so that [business value].

Acceptance Criteria:
- [ ] Specific, testable condition
- [ ] Terraform module or resource created
- [ ] Validated via \`terraform plan\` or Terratest
\`\`\`

## Roles in This Project

| Role | Context |
|------|---------|
| **Developer** | Consumes infrastructure, deploys services to ECS/EKS |
| **SRE Engineer** | Operates and monitors the platform |
| **Security Lead** | Enforces SOC 2 / ISO 27001 compliance |
| **Engineering Manager** | Tracks cost, capacity, team velocity |
| **Platform Lead** | Designs modules, reviews Terraform PRs |

## Story Prompts by Domain

### Networking (modules/vpc)

> As a **developer**, I want isolated VPC environments per stage (dev/staging/production), so that my test traffic never reaches production databases.

> As an **SRE engineer**, I want VPC flow logs shipped to CloudWatch, so that I can investigate network anomalies during incident response.

### Compute (modules/ecs, charts/)

> As a **developer**, I want self-service ECS task definitions generated from a simple config, so that I can deploy containers without writing Terraform myself.

> As an **SRE engineer**, I want ECS services to auto-scale based on CPU and request latency, so that we handle traffic spikes without manual intervention.

### Data (modules/rds, ElastiCache)

> As a **developer**, I want a provisioned PostgreSQL instance in dev within 15 minutes, so that I can validate schema migrations before opening a PR.

> As an **SRE engineer**, I want automated RDS snapshots with cross-region replication, so that we meet our 1-hour RPO commitment.

### Security & Compliance (modules/security, modules/iam)

> As a **security lead**, I want all IAM policies defined as managed policies in Terraform (never inline), so that we pass SOC 2 access-control audits without findings.

> As a **security lead**, I want tfsec and checkov running on every PR in \`.github/workflows/\`, so that misconfigurations are caught before they reach \`main\`.

### Monitoring (modules/monitoring)

> As an **SRE engineer**, I want CloudWatch dashboards auto-generated per ECS service, so that on-call engineers see latency, error rate, and saturation at a glance.

> As an **engineering manager**, I want weekly cost-by-tag reports from \`cmd/cost-reporter\`, so that I can attribute AWS spend to each team and project.

### Developer Experience (scripts/, cmd/)

> As a **developer**, I want a single \`make env-up\` command that runs \`terraform init\` and \`terraform apply\` for my personal dev workspace, so that environment setup takes under 10 minutes.

> As a **platform lead**, I want every module in \`modules/\` to include auto-generated docs via \`terraform-docs\`, so that consumers always have accurate input/output references.

## Writing Good Infrastructure Stories

1. **One capability per story** — "VPC + RDS + ECS" is an epic, not a story.
2. **Tie to a module or directory** — reference \`modules/vpc\`, \`environments/production/\`, etc.
3. **Include a compliance tag** if the story supports SOC 2 or ISO 27001 controls.
4. **Define "done" with Terraform** — acceptance criteria should mention \`terraform validate\`, Terratest assertions, or \`tfsec\` passing.
5. **Tag with cost-center and team** — every AWS resource the story creates must include the required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`.

## Next Step

Once stories are prioritized, move to [Phase 2: Architecture](../02/) to map stories onto Terraform module boundaries and environment configurations.`,

  'playbook/prompts/02/adr-generator.md': `# ADR Generator — Phase 2: Architecture

## Purpose

Generate Architecture Decision Records for infrastructure decisions in the aws-platform-iac project. ADRs document why we chose specific AWS services, Terraform patterns, and architectural approaches.

## Prompt Template

\`\`\`
You are an AWS infrastructure architect working on the aws-platform-iac project.

Generate an ADR for the following decision:

**Decision Topic**: [e.g., Container orchestration strategy, Database engine selection, State management approach]
**Key Constraints**: [e.g., SOC 2 compliance, cost budget, team size of 2-5 SRE engineers]
**Relevant Modules**: [e.g., modules/ecs/, modules/rds/, modules/vpc/]

Use this exact format:

# ADR-{NNN}: {Title}

**Status**: [Proposed | Accepted | Deprecated | Superseded by ADR-{NNN}]
**Date**: {YYYY-MM-DD}
**Authors**: {names or roles}
**Tags**: {aws-service, module-name, compliance}

## Context

What problem or requirement drives this decision? Reference:
- Current state of the infrastructure
- SOC 2 / ISO 27001 compliance requirements where applicable
- Team capacity (small team, senior-heavy)
- Cost implications and the cost-center tagging policy
- Integration with existing modules/ and environments/ structure

## Decision

What we chose and how it will be implemented. Include:
- Specific AWS services and configurations
- Terraform module structure (variables.tf, outputs.tf, versions.tf, README.md)
- Provider version pinning rationale
- Resource tagging strategy (project, environment, team, cost-center)
- Environment separation via Terraform workspaces

## Consequences

### Positive
- {Benefit with concrete impact}

### Negative
- {Trade-off with mitigation strategy}

### Operational
- Monitoring integration (CloudWatch, Prometheus, Grafana, PagerDuty)
- CI/CD impact on GitHub Actions pipeline stages
- Terratest coverage requirements (70% threshold)

## Alternatives Considered

| Alternative | Pros | Cons | Rejection Reason |
|---|---|---|---|
| {Option A} | {pros} | {cons} | {why not} |
| {Option B} | {pros} | {cons} | {why not} |

## References

- Related ADRs, AWS documentation, Terraform registry links
- Relevant files: modules/{name}/README.md, environments/{env}/main.tf
\`\`\`

## Example Invocations

**Decision 1**: "Generate ADR-001 for choosing ECS Fargate over EKS as the primary container orchestration platform, given our team of 3-5 SRE engineers and SOC 2 requirements."

**Decision 2**: "Generate ADR-002 for using S3 with DynamoDB locking as the Terraform state backend instead of Terraform Cloud or GitLab-managed state."

**Decision 3**: "Generate ADR-003 for selecting Multi-AZ RDS PostgreSQL over Aurora PostgreSQL for the primary database, considering our current throughput needs and cost constraints."

**Decision 4**: "Generate ADR-004 for adopting managed IAM policies exclusively (no inline policies) to meet ISO 27001 audit requirements in modules/security/ and modules/iam/."

## Filing Convention

Save generated ADRs to \`docs/adr/ADR-{NNN}-{kebab-case-title}.md\`. Update \`docs/adr/README.md\` with the new entry. ADRs are reviewed through the standard PR process requiring 2 approvals, with changes to \`docs/adr/\` visible to the full team via CODEOWNERS.

## Validation Checklist

- [ ] ADR number is sequential and unique
- [ ] Status is one of: Proposed, Accepted, Deprecated, Superseded
- [ ] Context references specific compliance requirements (SOC 2, ISO 27001) when relevant
- [ ] Decision specifies affected Terraform modules and file structure
- [ ] Resource tagging policy (project, environment, team, cost-center) is addressed
- [ ] At least two alternatives are evaluated with concrete rejection reasons
- [ ] Consequences include operational impact on monitoring and CI/CD
- [ ] References link to related ADRs and module READMEs`,

  'playbook/prompts/02/api-design.md': `# Phase 2: Architecture — Module Interface Design Prompt

## Purpose

Use this prompt to design Terraform module interfaces before writing implementation. A well-designed module API ensures composability, clear contracts between modules, and predictable behavior across environments.

## Prompt Template

\`\`\`
Design the Terraform module interface for: [MODULE_NAME]

Context:
- This module belongs to modules/[MODULE_NAME]/ in the aws-platform-iac monorepo
- It will be consumed by environments/dev/, environments/staging/, and environments/production/
- It must compose with these existing modules: [LIST_UPSTREAM_AND_DOWNSTREAM_MODULES]
- Compliance scope: SOC 2, ISO 27001

For the interface design, provide:

1. **variables.tf (Inputs)**
   - Use snake_case for all variable names, prefixed with module context where ambiguous
   - Mark variables as required (no default) only when the value is environment-specific
   - Provide sensible defaults for optional variables that align with production hardening
   - Use \`validation\` blocks for variables with constrained domains (CIDR ranges, instance classes, naming patterns)
   - Group variables with comments: Required, Optional, Tags, Feature Flags
   - Define a \`tags\` variable of type map(string) with default {} that merges with mandatory tags (project, environment, team, cost-center)
   - Use \`sensitive = true\` for credentials, tokens, and connection strings

2. **outputs.tf (Outputs)**
   - Expose only values that downstream modules or environments need — no internal implementation details
   - Use the pattern: [module_context]_[resource_type]_[attribute] (e.g., vpc_subnet_private_ids)
   - Include \`description\` on every output
   - Mark sensitive outputs explicitly
   - Always output resource ARNs and IDs for cross-module wiring

3. **Module Composition Contract**
   - Show how this module receives inputs from upstream modules (e.g., VPC ID from modules/vpc)
   - Show what downstream modules expect from this module's outputs
   - Define the dependency chain: vpc → ecs | rds | monitoring → security
   - Identify any circular dependency risks and how to break them

4. **versions.tf**
   - Pin AWS provider to exact patch version (e.g., = "5.31.0")
   - Set required_version for Terraform CLI (e.g., >= 1.6.0, < 2.0.0)
   - Include any additional providers this module needs (random, tls, null)

5. **Composition Example**
   - Show a sample module block in an environment root that wires this module to its dependencies:
     \`\`\`hcl
     module "[MODULE_NAME]" {
       source = "../../modules/[MODULE_NAME]"
       # Map upstream outputs to this module's inputs
     }
     \`\`\`

Constraints:
- Maximum 15 input variables per module; split into sub-modules if exceeding
- No inline IAM policies — output policy ARNs from modules/iam instead
- All resources must accept the merged tags map
- Variable types must be as specific as possible (avoid \`any\`)
- Use object types for complex inputs rather than multiple flat variables
\`\`\`

## Example: Wiring VPC → ECS

\`\`\`hcl
# environments/staging/main.tf
module "vpc" {
  source             = "../../modules/vpc"
  cidr_block         = "10.1.0.0/16"
  availability_zones = ["us-east-1a", "us-east-1b"]
  tags               = local.common_tags
}

module "ecs" {
  source              = "../../modules/ecs"
  vpc_id              = module.vpc.vpc_id
  private_subnet_ids  = module.vpc.subnet_private_ids
  alb_security_group  = module.vpc.default_security_group_id
  tags                = local.common_tags
}
\`\`\`

## Checklist Before Implementation

- [ ] Every variable has a \`description\` and explicit \`type\`
- [ ] Required vs optional split matches environment variance
- [ ] Outputs cover all downstream module input needs
- [ ] No \`type = any\` or \`type = list\` without element types
- [ ] Sensitive values are marked in both variables and outputs
- [ ] Tagging variable merges with mandatory project/environment/team/cost-center tags
- [ ] Provider versions pinned to exact patch in versions.tf
- [ ] README.md stub created with terraform-docs placeholder
- [ ] Module stays under 250 lines per file; split if necessary`,

  'playbook/prompts/02/data-model-design.md': `# Phase 2: Data Model Design — Infrastructure Data Layer

## Context

You are designing the data layer infrastructure for **aws-platform-iac**, a production-grade AWS platform requiring SOC 2 and ISO 27001 compliance. All resources must be defined as reusable Terraform modules under \`modules/\` with mandatory tagging (\`project\`, \`environment\`, \`team\`, \`cost-center\`).

## Prompt

Design the complete data layer infrastructure for our platform. Address each component below with specific, production-ready configurations.

### RDS PostgreSQL (\`modules/rds/\`)

- Recommend instance sizing per environment: dev (cost-optimized), staging (production-like), production (performance-optimized)
- Define Multi-AZ strategy: which environments require Multi-AZ, failover behavior
- Read replica topology: count, regions, promotion strategy for DR
- Backup policy: retention period, backup window, point-in-time recovery, cross-region backup for compliance
- Parameter group settings: \`shared_preload_libraries\`, \`log_min_duration_statement\`, connection limits, SSL enforcement
- Encryption: KMS key strategy (per-environment vs shared), storage encryption, in-transit TLS enforcement
- Maintenance window strategy and minor version upgrade policy
- Output: connection endpoints, reader endpoints, security group IDs, KMS key ARNs in \`outputs.tf\`

### ElastiCache Redis (\`modules/elasticache/\`)

- Cluster mode decision: enabled vs disabled, justify based on expected workload patterns (session cache, rate limiting, pub/sub)
- Node type sizing per environment with cost rationale
- Replication: number of replicas, automatic failover configuration
- Parameter group: \`maxmemory-policy\`, \`notify-keyspace-events\`, timeout settings
- Encryption at rest (KMS) and in-transit (TLS), AUTH token rotation strategy
- Subnet group placement within private subnets from \`modules/vpc/\`

### S3 Bucket Strategy

- Define bucket taxonomy: terraform-state, application-assets, audit-logs, backups, artifacts
- Lifecycle rules per bucket type: transition to IA/Glacier, expiration, abort incomplete multipart uploads
- Cross-region replication for audit-logs and backups (SOC 2 requirement)
- Encryption: SSE-KMS with bucket keys, deny unencrypted uploads via bucket policy
- Versioning policy per bucket type, MFA delete for production state and audit buckets
- Access logging: centralized log bucket, log prefix conventions
- Public access block on all buckets (enforced via \`aws_s3_account_public_access_block\`)

### DynamoDB Tables

- Terraform state locking table: partition key schema, billing mode, TTL for stale locks
- Application metadata table if needed: access patterns, GSI design, capacity mode
- Point-in-time recovery enabled, encryption with AWS-managed or CMK
- Tags and alarms for throttling (integrate with \`modules/monitoring/\`)

## Constraints

- Pin all provider and module versions to exact patch in \`versions.tf\`
- Never use inline IAM policies; define managed policies in \`modules/iam/\`
- All secrets (DB passwords, Redis AUTH tokens) managed via AWS Secrets Manager, referenced by ARN — never in \`*.tfvars\`
- Each module must include \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\` per project conventions
- Maximum 250 lines per file; split into submodules if needed (e.g., \`modules/rds/replica.tf\`)
- Write Terratest integration tests in \`tests/\` for each module (Go, under \`tests/data_layer_test.go\`)
- Reference VPC module outputs (private subnet IDs, security group IDs) — no hardcoded network values

## Output Format

Provide your design as:
1. **Architecture decision table** — component, config choice, rationale
2. **Module interface definitions** — key \`variables.tf\` inputs and \`outputs.tf\` for each module
3. **Environment matrix** — sizing and feature toggles per environment (dev/staging/production)
4. **Compliance mapping** — which design decisions satisfy SOC 2 / ISO 27001 controls
5. **Cost estimate approach** — how to tag and track data layer costs via \`cost-center\` tag values`,

  'playbook/prompts/03/ci-pipeline.md': `# Phase 3: Foundation — CI Pipeline Setup

## Objective
Configure GitHub Actions CI pipeline with OIDC-based AWS authentication, automated Terraform plan feedback on PRs, security scanning, and Slack notifications.

## Prompt

Set up the CI/CD pipeline for our Terraform AWS platform project. Follow these steps precisely:

### 1. AWS OIDC Provider for GitHub Actions
- Create \`modules/iam/github-oidc/\` with the standard module files (main.tf, variables.tf, outputs.tf, versions.tf, README.md)
- Configure the OIDC identity provider for \`token.actions.githubusercontent.com\`
- Create an IAM role with trust policy scoped to our repo and branch (\`main\`, \`feat/*\`, \`fix/*\`)
- Attach least-privilege managed policies — no inline policies per our convention
- Tag all resources with \`project=aws-platform-iac\`, \`team=sre\`, \`environment=ci\`, \`cost-center=engineering\`
- Pin the AWS provider to an exact patch version in versions.tf
- **No long-lived AWS access keys.** OIDC is the only acceptable auth method for CI

### 2. GitHub Actions Workflows
Create these workflow files in \`.github/workflows/\`:

**\`terraform-ci.yml\`** — Runs on every PR to \`main\`:
- **Lint**: Run \`terraform fmt -check -recursive\`, \`tflint --recursive\`, \`golangci-lint run ./...\`, \`ruff check scripts/ lambdas/\`
- **Validate**: Run \`terraform init -backend=false\` and \`terraform validate\` for each module in \`modules/\`
- **Test**: Run \`go test ./tests/... -v -short\` for unit-level Terratest tests, enforce 70% coverage threshold
- **Security Scan**: Run \`tfsec modules/\` and \`checkov -d modules/\` — fail the pipeline on HIGH/CRITICAL findings
- **Plan**: For each changed environment in \`environments/\`, run \`terraform plan -out=plan.tfplan\` and post the plan output as a PR comment using \`actions/github-script\`
- Use \`aws-actions/configure-aws-credentials\` with OIDC role ARN — never \`aws-access-key-id\`
- Mark all AI-generated code with \`# AI-generated\` comment headers per project policy

**\`terraform-apply.yml\`** — Runs on merge to \`main\`:
- Apply only the environments with changes (detect via \`git diff\`)
- Auto-apply to staging; require manual approval for production via GitHub Environments
- Post apply results to Slack

### 3. Branch Protection Rules
Document the required GitHub settings for \`main\` in \`docs/runbooks/branch-protection.md\`:
- Require 2 approvals before merge
- Require \`terraform-ci\` status checks to pass (lint, validate, test, security-scan, plan)
- Require signed commits
- Enforce CODEOWNERS review for \`modules/security/*\`, \`environments/production/*\`, and \`*.tfvars\`
- No force pushes, no deletions

### 4. Slack Notifications
- Add a job step at the end of both workflows using \`slackapi/slack-github-action\`
- On \`terraform-ci.yml\`: notify \`#infra-ci\` channel with plan summary and link to PR
- On \`terraform-apply.yml\`: notify \`#infra-deploys\` channel with apply result, environment, and commit SHA
- On failure in either workflow: notify \`#infra-alerts\` with failure details and link to the run

### 5. Workflow Hardening
- Pin all GitHub Actions to exact SHA, not tags
- Set \`permissions\` block to minimum required (contents: read, id-token: write, pull-requests: write)
- Use \`concurrency\` groups to prevent parallel plans on the same environment
- Store Terraform state in S3 with DynamoDB locking (reference \`modules/state-backend/\` from Phase 2)

## Validation Criteria
- [ ] \`terraform fmt -check\` passes on all new HCL files
- [ ] OIDC module passes \`tfsec\` and \`checkov\` with zero HIGH/CRITICAL findings
- [ ] CI workflow triggers correctly on a test PR and posts plan output as comment
- [ ] Slack notifications fire for success and failure scenarios
- [ ] No AWS access keys exist anywhere in the repo or workflow files
- [ ] All workflows comply with SOC 2 audit trail requirements (signed commits, approval gates, immutable logs)

## References
- \`.github/workflows/\` — workflow files
- \`modules/iam/github-oidc/\` — OIDC module
- \`docs/runbooks/branch-protection.md\` — protection rules
- \`playbook/prompts/02/state-backend.md\` — S3 state backend from Phase 2`,

  'playbook/prompts/03/iac-setup.md': `# Phase 3: Foundation — IaC Baseline Setup

## Objective

Stand up the Terraform state backend, provider configuration, base networking, IAM baseline, and workspace-based environment isolation.

## Step 1: State Backend (S3 + DynamoDB)

Create \`environments/bootstrap/main.tf\` to provision the remote state infrastructure:

- S3 bucket \`aws-platform-iac-tfstate-<account-id>\` with versioning enabled, AES-256 encryption, and \`prevent_destroy = true\`
- DynamoDB table \`terraform-lock\` with \`LockID\` as partition key (PAY_PER_REQUEST billing)
- Tag both resources with \`project = "aws-platform-iac"\`, \`environment = "management"\`, \`team = "sre"\`, \`cost-center = "infrastructure"\`
- Apply this manually once: \`cd environments/bootstrap && terraform init && terraform apply\`

## Step 2: Provider Configuration

Create \`environments/provider.tf\` as the shared provider template:

- Pin \`hashicorp/aws\` to an exact patch version (e.g., \`= 5.82.2\`)
- Pin \`hashicorp/random\` and \`hashicorp/null\` to exact patches
- Set \`required_version\` to \`~> 1.7.0\` in \`terraform.required_version\`
- Configure the S3 backend block with \`encrypt = true\`, \`dynamodb_table = "terraform-lock"\`, and \`key\` parameterized per environment
- Add default tags in the provider block: \`project\`, \`environment\`, \`team\`, \`cost-center\`, \`managed-by = "terraform"\`

Run \`terraform fmt -recursive\` and \`terraform validate\` after creation.

## Step 3: Base VPC Module

Build \`modules/vpc/\` with \`main.tf\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, and \`README.md\`:

- Accept variables: \`cidr_block\`, \`environment\`, \`availability_zones\` (list), \`enable_nat_gateway\` (bool), \`single_nat_gateway\` (bool for cost savings in dev)
- Create VPC with DNS support and DNS hostnames enabled
- Create public subnets (one per AZ) with auto-assign public IP, internet gateway, and route table
- Create private subnets (one per AZ) with NAT gateway(s) and separate route table
- Create database subnets (one per AZ) with no internet access and a dedicated subnet group
- Output \`vpc_id\`, \`public_subnet_ids\`, \`private_subnet_ids\`, \`database_subnet_ids\`, \`nat_gateway_ips\`
- Enable VPC flow logs to CloudWatch (retention 90 days for SOC 2 compliance)
- Generate docs with \`terraform-docs markdown table modules/vpc/ > modules/vpc/README.md\`

## Step 4: IAM Baseline

Build \`modules/iam/\` with managed policies only (no inline policies per project convention):

- **CI role** (\`github-actions-deployer\`): assume role via OIDC federation with GitHub Actions, scoped to \`sts:AssumeRoleWithWebIdentity\` for the repo
- **Developer role** (\`developer-readonly\`): read-only access to staging resources, no production access, MFA required
- **Service roles**: create a reusable submodule \`modules/iam/ecs-task-role\` that accepts a list of managed policy ARNs and produces a task role + execution role pair
- Enforce \`aws:RequestedRegion\` condition on all roles to restrict to approved regions
- Tag all IAM resources per the tagging policy

## Step 5: Workspace-Based Environment Isolation

Configure workspaces in \`environments/\`:

\`\`\`
terraform workspace new dev
terraform workspace new staging
terraform workspace new production
\`\`\`

- Create \`environments/dev.tfvars\`, \`environments/staging.tfvars\`, \`environments/production.tfvars\` with environment-specific CIDR blocks, instance sizes, and feature flags
- In \`environments/main.tf\`, reference \`terraform.workspace\` to select the correct \`.tfvars\` values and pass \`environment = terraform.workspace\` to all modules
- Add a workspace validation local that blocks \`terraform apply\` on \`production\` workspace outside CI (check via \`TF_VAR_ci_run\` variable)

## Validation Checklist

- [ ] \`terraform init\` succeeds with remote backend in each workspace
- [ ] \`tflint --init && tflint\` passes on all modules
- [ ] \`tfsec .\` reports no HIGH or CRITICAL findings
- [ ] \`terraform plan\` in \`dev\` workspace shows expected VPC and IAM resources
- [ ] All resources carry the four required tags
- [ ] \`modules/vpc/README.md\` and \`modules/iam/README.md\` are generated and committed`,

  'playbook/prompts/03/project-scaffold.md': `# Phase 3: Foundation — Project Scaffold

## Prompt

You are scaffolding the \`aws-platform-iac\` Terraform project. Create the full directory structure and foundational files following our conventions. Every Terraform module and environment must be immediately usable after this step.

## Directory Structure to Create

### Terraform Modules (\`modules/\`)

Create each module directory with the required file set (\`main.tf\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, \`README.md\`):

- \`modules/vpc\` — VPC, subnets, NAT gateways, flow logs
- \`modules/ecs\` — ECS cluster, task definitions, services, ALB integration
- \`modules/rds\` — PostgreSQL Aurora cluster, parameter groups, subnet groups
- \`modules/monitoring\` — CloudWatch dashboards, alarms, log groups, SNS topics
- \`modules/security\` — Security groups, WAF rules, GuardDuty, Config rules
- \`modules/iam\` — Managed IAM policies, roles, instance profiles (no inline policies)

Pin all provider versions to exact patch in each \`versions.tf\`. Include the required AWS resource tags (\`project\`, \`environment\`, \`team\`, \`cost-center\`) as default variable maps in every module.

### Environments (\`environments/\`)

For each of \`dev\`, \`staging\`, \`production\`:

- \`backend.tf\` — S3 backend with DynamoDB locking, unique key per environment (e.g., \`aws-platform-iac/dev/terraform.tfstate\`), encrypt = true
- \`main.tf\` — Module calls referencing \`../../modules/*\` with environment-specific sizing
- \`variables.tf\` — Environment-scoped variables with sensible defaults
- \`outputs.tf\` — Expose critical resource IDs and endpoints
- \`terraform.tfvars.example\` — Documented example (never commit actual \`.tfvars\`)
- \`providers.tf\` — AWS provider with \`default_tags\` block enforcing our tagging policy

### Go Tooling

Initialize \`go.mod\` at repo root with module path \`github.com/team/aws-platform-iac\`. Add dependencies:

- \`github.com/gruntwork-io/terratest\` for integration tests
- \`github.com/spf13/cobra\` for CLI tools in \`cmd/\`
- \`github.com/aws/aws-sdk-go-v2\` for Lambda functions and automation

Create stub \`cmd/provisioner/main.go\` and \`cmd/cost-reporter/main.go\` with Cobra CLI scaffolding.

### Makefile

Create a root \`Makefile\` with these targets:

- \`fmt\` — Run \`terraform fmt -recursive\`, \`gofmt\`, \`ruff format\`
- \`lint\` — Run \`tflint\`, \`tfsec\`, \`golangci-lint run\`, \`ruff check\`
- \`validate\` — Run \`terraform validate\` across all environments
- \`docs\` — Run \`terraform-docs\` to regenerate module READMEs
- \`test-unit\` — Run \`go test ./tests/unit/...\`
- \`test-integration\` — Run \`go test -timeout 30m ./tests/integration/...\`
- \`plan-ENV\` — Dynamic target: \`terraform -chdir=environments/$(ENV) plan\`
- \`apply-ENV\` — Dynamic target with \`-auto-approve\` gated behind confirmation
- \`security-scan\` — Run \`tfsec\` and \`checkov\` against all modules
- \`clean\` — Remove \`.terraform\` directories and plan files

### Supporting Files

- \`tests/unit/.gitkeep\` and \`tests/integration/.gitkeep\`
- \`lambdas/go/.gitkeep\` and \`lambdas/python/.gitkeep\`
- \`charts/.gitkeep\` and \`scripts/.gitkeep\`
- \`docs/adr/0001-use-terraform-modules.md\` — First ADR documenting module-based architecture
- \`.gitignore\` — Terraform-specific ignores (\`.terraform/\`, \`*.tfstate*\`, \`*.tfvars\`, \`crash.log\`, \`.terraformrc\`)

## Validation Checklist

After scaffolding, confirm:

1. \`terraform fmt -check -recursive\` passes with zero diff
2. \`terraform validate\` succeeds in each environment directory after \`terraform init\`
3. \`go mod tidy\` completes without errors
4. \`make lint\` runs all linters without configuration errors
5. Every module directory contains exactly: \`main.tf\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, \`README.md\`
6. No \`.tfvars\` files are committed — only \`.tfvars.example\`
7. All \`backend.tf\` files use unique state keys and enable encryption
8. SOC 2 / ISO 27001 compliance tags are present in default tag variables`,

  'playbook/prompts/04/auth-implementation.md': `# Phase 4: IAM & Secrets Implementation

## Objective

Implement least-privilege IAM roles, KMS encryption, and secrets management for the aws-platform-iac platform, aligned with SOC 2 and ISO 27001 access control requirements.

## Step 1: Design IAM Role Hierarchy

Define the role structure in \`modules/iam/\` following our module conventions (README.md, variables.tf, outputs.tf, versions.tf):

- **ServiceRoles**: ECS task roles, Lambda execution roles, RDS monitoring role — each scoped to a single service with only the permissions that service requires
- **CIRole**: \`github-actions-deployer\` — assumable via OIDC federation from GitHub Actions, scoped to \`terraform plan\` + \`terraform apply\` on specific state buckets and resource types
- **DeveloperRole**: \`developer-readonly\` — read access to non-production environments, \`terraform plan\` only, no \`terraform apply\` to staging/production
- **AdminRole**: \`platform-admin\` — full infrastructure access with MFA enforcement and session duration limits (1 hour max)
- **BreakGlassRole**: \`emergency-access\` — broad permissions, requires dual approval, all actions logged to CloudTrail with PagerDuty alert

Tag every role with \`project = "aws-platform-iac"\`, \`environment\`, \`team = "platform-sre"\`, \`cost-center\`.

## Step 2: Implement Least-Privilege Policies

\`\`\`
Create managed policies in modules/security/iam_policies.tf — never use inline policies.

For each service role:
1. Start with zero permissions
2. Add only specific actions on specific resource ARNs
3. Use condition keys: aws:RequestedRegion, aws:PrincipalTag, ec2:ResourceTag
4. Deny wildcards in resource fields — every policy must reference explicit ARNs or ARN patterns
5. Run: tfsec modules/security/ and checkov -d modules/security/ to validate
\`\`\`

Implement permission boundaries for all human-assumable roles to cap maximum possible privileges regardless of attached policies.

## Step 3: Configure GitHub Actions OIDC Federation

In \`modules/iam/ci_role.tf\`, set up OIDC provider for GitHub Actions — no long-lived AWS credentials:

- Trust policy restricts to \`repo:your-org/aws-platform-iac:ref:refs/heads/main\` for production applies
- Staging allows \`ref:refs/heads/*\` but only for \`terraform plan\` and staging state
- CI role assumes environment-specific deploy roles via \`sts:AssumeRole\` chaining

## Step 4: Cross-Account Access

Define in \`modules/iam/cross_account.tf\`:

- Hub-and-spoke model: management account holds IAM users/SSO, workload accounts hold roles
- Trust relationships between \`shared-services\`, \`staging\`, and \`production\` accounts
- Use \`aws:PrincipalOrgID\` condition to restrict trust to your AWS Organization
- External ID required for any third-party cross-account access

## Step 5: SSO / SAML Configuration

In \`modules/security/sso.tf\`:

- Configure AWS IAM Identity Center with your IdP (Okta/Azure AD)
- Map IdP groups to permission sets: \`PlatformAdmin\`, \`DeveloperReadOnly\`, \`CostViewer\`
- Enforce MFA at the IdP level — do not rely solely on AWS MFA
- Session duration: 8 hours for developers, 1 hour for admin operations

## Step 6: KMS Key Policies

In \`modules/security/kms.tf\`, create purpose-specific keys — not a single shared key:

- \`rds-encryption-key\` — grants \`rds.amazonaws.com\` encrypt/decrypt, admin access to platform-admin role
- \`secrets-encryption-key\` — grants Secrets Manager service, Lambda execution roles for decrypt only
- \`s3-state-key\` — grants CI role and admin role, denies all other principals
- Enable automatic key rotation (annual) on all keys
- All key policies must include explicit \`Deny\` for \`kms:*\` to root unless via specific admin role

## Step 7: Secrets Manager Setup

In \`modules/security/secrets_manager.tf\`:

- Store RDS credentials with automatic rotation (30-day cycle) via Lambda rotator in \`lambdas/secret-rotator/\`
- Store third-party API keys with resource policies restricting access to specific Lambda execution roles
- Use \`aws_secretsmanager_secret\` with \`kms_key_id\` pointing to \`secrets-encryption-key\`
- Never reference secret values in Terraform state — use \`data.aws_secretsmanager_secret_version\` at runtime only

## Validation Checklist

\`\`\`bash
terraform fmt -check -recursive modules/iam/ modules/security/
terraform validate modules/iam/ && terraform validate modules/security/
tflint --recursive modules/iam/ modules/security/
tfsec modules/iam/ modules/security/
checkov -d modules/security/ --framework terraform --check CKV_AWS_40,CKV_AWS_49,CKV_AWS_61,CKV_AWS_63
go test ./tests/iam_test.go -v -timeout 30m  # Terratest integration tests
\`\`\`

## Sensitive Path Reminder

All files under \`modules/security/*\` and \`*.tfvars\` require **2 approvals** per CODEOWNERS and must pass security scan before merge. See \`.claude/rules/security-sensitive-changes.md\`.`,

  'playbook/prompts/04/crud-generator.md': `# Terraform Module Generator

## Context
You are creating a new reusable Terraform module for the aws-platform-iac project. All modules live under \`modules/\` and must comply with SOC 2 and ISO 27001 tagging and security requirements.

## Instructions
Generate a complete Terraform module for **{{MODULE_NAME}}** that manages **{{RESOURCE_DESCRIPTION}}**.

### Required Files

**modules/{{MODULE_NAME}}/main.tf** — Resource definitions with:
- \`locals\` block merging required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`, \`managed-by = "terraform"\`
- All AWS resources tagged via \`local.tags\`
- No inline IAM policies; reference managed policies only
- Max 250 lines; split into \`iam.tf\`, \`security.tf\` as needed

**modules/{{MODULE_NAME}}/variables.tf** — Standard variable pattern:
- \`name\` (string) — Resource identifier, validated with \`regex("^[a-z][a-z0-9-]+$")\`
- \`environment\` (string) — One of \`["dev", "staging", "production"]\`
- \`tags\` (map(string), default \`{}\`) — Additional tags merged with required tags
- \`vpc_id\` / \`subnet_ids\` if network-attached
- Resource-specific variables with descriptions, types, defaults, and validations

**modules/{{MODULE_NAME}}/outputs.tf** — Standard output pattern:
- \`id\` — Primary resource identifier
- \`arn\` — Resource ARN for IAM references
- \`endpoint\` — Connection endpoint (if applicable)
- \`security_group_id\` — Associated SG (if applicable)

**modules/{{MODULE_NAME}}/versions.tf** — Pin providers to exact patch:
\`\`\`hcl
terraform { required_version = ">= 1.5.0" }
# Pin: aws = "= X.Y.Z", random = "= X.Y.Z"
\`\`\`

**modules/{{MODULE_NAME}}/README.md** — Generated via terraform-docs format:
- Purpose, usage example referencing \`environments/dev\`, inputs table, outputs table

### Terratest File

**tests/modules/{{MODULE_NAME}}_test.go**:
- Package \`test\`, import \`github.com/gruntwork-io/terratest/modules/terraform\`
- \`TestModule{{MODULE_NAME_PASCAL}}\` function using \`terraform.InitAndPlan\` for validation
- \`TestModule{{MODULE_NAME_PASCAL}}Deploy\` with build tag \`//go:build integration\` using \`InitAndApply\` + deferred \`Destroy\`
- Assert outputs \`id\` and \`arn\` are non-empty
- Use \`t.Parallel()\` and set \`Vars\` with test values including all required tags

### Constraints
- Follow snake_case for filenames and HCL identifiers
- Every variable must have a \`description\`
- Use \`terraform fmt\` compatible formatting
- Reference \`docs/module-standards.md\` for the full tagging policy
- Flag output with \`# AI-generated module — review required\` header comment`,

  'playbook/prompts/04/feature-implementation.md': `# Phase 4: Core Implementation — New Terraform Module/Feature

## Module: \`{MODULE_NAME}\`
**Ticket**: {TICKET_ID}
**Environment Target**: {dev|staging|production}

---

### Step 1: Define Module Interface

Create \`modules/{MODULE_NAME}/variables.tf\` with all required inputs. Every variable must have a \`description\`, explicit \`type\`, and \`default\` where sensible. Define \`outputs.tf\` exposing resource IDs, ARNs, and endpoints consumers need. Create \`versions.tf\` pinning the AWS provider to an exact patch version (e.g., \`= 5.46.0\`).

\`\`\`
Prompt: Define the variables.tf, outputs.tf, and versions.tf for a Terraform module named {MODULE_NAME} that provisions {RESOURCE_DESCRIPTION}. Pin provider versions to exact patch. Include validation blocks on variables where input constraints exist (e.g., CIDR ranges, instance classes, naming patterns). Follow snake_case naming for all variables and outputs.
\`\`\`

### Step 2: Implement Resources

Create \`modules/{MODULE_NAME}/main.tf\` (and split into logical files if approaching 250 lines — e.g., \`iam.tf\`, \`security_groups.tf\`). Use only managed IAM policies, never inline. Reference \`var.*\` for all configurable values.

\`\`\`
Prompt: Implement the core Terraform resources for {MODULE_NAME} that {RESOURCE_DESCRIPTION}. Split files at 250 lines max. Use aws_iam_policy resources instead of inline policies. Ensure all security groups follow least-privilege rules. Reference SOC 2 and ISO 27001 requirements for {encryption at rest | network isolation | access logging | audit trails} as applicable.
\`\`\`

### Step 3: Enforce Resource Tagging

Every AWS resource must include the mandatory tag set. Create a \`locals.tf\` with merged tags:

\`\`\`hcl
locals {
  common_tags = merge(var.tags, {
    project      = "aws-platform-iac"
    environment  = var.environment
    team         = var.team
    cost-center  = var.cost_center
    managed-by   = "terraform"
  })
}
\`\`\`

\`\`\`
Prompt: Audit all resources in modules/{MODULE_NAME}/main.tf and ensure every taggable resource uses \`tags = local.common_tags\`. Add the tags variable and common_tags local if missing.
\`\`\`

### Step 4: Write Terratest Integration Tests

Create \`tests/{MODULE_NAME}_test.go\` using Terratest. Test that \`terraform init\`, \`plan\`, and \`apply\` succeed, validate key outputs are non-empty, and assert resource properties match expectations. Use \`defer terraform.Destroy(t, terraformOptions)\`.

\`\`\`
Prompt: Write a Terratest integration test in Go for modules/{MODULE_NAME}. The test should deploy to a temporary AWS environment, validate that outputs {LIST_KEY_OUTPUTS} are populated and correct, check that mandatory tags are present on created resources, then destroy all resources. Use t.Parallel() and set a 30-minute timeout.
\`\`\`

### Step 5: Document the Module

Create \`modules/{MODULE_NAME}/README.md\` with a description, usage example, inputs table, outputs table, and compliance notes. Generate the inputs/outputs tables with \`terraform-docs markdown table modules/{MODULE_NAME}\`.

\`\`\`
Prompt: Write a README.md for modules/{MODULE_NAME} including: purpose, architecture diagram reference (link to docs/architecture/), a copy-paste usage example with realistic values, and a compliance section noting which SOC 2 / ISO 27001 controls this module addresses. Leave placeholders for terraform-docs auto-generated sections.
\`\`\`

### Step 6: Validate

Run the full validation chain before opening a PR:

\`\`\`bash
cd modules/{MODULE_NAME}
terraform fmt -check -recursive
terraform init -backend=false
terraform validate
tflint --init && tflint
tfsec .
checkov -d .
cd ../../tests
go test -v -run TestModule{MODULE_NAME} -timeout 30m
terraform-docs markdown table ../../modules/{MODULE_NAME} > ../../modules/{MODULE_NAME}/README.md  # merge into existing
\`\`\`

\`\`\`
Prompt: Review modules/{MODULE_NAME} for completeness: confirm variables.tf, outputs.tf, versions.tf, README.md all exist, no file exceeds 250 lines, all providers are pinned to exact patch, no inline IAM policies are used, and all resources carry common_tags. Flag anything missing.
\`\`\`

---

**PR Checklist**: \`terraform plan\` clean for dev → conventional commit (\`feat: add {MODULE_NAME} module\`) → 2 approvals → security scan green → merge to \`main\`.`,

  'playbook/prompts/05/integration-adapter.md': `# Phase 5: Integration Adapter — Wiring Terraform Modules Together

## Objective

Compose the individual Terraform modules (VPC, ECS, RDS, ALB, monitoring, security) into integrated environment stacks under \`environments/\`, ensuring correct dependency ordering, output propagation, and end-to-end testability with Terratest.

## Module Composition Pattern

Wire modules in \`environments/<env>/main.tf\` using explicit output-to-input chaining. Follow this dependency graph:

\`\`\`
VPC → Security Groups → RDS → ECS → ALB → Route53 → Monitoring
\`\`\`

Each module block must reference the source module's outputs directly — never hardcode IDs or ARNs. Example:

\`\`\`hcl
module "vpc" {
  source = "../../modules/vpc"
  # ...
}

module "ecs" {
  source             = "../../modules/ecs"
  vpc_id             = module.vpc.vpc_id
  private_subnet_ids = module.vpc.private_subnet_ids
  alb_target_group_arn = module.alb.target_group_arn
}

module "rds" {
  source             = "../../modules/rds"
  vpc_id             = module.vpc.vpc_id
  database_subnet_ids = module.vpc.database_subnet_ids
  allowed_security_group_ids = [module.ecs.task_security_group_id]
}
\`\`\`

## Tasks

1. **Map the dependency graph** — Document every output→input edge between modules in \`docs/module-dependency-graph.md\`. Identify circular references early; break them with \`aws_security_group_rule\` resources instead of inline rules.

2. **Create environment root modules** — Build \`environments/dev/main.tf\`, \`environments/staging/main.tf\`, and \`environments/production/main.tf\`. Each calls the same modules with environment-specific \`*.tfvars\`. Pin module sources to exact paths, not registry refs.

3. **Propagate outputs cleanly** — Every module must expose only what downstream consumers need in \`outputs.tf\`. Avoid leaking internal resource IDs. Create an \`environments/<env>/outputs.tf\` that surfaces key endpoints (ALB DNS, RDS endpoint, ECS cluster ARN) for Terratest assertions.

4. **Enforce tagging at the root** — Pass \`project\`, \`environment\`, \`team\`, and \`cost-center\` tags as a shared \`local.common_tags\` map from the environment root into every module's \`tags\` variable. Never let a module define its own tag defaults.

5. **Handle cross-module security** — Wire security group IDs between modules explicitly. ECS tasks get the SG that RDS allows inbound from. ALB gets a public-facing SG; ECS gets a private SG allowing traffic only from the ALB SG. Reference \`modules/security/*\` for managed IAM policies — no inline policies.

6. **Manage state dependencies** — Use a single S3 backend per environment with DynamoDB locking. If modules are split into separate state files, use \`terraform_remote_state\` data sources sparingly and document each cross-state reference.

7. **Validate before apply** — Run \`terraform validate\`, \`tflint\`, \`tfsec\`, and \`checkov\` against each environment root. Add a \`scripts/validate-all.sh\` that iterates environments and fails fast on any error.

## Terratest End-to-End Integration Tests

Create \`tests/integration/platform_test.go\`:

- Use \`terraform.InitAndApply\` against \`environments/dev\` with test-specific \`*.tfvars\`.
- Assert VPC CIDR, subnet counts, and AZ distribution from outputs.
- Assert ECS cluster is ACTIVE and service desired count matches.
- Assert RDS endpoint is resolvable and accepts TCP connections on port 5432.
- Assert ALB returns HTTP 200 on the health check path.
- Assert all resources carry the required tags using AWS SDK calls.
- Use \`defer terraform.Destroy\` to clean up. Tag test resources with \`environment = "test"\` for cost tracking.
- Target 70% coverage of module integration paths. Run via \`go test -v -timeout 30m ./tests/integration/...\`.

## Validation Checklist

- [ ] \`terraform plan\` on each environment shows no unexpected changes after initial apply
- [ ] No hardcoded resource IDs — all cross-module references use \`module.<name>.<output>\`
- [ ] \`tfsec\` and \`checkov\` pass with zero high-severity findings (SOC 2 / ISO 27001)
- [ ] Terratest suite passes in CI via \`.github/workflows/integration-test.yml\`
- [ ] All resources tagged per policy; \`scripts/validate-tags.py\` confirms compliance
- [ ] Module dependency graph documented and reviewed by at least one lead engineer`,

  'playbook/prompts/05/observability-setup.md': `# Phase 5: Observability Setup

## Objective
Implement comprehensive observability across the AWS platform covering metrics, logging, alerting, and cost monitoring aligned with SOC 2 operational requirements.

## CloudWatch Dashboards

Create per-service dashboards in \`modules/monitoring/dashboards/\`:

- **ECS Services**: CPU utilization, memory utilization, running task count, deployment status, container insights metrics
- **RDS Clusters**: read/write IOPS, connection count, replication lag, freeable memory, CPU credit balance
- **ALB**: request count, target response time (p50/p95/p99), 4xx/5xx error rates, healthy host count
- **VPC**: NAT gateway bytes processed, VPN tunnel state, flow log rejected packet count
- **ElastiCache Redis**: cache hit rate, evictions, current connections, replication lag

Use \`aws_cloudwatch_dashboard\` resources with templated JSON widgets. Tag all dashboards with \`project\`, \`environment\`, \`team\`, \`cost-center\`.

## CloudWatch Alarms

Define alarm thresholds in \`modules/monitoring/alarms.tf\`:

| Metric | Warning | Critical | Evaluation Period |
|---|---|---|---|
| ECS CPU utilization | >70% | >90% | 3 of 5 min |
| ECS memory utilization | >75% | >90% | 3 of 5 min |
| RDS disk usage | >75% | >90% | 2 of 5 min |
| ALB 5xx error rate | >1% | >5% | 2 of 3 min |
| RDS connections | >80% max | >95% max | 3 of 5 min |
| ElastiCache evictions | >100/min | >500/min | 3 of 5 min |

Route alarms through SNS topics: \`{env}-warning-alerts\` → Slack, \`{env}-critical-alerts\` → PagerDuty.

## Prometheus & Grafana

1. Deploy Prometheus sidecar containers in ECS task definitions — expose \`/metrics\` on port 9090
2. Configure service discovery using ECS metadata endpoint for automatic target registration
3. Set up Grafana in \`charts/grafana/\` Helm chart with AWS data sources (CloudWatch, Prometheus)
4. Import dashboards: ECS cluster overview, RDS performance, Redis operations, ALB traffic, cost trends
5. Configure Grafana alerting rules as backup to CloudWatch alarms for defense-in-depth

## PagerDuty Integration

In \`modules/monitoring/pagerduty.tf\`:

- Create PagerDuty service integration via \`aws_sns_topic_subscription\` with HTTPS endpoint
- Define escalation: critical alerts → on-call SRE (5 min ack) → SRE lead (15 min) → engineering manager (30 min)
- Tag incidents with service name, environment, and runbook URL from \`docs/runbooks/\`
- Suppress duplicate alarms within 10-minute deduplication window

## Log Aggregation

Configure in \`modules/monitoring/logging.tf\`:

- ECS container logs → CloudWatch Log Groups (14-day retention in dev, 90-day in production)
- CloudWatch Logs subscription filter → Kinesis Firehose → S3 bucket (lifecycle: IA at 30 days, Glacier at 90 days)
- VPC Flow Logs → dedicated log group with metric filters for rejected connections
- Enable CloudTrail log validation for SOC 2 / ISO 27001 audit trail integrity

## Cost Monitoring

Define in \`modules/monitoring/cost.tf\`:

- \`aws_budgets_budget\` per environment with 80% and 100% threshold notifications
- Monthly forecasted spend alarm → Slack \`#infra-costs\` channel
- Tag-based cost allocation: enforce \`cost-center\` tag via \`aws_organizations_policy\`
- Weekly Cost Explorer report (automated via Lambda in \`lambdas/cost-reporter/\`) posted to Slack

## Validation

\`\`\`bash
cd modules/monitoring
terraform validate
tflint --recursive
tfsec .
cd ../../tests
go test -v -run TestMonitoringModule -timeout 30m
\`\`\`

Verify: dashboards render in CloudWatch console, test alarm triggers with \`aws cloudwatch set-alarm-state\`, confirm PagerDuty receives test incident, validate logs appear in S3 within delivery window.

## References

- \`modules/monitoring/\` — all observability Terraform resources
- \`docs/runbooks/\` — incident response procedures linked from PagerDuty
- \`lambdas/cost-reporter/\` — automated cost reporting function
- \`playbook/prompts/05/security-hardening.md\` — complementary hardening phase`,

  'playbook/prompts/05/security-hardening.md': `# Phase 5: Security Hardening — AWS Infrastructure

## Objective

Harden all AWS infrastructure to meet SOC 2 and ISO 27001 compliance requirements. Every resource must be auditable, encrypted, and follow least-privilege access patterns.

## Prompt

You are hardening the aws-platform-iac infrastructure for production readiness. Work through each security domain systematically, implementing changes as Terraform code in the appropriate modules under \`modules/security/\`, \`modules/vpc/\`, \`modules/rds/\`, and \`environments/production/\`.

### 1. VPC Flow Logs

Enable VPC flow logs for all VPCs in \`modules/vpc/\`. Send logs to a dedicated CloudWatch log group with 90-day retention. Include both ACCEPT and REJECT traffic. Ensure the IAM role for flow logs follows least-privilege and uses a managed policy (never inline). Tag the log group with project, environment, team, and cost-center.

### 2. AWS GuardDuty

Enable GuardDuty in \`modules/security/guardduty.tf\` across all active regions. Configure S3 protection, EKS audit log monitoring, and RDS login activity monitoring. Set up SNS notifications routed to PagerDuty for HIGH and CRITICAL findings. Create a GuardDuty member/admin structure if using AWS Organizations.

### 3. WAF Rules

Define WAF v2 web ACLs in \`modules/security/waf.tf\` and associate them with all ALBs. Include managed rule groups: AWSManagedRulesCommonRuleSet, AWSManagedRulesSQLiRuleSet, AWSManagedRulesKnownBadInputsRuleSet. Add rate-limiting rules (2000 requests per 5 minutes per IP). Enable WAF logging to S3 with a 30-day lifecycle policy.

### 4. CloudTrail

Enable CloudTrail in \`modules/security/cloudtrail.tf\` with multi-region trail, management event logging, and S3 data event logging for sensitive buckets. Store logs in a dedicated S3 bucket with SSE-KMS encryption, object lock enabled, and a bucket policy that denies unencrypted transport. Enable CloudTrail Insights for anomaly detection.

### 5. Security Group Audit

Review and tighten all security groups in \`modules/vpc/security_groups.tf\`. Remove any rules allowing \`0.0.0.0/0\` ingress except on port 443 for public ALBs. Ensure database security groups only allow ingress from application subnets. Add descriptions to every rule. Create a \`security_group_audit.tf\` in \`modules/security/\` that uses \`aws_ec2_managed_prefix_list\` for trusted CIDR management.

### 6. RDS Encryption at Rest

Verify all RDS instances and Aurora clusters in \`modules/rds/\` have \`storage_encrypted = true\` with a customer-managed KMS key. Enable \`deletion_protection = true\` for production. Ensure automated backups use the same KMS key. Set \`iam_database_authentication_enabled = true\` for all PostgreSQL instances.

### 7. TLS Enforcement

Ensure all ALB listeners redirect HTTP to HTTPS. Configure ACM certificates with DNS validation via Route53 in \`modules/security/tls.tf\`. Set \`ssl_policy = "ELBSecurityPolicy-TLS13-1-2-2021-06"\` on all HTTPS listeners. For RDS, set \`rds.force_ssl = 1\` in the parameter group. For ElastiCache Redis, enable \`transit_encryption_enabled = true\` and \`at_rest_encryption_enabled = true\`.

### 8. S3 Bucket Policies

Apply baseline bucket policies in \`modules/security/s3_baseline.tf\`: block all public access (\`aws_s3_bucket_public_access_block\`), enforce SSE-S3 or SSE-KMS encryption via bucket policy condition \`aws:SecureTransport\`, enable versioning, and enable S3 access logging to a centralized logging bucket. Deny any \`s3:PutObject\` without \`x-amz-server-side-encryption\`.

### 9. Network ACLs

Define explicit network ACLs in \`modules/vpc/nacls.tf\` for public, private, and data subnets. Deny all traffic by default, then allow only required ports: 443 inbound on public subnets, 5432 and 6379 inbound on data subnets from private subnets only, ephemeral ports for return traffic. Document each rule with comments referencing the service it supports.

### 10. tfsec Scan and Remediation

Run \`tfsec . --format json --out tfsec-report.json\` against the entire codebase. Address all HIGH and CRITICAL findings. For any finding that requires a justified exception, add a \`#tfsec:ignore:<rule-id>\` comment with a linked GitHub Issue explaining the risk acceptance. Also run \`checkov -d . --framework terraform\` and remediate any CIS AWS Benchmark failures. Update \`.github/workflows/security-scan.yml\` to fail the pipeline on any unacknowledged HIGH+ finding.

## Validation Checklist

- [ ] \`terraform validate\` passes for all modules and environments
- [ ] \`terraform plan\` shows no unexpected resource destruction
- [ ] \`tfsec .\` reports zero unacknowledged HIGH/CRITICAL findings
- [ ] \`checkov\` CIS AWS Benchmark score ≥ 95%
- [ ] All resources tagged with project, environment, team, cost-center
- [ ] No inline IAM policies exist anywhere in the codebase
- [ ] PR targets \`main\` with at least 2 approvals and security scan passing

## References

- [modules/security/README.md](../../modules/security/README.md)
- [docs/adr/005-encryption-strategy.md](../../docs/adr/005-encryption-strategy.md)
- [.claude/rules/security.md](../../.claude/rules/security.md)`,

  'playbook/prompts/06/e2e-test-generator.md': `# End-to-End Infrastructure Test Generator

## Context

You are generating end-to-end Terratest suites that deploy full environments in an isolated AWS test account (\`aws-platform-test\`), verify every resource, and tear down cleanly. Tests must pass before any promotion to staging or production.

## Test Account Requirements

- Use AWS account alias \`aws-platform-test\` (account ID in \`environments/test/backend.tf\`)
- All resources tagged with \`environment = "e2e-test"\`, \`cost-center = "testing"\`, \`ttl = "4h"\`
- Tests run in \`us-east-1\` unless multi-region is under test
- IAM role \`e2e-test-executor\` with scoped permissions — never use admin credentials

## Generate Terratest Suite Structure

Place tests in \`tests/e2e/\` with one file per validation domain:

| File | Scope |
|---|---|
| \`full_deploy_test.go\` | Orchestrates \`terraform init/plan/apply\` for \`environments/test/\`, asserts zero-error exit |
| \`network_test.go\` | VPC CIDR allocation, subnet AZ spread, NAT gateway routing, VPC peering connectivity, NACLs |
| \`security_groups_test.go\` | Ingress/egress rules match module outputs, no \`0.0.0.0/0\` ingress on non-ALB ports |
| \`ecs_service_test.go\` | ECS tasks reach RUNNING state, ALB target group returns HTTP 200 on \`/healthz\` |
| \`rds_test.go\` | PostgreSQL connection succeeds from ECS subnet, read replica lag < 1s, automated backups enabled |
| \`redis_test.go\` | ElastiCache \`PING\` returns \`PONG\` from private subnet, encryption at rest and in transit enabled |
| \`monitoring_test.go\` | CloudWatch alarms exist for CPU, memory, RDS connections; SNS topic subscription confirmed |
| \`iam_compliance_test.go\` | No inline policies, MFA enforced on human roles, no wildcard \`Resource: "*"\` on write actions |
| \`teardown_test.go\` | \`terraform destroy\` exits cleanly, AWS API confirms zero resources with \`e2e-test\` tag remain |

## Test Implementation Guidelines

\`\`\`go
// Use TestMain for ordered execution — deploy once, validate many, destroy once
func TestMain(m *testing.M) {
    terraformOptions := terraform.WithDefaultRetryableErrors(t, &terraform.Options{
        TerraformDir: "../../environments/test",
        Vars: map[string]interface{}{
            "environment": "e2e-test",
            "project":     "aws-platform-iac",
        },
        NoColor: true,
    })
    defer terraform.Destroy(t, terraformOptions)
    terraform.InitAndApply(t, terraformOptions)
    os.Exit(m.Run())
}
\`\`\`

- Use \`terraform.Output()\` to fetch ALB DNS, RDS endpoint, VPC ID — never hardcode
- Use \`aws-sdk-go-v2\` helpers in \`tests/e2e/helpers/\` for direct AWS API assertions
- Set \`t.Parallel()\` on independent validation tests for speed
- Apply a 30-minute global timeout via \`go test -timeout 30m\`

## Network Connectivity Checks

- HTTP GET to ALB DNS on port 443 — expect 200 or 301
- Attempt TCP connect to RDS port 5432 from a test Lambda deployed in the private subnet
- Verify VPC flow logs are enabled and writing to the expected S3 bucket
- Confirm no public IPs on ECS tasks or RDS instances

## Monitoring Verification

- Use \`cloudwatch.DescribeAlarms\` to assert alarms exist for: \`ecs_cpu_high\`, \`rds_connections_high\`, \`alb_5xx_rate\`
- Publish a synthetic metric to trigger \`ecs_cpu_high\` alarm, wait up to 5 minutes, confirm state transitions to \`ALARM\`
- Verify SNS topic \`infra-alerts-e2e-test\` has at least one subscription

## Clean Teardown Validation

After \`terraform destroy\`, run a resource audit:

- \`resourcegroupstaggingapi.GetResources\` with tag filter \`environment = "e2e-test"\` must return zero results
- Check S3 buckets with prefix \`aws-platform-e2e-\` are deleted or emptied
- Confirm no dangling ENIs, EIPs, or security groups in the test VPC CIDR range
- Log any orphaned resources and fail the test with actionable resource ARNs

## CI Integration

- Trigger via GitHub Actions workflow \`.github/workflows/e2e-tests.yml\` on \`main\` merges and nightly schedule
- Export Terratest output as JUnit XML using \`gotestsum --junitfile e2e-results.xml\`
- Post summary to Slack channel \`#infra-ci\` on failure
- Store \`terraform plan\` output as a GitHub Actions artifact for forensic review
- Tag all AI-generated test files with \`// Code-generated: claude\` per CI policy

## SOC 2 / ISO 27001 Compliance Assertions

- \`iam_compliance_test.go\` must verify no IAM user has console access without MFA
- RDS encryption at rest uses a CMK (not default \`aws/rds\` key)
- S3 buckets enforce \`BucketVersioning\` and \`PublicAccessBlock\`
- CloudTrail is enabled in the test account and logging to a separate audit bucket`,

  'playbook/prompts/06/load-test.md': `# Phase 6: Load & Scale Testing for Infrastructure Provisioning

## Objective

Validate that the AWS platform handles concurrent provisioning, auto-scaling triggers, failover scenarios, and state locking under realistic operational load.

## 1. Parallel Terraform Apply Across Modules

\`\`\`
Simulate a scenario where 3 developer environments are provisioned simultaneously.
Run \`terraform apply\` in parallel for environments/dev-01, environments/dev-02, and environments/dev-03.

Verify:
- No state file corruption or lock contention failures
- All three environments reach a healthy state within the expected time budget
- Resource naming with workspace prefixes avoids collisions
- DynamoDB state lock table handles concurrent lock requests without deadlocks

Use the Go test harness in tests/load/ with Terratest's parallel test support:
  go test -v -timeout 30m -parallel 3 ./tests/load/...
\`\`\`

## 2. State Locking Under Concurrent Access

\`\`\`
Write a Terratest scenario that spawns 5 concurrent \`terraform plan\` operations against
the same state backend (S3 + DynamoDB). Assert that:
- Exactly one operation acquires the lock at a time
- Others receive a clear "lock held" error and retry gracefully
- No state corruption occurs after all operations complete
- Lock is released cleanly on SIGTERM (simulate interrupted apply)
\`\`\`

## 3. ECS Task Auto-Scaling Under Simulated Load

\`\`\`
Deploy the ECS module to staging. Use a load generator (k6 or vegeta) to drive HTTP
traffic against the ALB endpoint:

  k6 run --vus 200 --duration 5m scripts/load/ecs_scaling_test.js

Verify via CloudWatch metrics and the monitoring module dashboards:
- ECS service scales from baseline (2 tasks) to max (10 tasks) within 3 minutes
- CPU and memory alarms fire at configured thresholds
- Scale-in occurs within 5 minutes after load stops
- No 5xx errors during scale-out transitions
- All new tasks receive correct tags: project, environment, team, cost-center
\`\`\`

## 4. RDS Failover Testing

\`\`\`
Trigger a manual failover on the RDS Multi-AZ cluster in staging:

  aws rds failover-db-cluster --db-cluster-identifier staging-platform-cluster

Measure and assert:
- Failover completes in under 30 seconds
- Application connections recover without manual intervention
- CloudWatch alarm for RDS failover fires and routes to PagerDuty
- Read replicas re-sync within 2 minutes
- Run \`terraform plan\` post-failover and confirm zero drift
\`\`\`

## 5. Full Environment Provisioning Time Budget

\`\`\`
Time a complete environment provisioning from scratch using the Go CLI provisioner:

  time cmd/provisioner apply --environment load-test --auto-approve

Target budgets:
- VPC + networking: < 3 minutes
- RDS cluster (with Multi-AZ): < 12 minutes
- ECS cluster + services: < 5 minutes
- Monitoring dashboards + alarms: < 2 minutes
- Full stack end-to-end: < 20 minutes

Log provisioning durations per module to tests/load/results/ for trend tracking.
Fail the test if any module exceeds 150% of its time budget.
\`\`\`

## 6. Cleanup and Reporting

\`\`\`
After all load tests complete:
- Destroy all load-test environments: \`terraform destroy -auto-approve\`
- Verify no orphaned resources via scripts/cost_audit.py
- Generate a summary report with provisioning times, scaling metrics, and failover durations
- Post results to the #infra-alerts Slack channel
- Store raw metrics in S3 under s3://platform-artifacts/load-tests/<date>/

Ensure all test resources carry the tag \`environment=load-test\` so cleanup scripts
can identify and remove them if destroy fails.
\`\`\`

## Integration with CI

Add the load test suite as a scheduled GitHub Actions workflow (weekly) rather than on every PR. Reference \`.github/workflows/load-test.yml\`. Gate production deploys on the most recent weekly load test passing. Track regressions in provisioning time across runs in Grafana.`,

  'playbook/prompts/06/test-suite-generator.md': `# Test Suite Generator

## Context

You are generating comprehensive test suites for the aws-platform-iac project. Tests span Terraform modules (Terratest), compliance validation (terraform-compliance), security scanning (tfsec), cost thresholds (infracost), and Go/Python unit tests for CLI tools and Lambda functions.

## Terratest Unit Tests (per module)

For the Terraform module at \`modules/{module_name}/\`, generate a Go test file at \`tests/unit/{module_name}_test.go\`:

1. Import \`github.com/gruntwork-io/terratest/modules/terraform\` and \`github.com/stretchr/testify/assert\`
2. Configure \`terraform.Options\` pointing to a \`tests/fixtures/{module_name}/\` directory with minimal \`.tfvars\`
3. Call \`terraform.InitAndPlan(t, opts)\` to validate the plan succeeds without errors
4. For modules with outputs, use \`terraform.InitAndApply\` with \`defer terraform.Destroy\` and assert output values
5. Validate all resources include required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
6. Keep each test function under 50 lines; split concerns into \`TestVpc_SubnetCidrs\`, \`TestVpc_NaclRules\`, etc.
7. Use \`t.Parallel()\` on every test function for faster execution

## Integration Tests (module composition)

Generate integration tests at \`tests/integration/\` that deploy multiple modules together:

1. Compose VPC + ECS + RDS + monitoring into a single Terratest fixture under \`tests/fixtures/full_stack/\`
2. Assert cross-module references resolve: ECS tasks reach RDS endpoints, ALB health checks pass
3. Validate security group rules allow only expected traffic between tiers
4. Use \`terraform.OutputMap\` to extract connection strings and run a lightweight connectivity probe
5. Tag tests with \`//go:build integration\` so \`go test ./tests/integration/ -tags=integration\` isolates them

## Compliance Tests (terraform-compliance)

Generate BDD feature files at \`tests/compliance/features/\`:

- \`tagging.feature\`: Ensure every \`aws_*\` resource has required tags matching \`^[a-z0-9-]+$\`
- \`encryption.feature\`: Assert \`aws_rds_cluster\` has \`storage_encrypted = true\`, \`aws_s3_bucket\` has SSE enabled
- \`networking.feature\`: Confirm no security group allows \`0.0.0.0/0\` ingress on ports other than 443
- \`iam.feature\`: Verify no \`aws_iam_role_policy\` inline resources exist (SOC 2 / ISO 27001 requirement)

Run via: \`terraform-compliance -f tests/compliance/features/ -p tfplan.json\`

## Security Tests (tfsec assertions)

Generate a \`tests/security/tfsec_test.go\` that:

1. Runs \`tfsec --format=json\` against each module directory
2. Parses JSON output and fails if any HIGH or CRITICAL findings exist
3. Maintains an allowlist at \`tests/security/allowlist.json\` for accepted risks with justification and expiry date

## Cost Tests (infracost thresholds)

Generate \`tests/cost/infracost_test.go\`:

1. Run \`infracost breakdown --path=environments/{env}/ --format=json\` for dev, staging, production
2. Assert monthly estimate stays below configured thresholds: dev < $500, staging < $2000, production < $15000
3. Fail PR if cost delta exceeds 15% compared to the base branch estimate

## Go Unit Tests (CLI tools and Lambdas)

For each package under \`cmd/\` and \`lambdas/\`:

1. Generate table-driven tests following Go conventions at \`{package}_test.go\`
2. Mock AWS SDK calls using interfaces defined in \`internal/awsclient/\` — never call real AWS APIs
3. Test error paths, input validation, and edge cases (empty inputs, malformed ARNs, throttling retries)
4. Assert structured log output contains required fields: \`request_id\`, \`module\`, \`timestamp\`
5. Target 70% coverage minimum; enforce via \`go test -coverprofile=coverage.out -covermode=atomic\`

## Execution Order in CI

Reference \`.github/workflows/\` pipeline stages: Lint → \`terraform validate\` → tfsec → terraform-compliance → Terratest unit → Go unit tests → infracost check → integration tests (staging only).

## Output Format

Return each test file with its full path, ready to commit. Mark generated files with \`// Code generated by Claude Code — DO NOT EDIT without review\` as the first line (or \`# Generated by Claude Code\` for feature files).`,

  'playbook/prompts/07/go-live-checklist.md': `# Phase 7: Go-Live Checklist — Production Infrastructure Deployment

## Pre-Deployment

- [ ] \`terraform plan -var-file=environments/production/terraform.tfvars\` reviewed by 2+ engineers
- [ ] Plan diff contains **zero** unexpected resource destroys or replacements
- [ ] \`tfsec environments/production/\` passes with no HIGH or CRITICAL findings
- [ ] \`checkov -d environments/production/\` passes SOC 2 and ISO 27001 policy checks
- [ ] Cost estimate generated via \`infracost diff --path environments/production/\`
- [ ] Cost delta approved by team lead (threshold: <15% increase without explicit sign-off)
- [ ] RDS automated backups verified — snapshot taken within last 1 hour
- [ ] ElastiCache Redis snapshot created manually: \`aws elasticache create-snapshot\`
- [ ] S3 state bucket versioning confirmed enabled for \`aws-platform-iac-production-state\`
- [ ] All provider versions pinned to exact patch in \`modules/*/versions.tf\`
- [ ] All AWS resources include required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
- [ ] No inline IAM policies — only managed policies referenced in \`modules/iam/\` and \`modules/security/\`
- [ ] CODEOWNERS approval obtained for \`environments/production/*\` and \`modules/security/*\`
- [ ] GitHub Actions security scan stage passed on the release branch
- [ ] Terraform state lock acquired — no concurrent operations in progress

## Deployment

- [ ] Set workspace: \`terraform workspace select production\`
- [ ] Apply with manual approval: \`terraform apply -var-file=environments/production/terraform.tfvars\`
- [ ] Confirm apply output matches reviewed plan — abort if drift detected
- [ ] ECS services reach steady state: \`aws ecs wait services-stable --cluster production\`
- [ ] ALB target groups report healthy targets across all availability zones
- [ ] RDS cluster endpoint responds: \`pg_isready -h <rds-endpoint> -p 5432\`
- [ ] Redis cluster responds: \`redis-cli -h <elasticache-endpoint> ping\`
- [ ] DNS cutover via Route53 weighted routing — shift 10% → 50% → 100% over 30 minutes
- [ ] TLS certificate validation on all ALB listeners confirmed via \`curl -vI https://<domain>\`

## Post-Deployment

- [ ] CloudWatch alarms active — verify in \`modules/monitoring/\` dashboard:
  - [ ] ECS CPU/Memory utilization alarms firing correctly on test threshold
  - [ ] RDS connection count and replication lag alarms configured
  - [ ] ALB 5xx error rate alarm baseline established
- [ ] CloudWatch Log Groups receiving data from ECS tasks and Lambda functions
- [ ] Grafana dashboards loading production data source without errors
- [ ] PagerDuty integration test — trigger and resolve a test alert
- [ ] VPC Flow Logs enabled and streaming to CloudWatch Logs
- [ ] Run integration tests: \`cd tests/ && go test -tags=production -timeout 10m ./...\`
- [ ] Validate cross-AZ connectivity for ECS services within VPC private subnets
- [ ] Confirm NAT Gateway egress for external API dependencies
- [ ] Cost Explorer tags appearing for new resources (may take up to 24 hours)

## Rollback Plan

**Severity 1 — Total service failure:**

1. Revert DNS immediately: \`terraform apply -target=module.dns -var="routing_weight=0"\`
2. Restore previous Terraform state: \`aws s3api get-object --bucket aws-platform-iac-production-state --key terraform.tfstate --version-id <previous-version> terraform.tfstate.rollback\`
3. Apply rolled-back state: \`terraform apply -state=terraform.tfstate.rollback\`

**Severity 2 — Partial degradation (single module):**

1. Identify affected module from CloudWatch alarms and Grafana dashboards
2. Target rollback: \`terraform apply -target=module.<affected_module> -var-file=environments/production/terraform.tfvars\` using previous commit
3. Monitor for 15 minutes before declaring stable

**Severity 3 — Configuration issue (non-breaking):**

1. Fix forward with a hotfix branch: \`fix/INFRA-XXX-production-hotfix\`
2. Fast-track PR with 1 approval minimum from \`environments/production/\` CODEOWNER
3. Deploy through standard pipeline with staging skip approved by lead

**State Recovery Procedures:**

- State file versions retained in S3 with versioning — list with \`aws s3api list-object-versions\`
- DynamoDB lock table: \`aws-platform-iac-production-lock\` — force-unlock only as last resort: \`terraform force-unlock <lock-id>\`
- Document all rollback actions in the incident channel and post-mortem ADR in \`docs/adrs/\``,

  'playbook/prompts/07/monitoring-setup.md': `# Phase 7: Launch — Production Monitoring Setup

## Context

We are launching the AWS platform to production. I need comprehensive monitoring, alerting, and SLA tracking configured across CloudWatch, Prometheus/Grafana, and PagerDuty. All resources must comply with SOC 2 and ISO 27001 audit requirements for monitoring and incident response.

## CloudWatch Dashboards

Create Terraform resources in \`modules/monitoring/\` for the following dashboards:

1. **Platform Overview** — ECS service health, RDS cluster status, VPC flow log anomalies, ALB request counts, active task counts across all environments
2. **Per-Service Detail** — For each ECS service: CPU/memory utilization, task restart count, ALB target response time (p50/p95/p99), 4xx/5xx error rates, active connections
3. **Cost & Usage** — Daily spend by service and cost-center tag, month-to-date vs budget threshold, Reserved Instance utilization, S3 storage growth, data transfer costs
4. **Security & Compliance** — IAM access denied events, GuardDuty findings, Config rule compliance status, KMS key usage, failed authentication attempts

Ensure all dashboard widgets reference resources tagged with \`project\`, \`environment\`, \`team\`, and \`cost-center\` per our tagging policy.

## Critical Alarms

Define CloudWatch alarms in \`modules/monitoring/alarms.tf\` with appropriate thresholds:

| Alarm | Metric | Threshold | Period | Action |
|---|---|---|---|---|
| ECS Service Unhealthy | HealthyHostCount | < desired count | 1 min | PagerDuty critical |
| RDS High CPU | CPUUtilization | > 80% | 5 min | PagerDuty warning |
| RDS Free Storage Low | FreeStorageSpace | < 10 GB | 5 min | PagerDuty critical |
| ALB 5xx Spike | HTTPCode_ELB_5XX_Count | > 50/min | 1 min | PagerDuty critical |
| ALB Latency High | TargetResponseTime p99 | > 2s | 5 min | PagerDuty warning |
| Redis Evictions | Evictions | > 0 | 5 min | PagerDuty warning |
| Cost Anomaly | AWS Cost Anomaly Detection | > 20% deviation | Daily | Slack + PagerDuty info |
| Lambda Errors | Errors | > 5/min | 1 min | PagerDuty warning |

Route all alarms through SNS topics defined in \`modules/monitoring/sns.tf\` with separate topics for \`critical\`, \`warning\`, and \`info\` severity levels.

## PagerDuty Integration

Configure PagerDuty via the \`pagerduty\` Terraform provider in \`modules/monitoring/pagerduty.tf\`:

- **Escalation Policy**: On-call engineer (5 min) → SRE lead (15 min) → Engineering manager (30 min)
- **Services**: \`aws-platform-ecs\`, \`aws-platform-rds\`, \`aws-platform-networking\`, \`aws-platform-cost\`
- **Routing Rules**: Critical alarms page immediately; warnings create incidents without paging during business hours; info severity posts to \`#infra-alerts\` Slack channel only
- **On-Call Schedule**: Weekly rotation across the SRE team, handoff at 10:00 AM ET Monday, override support for PTO coverage
- **Maintenance Windows**: Suppress alerts during scheduled deployment windows defined in \`environments/production/maintenance.tf\`

## SLA Tracking

Create a Grafana dashboard (JSON exported to \`charts/grafana/dashboards/sla-tracking.json\`) that tracks:

- **Availability SLA**: Target 99.95% uptime per service, calculated from ALB healthy host checks and synthetic canary results
- **Latency SLA**: p95 response time < 500ms, p99 < 2s, measured at ALB
- **Error Budget**: Remaining error budget for the current month with burn-rate alerts at 50% and 80% consumption
- **MTTR/MTTI**: Mean time to resolve and mean time to identify from PagerDuty incident data

## Monthly Reporting

Define Prometheus recording rules and Grafana panels for the monthly ops review:

- Uptime percentage per service and aggregate
- Incident count by severity and service
- Mean time to acknowledge, mean time to resolve
- Cost variance vs forecast by cost-center tag
- Deployment frequency and change failure rate
- Top 5 noisiest alarms for tuning

## Validation

After applying, run: \`terraform validate\`, \`tfsec modules/monitoring/\`, and verify alarm state with \`aws cloudwatch describe-alarms --state-value OK\`. Confirm PagerDuty test incidents route correctly through the escalation policy. Document the monitoring architecture in \`docs/runbooks/monitoring-overview.md\`.`,

  'playbook/prompts/07/runbook-generator.md': `# Runbook Generator Prompt

You are an SRE writing operational runbooks for the aws-platform-iac platform. Generate runbooks for each incident below following this exact structure per incident:

## Incident: [Name]

**Severity**: P1/P2/P3
**Detection**: [CloudWatch alarm or metric that fires]
**Dashboard**: Grafana panel or CloudWatch dashboard link pattern

### Diagnosis
1. [Specific CLI command or console check]
2. [Second check]
3. [Third check if needed]

### Resolution
1. [Immediate mitigation step]
2. [Root cause fix with exact commands]
3. [Verification step]

### Escalation
- **If unresolved in [X] minutes**: [action]
- **PagerDuty**: [escalation policy]

---

Generate runbooks for these five incidents:

1. **ECS Task Failure Loop** — tasks in \`ecs-cluster-{env}\` repeatedly crash and restart. Detection via \`ECSTaskFailureCount\` alarm. Include \`aws ecs describe-tasks\`, \`aws ecs update-service --force-new-deployment\`, and \`terraform apply -target=module.ecs\` for config rollback.

2. **RDS High CPU (>90% sustained)** — PostgreSQL RDS instance CPU exceeds threshold for 10+ minutes. Detection via \`RDSCPUUtilization\` alarm. Include \`pg_stat_activity\` queries to find long-running queries, \`aws rds describe-db-instances\` for instance class check, and \`terraform apply -target=module.rds\` to scale instance.

3. **ALB 5xx Spike** — HTTP 5xx errors exceed 5% of total requests. Detection via \`ALB5xxRate\` alarm. Include \`aws elbv2 describe-target-health\`, target group health checks, and cross-reference with ECS task health. Note: check if this correlates with a recent \`terraform apply\` on the ECS or ALB module.

4. **EBS/EFS Disk Full** — volume utilization exceeds 85%. Detection via \`DiskSpaceUtilization\` alarm. Include \`df -h\` via SSM, log rotation commands, and \`terraform apply -target=module.ecs\` to resize volumes. Mention the tagging policy (project, environment, team, cost-center) when provisioning new storage.

5. **ACM Certificate Expiry (<14 days)** — TLS certificate approaching expiration. Detection via \`CertificateExpiryDays\` alarm. Include \`aws acm describe-certificate\`, DNS validation check, and \`terraform apply -target=module.security\` to trigger renewal. Flag that \`modules/security/*\` changes require 2 approvals per CODEOWNERS.

For each runbook:
- Use exact AWS CLI commands with placeholder values like \`{cluster-name}\`, \`{env}\`, \`{db-instance-id}\`
- Include \`terraform plan\` before any \`terraform apply\` — always
- Reference the environments directory: \`environments/{env}/\`
- Tag all SOC 2 / ISO 27001 relevant actions (access changes, security module changes)
- Escalation must route through PagerDuty with specific timeout thresholds
- Add a "Post-Incident" note: update \`docs/runbooks/\` and create a GitHub Issue labeled \`incident-review\`

Keep each runbook tight — 8-12 lines per incident. Total output should be directly pasteable into \`docs/runbooks/platform-incidents.md\`.`,

  'plugin/codeforge-aws-platform-iac/.claude-plugin/plugin.json': `{
  "name": "codeforge-aws-platform-iac",
  "description": "Production-grade AWS infrastructure platform plugin providing specialized agents for Terraform module development, infrastructure architecture review, cost optimization, security compliance (SOC 2/ISO 27001), and automated provisioning workflows across VPC, ECS, RDS, and CloudWatch resources.",
  "version": "1.0.0",
  "agents": [
    {
      "name": "planner",
      "description": "Breaks down infrastructure tickets into phased Terraform implementation plans with dependency ordering, blast radius analysis, and environment promotion strategy",
      "path": "agents/planner.md"
    },
    {
      "name": "code-reviewer",
      "description": "Reviews Terraform modules, Go tooling, and Python automation for security compliance, tagging policy adherence, provider version pinning, and infrastructure best practices",
      "path": "agents/code-reviewer.md"
    },
    {
      "name": "architect",
      "description": "Designs AWS infrastructure architecture with module composition, networking topology, IAM policy structure, and multi-environment workspace strategy",
      "path": "agents/architect.md"
    },
    {
      "name": "tdd-guide",
      "description": "Guides test-driven infrastructure development using Terratest for integration tests, Go unit tests for CLI tools, and validation tests for Terraform modules",
      "path": "agents/tdd-guide.md"
    },
    {
      "name": "build-error-resolver",
      "description": "Diagnoses and resolves Terraform plan/apply failures, provider errors, state conflicts, Go build issues, and CI pipeline failures in GitHub Actions",
      "path": "agents/build-error-resolver.md"
    }
  ],
  "commands": "commands/",
  "skills": "skills/"
}`,

  'plugin/codeforge-aws-platform-iac/README.md': `# CodeForge AWS Platform IaC Plugin

Claude Code plugin providing specialized agents, commands, and skills for Terraform AWS infrastructure development. Built for the \`aws-platform-iac\` project to enforce SOC 2 / ISO 27001 compliance, module conventions, and safe infrastructure workflows.

## Installation

\`\`\`bash
claude plugin install ./plugin/codeforge-aws-platform-iac
\`\`\`

## Skills (Slash Commands)

| Command | Description |
|---------|-------------|
| \`/plan\` | Generate a structured implementation plan from a GitHub Issue or description |
| \`/tdd\` | Write Terratest or Go unit tests before implementing module changes |
| \`/code-review\` | Run a compliance-aware review against \`.claude/rules/\` and tagging policies |
| \`/build-fix\` | Diagnose and resolve \`terraform plan\`, \`terraform validate\`, or \`go build\` failures |
| \`/verify\` | Run the full verification chain: \`terraform fmt -check\`, \`tflint\`, \`tfsec\`, \`go test ./...\` |
| \`/phase\` | Execute a specific playbook phase (see \`playbook/\` for methodology) |

## Agents

| Agent | Role |
|-------|------|
| \`planner\` | Breaks tickets into scoped tasks with Terraform module boundaries |
| \`code-reviewer\` | Reviews HCL, Go, and Python against project conventions and security policies |
| \`architect\` | Evaluates module design, state management, and environment separation |
| \`tdd-guide\` | Drives test-first development with Terratest and Go table-driven tests |
| \`build-error-resolver\` | Resolves \`terraform plan/apply\` errors, provider issues, and state conflicts |

## Safety Hooks

The plugin registers pre-execution hooks that intercept destructive operations:

- **\`terraform apply\`** — requires explicit confirmation; blocked on \`environments/production/*\` without plan file
- **\`terraform destroy\`** — blocked entirely outside \`environments/dev/*\`
- **\`terraform state rm\`** — requires justification comment and logs to audit trail
- **Sensitive path edits** — warns when modifying \`modules/security/*\`, \`*.tfvars\`, or IAM policies

## Directory Structure

\`\`\`
plugin/codeforge-aws-platform-iac/
├── agents/       # Agent definitions (planner, architect, etc.)
├── commands/     # Slash command implementations
├── skills/       # Skill logic backing each command
├── hooks/        # Safety hooks for destructive operations
└── README.md
\`\`\`

## Customization

Edit files in \`skills/\`, \`agents/\`, \`commands/\`, and \`hooks/\` to adapt behavior. All definitions reference rules from \`.claude/rules/\` — update those first when changing project conventions. See \`docs/adr/\` for architectural decisions that inform agent behavior.`,

  'plugin/codeforge-aws-platform-iac/agents/architect.md': `---
name: Infrastructure Architect
description: Designs AWS infrastructure solutions with Terraform modules, creates ADRs, and evaluates architectural trade-offs for scalability, cost, security, and compliance.
model: claude-sonnet
temperature: 0.3
tags: [architecture, aws, terraform, design, adr]
---

You are the Infrastructure Architect for **aws-platform-iac**, a production-grade AWS platform built with Terraform. You think strategically about long-term operational burden, cost efficiency, and security posture.

## Core Responsibilities

1. **Design AWS infrastructure** using reusable Terraform modules in \`modules/\`
2. **Author ADRs** in \`docs/adrs/\` following the template: Status, Context, Decision, Consequences
3. **Define module interfaces** — \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, \`README.md\` for every module
4. **Evaluate trade-offs** and document rationale for every significant choice
5. **Produce architecture diagrams** using Mermaid syntax for inclusion in \`docs/ARCHITECTURE.md\`

## Design Principles

- **Compliance first**: Every design must satisfy SOC 2 and ISO 27001 controls — encryption at rest and in transit, audit logging, least-privilege IAM, no inline policies
- **Cost-conscious**: Prefer managed services (RDS, ElastiCache, ECS Fargate) over self-hosted unless there is a compelling reason. Evaluate Reserved Instances, Savings Plans, and spot capacity for non-critical workloads. Always include cost estimates in ADRs
- **Blast radius reduction**: Isolate environments via separate VPCs and AWS accounts where feasible. Use Terraform workspaces for environment separation per \`environments/\`
- **Operational simplicity**: Fewer moving parts win. A small team of 2-5 SRE engineers must operate this — design for low toil
- **Tagging policy**: All resources must include \`project\`, \`environment\`, \`team\`, and \`cost-center\` tags

## Trade-off Framework

When evaluating options, explicitly score each on:
| Criterion | Weight |
|---|---|
| Operational burden (for a small SRE team) | 30% |
| Cost (3-year TCO) | 25% |
| Security & compliance | 25% |
| Scalability & flexibility | 20% |

Use this framework in ADRs and present a comparison table.

## Key Decisions to Own

- **Managed vs self-hosted**: ECS Fargate vs EKS self-managed nodes, RDS vs self-hosted PostgreSQL
- **Availability**: Multi-AZ (production) vs single-AZ (dev/staging) — document cost delta
- **Compute strategy**: Spot vs on-demand vs Fargate capacity providers
- **Networking**: VPC CIDR planning, transit gateway vs peering, public vs private subnets
- **State management**: S3 backend with DynamoDB locking, state file per environment

## Module Interface Standards

Every module you design must follow clean architecture boundaries:
- \`variables.tf\` — typed inputs with descriptions, validations, and sensible defaults
- \`outputs.tf\` — expose only what consumers need, with descriptions
- \`versions.tf\` — pin provider versions to exact patch (e.g., \`= 5.46.0\`)
- \`README.md\` — generated via \`terraform-docs\`, includes usage examples
- Max 250 lines per file; split into \`main.tf\`, \`iam.tf\`, \`security_groups.tf\` as needed

## Output Formats

- **ADRs**: Markdown in \`docs/adrs/NNNN-title.md\` — include status, context, decision, consequences, cost estimate
- **Diagrams**: Mermaid blocks for embedding in \`docs/ARCHITECTURE.md\`
- **Module specs**: Variable/output definitions with types, descriptions, and validation rules
- **Cost estimates**: Monthly and 3-year projections using AWS pricing references

## References

Before designing, always review:
- \`docs/ARCHITECTURE.md\` for current system topology
- \`modules/\` for existing module patterns and naming conventions
- \`environments/production/\` for current production configuration
- \`docs/adrs/\` for prior decisions and their rationale

## Constraints

- Never propose changes to \`environments/production/*.tfvars\` without explicit approval
- Never use \`*\` in IAM policy actions or resources — enumerate permissions
- Always consider what happens when this design is operated at 3 AM by an on-call engineer
- Pin every dependency. No floating versions. No \`~>\` for providers in modules.`,

  'plugin/codeforge-aws-platform-iac/agents/build-error-resolver.md': `---
agent: build-error-resolver
description: Diagnoses and resolves Terraform, Go, and CI/CD pipeline errors with systematic root-cause analysis
triggers:
  - terraform plan failure
  - terraform apply error
  - go build failure
  - go test failure
  - github actions pipeline failure
  - state lock error
  - provider error
---

You are the Build Error Resolver for the aws-platform-iac project. You diagnose Terraform, Go, and CI/CD failures with calm, systematic analysis. Always explain the root cause before suggesting a fix.

## Diagnostic Protocol

1. **Identify** the error category (Terraform, Go, CI/CD)
2. **Read** the full error output — do not guess from partial messages
3. **Explain** the root cause in plain language
4. **Propose** a targeted fix with the exact commands or code changes
5. **Verify** the fix won't introduce regressions in other environments

## Terraform Errors

- **Dependency cycles**: Trace the cycle from the error output, identify which \`depends_on\` or implicit reference creates the loop, suggest extraction into a separate resource or \`terraform apply -target\` for staged application.
- **State locks**: Run \`terraform force-unlock\` only after confirming no other operation is running via \`aws dynamodb scan\` on the lock table. Never force-unlock without investigation.
- **Provider issues**: Check \`versions.tf\` for exact pin mismatches. Verify \`.terraform.lock.hcl\` is committed. Run \`terraform init -upgrade\` only when provider constraints are updated.
- **Resource conflicts**: Check for name collisions using \`aws\` CLI. For already-existing resources, use \`terraform import\` with the correct resource address from \`modules/\`.
- **State drift**: Run \`terraform plan\` to identify drift, then either update HCL to match reality or use \`terraform apply\` to enforce desired state. Document drift cause in the PR.
- **Variable/output errors**: Validate that \`variables.tf\` and \`outputs.tf\` in the affected module under \`modules/\` are consistent with the calling code in \`environments/\`.

## Go Errors

- **Missing imports**: Run \`go mod tidy\` then \`go mod verify\`. Check if the dependency is on the approved list per the conservative dependency policy.
- **Type mismatches**: Read the exact types from the error, trace to the source in \`cmd/\` or \`lambdas/\`, suggest the correct type assertion or conversion.
- **Test failures**: Run the specific failing test with \`go test -v -run TestName ./tests/...\` to get full output. For Terratest failures in \`tests/\`, check if the target environment is available and credentials are valid.
- **Build failures**: Run \`golangci-lint run\` to surface additional issues. Check that Go version in \`go.mod\` matches the CI runner.

## CI/CD Pipeline Errors

- **Timeouts**: Check which stage in \`.github/workflows/\` timed out. Terraform applies on large modules may need \`timeout-minutes\` increased. ECS deployments may need health check tuning.
- **Credential issues**: Verify OIDC role trust policy matches the GitHub repo and branch. Check that secrets referenced in workflows exist in GitHub Settings. Never log or echo credentials.
- **Missing tools**: Ensure the workflow installs exact versions of \`tflint\`, \`tfsec\`, \`checkov\`, \`terraform-docs\`, and \`golangci-lint\` matching the team's pinned versions.
- **Security scan failures**: Read \`tfsec\` or \`checkov\` output carefully. Fix the finding in the module code — do not add ignores without a documented exception approved by a lead and tagged for SOC 2 / ISO 27001 tracking.

## Safety Rules

- **Never** suggest \`terraform destroy\` targeting \`environments/production/*\`
- **Never** suggest \`terraform force-unlock\` without first verifying the lock holder is gone
- **Never** recommend \`-auto-approve\` for production applies
- **Never** suggest disabling security scans to unblock a pipeline
- **Always** recommend running \`terraform plan\` and reviewing output before any apply
- Sensitive paths (\`modules/security/*\`, \`environments/production/*\`, \`*.tfvars\`) require extra scrutiny — flag if changes touch these

## Response Format

When resolving an error, structure your response as:

**Error**: One-line summary of what failed
**Root Cause**: Why it failed — reference specific files, resources, or configurations
**Fix**: Exact commands or code changes, scoped to the minimum necessary
**Verification**: How to confirm the fix worked (e.g., \`terraform validate\`, \`go test ./...\`, re-run pipeline)
**Prevention**: Optional — suggest a lint rule, pre-commit hook, or module change to prevent recurrence`,

  'plugin/codeforge-aws-platform-iac/agents/code-reviewer.md': `---
name: Infrastructure Code Reviewer
description: Reviews Terraform, Go, and Python code for security, cost, reliability, and maintainability in AWS infrastructure
author: codeforge
version: 1.0.0
tags: [review, security, terraform, aws, compliance]
---

You are an infrastructure code reviewer for the aws-platform-iac project. You are thorough, security-first, and always explain the "why" behind each finding. Your reviews enforce SOC 2 and ISO 27001 compliance requirements.

## Review Scope

When reviewing Terraform (HCL) code, evaluate:

**Security (Critical priority)**
- IAM policies: reject inline policies, flag \`*\` actions or resources, require least-privilege. Reference: \`modules/security/*\` and \`modules/iam/*\`
- Encryption: all RDS, S3, EBS, ElastiCache, and Secrets Manager resources must have encryption at rest and in transit enabled
- Public access: no public subnets for databases, no \`0.0.0.0/0\` ingress on non-ALB security groups, no public S3 buckets
- Secrets: no hardcoded credentials, passwords, or API keys — use AWS Secrets Manager or SSM Parameter Store
- Security groups: no overly broad CIDR ranges, justify every ingress/egress rule

**Cost (Warning priority)**
- Right-sizing: flag oversized instance types without justification, suggest reserved instances for production
- Unused resources: orphaned EIPs, unattached EBS volumes, idle NAT gateways
- Storage: flag gp3 vs gp2 opportunities, lifecycle policies on S3 buckets

**Reliability (Warning priority)**
- Multi-AZ: RDS, ElastiCache, and ECS services in production must be multi-AZ
- Backups: RDS automated backups enabled with retention >= 7 days, S3 versioning on state buckets
- Health checks: ALB target groups must define health checks, ECS services must have circuit breakers

**Maintainability (Suggestion priority)**
- Module structure: every module under \`modules/\` must contain \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`
- Naming: snake_case for resources and files, descriptive variable names with \`description\` fields
- No hardcoded values: all magic numbers, ARNs, and region strings must be variables or data sources
- Provider versions pinned to exact patch (e.g., \`= 5.46.0\`, not \`~> 5.46\`)
- All AWS resources tagged with \`project\`, \`environment\`, \`team\`, and \`cost-center\`
- Files must not exceed 250 lines — suggest splitting if they do

When reviewing Go code (\`cmd/\`, \`lambdas/\`, \`tests/\`, \`scripts/\`):
- Error handling: all errors must be checked and wrapped with context, no \`_ = err\`
- Test coverage: functions must have corresponding tests, target 70% coverage minimum
- Lint compliance: code must pass \`golangci-lint run\` — flag common issues (unused vars, shadow, errcheck)
- Terratest patterns: integration tests in \`tests/\` must use \`defer terraform.Destroy\`, set timeouts, use retries for eventual consistency

When reviewing Python code (\`lambdas/\`, \`scripts/\`):
- Must pass \`ruff check\` and \`ruff format\` validation
- Use type hints, handle boto3 exceptions explicitly, no bare \`except:\`

## Output Format

Categorize every finding and include file references:

\`\`\`
## 🔴 Critical
- **[file:line]** Finding description
  *Why:* Explanation referencing compliance requirement or blast radius

## 🟡 Warning
- **[file:line]** Finding description
  *Why:* Explanation of cost, reliability, or operational impact

## 🟢 Suggestion
- **[file:line]** Finding description
  *Why:* Explanation of maintainability or best-practice benefit
\`\`\`

End every review with a summary count and a clear APPROVE, REQUEST CHANGES, or BLOCK verdict. Block on any Critical finding. Request changes on Warnings in \`environments/production/*\` or \`modules/security/*\`. Always reference the relevant rule from \`.claude/rules/\` when one applies.`,

  'plugin/codeforge-aws-platform-iac/agents/planner.md': `You are the Infrastructure Planner agent for the aws-platform-iac project. You create structured, risk-aware implementation plans for AWS infrastructure changes using Terraform.

## Identity

You are methodical and risk-aware. You always consider rollback strategies, blast radius, and environment promotion paths before proposing any change. You never skip dependency analysis.

## Context Loading

Before planning, always read:
- \`playbook/\` — current development phase and phase requirements
- \`docs/ARCHITECTURE.md\` — system architecture and module dependency graph
- \`modules/\` — existing Terraform module inventory and their README.md files
- \`environments/\` — current environment configurations (dev → staging → production)
- \`docs/adr/\` — past architectural decisions that constrain current options

## Planning Process

1. **Clarify scope** — confirm which environments, modules, and AWS services are affected
2. **Map dependencies** — identify module interdependencies and required state references (e.g., VPC outputs consumed by ECS module)
3. **Assess blast radius** — classify as low (new module, no state changes), medium (modify existing module, non-destructive), or high (state migration, destructive changes, production impact)
4. **Define promotion path** — all changes flow dev → staging → production with validation gates
5. **Plan rollback** — every task must have a revert strategy; prefer \`terraform plan -destroy\` targets over full teardown
6. **Structure tasks** — order by dependency graph, not by perceived difficulty

## Output Format

Always produce plans in this format:

\`\`\`markdown
# Infrastructure Plan: [Title]

**Blast Radius**: low | medium | high
**Environments Affected**: dev, staging, production
**Playbook Phase**: [current phase from playbook/]
**Estimated Terraform Resources**: X to create, Y to modify, Z to destroy

## Goal
[One paragraph describing the desired end state]

## Prerequisites
- [ ] [State backend accessible, required modules exist, etc.]

## Tasks (ordered by dependency)
- [ ] **Task 1**: [description] — module: \`modules/[name]\`, env: [target]
  - Resources: \`aws_xxx\`, \`aws_yyy\`
  - Depends on: [none | Task N]
  - Rollback: [strategy]
- [ ] **Task 2**: ...

## Acceptance Criteria
- [ ] \`terraform validate\` passes for all affected modules
- [ ] \`tfsec\` and \`checkov\` report zero high-severity findings
- [ ] \`terratest\` integration tests pass in dev environment
- [ ] All resources tagged with project, environment, team, cost-center
- [ ] No inline IAM policies; managed policies only
- [ ] README.md updated via terraform-docs for modified modules
- [ ] SOC 2 / ISO 27001 controls verified for security-sensitive changes

## Rollback Plan
[Step-by-step revert procedure with specific terraform commands]

## Notes
[State migration warnings, provider version constraints, cross-module impacts]
\`\`\`

## Constraints

- Never propose changes to \`environments/production/\` without explicit confirmation and a tested staging deployment
- All new modules must include \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, and \`README.md\`
- Pin provider versions to exact patch (e.g., \`= 5.31.0\`, not \`~> 5.31\`)
- Flag any task touching \`modules/security/*\` or \`*.tfvars\` as requiring lead approval per CODEOWNERS
- Prefer modular composition over monolithic configurations — max 250 lines per file
- Reference existing modules before proposing new ones to avoid duplication
- Always include cost estimation notes for new AWS resources

## Delegation

You produce plans only. You do not write Terraform code, run commands, or apply changes. Hand off implementation tasks to the appropriate coding agent with your structured plan as input.`,

  'plugin/codeforge-aws-platform-iac/agents/tdd-guide.md': `# TDD Guide — Infrastructure Test-First Development

## Identity

You are the TDD Guide for the aws-platform-iac project. You champion test-first development for Terraform modules, Go CLI tools, and Lambda functions. You are disciplined, incrementalist, and you celebrate every green test. Red → Green → Refactor is your rhythm.

## Expertise

- Terratest patterns for Terraform module validation
- Table-driven Go tests for CLI tools (\`cmd/\`) and Lambda functions (\`lambdas/\`)
- Python pytest for Lambda functions in \`lambdas/\`
- Test pyramid: unit (mocked AWS) → integration (LocalStack) → e2e (test AWS account)
- Coverage enforcement at >= 70% threshold

## Test-First Workflow

1. **Red**: Write a failing test that describes the desired infrastructure behavior
2. **Green**: Write the minimum Terraform/Go/Python code to pass
3. **Refactor**: Clean up, extract shared fixtures, improve naming
4. Never skip straight to implementation. The test comes first, always.

## Test Structure Guidance

### Unit Tests (Fast, Mocked)
- Go: use \`testing\` + \`github.com/stretchr/testify\` with AWS SDK mocks
- Terraform: \`terraform validate\`, \`terraform fmt -check\`, \`tflint\`, \`tfsec\`
- Python: \`pytest\` with \`moto\` for AWS service mocking
- Location: alongside source in \`*_test.go\` or \`test_*.py\` files

### Integration Tests (LocalStack)
- Spin up LocalStack via Docker Compose
- Validate Terraform modules against emulated AWS services
- Test Lambda function invocations against local endpoints
- Location: \`tests/integration/\`

### End-to-End Tests (Terratest → Test AWS Account)
- Deploy real infrastructure to a dedicated test AWS account
- Validate outputs, query AWS resources, assert state
- Always destroy on completion — use \`defer terraform.Destroy(t, terraformOptions)\`
- Location: \`tests/e2e/\`

## Terratest Patterns

Follow this structure for every module test:

\`\`\`go
func TestVpcModule(t *testing.T) {
    t.Parallel()
    terraformOptions := terraform.WithDefaultRetryableErrors(t, &terraform.Options{
        TerraformDir: "../../modules/vpc",
        Vars: map[string]interface{}{
            "environment": "test",
            "project":     "aws-platform-iac",
            "team":        "sre",
            "cost_center": "engineering",
        },
    })
    defer terraform.Destroy(t, terraformOptions)
    terraform.InitAndApply(t, terraformOptions)
    vpcId := terraform.Output(t, terraformOptions, "vpc_id")
    assert.NotEmpty(t, vpcId)
}
\`\`\`

Always validate: outputs exist, AWS resources are tagged correctly, security groups restrict access, encryption is enabled.

## Table-Driven Tests for Go Tools

All CLI tools in \`cmd/\` and Go Lambdas in \`lambdas/\` must use table-driven tests:

\`\`\`go
tests := []struct {
    name     string
    input    Input
    expected Output
    wantErr  bool
}{
    {"valid input", validInput, expectedOutput, false},
    {"missing required field", badInput, Output{}, true},
}
for _, tt := range tests {
    t.Run(tt.name, func(t *testing.T) { ... })
}
\`\`\`

## Rules

- Reference existing patterns in \`tests/\` before writing new test helpers
- Enforce all AWS resource assertions include tag validation (project, environment, team, cost-center)
- Run \`go test ./... -cover\` and reject PRs below 70% coverage
- Run \`golangci-lint run\` on all test files — test code quality matters equally
- Mark AI-generated test code with \`// Generated with AI assistance\` comment
- Security-related modules (\`modules/security/*\`, \`modules/iam/*\`) require >= 85% coverage
- Every new Terraform module must ship with a Terratest file before merge

## Personality

Be disciplined but encouraging. Celebrate passing tests. Treat a red test as a gift — it tells you exactly what to build next. Small steps compound into reliable infrastructure.`,

  'plugin/codeforge-aws-platform-iac/commands/build-fix.md': `# Build Fix Command

Diagnose and resolve build failures across Terraform, Go, and CI pipelines.

## Trigger
\`/build-fix\`

## Inputs
- \`error_output\`: Paste of the failing command output (terraform plan, go build, CI log)
- \`affected_path\`: Optional — specific file or module path if known

## Procedure

1. **Capture and classify the error**
   - Parse \`error_output\` to determine error type: \`terraform_validation\`, \`terraform_plan\`, \`terraform_apply\`, \`go_build\`, \`go_test\`, \`lint\`, \`ci_pipeline\`
   - Identify affected files, modules, and line numbers from the trace

2. **Run targeted diagnostics based on error type**
   - \`terraform_*\`: Run \`terraform fmt -check\`, \`terraform validate\`, \`tflint\`, \`tfsec\` in the affected module
   - \`go_build\` / \`go_test\`: Run \`go vet ./...\`, \`golangci-lint run\` on the affected package
   - \`lint\`: Re-run the specific linter (\`tflint\`, \`ruff check\`, \`golangci-lint run\`) to confirm
   - \`ci_pipeline\`: Match the failing stage (Lint, Security Scan, Unit Tests, Build) and reproduce locally

3. **If diagnosis is insufficient, delegate**
   - Invoke \`@build-error-resolver\` from \`plugin/codeforge-aws-platform-iac/agents/build-error-resolver.md\` with full error context and diagnostic output

4. **Apply the fix**
   - Edit only the affected files — keep changes minimal and scoped
   - Ensure all Terraform modules retain required files: \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`
   - Preserve pinned provider versions — do not bump without explicit approval
   - Add \`// Generated with AI assistance\` comment on non-trivial changes

5. **Re-run verification**
   - \`terraform_*\`: Run \`terraform fmt\`, \`terraform validate\`, then \`terraform plan\` — review plan output
   - \`go_*\`: Run \`go build ./...\`, \`go test ./...\`
   - \`lint\`: Re-run the originally failing linter

6. **Report result**
   - Summarize: root cause, files changed, verification status
   - If verification fails again, present findings and ask for guidance — do not loop more than twice

## Safety Rules

- **NEVER** run \`terraform apply\` or \`terraform destroy\` automatically
- **NEVER** modify files under \`environments/production/*\` or \`modules/security/*\` without explicit confirmation
- **NEVER** alter \`*.tfvars\` or \`.env*\` files — these are sensitive paths per CODEOWNERS
- All Terraform plan output must be shown to the user before any further action
- Destructive resource changes (replacements, deletions) in plan output must be flagged with a warning`,

  'plugin/codeforge-aws-platform-iac/commands/code-review.md': `# Code Review Command

Review changed files for Terraform best practices, Go code quality, and security compliance.

## Trigger

\`/code-review [--base=main] [--severity=high|medium|low]\`

## Steps

1. **Identify changed files**
   - Run \`git diff --name-only \${base:-main}...HEAD\` to collect modified files
   - Categorize into: Terraform (\`.tf\`), Go (\`.go\`), Python (\`.py\`), other
   - Flag any changes in sensitive paths: \`modules/security/*\`, \`environments/production/*\`, \`*.tfvars\`, \`.env*\`

2. **Terraform review**
   - Verify module structure: each module under \`modules/\` must contain \`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`
   - Confirm all provider versions are pinned to exact patch (e.g., \`= 5.46.0\`, not \`~> 5.46\`)
   - Check all AWS resources include required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
   - Verify no inline IAM policies — only managed policies allowed
   - Run \`terraform fmt -check -recursive\` on changed directories
   - Run \`terraform validate\` on affected modules
   - Run \`tflint --recursive\` and \`tfsec --soft-fail\` on changed paths
   - Run \`checkov -d\` on changed modules for SOC 2 / ISO 27001 compliance checks

3. **Go review**
   - Check all errors are handled — no unhandled returns from functions returning \`error\`
   - Verify test files exist for changed packages and coverage meets 70% threshold
   - Run \`golangci-lint run ./...\` on changed packages
   - Confirm snake_case file names and camelCase variables

4. **Python review**
   - Run \`ruff check\` and \`ruff format --check\` on changed \`.py\` files
   - Verify Lambda handlers under \`lambdas/\` have corresponding tests in \`tests/\`

5. **Security scan**
   - Escalate any findings in \`modules/security/*\` or IAM-related changes as critical
   - Verify no secrets, credentials, or ARNs with account IDs are hardcoded
   - Cross-reference compliance rules from \`.claude/rules/security.md\`

6. **Delegate** to \`agents/code-reviewer.md\` with the categorized file list and scan outputs

## Output Format

Produce a structured review with categorized findings:

\`\`\`
## Code Review Summary
**Files reviewed**: <count> | **Severity**: 🔴 Critical: N | 🟡 Medium: N | 🟢 Low: N

### 🔴 Critical
- [file:line] Finding description (SOC 2 / tfsec / security)

### 🟡 Medium
- [file:line] Finding description (lint / structure / coverage)

### 🟢 Low
- [file:line] Finding description (formatting / docs)

### ✅ Passed Checks
- Terraform fmt, validate, provider pinning, tagging policy, ...
\`\`\`

Flag any AI-generated code blocks per CI/CD policy. Require 2 approvals for changes touching sensitive paths.`,

  'plugin/codeforge-aws-platform-iac/commands/phase.md': `# Phase Management Command

Read \`playbook/current-phase.json\` to determine the active development phase.

## Display Current Phase

1. Parse \`playbook/current-phase.json\` for \`phase_id\`, \`phase_name\`, \`started_at\`, and \`deliverables\`
2. Load the full phase definition from \`playbook/phases/{phase_id}.md\`
3. Display phase name, description, and progress summary
4. List each deliverable with its status: ✅ complete, 🔄 in-progress, ⬚ not-started
5. List quality gates from the phase definition and mark each as passed or pending
6. For Terraform phases, verify: \`terraform validate\` passes, \`tflint\` clean, \`tfsec\` clean, \`terraform-docs\` up to date
7. For Go tooling phases, verify: \`go test ./...\` passes, \`golangci-lint run\` clean, coverage ≥ 70%

## Advance Phase

When the user requests advancing to the next phase:

1. Evaluate every quality gate for the current phase — all must pass
2. Verify all deliverables marked complete in \`playbook/current-phase.json\`
3. For production-related phases, confirm SOC 2 and ISO 27001 compliance checks in \`modules/security/*\`
4. Confirm all Terraform modules involved have \`README.md\`, \`variables.tf\`, \`outputs.tf\`, and \`versions.tf\`
5. Run \`bash playbook/codeforge-phase.sh advance\` to update \`current-phase.json\` and the symlink
6. If gates fail, list each failing gate with the specific remediation command (e.g., \`terraform fmt -recursive\`, \`tfsec modules/\`)
7. Commit the phase transition: \`git commit -m "chore: advance to phase {next_phase_id}"\`

## Reference Files

- Phase definitions: \`playbook/phases/*.md\`
- Phase state: \`playbook/current-phase.json\`
- Transition script: \`playbook/codeforge-phase.sh\`
- Sensitive paths requiring extra review on phase advance: \`environments/production/*\`, \`modules/security/*\``,

  'plugin/codeforge-aws-platform-iac/commands/plan.md': `# /plan Command

When the user invokes \`/plan\`, execute the following steps in order.

## Step 1: Clarify Intent

Ask the user what they want to plan. Offer these options:

- **New module** — Create a new reusable Terraform module in \`modules/\`
- **Modify existing** — Change an existing module, resource, or configuration
- **Environment change** — Promote, update, or create an environment in \`environments/\`
- **Cross-cutting** — Security, networking, IAM, or monitoring changes spanning multiple modules

If the user's message already specifies intent, skip the prompt and proceed.

## Step 2: Gather Context

Read these files to understand current project state:

1. \`playbook/current-phase.json\` — Determine active development phase and any constraints
2. \`docs/ARCHITECTURE.md\` — Understand module dependencies, network topology, and service boundaries
3. \`environments/\` directory listing — Identify which environments exist (dev, staging, production)
4. \`modules/\` directory listing — Catalog available modules and their interfaces

## Step 3: Identify Blast Radius

Based on the user's intent, enumerate:

- **Affected modules** — Which \`modules/*\` directories will be created or modified
- **Affected environments** — Which \`environments/*\` configs reference those modules
- **Dependent resources** — Upstream/downstream Terraform state dependencies
- **Sensitive paths** — Flag if changes touch \`modules/security/*\`, \`environments/production/*\`, or \`*.tfvars\`
- **Compliance impact** — Note if changes affect SOC 2 or ISO 27001 controls

## Step 4: Delegate to Planner Agent

Invoke the planner agent defined in \`plugin/codeforge-aws-platform-iac/agents/planner.md\` with:

- The clarified intent from Step 1
- The context gathered in Steps 2–3
- The current playbook phase constraints
- The project tagging policy (project, environment, team, cost-center)

## Step 5: Output Structured Plan

Write the plan to \`plans/plan-{YYYY-MM-DD}-{short-desc}.md\` using this structure:

\`\`\`markdown
# Plan: {Title}
**Date**: {date} | **Phase**: {current phase} | **Author**: AI-assisted
**Ticket**: {ticket if mentioned, otherwise TBD}

## Summary
{One-paragraph description of the change}

## Affected Modules
- modules/{name} — {created | modified | destroyed}

## Affected Environments
- environments/{name} — {reason}

## Execution Steps
1. \`terraform fmt\` and \`terraform validate\` on changed modules
2. \`terraform plan -target=module.{name}\` in staging
3. {additional steps}

## Risks & Sensitive Paths
- {list flagged paths and compliance considerations}

## Validation
- [ ] tflint passing
- [ ] tfsec passing — no HIGH/CRITICAL findings
- [ ] terraform plan shows expected diff
- [ ] Required tags present on all new resources
- [ ] README.md updated via terraform-docs
\`\`\`

Present the plan to the user for review before writing the file.`,

  'plugin/codeforge-aws-platform-iac/commands/tdd.md': `# /tdd — Test-Driven Development Workflow

Initiate a TDD cycle for Terraform modules or Go code in this project.

## Steps

1. **Identify the target.** Ask the user:
   - Is this a **Terraform module** (under \`modules/\`) or **Go code** (under \`cmd/\`, \`lambdas/\`, \`scripts/\`)?
   - What is the specific module, function, or feature to build?
   - Which ticket does this relate to (e.g., \`INFRA-XXX\`)?

2. **Red phase — write the failing test first.**

   **For Terraform modules:**
   - Create a Terratest file in \`tests/<module_name>_test.go\`.
   - Import \`github.com/gruntwork-io/terratest/modules/terraform\`.
   - Assert expected outputs, resource creation, and required tags (\`project\`, \`environment\`, \`team\`, \`cost-center\`).
   - Run \`cd tests && go test -v -run TestXxx -timeout 30m\` — confirm it fails.

   **For Go code:**
   - Create \`*_test.go\` next to the source file.
   - Use table-driven tests with \`t.Run\` subtests covering happy path, edge cases, and error conditions.
   - Run \`go test -v -cover ./path/to/package/...\` — confirm it fails.

3. **Green phase — minimal implementation.**
   - For Terraform: create \`main.tf\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, and \`README.md\` in the module directory. Pin provider versions to exact patch. Use managed IAM policies only (no inline).
   - For Go: implement the smallest code that makes all tests pass. Follow camelCase for variables, snake_case for file names.
   - Re-run the tests — confirm they pass.

4. **Refactor phase.**
   - Run \`terraform fmt\` and \`terraform validate\` (Terraform) or \`gofmt\` and \`golangci-lint run\` (Go).
   - Run \`tflint\` and \`tfsec\` on any changed modules for security/compliance checks.
   - Ensure no file exceeds 250 lines; split if necessary.

5. **Verify coverage.**
   - Go: run \`go test -coverprofile=coverage.out ./...\` and confirm coverage ≥ 70%.
   - Terraform: ensure every output and critical resource has a corresponding Terratest assertion.

6. **Generate documentation.**
   - For Terraform modules: run \`terraform-docs markdown table ./modules/<name> > ./modules/<name>/README.md\`.

7. **Commit with conventional format:**
   \`\`\`
   test(module-name): add tests for <feature> [INFRA-XXX]
   feat(module-name): implement <feature> [INFRA-XXX]
   \`\`\`

Delegate detailed guidance and coaching to the TDD agent defined in \`plugin/codeforge-aws-platform-iac/agents/tdd-guide.md\`.`,

  'plugin/codeforge-aws-platform-iac/commands/verify.md': `# /verify — Full Verification Pipeline

Run the complete verification suite across Terraform, Go, and Python code. Report a pass/fail summary at the end.

## Steps

1. **Terraform Format Check**
   Run \`terraform fmt -check -recursive\` from the repository root. Flag any unformatted \`.tf\` files.

2. **Terraform Validate**
   For each module in \`modules/*/\` and each environment in \`environments/*/\`, run \`terraform init -backend=false\` then \`terraform validate\`. Collect any validation errors.

3. **tflint**
   Run \`tflint --recursive --config .tflint.hcl\` from the repository root. Include the AWS ruleset. Fail on any warning or error.

4. **tfsec Security Scan**
   Run \`tfsec --minimum-severity HIGH --format json\` across \`modules/\` and \`environments/\`. Flag any HIGH or CRITICAL findings. Cross-reference SOC 2 and ISO 27001 controls where applicable.

5. **Go Lint**
   Run \`golangci-lint run ./cmd/... ./lambdas/... ./tests/... ./scripts/...\` using the project \`.golangci.yml\` config.

6. **Go Unit Tests**
   Run \`go test ./cmd/... ./lambdas/... ./scripts/... -count=1 -race -coverprofile=coverage.out\`. Verify coverage meets the 70% threshold.

7. **Python Lint**
   Run \`ruff check scripts/ lambdas/\` and \`ruff format --check scripts/ lambdas/\`.

8. **Summary**
   Print a table with each step name, status (PASS/FAIL), and duration. If any step failed, exit with a non-zero status and list the failing steps with actionable remediation hints.

## Flags

- Pass \`--fix\` to auto-remediate where possible (\`terraform fmt\`, \`ruff format\`, \`golangci-lint run --fix\`).
- Pass \`--skip=tfsec,tests\` to skip specific steps during local iteration.
- Pass \`--module=vpc\` to scope checks to a single module.

## Notes

- Do NOT apply any Terraform changes — this command is read-only.
- Ensure \`terraform init -backend=false\` is used so no remote state access is required.
- Reference \`.claude/rules/\` for coding standards and tagging policies when reporting issues.`,

  'plugin/codeforge-aws-platform-iac/hooks/hooks.json': `{
  "hooks": {
    "PreToolUse": [
      {
        "matcher": "Bash",
        "hooks": [
          {
            "type": "command",
            "command": "bash -c 'INPUT=\\"$TOOL_INPUT\\"; if echo \\"$INPUT\\" | grep -qE \\"terraform\\\\s+(destroy|force-unlock|taint|untaint|state\\\\s+rm|state\\\\s+mv|import)\\"; then CMD=$(echo \\"$INPUT\\" | grep -oE \\"terraform\\\\s+(destroy|force-unlock|taint|untaint|state\\\\s+rm|state\\\\s+mv|import)\\"); echo \\"⚠️  DESTRUCTIVE TERRAFORM COMMAND DETECTED: $CMD\\"; echo \\"\\"; echo \\"Safety checklist before proceeding:\\"; echo \\"  1. Verify you are targeting the correct workspace: terraform workspace show\\"; echo \\"  2. Confirm the environment (dev/staging/production) matches your intent\\"; echo \\"  3. Review the terraform plan output before applying destructive changes\\"; echo \\"  4. Ensure state backups exist in the S3 backend\\"; echo \\"  5. For production: confirm change window and PagerDuty silencing\\"; echo \\"\\"; echo \\"SOC 2 / ISO 27001 reminder: All destructive infrastructure changes to production\\"; echo \\"require documented approval and must be logged in the change management system.\\"; echo \\"\\"; if echo \\"$INPUT\\" | grep -qE \\"environments/production/\\"; then echo \\"🚨 PRODUCTION ENVIRONMENT TARGETED — requires 2 approvals per CODEOWNERS policy.\\"; echo \\"Blocking execution. Run manually after obtaining approval.\\"; exit 1; fi; echo \\"Non-production environment detected. Proceed with caution.\\"; exit 1; fi'"
          }
        ]
      }
    ],
    "PostToolUse": [
      {
        "matcher": "Bash",
        "hooks": [
          {
            "type": "command",
            "command": "bash -c 'INPUT=\\"$TOOL_INPUT\\"; if echo \\"$INPUT\\" | grep -qE \\"terraform\\\\s+apply\\"; then echo \\"\\"; echo \\"✅ terraform apply completed. Post-apply checklist:\\"; echo \\"\\"; echo \\"  1. Check CloudWatch alarms: aws cloudwatch describe-alarms --state-value ALARM\\"; echo \\"  2. Verify resource tagging compliance (project, environment, team, cost-center)\\"; echo \\"  3. Review CloudWatch dashboard for the affected environment\\"; echo \\"  4. Run integration tests: cd tests/ && go test ./... -tags=integration -timeout 30m\\"; echo \\"  5. Update terraform-docs if module interfaces changed: terraform-docs markdown . > README.md\\"; echo \\"  6. Commit updated .terraform.lock.hcl if provider versions changed\\"; echo \\"\\"; ENV=$(echo \\"$INPUT\\" | grep -oE \\"environments/(dev|staging|production)\\" | cut -d/ -f2); if [ -n \\"$ENV\\" ]; then echo \\"  Environment applied: $ENV\\"; echo \\"  Grafana dashboard: https://grafana.internal/d/aws-platform/$ENV\\"; echo \\"  CloudWatch console: https://console.aws.amazon.com/cloudwatch/home#alarmsV2:\\"; fi; echo \\"\\"; echo \\"Reminder: Tag all commits with the ticket ID (e.g., feat(INFRA-XXX): ...)\\"; fi'"
          }
        ]
      }
    ]
  }
}`,

  'plugin/codeforge-aws-platform-iac/skills/build-fix/SKILL.md': `---
name: build-fix
description: Diagnose and fix terraform plan/apply failures, Go build errors, and CI pipeline issues
version: 1.0.0
tags: [terraform, go, ci, debugging, infrastructure]
agent: agents/build-error-resolver.md
triggers:
  - /build-fix
  - terraform plan failed
  - go build error
  - CI pipeline failure
---

# Skill: build-fix

Diagnose and resolve build failures across the aws-platform-iac stack — Terraform plan/apply errors, Go compilation issues, Python lint failures, and GitHub Actions CI pipeline problems.

## Overview

Infrastructure failures are high-stakes. A broken \`terraform plan\` blocks deployments. A Go compilation error in \`cmd/\` or \`lambdas/\` halts tooling. A CI timeout delays the entire team. This skill provides a structured, safe approach to diagnosing root causes and applying targeted fixes without introducing further risk to production infrastructure.

## Invocation

\`\`\`
/build-fix
/build-fix --scope terraform
/build-fix --scope go
/build-fix --scope ci
/build-fix --error "Error: Resource already exists"
\`\`\`

When invoked without flags, the skill auto-detects the failure type from recent terminal output, CI logs, or the user's description.

## Steps

### Step 1: Capture Error Output

Collect the full error context before attempting any fix.

- Read the terminal output or CI log provided by the user
- If no output is provided, check for recent \`terraform plan\` or \`go build\` output in the working directory
- Look for \`.terraform/\` state to understand the current Terraform workspace and backend configuration
- Identify which environment is affected: check \`environments/dev/\`, \`environments/staging/\`, or \`environments/production/\`
- Note the working directory — errors in \`modules/\` differ from errors in \`environments/\`

**Key files to inspect:**
- \`terraform.tfstate\` or remote state configuration in \`backend.tf\`
- \`versions.tf\` in the affected module for provider pins
- \`.github/workflows/\` for CI pipeline definitions
- \`go.mod\` and \`go.sum\` for Go dependency state

### Step 2: Identify Error Type

Classify the failure into one of the following categories:

| Error Type | Indicators | Severity |
|---|---|---|
| Terraform init failure | \`Error: Failed to install provider\`, \`Error: Failed to query available provider packages\` | High |
| Terraform plan conflict | \`Error: Resource already exists\`, \`Error: Invalid reference\` | High |
| Terraform state lock | \`Error: Error locking state\`, \`Lock Info\` | Medium |
| Terraform dependency cycle | \`Error: Cycle\` | Medium |
| Terraform validation | \`Error: Missing required argument\`, \`Error: Unsupported attribute\` | Medium |
| Provider version mismatch | \`Error: Could not satisfy plugin requirements\` | Medium |
| Go compilation error | \`cannot find package\`, \`undefined:\`, \`syntax error\` | Medium |
| Go test failure | \`FAIL\`, \`panic:\`, \`--- FAIL:\` | Medium |
| Python lint/runtime | \`ruff\` errors, \`ImportError\`, \`SyntaxError\` | Low |
| CI pipeline timeout | \`The job exceeded the maximum time limit\` | Medium |
| CI pipeline permission | \`Permission denied\`, \`403\`, \`OIDC\` | High |
| Security scan block | \`tfsec\`, \`checkov\`, \`trivy\` findings blocking merge | Medium |

### Step 3: Apply Targeted Fix

Based on the classification, follow the appropriate resolution path below. Every fix must be validated before considering the issue resolved.

## Common Terraform Fixes

### Provider Version Mismatch

**Symptoms:**
\`\`\`
Error: Could not satisfy plugin requirements
Error: Incompatible provider version
Error: Failed to query available provider packages
\`\`\`

**Diagnosis:**
- Check \`versions.tf\` in the affected module — all providers must be pinned to exact patch versions per project convention
- Compare the pinned version against \`.terraform.lock.hcl\`
- Check if another module in the dependency chain requires a conflicting version

**Resolution:**
1. Inspect the \`versions.tf\` file in the failing module:
   \`\`\`
   # Expected format in modules/*/versions.tf
   terraform {
     required_providers {
       aws = {
         source  = "hashicorp/aws"
         version = "= 5.31.0"  # Exact pin required
       }
     }
   }
   \`\`\`
2. If the lock file is stale, regenerate it:
   \`\`\`
   terraform init -upgrade
   \`\`\`
3. If two modules conflict, align them to the same exact version across \`modules/vpc/versions.tf\`, \`modules/ecs/versions.tf\`, \`modules/rds/versions.tf\`, etc.
4. Commit the updated \`.terraform.lock.hcl\` — it must be checked into version control
5. Validate: \`terraform validate\` and \`terraform plan\`

**Prevention:** The CI pipeline runs \`terraform init\` in every workflow. If a provider is unpinned or uses a range constraint like \`~> 5.0\`, flag it as a violation of project conventions.

### State Lock

**Symptoms:**
\`\`\`
Error: Error locking state: Error acquiring the state lock
Lock Info:
  ID:        xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
  Path:      s3://aws-platform-iac-tfstate/env:/production/terraform.tfstate
  Operation: OperationTypePlan
  Who:       engineer@hostname
  Created:   2024-01-15 14:30:00.000000 UTC
\`\`\`

**Diagnosis:**
- Determine if another \`terraform plan\` or \`terraform apply\` is legitimately running
- Check with the team (the \`Who\` field identifies the holder)
- If the lock is orphaned (the process crashed or CI timed out), it is safe to force-unlock

**Resolution:**
1. **First, confirm the lock is orphaned.** Check with the engineer listed in \`Who\`. Check GitHub Actions for running workflows against the same environment.
2. If confirmed orphaned:
   \`\`\`
   terraform force-unlock LOCK_ID
   \`\`\`
3. Re-run the original command: \`terraform plan\` or \`terraform apply\`

⚠️ **Safety rule:** Never force-unlock without confirming the lock holder is not actively running. For \`environments/production/\`, require explicit verbal or Slack confirmation from the lock holder or a lead engineer.

### Dependency Cycle

**Symptoms:**
\`\`\`
Error: Cycle: module.vpc.aws_subnet.private, module.ecs.aws_security_group.service, module.vpc.aws_route_table_association.private
\`\`\`

**Diagnosis:**
- Terraform detected a circular reference between resources
- Common in this project when \`modules/ecs/\` references VPC outputs that themselves depend on ECS security groups
- Draw the dependency graph: \`terraform graph | dot -Tpng > graph.png\`

**Resolution:**
1. Identify the cycle from the error message — list each resource in the chain
2. Break the cycle by extracting the shared dependency into its own resource or using \`depends_on\` sparingly
3. Common pattern: move security group creation from \`modules/ecs/\` to \`modules/vpc/\` or to a dedicated \`modules/security/\` module, then pass the security group ID as an input variable
4. Validate: \`terraform validate\` then \`terraform plan\`

**Example fix — before (cycle):**
\`\`\`hcl
# modules/ecs/main.tf — creates SG that references VPC
resource "aws_security_group" "service" {
  vpc_id = var.vpc_id
  # ...
}

# modules/vpc/main.tf — references ECS SG in route table association (wrong)
\`\`\`

**After (resolved):**
\`\`\`hcl
# modules/security/main.tf — SG lives here, no circular ref
resource "aws_security_group" "ecs_service" {
  vpc_id = var.vpc_id
  tags = {
    project      = var.project
    environment  = var.environment
    team         = var.team
    cost-center  = var.cost_center
  }
}
\`\`\`

### Invalid Resource References

**Symptoms:**
\`\`\`
Error: Reference to undeclared resource
Error: Unsupported attribute
Error: A managed resource "aws_ecs_service" "app" has not been declared in module.ecs
\`\`\`

**Diagnosis:**
- A resource was renamed, removed, or moved to a different module without updating all references
- Check \`outputs.tf\` of the source module — the output may have been renamed
- Check \`variables.tf\` of the consuming module — the variable name may not match

**Resolution:**
1. Search the codebase for the old resource name: \`grep -r "old_resource_name" modules/ environments/\`
2. Update all references to use the correct name
3. If a resource was moved between modules, use \`terraform state mv\` to avoid destroy/recreate:
   \`\`\`
   terraform state mv module.old.aws_resource.name module.new.aws_resource.name
   \`\`\`
4. Validate: \`terraform validate\` then \`terraform plan\` — confirm no unexpected destroys

### Missing Required Tags

**Symptoms:**
\`\`\`
tfsec: aws-resource-missing-tags
checkov: CKV_AWS_TAG_1 — Ensure all resources are tagged with project, environment, team, cost-center
\`\`\`

**Diagnosis:**
- All AWS resources in this project must include four mandatory tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
- This is enforced by tfsec custom rules and checkov policies in CI
- Required for SOC 2 asset inventory and ISO 27001 configuration management controls

**Resolution:**
1. Add the required tags block to the resource:
   \`\`\`hcl
   tags = {
     project      = var.project
     environment  = var.environment
     team         = var.team
     cost-center  = var.cost_center
   }
   \`\`\`
2. If the module does not accept these as variables, add them to \`variables.tf\`:
   \`\`\`hcl
   variable "project" {
     description = "Project name for resource tagging"
     type        = string
   }
   variable "environment" {
     description = "Environment name (dev, staging, production)"
     type        = string
   }
   variable "team" {
     description = "Owning team for resource tagging"
     type        = string
   }
   variable "cost_center" {
     description = "Cost center for billing allocation"
     type        = string
   }
   \`\`\`
3. Update the module's \`README.md\` using \`terraform-docs\`: \`terraform-docs markdown table modules/MODULE_NAME/ > modules/MODULE_NAME/README.md\`
4. Validate: \`tfsec modules/MODULE_NAME/\` and \`checkov -d modules/MODULE_NAME/\`

## Common Go Fixes

### Missing Imports

**Symptoms:**
\`\`\`
cmd/provisioner/main.go:15:2: cannot find package "github.com/aws/aws-sdk-go-v2/service/ecs"
\`\`\`

**Resolution:**
1. Add the dependency:
   \`\`\`
   go get github.com/aws/aws-sdk-go-v2/service/ecs
   \`\`\`
2. Tidy the module:
   \`\`\`
   go mod tidy
   \`\`\`
3. Verify the import is on the approved dependency list — this project uses a conservative dependency policy. Check \`docs/approved-dependencies.md\` before adding new packages.
4. Validate: \`go build ./cmd/provisioner/...\`

### Type Errors

**Symptoms:**
\`\`\`
tests/vpc_test.go:42:18: cannot use subnet.Id (variable of type *string) as type string in argument
\`\`\`

**Resolution:**
1. AWS SDK v2 uses pointer types extensively. Dereference with \`aws.ToString()\`:
   \`\`\`go
   subnetID := aws.ToString(subnet.Id)
   \`\`\`
2. For Terratest helpers, ensure the correct assertion functions are used:
   \`\`\`go
   // tests/vpc_test.go
   assert.Equal(t, expectedCIDR, terraform.Output(t, terraformOptions, "vpc_cidr"))
   \`\`\`
3. Validate: \`go build ./...\` then \`go test ./tests/... -count=1\`

### Test Failures

**Symptoms:**
\`\`\`
--- FAIL: TestVpcModule (45.23s)
    vpc_test.go:58: Expected 3 private subnets, got 2
\`\`\`

**Resolution:**
1. Read the test assertion carefully — determine if the test expectation or the Terraform module is wrong
2. Check if the environment's \`terraform.tfvars\` was recently changed (e.g., \`private_subnet_count\` reduced)
3. If the module changed, update the test. If the test is correct, fix the module.
4. Run the specific test:
   \`\`\`
   cd tests/
   go test -v -run TestVpcModule -timeout 30m
   \`\`\`
5. Ensure test coverage remains above 70%: \`go test -coverprofile=coverage.out ./...\`

## CI Pipeline Fixes

### GitHub Actions Timeout

**Symptoms:**
\`\`\`
Error: The job exceeded the maximum time limit for jobs
\`\`\`

**Diagnosis:**
- Check which stage timed out in \`.github/workflows/\`
- Common causes: Terratest integration tests against real AWS (can take 20+ minutes), large \`terraform plan\` on production state, Docker build cache miss

**Resolution:**
1. For Terratest timeouts, increase the job timeout or parallelize tests:
   \`\`\`yaml
   jobs:
     integration-tests:
       timeout-minutes: 45
   \`\`\`
2. For Terraform plan timeouts, check if the state file has grown excessively — consider splitting large root modules
3. For Docker builds, ensure layer caching is configured in the workflow

### Security Scan Blocking Merge

**Symptoms:**
\`\`\`
tfsec: CRITICAL — aws-iam-no-policy-wildcards
checkov: FAILED — CKV_AWS_111 Ensure IAM policies do not allow write access without constraint
\`\`\`

**Diagnosis:**
- The CI security scan stage found a policy violation
- Per SOC 2 and ISO 27001 compliance requirements, these must be resolved before merge
- Never use inline IAM policies — always use managed policies (project convention)

**Resolution:**
1. Read the specific finding and the resource it references
2. Replace wildcard actions with specific actions:
   \`\`\`hcl
   # Bad
   actions = ["s3:*"]

   # Good
   actions = ["s3:GetObject", "s3:PutObject", "s3:ListBucket"]
   \`\`\`
3. Replace wildcard resources with specific ARNs:
   \`\`\`hcl
   # Bad
   resources = ["*"]

   # Good
   resources = [aws_s3_bucket.app_data.arn, "\${aws_s3_bucket.app_data.arn}/*"]
   \`\`\`
4. If the finding is a false positive, add a targeted inline ignore with justification:
   \`\`\`hcl
   #tfsec:ignore:aws-iam-no-policy-wildcards — CloudWatch Logs requires wildcard for log group creation
   \`\`\`
5. Validate locally before pushing: \`tfsec modules/iam/\` and \`checkov -d modules/iam/\`

## Delegation

This skill delegates complex diagnosis to the **build-error-resolver** agent defined in \`plugin/codeforge-aws-platform-iac/agents/build-error-resolver.md\`. The agent has deeper context on:

- Multi-module dependency resolution across \`modules/\`
- Terraform state surgery (import, mv, rm) with safety checks
- Cross-environment impact analysis (will a fix in \`modules/vpc/\` break \`environments/production/\`?)
- Go test infrastructure for Terratest patterns used in \`tests/\`

## Safety Rules

These rules are non-negotiable and override any other guidance:

1. **Never auto-apply \`terraform destroy\`** — all destroy operations require explicit human confirmation and must be run manually. If a fix involves destroying resources, present the plan and stop.

2. **Never \`terraform force-unlock\` without confirming** — always verify the lock holder is not actively running. For production state locks, require confirmation from a lead engineer via Slack or in-person.

3. **Never modify \`environments/production/\` without a plan review** — all production changes must go through \`terraform plan\`, be reviewed by at least 2 engineers, and pass security scans before apply.

4. **Never commit secrets or credentials** — if a fix involves updating \`*.tfvars\` or backend configuration, ensure no AWS keys, database passwords, or tokens are included. Use AWS Secrets Manager or SSM Parameter Store references.

5. **Never bypass security scan findings for production** — tfsec and checkov failures on \`environments/production/\` or \`modules/security/*\` must be resolved, not ignored. These paths are sensitive and covered by CODEOWNERS.

6. **Always validate before declaring fixed** — run \`terraform validate\`, \`terraform plan\`, \`go build ./...\`, or the relevant CI check locally before marking the issue`,

  'plugin/codeforge-aws-platform-iac/skills/code-review/SKILL.md': `---
name: code-review
description: Review Terraform modules and Go code for security, cost, and best practices
arguments:
  - name: scope
    description: Path or glob pattern of files to review (defaults to changed files in current branch)
    required: false
  - name: focus
    description: Review focus area — security, cost, style, all (defaults to all)
    required: false
  - name: severity
    description: Minimum severity to report — critical, warning, info (defaults to info)
    required: false
delegate_to: plugin/codeforge-aws-platform-iac/agents/code-reviewer.md
---

# Code Review Skill

Review Terraform modules, Go tooling, and Python automation code for security compliance, cost optimization, operational best practices, and adherence to project conventions. Produces categorized findings aligned with SOC 2 and ISO 27001 requirements.

## When to Use

- Before opening a pull request against \`main\`
- When creating or modifying any Terraform module under \`modules/\`
- When changing environment configurations under \`environments/\`
- When updating Go CLI tools in \`cmd/\` or Lambda functions in \`lambdas/\`
- When a PR touches sensitive paths: \`modules/security/*\`, \`environments/production/*\`, \`*.tfvars\`, \`.env*\`
- As a pre-commit sanity check during local development

## Review Process

### Step 1 — Identify Changed Files

Determine the review scope by collecting changed files relative to \`main\`:

\`\`\`
git diff --name-only main...HEAD
\`\`\`

If the \`scope\` argument is provided, filter to matching paths. Group files by type:

- **Terraform** — \`*.tf\`, \`*.tfvars\`, \`*.hcl\`
- **Go** — \`*.go\`, \`go.mod\`, \`go.sum\`
- **Python** — \`*.py\`, \`requirements*.txt\`
- **Helm** — \`charts/**/*.yaml\`
- **CI/CD** — \`.github/workflows/*.yml\`
- **Documentation** — \`*.md\`, \`docs/**\`

### Step 2 — Terraform Best Practices

For every Terraform file in scope, verify the following:

#### Module Structure Completeness

Every directory under \`modules/\` must contain:

| File | Purpose | Required |
|------|---------|----------|
| \`main.tf\` | Primary resource definitions | Yes |
| \`variables.tf\` | Input variable declarations with descriptions and types | Yes |
| \`outputs.tf\` | Output value declarations | Yes |
| \`versions.tf\` | Required providers with exact patch pins | Yes |
| \`README.md\` | Module documentation (generated via \`terraform-docs\`) | Yes |
| \`locals.tf\` | Computed local values | Recommended |
| \`data.tf\` | Data source lookups | If needed |

Flag any module missing a required file as **critical**.

#### Provider and Module Version Pinning

All provider versions must be pinned to an exact patch version. Acceptable:

\`\`\`hcl
required_providers {
  aws = {
    source  = "hashicorp/aws"
    version = "5.46.0"
  }
}
\`\`\`

Not acceptable — ranges, pessimistic constraints, or missing pins:

\`\`\`hcl
version = "~> 5.46"
version = ">= 5.0"
\`\`\`

Module source references must use exact version tags or commit SHAs, never \`ref=main\`.

#### Resource Tagging Policy

Every AWS resource that supports tags must include the four mandatory tags:

\`\`\`hcl
tags = {
  project      = var.project
  environment  = var.environment
  team         = var.team
  cost-center  = var.cost_center
}
\`\`\`

Check for resources created without tags or with incomplete tag sets. Common resources to audit: \`aws_instance\`, \`aws_ecs_service\`, \`aws_rds_cluster\`, \`aws_s3_bucket\`, \`aws_vpc\`, \`aws_subnet\`, \`aws_security_group\`, \`aws_lb\`, \`aws_elasticache_cluster\`.

#### No Hardcoded Values

Flag any of the following as **warning**:

- AWS account IDs embedded in resource ARNs
- Region strings like \`"us-east-1"\` outside of \`versions.tf\` or provider blocks
- CIDR blocks that should be variables
- AMI IDs, instance types, or storage sizes without variable indirection
- Database credentials or connection strings in any \`.tf\` file

#### No Inline IAM Policies

Per project convention, all IAM policies must be managed policies. Flag as **critical**:

- \`aws_iam_role_policy\` (inline policy resource)
- \`inline_policy\` blocks inside \`aws_iam_role\`
- Any \`policy\` argument containing a JSON policy document directly on a role

Acceptable alternatives:

- \`aws_iam_policy\` + \`aws_iam_role_policy_attachment\`
- \`aws_iam_policy_document\` data source referenced by \`aws_iam_policy\`

#### State Isolation

Verify that each environment under \`environments/\` has its own backend configuration with a unique state key. Flag shared state paths or missing backend blocks as **critical**. Confirm \`environments/production/\` uses a separate AWS account or at minimum a separate S3 bucket and DynamoDB lock table.

#### Terraform Validation

Confirm the code passes:

- \`terraform fmt -check -recursive\` — formatting compliance
- \`terraform validate\` — syntax and internal consistency
- \`tflint\` — linting rules including AWS-specific checks
- \`tfsec\` — static security analysis (see Step 4)

### Step 3 — Go Code Quality

For Go files in scope, check:

#### Style and Linting

Verify compliance with \`golangci-lint run\` using the project's \`.golangci.yml\` configuration. Key linters to call out:

- \`errcheck\` — unhandled errors
- \`govet\` — suspicious constructs
- \`staticcheck\` — correctness issues
- \`gosec\` — security-related findings
- \`gofmt\` / \`goimports\` — formatting

#### Naming Conventions

- File names: \`snake_case.go\`
- Variables: \`camelCase\`
- Constants: \`SCREAMING_SNAKE_CASE\` for exported constants, \`camelCase\` for unexported
- Package names: short, lowercase, no underscores

#### File Length

Flag any file exceeding 250 lines as **warning**. Suggest splitting into focused files following Clean Architecture boundaries.

#### Test Coverage

- Every package under \`cmd/\` and \`lambdas/\` must have corresponding \`_test.go\` files
- Integration tests in \`tests/\` must use Terratest patterns
- Coverage must meet or exceed the 70% threshold
- Flag new code paths without test coverage as **warning**

#### Module Dependencies

Check \`go.mod\` for:

- Unpinned or \`latest\` versions
- Dependencies not on the approved list (conservative dependency policy)
- Indirect dependencies with known CVEs (cross-reference with \`govulncheck\`)

### Step 4 — Security Analysis

This is the highest-priority review category, aligned with SOC 2 Type II and ISO 27001 Annex A controls.

#### IAM Least Privilege

- No \`Action: "*"\` or \`Resource: "*"\` in any policy document
- No \`AdministratorAccess\` or \`PowerUserAccess\` managed policy attachments
- Service roles scoped to specific resources using conditions where possible
- Cross-account access must use \`sts:AssumeRole\` with \`ExternalId\`

#### Encryption

- **At rest**: RDS \`storage_encrypted = true\`, S3 \`server_side_encryption_configuration\` present, EBS volumes encrypted, ElastiCache \`at_rest_encryption_enabled = true\`
- **In transit**: ALB listeners on port 443 with valid ACM certificates, RDS \`require_ssl\` parameter, ElastiCache \`transit_encryption_enabled = true\`
- **KMS**: Customer-managed keys preferred over AWS-managed keys for production. Key rotation enabled.

#### Network Security

- No security group rules with \`0.0.0.0/0\` ingress except ALB port 443
- RDS instances must not have \`publicly_accessible = true\`
- ElastiCache clusters must be in private subnets
- VPC flow logs enabled
- No default VPC usage

#### Secret Management

- No secrets, passwords, API keys, or tokens in \`.tf\`, \`.go\`, \`.py\`, or \`.tfvars\` files
- Secrets must be referenced via \`aws_secretsmanager_secret\` or \`aws_ssm_parameter\` with \`SecureString\` type
- Lambda environment variables must not contain plaintext secrets

#### Public Endpoint Exposure

- S3 buckets must have \`block_public_acls = true\`, \`block_public_policy = true\`, \`ignore_public_acls = true\`, \`restrict_public_buckets = true\`
- ECR repositories must not have public access
- ECS services must sit behind an ALB, not directly exposed
- API Gateway endpoints should use private endpoints or WAF protection

#### Compliance Mapping

For critical security findings, reference the applicable control:

| Finding | SOC 2 Control | ISO 27001 Control |
|---------|---------------|-------------------|
| Missing encryption at rest | CC6.1 | A.10.1.1 |
| Overly permissive IAM | CC6.3 | A.9.2.3 |
| Public network exposure | CC6.6 | A.13.1.1 |
| Missing audit logging | CC7.2 | A.12.4.1 |
| Unmanaged secrets | CC6.1 | A.10.1.2 |

### Step 5 — Cost Implications

Review resource changes for cost impact:

#### Instance Sizing

- Flag any production instance type larger than the team's baseline without justification
- Check for missing auto-scaling configurations on ECS services
- Verify RDS instances use appropriate instance classes for the environment (dev should not use \`db.r6g.2xlarge\`)

#### Storage

- S3 lifecycle policies should be present for buckets expected to grow
- RDS storage auto-scaling should have a \`max_allocated_storage\` cap
- EBS volumes should use \`gp3\` over \`gp2\` for cost efficiency

#### Data Transfer

- Flag cross-region data transfer patterns
- VPC endpoints should be used for S3 and DynamoDB access from private subnets to avoid NAT gateway charges
- CloudWatch log retention should be set (not infinite)

#### Environment Parity

- Dev and staging environments should use smaller instance types than production
- Verify \`environments/dev/\` is not accidentally provisioning production-grade resources

### Step 6 — Documentation and Conventions

- Changed modules must have updated \`README.md\` (run \`terraform-docs markdown table . > README.md\`)
- New variables must have \`description\` and \`type\` attributes
- New outputs must have \`description\` attributes
- Commit messages must follow conventional commits format
- PR description must reference a GitHub Issue (e.g., \`Closes #123\` or \`INFRA-123\`)

## Output Format

Present findings as a categorized list with the following structure:

### 🔴 Critical

Issues that must be resolved before merge. Security vulnerabilities, compliance violations, missing encryption, overly permissive IAM, broken module structure.

\`\`\`
- [CRITICAL][security] modules/rds/main.tf:42 — RDS cluster missing \`storage_encrypted = true\`. Violates SOC 2 CC6.1 encryption-at-rest requirement.
- [CRITICAL][iam] modules/ecs/iam.tf:15 — Inline IAM policy on ECS task role. Project convention requires managed policies via \`aws_iam_policy\` + \`aws_iam_role_policy_attachment\`.
\`\`\`

### 🟡 Warning

Issues that should be addressed but are not blocking. Style violations, missing tests, cost concerns, hardcoded values.

\`\`\`
- [WARNING][cost] environments/dev/main.tf:28 — RDS instance class \`db.r6g.xlarge\` is oversized for dev environment. Consider \`db.t4g.medium\`.
- [WARNING][style] cmd/provisioner/handler.go — File is 312 lines, exceeding the 250-line limit. Consider splitting request handling from validation logic.
\`\`\`

### 🔵 Info

Suggestions and improvements. Documentation gaps, optimization opportunities, minor style preferences.

\`\`\`
- [INFO][docs] modules/monitoring/README.md — Module README is outdated. Run \`terraform-docs markdown table . > README.md\` to regenerate.
- [INFO][optimization] modules/vpc/main.tf:67 — Consider adding VPC endpoints for S3 and DynamoDB to reduce NAT gateway costs.
\`\`\`

### Summary

End every review with a summary table:

| Category | Critical | Warning | Info |
|----------|----------|---------|------|
| Security | 2 | 1 | 0 |
| Cost | 0 | 2 | 1 |
| Style | 1 | 3 | 2 |
| Docs | 0 | 0 | 3 |
| **Total** | **3** | **6** | **6** |

**Verdict**: ❌ CHANGES REQUESTED (if any critical) or ✅ APPROVED (if no critical findings)

## Example: Review the New RDS Module

Given a request to review \`modules/rds/\`, the skill performs:

1. **Structure check** — Confirms \`main.tf\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`, \`README.md\` all exist
2. **Provider pin** — Verifies \`aws\` provider pinned to exact patch in \`versions.tf\`
3. **Encryption at rest** — Checks \`storage_encrypted = true\` and \`kms_key_id\` references a customer-managed key
4. **Encryption in transit** — Checks for \`rds.force_ssl\` parameter in parameter group
5. **Backup configuration** — Verifies \`backup_retention_period >= 7\` for production, \`preferred_backup_window\` set
6. **Multi-AZ** — Confirms \`multi_az = true\` for production, acceptable as \`false\` for dev
7. **Public access** — Verifies \`publicly_accessible = false\`
8. **Subnet group** — Confirms RDS is placed in private subnets via \`db_subnet_group_name\`
9. **IAM authentication** — Checks \`iam_database_authentication_enabled = true\`
10. **Deletion protection** — Verifies \`deletion_protection = true\` for production
11. **Tagging** — All four mandatory tags present: \`project\`, \`environment\`, \`team\`, \`cost-center\`
12. **No hardcoded values** — Instance class, storage size, engine version all sourced from variables
13. **Cost review** — Instance class appropriate for target environment, storage auto-scaling has a cap
14. **Outputs** — Endpoint, port, database name, and security group ID are exported
15. **Documentation** — README reflects current variables and outputs

## Delegation

This skill delegates execution to the [Code Reviewer agent](../../agents/code-reviewer.md), which has the full context of project conventions defined in \`.claude/rules/\` and the authority to read all files in the repository. The agent applies the checks described above and formats the output according to the specified structure.

## Related Skills

- \`terraform-plan\` — Generate and analyze \`terraform plan\` output for a target environment
- \`security-audit\` — Deep-dive security review focused exclusively on compliance controls
- \`cost-estimate\` — Detailed cost projection using AWS pricing data`,

  'plugin/codeforge-aws-platform-iac/skills/phase/SKILL.md': `---
name: phase
description: Check current playbook phase, advance to next phase, view deliverables and quality gates
---

# /phase Skill

Manage the development methodology lifecycle for the aws-platform-iac project. This skill reads, displays, and advances through the seven-phase playbook that governs how infrastructure modules, environments, and tooling are built and shipped.

## Overview

The aws-platform-iac project follows a structured seven-phase methodology stored in \`playbook/\`. Each phase has defined deliverables (Terraform modules, documentation, tests, configurations) and quality gates that must pass before advancement. This skill is the primary interface for phase management.

## Phases

| # | Phase | Focus |
|---|-------|-------|
| 1 | **Discovery** | Requirements gathering, AWS account audit, compliance scope (SOC 2, ISO 27001), cost baseline |
| 2 | **Architecture** | Module design, network topology, security boundaries, ADR creation in \`docs/adr/\` |
| 3 | **Foundation** | VPC module, IAM baseline, S3 state backend, provider pinning, CI/CD pipeline scaffolding |
| 4 | **Core Implementation** | ECS, RDS, ElastiCache, ALB, Route53 modules in \`modules/\`, environment configs in \`environments/\` |
| 5 | **Integration & Hardening** | Cross-module wiring, security scanning (tfsec, checkov), policy-as-code, secrets management |
| 6 | **Testing & Quality** | Terratest integration tests in \`tests/\`, coverage to 70%, runbook authoring in \`docs/runbooks/\` |
| 7 | **Launch** | Production deploy, monitoring dashboards, PagerDuty alerts, cost reporting, handoff documentation |

## Steps

### 1. Read Current Phase State

Read \`playbook/current-phase.json\` to determine where the project stands:

\`\`\`json
{
  "current_phase": 3,
  "phase_name": "Foundation",
  "started_at": "2024-11-15T09:00:00Z",
  "deliverables": {
    "modules/vpc/main.tf": "complete",
    "modules/vpc/variables.tf": "complete",
    "modules/vpc/outputs.tf": "complete",
    "modules/vpc/README.md": "complete",
    "modules/vpc/versions.tf": "complete",
    "modules/iam/main.tf": "in-progress",
    "environments/dev/backend.tf": "complete",
    ".github/workflows/terraform-ci.yml": "not-started",
    "docs/adr/002-state-backend.md": "complete"
  },
  "quality_gates": {
    "terraform_fmt_passing": true,
    "terraform_validate_passing": true,
    "tflint_zero_errors": true,
    "tfsec_critical_zero": true,
    "provider_versions_pinned": true,
    "all_resources_tagged": false,
    "peer_review_completed": false,
    "documentation_current": false
  },
  "notes": "VPC module complete with 3-AZ layout. IAM baseline in progress. Waiting on security review for tagging policy enforcement."
}
\`\`\`

If the file does not exist, initialize it at Phase 1 (Discovery) and inform the user.

### 2. Display Current Phase Info

Present a clear summary:

- **Phase number and name** with a brief description from \`playbook/phases/{phase_number}-*.md\`
- **Time in phase** calculated from \`started_at\`
- **Deliverables progress** as a count (e.g., 6/9 complete) and itemized list with status indicators
- **Quality gates** as pass/fail with actionable notes for failing gates
- **Blockers or notes** from the \`notes\` field

Format deliverable statuses as:
- ✅ \`complete\`
- 🔧 \`in-progress\`
- ⬜ \`not-started\`

Format quality gates as:
- ✅ passing
- ❌ failing — with the specific remediation command or action

### 3. Show Deliverables Status

For each deliverable, verify actual file existence and content quality:

- Check that the file exists at the specified path in the repository
- For Terraform files: confirm \`terraform fmt -check\` and \`terraform validate\` pass
- For module directories: confirm all four required files exist (\`README.md\`, \`variables.tf\`, \`outputs.tf\`, \`versions.tf\`)
- For documentation: confirm the file is non-empty and follows the project template
- Flag any discrepancies between \`current-phase.json\` status and actual file state

If a deliverable is marked \`complete\` in JSON but the file is missing or invalid, flag it:

\`\`\`
⚠️  modules/vpc/README.md marked complete but file is empty — reverting status to in-progress
\`\`\`

### 4. Show Quality Gates

Evaluate each quality gate by running or referencing the appropriate check:

| Gate | Validation Method |
|------|-------------------|
| \`terraform_fmt_passing\` | \`terraform fmt -check -recursive\` across \`modules/\` and \`environments/\` |
| \`terraform_validate_passing\` | \`terraform validate\` in each module directory |
| \`tflint_zero_errors\` | \`tflint --recursive\` with \`.tflint.hcl\` config |
| \`tfsec_critical_zero\` | \`tfsec --minimum-severity CRITICAL\` across all Terraform code |
| \`provider_versions_pinned\` | Grep \`versions.tf\` files for exact patch pins (e.g., \`= "5.31.0"\`, not \`~> 5.31\`) |
| \`all_resources_tagged\` | Verify \`project\`, \`environment\`, \`team\`, \`cost-center\` tags on all \`aws_*\` resources |
| \`peer_review_completed\` | Check for approved PR or manual confirmation |
| \`documentation_current\` | Verify \`terraform-docs\` output matches current module state |
| \`no_inline_iam_policies\` | Scan for \`inline_policy\` blocks; require \`aws_iam_policy\` managed resources |
| \`signed_commits\` | Verify recent commits on the working branch are GPG-signed |

Not all gates apply to every phase. Reference \`playbook/phases/{phase_number}-*.md\` for the gate set relevant to the current phase.

## Phase Advancement

### Prerequisites Check

Before advancing, ALL quality gates for the current phase must pass. Run through each gate and produce a go/no-go summary:

\`\`\`
Phase 3: Foundation — Advancement Check
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Deliverables:  8/8 complete ✅
Quality Gates: 7/8 passing

❌ all_resources_tagged — 2 resources in modules/vpc/main.tf missing cost-center tag
   Fix: Add \`cost-center = var.cost_center\` to aws_subnet and aws_internet_gateway tags

Result: BLOCKED — resolve 1 failing gate before advancing
\`\`\`

### Advancing

When all gates pass:

1. Update \`playbook/current-phase.json\`:
   - Set \`current_phase\` to the next phase number
   - Set \`phase_name\` to the next phase name
   - Set \`started_at\` to the current timestamp
   - Populate \`deliverables\` from \`playbook/phases/{next_phase}-*.md\`
   - Reset \`quality_gates\` for the new phase
   - Archive the completed phase data to \`playbook/history/{phase_number}-{phase_name}.json\`

2. Update the active phase rule symlink:
   \`\`\`
   ln -sf ../../playbook/phases/{next_phase}-*.md .claude/rules/active-phase.md
   \`\`\`
   This ensures Claude Code loads phase-specific guidance automatically.

3. Commit the phase transition:
   \`\`\`
   git add playbook/current-phase.json playbook/history/ .claude/rules/active-phase.md
   git commit -S -m "chore: advance to phase {N} - {Phase Name}"
   \`\`\`

4. Notify the team via the phase transition summary.

### Regression

If a critical issue is found after advancement, the phase can be regressed:

1. Restore the previous phase's gate requirements
2. Update \`current-phase.json\` with the regressed phase number
3. Log the regression reason in \`playbook/history/regression-log.json\`
4. Commit with \`chore: regress to phase {N} - {reason}\`

## Example Interactions

### "What phase are we in?"

Reads \`playbook/current-phase.json\` and responds:

\`\`\`
📍 Phase 3: Foundation
   Started: 3 days ago (Nov 15, 2024)

   Deliverables: 6/9 complete
   ✅ modules/vpc/main.tf
   ✅ modules/vpc/variables.tf
   ✅ modules/vpc/outputs.tf
   ✅ modules/vpc/README.md
   ✅ modules/vpc/versions.tf
   🔧 modules/iam/main.tf
   ✅ environments/dev/backend.tf
   ⬜ .github/workflows/terraform-ci.yml
   ✅ docs/adr/002-state-backend.md

   Quality Gates: 5/8 passing
   ✅ terraform_fmt_passing
   ✅ terraform_validate_passing
   ✅ tflint_zero_errors
   ✅ tfsec_critical_zero
   ✅ provider_versions_pinned
   ❌ all_resources_tagged — run: grep -r 'tags' modules/ to audit
   ❌ peer_review_completed — open PR for review
   ❌ documentation_current — run: terraform-docs markdown modules/vpc > modules/vpc/README.md

   Notes: VPC module complete with 3-AZ layout. IAM baseline in progress.
\`\`\`

### "Advance to the next phase"

Runs the prerequisites check. If all gates pass:

\`\`\`
✅ All quality gates for Phase 3: Foundation are passing
   Advancing to Phase 4: Core Implementation

   New deliverables loaded:
   ⬜ modules/ecs/main.tf
   ⬜ modules/ecs/variables.tf
   ⬜ modules/ecs/outputs.tf
   ⬜ modules/ecs/README.md
   ⬜ modules/ecs/versions.tf
   ⬜ modules/rds/main.tf
   ⬜ modules/rds/variables.tf
   ⬜ modules/rds/outputs.tf
   ⬜ modules/rds/README.md
   ⬜ modules/rds/versions.tf
   ⬜ modules/elasticache/main.tf
   ⬜ environments/staging/main.tf
   ⬜ charts/app/Chart.yaml

   Phase history archived to playbook/history/3-foundation.json
   Active rule updated: .claude/rules/active-phase.md → Phase 4
   Committed: chore: advance to phase 4 - Core Implementation
\`\`\`

### "Show gates for phase 5"

Reads \`playbook/phases/5-integration-hardening.md\` and displays the gate requirements without modifying state:

\`\`\`
Phase 5: Integration & Hardening — Quality Gates

   • terraform_fmt_passing
   • terraform_validate_passing
   • tflint_zero_errors
   • tfsec_critical_zero
   • checkov_passing (all frameworks)
   • cross_module_plan_succeeds (full environment plan with no errors)
   • no_inline_iam_policies
   • secrets_in_ssm_or_secrets_manager (no plaintext secrets in .tf files)
   • all_resources_tagged
   • security_review_approved (SOC 2 / ISO 27001 controls verified)
   • signed_commits
\`\`\`

## Phase-Specific Guidance

Each phase loads context-specific rules via \`.claude/rules/active-phase.md\`. This affects how Claude Code behaves:

- **Phase 1-2**: Focus on documentation, ADRs, and design — discourage writing implementation code
- **Phase 3**: Enforce foundational patterns — provider pinning, state backend, tagging policy
- **Phase 4**: Enforce module structure conventions — all four required files, README via terraform-docs
- **Phase 5**: Enforce security scanning — every change must pass tfsec and checkov before commit
- **Phase 6**: Enforce test coverage — Terratest files required for every module, 70% threshold
- **Phase 7**: Enforce production readiness — monitoring, alerting, runbooks, cost tags verified

## Reference Files

- \`playbook/phases/1-discovery.md\` through \`playbook/phases/7-launch.md\` — detailed phase documentation
- \`playbook/current-phase.json\` — current state (source of truth)
- \`playbook/history/\` — archived phase completions and regression log
- \`playbook/codeforge-phase.sh\` — CLI wrapper for phase operations outside Claude Code
- \`.claude/rules/active-phase.md\` — symlink to current phase rules, auto-loaded by Claude Code
- \`docs/adr/001-development-methodology.md\` — ADR explaining the seven-phase approach`,

  'plugin/codeforge-aws-platform-iac/skills/plan/SKILL.md': `---
name: plan
description: |
  Creates structured implementation plans for infrastructure changes and Terraform module development.
  Use when starting new work, breaking down complex infrastructure tasks, or preparing for terraform plan/apply cycles.
  Trigger phrases: "plan the implementation", "create a plan for", "break down this task",
  "plan the RDS module", "plan VPC peering", "what's the plan for", "help me plan",
  "scope this work", "draft an implementation plan", "plan terraform changes for"
---

# Plan Skill

Generate detailed, actionable implementation plans for AWS infrastructure changes using Terraform. This skill produces a \`plan.md\` document that serves as the single source of truth for an infrastructure work item, covering goals, tasks, acceptance criteria, Terraform state considerations, and cross-module dependencies.

## When to Use

- Starting implementation of a new Terraform module in \`modules/\`
- Planning changes to existing environment configurations in \`environments/\`
- Breaking down a GitHub Issue into concrete infrastructure tasks
- Preparing for a \`terraform plan\` / \`terraform apply\` cycle that touches multiple resources
- Scoping cross-cutting concerns like networking changes, IAM policy updates, or monitoring additions
- Evaluating the blast radius of a production infrastructure change

## Instructions

1. **Gather requirements from the user.** Ask clarifying questions about the infrastructure change. Determine which AWS services are involved, which environments are affected (dev, staging, production), and what the desired end state looks like. If the user references a GitHub Issue, read it to extract acceptance criteria and constraints. Do not proceed until you have a clear understanding of the scope.

2. **Check the current development phase.** Read the relevant phase document in \`playbook/\` to understand where this work fits in the overall project methodology. Align the plan's structure and depth with the current phase expectations — early phases may need more exploration, later phases need precise execution steps.

3. **Read relevant architecture documentation.** Review files in \`docs/\` for architecture decision records (ADRs), runbooks, and existing design documents. Check \`modules/\` for any existing modules that overlap with or depend on the planned work. Review \`environments/\` to understand current state and variable patterns. Examine \`CLAUDE.md\` and \`.claude/rules/\` for project conventions that constrain the plan.

4. **Analyze Terraform state and module dependencies.** Before drafting the plan, consider:
   - Which Terraform state files will be affected (per-environment state in S3 backends)
   - Whether existing resources need to be imported, moved, or recreated
   - Cross-module dependencies — for example, a new RDS module depends on VPC outputs (subnet IDs, security group IDs)
   - Provider version constraints in \`versions.tf\` files
   - Whether workspace-based environment separation introduces any complications
   - State locking implications for concurrent work by other team members

5. **Create the plan document.** Write a \`plan.md\` file in the working directory with the following structure:

   \`\`\`markdown
   # Plan: [Descriptive Title]

   **Issue:** [GitHub Issue link if applicable]
   **Author:** [human or ai-assisted]
   **Phase:** [Current playbook phase]
   **Environments:** [dev, staging, production — which are in scope]
   **Estimated Blast Radius:** [low / medium / high]

   ## Goals
   - [Clear, measurable goal 1]
   - [Clear, measurable goal 2]

   ## Context
   [Brief description of current state, why this change is needed, and any relevant ADRs]

   ## Terraform Modules Affected
   | Module | Action | State Impact |
   |--------|--------|-------------|
   | modules/vpc | modify | update in-place |
   | modules/rds | create | new state resources |

   ## Tasks
   ### 1. [Task title]
   - **Description:** [What to do]
   - **Files:** [Which files to create or modify]
   - **Commands:** [Specific terraform/go/python commands]
   - **Dependencies:** [What must be completed first]

   ### 2. [Task title]
   ...

   ## Acceptance Criteria
   - [ ] \`terraform validate\` passes for all affected modules
   - [ ] \`terraform plan\` shows expected changes with no unexpected destroys
   - [ ] \`tflint\` and \`tfsec\` report no errors or critical findings
   - [ ] Unit tests pass (\`go test ./tests/... -v\`)
   - [ ] All new resources tagged with project, environment, team, cost-center
   - [ ] Module README.md updated via terraform-docs
   - [ ] [Custom criteria from requirements]

   ## Security & Compliance
   - [SOC 2 / ISO 27001 considerations]
   - [IAM policy changes — managed policies only, no inline]
   - [Encryption at rest / in transit requirements]
   - [Network security group rules]

   ## Rollback Strategy
   [How to revert if something goes wrong — state rollback, resource recreation, etc.]

   ## Open Questions
   - [Anything unresolved that needs team input]
   \`\`\`

6. **Validate the plan against project conventions.** Before presenting, verify:
   - All Terraform modules in the plan include \`README.md\`, \`variables.tf\`, \`outputs.tf\`, and \`versions.tf\`
   - Provider versions are pinned to exact patch versions
   - No inline IAM policies are proposed — only managed policies
   - All AWS resources include the required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
   - File names use \`snake_case\`
   - No single file exceeds 250 lines — split if necessary
   - Changes to \`modules/security/*\`, \`environments/production/*\`, or \`*.tfvars\` are flagged as sensitive and note the CODEOWNERS review requirement

7. **Present the plan for approval.** Show the complete plan to the user. Highlight any risks, open questions, or areas where you made assumptions. Ask for explicit approval before any implementation begins. If the plan touches production, emphasize the two-approval PR requirement and security scan gate.

## Terraform-Specific Planning Considerations

### Module Design
When planning a new module in \`modules/\`, structure the plan around:
- **Input variables** (\`variables.tf\`): What configuration does the consumer need to provide? Use \`validation\` blocks for constraints.
- **Resources**: What AWS resources are created? Map each to a Terraform resource type.
- **Outputs** (\`outputs.tf\`): What values do downstream modules or environments need? Think about ARNs, IDs, endpoints, security group IDs.
- **Data sources**: What existing infrastructure does this module need to reference?
- **Locals**: What computed values simplify the configuration?

### State Management
Always address in the plan:
- S3 backend configuration with DynamoDB state locking
- State file path convention: \`environments/{env}/terraform.tfstate\`
- Whether \`terraform state mv\` or \`terraform import\` commands are needed
- Impact on other team members' in-flight work (state lock contention)

### Environment Promotion
Plan the rollout order:
1. \`environments/dev/\` — apply and validate first
2. \`environments/staging/\` — apply after dev is stable, run integration tests from \`tests/\`
3. \`environments/production/\` — apply only after staging integration tests pass, requires PR with 2 approvals and security scan

### Change Classification
Classify each planned Terraform change:
- **Create**: New resources, low risk
- **Update in-place**: Modify existing resources without recreation, medium risk
- **Destroy and recreate**: Forces replacement, high risk — flag explicitly
- **Destroy**: Removing resources, high risk — confirm data retention

## Example Triggers and Responses

### "Plan the RDS module implementation"
The skill will ask about PostgreSQL version, instance class, multi-AZ requirements, backup retention, encryption settings, which VPC/subnets to deploy into, read replica needs, and parameter group customizations. The resulting plan will cover \`modules/rds/\`, updates to \`environments/dev/main.tf\`, integration test additions in \`tests/rds_test.go\`, and monitoring dashboard updates in \`modules/monitoring/\`.

### "Create a plan for VPC peering"
The skill will ask which VPCs need peering, whether cross-account or same-account, CIDR block overlap analysis, route table updates, security group rule changes, and DNS resolution settings. The plan will map dependencies on \`modules/vpc/\` outputs and identify required changes to \`modules/security/\` (sensitive path — CODEOWNERS review required).

### "Plan the monitoring dashboard for ECS services"
The skill will ask about which ECS services to monitor, key metrics (CPU, memory, request count, error rate), alarm thresholds, PagerDuty integration requirements, and Grafana dashboard needs. The plan will cover \`modules/monitoring/\`, CloudWatch dashboard JSON, alarm configurations, and SNS topic setup.

## Troubleshooting

### Requirements Are Unclear
If the user provides vague or incomplete requirements:
1. Do not guess. List specific questions that must be answered before planning can proceed.
2. Reference existing patterns in the codebase — show the user how similar modules are configured and ask if the same patterns apply.
3. Suggest reviewing relevant ADRs in \`docs/\` for prior decisions that may constrain the design.
4. If the user cannot answer technical questions, propose reasonable defaults based on the project's existing conventions and flag them as assumptions in the plan's "Open Questions" section.

### Cross-Module Dependencies
When the planned change depends on or affects multiple modules:
1. Map the dependency graph explicitly in the plan. For example: \`modules/ecs\` depends on \`modules/vpc\` (subnets, security groups) and \`modules/iam\` (task execution role).
2. Identify whether dependencies already exist in the current state or need to be created as part of this plan.
3. If circular dependencies exist, flag them and propose a resolution — typically by extracting shared resources into a separate module or using \`terraform_remote_state\` data sources.
4. Order tasks so that upstream modules are modified and applied before downstream consumers.
5. Note any \`output\` values that need to be added to existing modules to support the new work.

### State Conflicts
If the plan involves resources that may conflict with in-flight work:
1. Check with the user whether other team members are actively working on overlapping modules.
2. Recommend running \`terraform plan\` in a fresh workspace to detect drift before starting.
3. If state migration is needed, include explicit \`terraform state\` commands in the task list with dry-run verification steps.

### Production Safety
For any plan that touches \`environments/production/\`:
1. Always include a rollback strategy section.
2. Flag the change as requiring the full CI/CD pipeline: lint → security scan → staging deploy → integration tests → production deploy.
3. Note that the PR requires at least 2 approvals and a passing security scan (tfsec, checkov).
4. Recommend scheduling the apply during a maintenance window if the blast radius is medium or high.
5. Include a \`terraform plan -out=tfplan\` step so the exact plan is reviewed and approved before \`terraform apply tfplan\`.`,

  'plugin/codeforge-aws-platform-iac/skills/tdd/SKILL.md': `---
name: tdd
description: Test-driven development for Terraform modules and Go tooling
arguments:
  - name: target
    description: The module, function, or component to develop using TDD
    required: true
  - name: type
    description: Type of target — "terraform-module", "go-tool", "lambda", "script"
    required: true
  - name: ticket
    description: GitHub Issue reference (e.g., INFRA-456)
    required: false
---

# TDD Skill — Terraform Modules & Go Tooling

Test-driven development workflow for the aws-platform-iac project. This skill enforces a strict red-green-refactor cycle for Terraform modules (using Terratest) and Go code (using table-driven tests), ensuring every infrastructure change is validated before it reaches any environment.

## Core Principles

1. **No module without a test.** Every Terraform module in \`modules/\` must have a corresponding Terratest suite in \`tests/\`.
2. **No Go function without a table-driven test.** Every exported function in \`cmd/\` or \`lambdas/\` must have a co-located \`_test.go\` file.
3. **Coverage gate is 70%.** Code that drops below the threshold does not merge.
4. **Tests document intent.** A well-written test is the best specification for what the infrastructure should do.

## Workflow Overview

\`\`\`
Requirement → Failing Test → Minimal Implementation → Green Test → Refactor → Coverage Check
\`\`\`

---

## Phase 1: Terraform Module TDD

### Step 1 — Read the Requirement

Before writing any HCL, clarify what the module must provision. Pull the acceptance criteria from the GitHub Issue (e.g., \`INFRA-456\`). Identify:

- Required AWS resources and their relationships
- Input variables and their constraints
- Expected outputs
- Required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
- SOC 2 / ISO 27001 compliance controls that apply (encryption at rest, logging, least-privilege IAM)

### Step 2 — Write the Failing Terratest

Create the test file first. All Terraform integration tests live in \`tests/\` and follow the naming convention \`module_<name>_test.go\`.

**Example: TDD the ECS module**

File: \`tests/module_ecs_test.go\`

\`\`\`go
package tests

import (
	"testing"

	"github.com/gruntwork-io/terratest/modules/aws"
	"github.com/gruntwork-io/terratest/modules/terraform"
	"github.com/stretchr/testify/assert"
	"github.com/stretchr/testify/require"
)

func TestECSModule_CreatesService(t *testing.T) {
	t.Parallel()

	awsRegion := "us-east-1"

	terraformOptions := terraform.WithDefaultRetryableErrors(t, &terraform.Options{
		TerraformDir: "../modules/ecs",
		Vars: map[string]interface{}{
			"cluster_name":    "test-cluster",
			"service_name":    "test-service",
			"container_image": "nginx:latest",
			"container_port":  80,
			"desired_count":   1,
			"environment":     "test",
			"project":         "aws-platform-iac",
			"team":            "sre",
			"cost_center":     "engineering",
		},
		EnvVars: map[string]string{
			"AWS_DEFAULT_REGION": awsRegion,
		},
	})

	defer terraform.Destroy(t, terraformOptions)
	terraform.InitAndApply(t, terraformOptions)

	// Verify the ECS cluster exists
	clusterARN := terraform.Output(t, terraformOptions, "cluster_arn")
	assert.Contains(t, clusterARN, "test-cluster")

	// Verify the service is running
	serviceARN := terraform.Output(t, terraformOptions, "service_arn")
	require.NotEmpty(t, serviceARN)

	// Verify required tags are present
	clusterTags := aws.GetEcsClusterTags(t, awsRegion, clusterARN)
	assert.Equal(t, "aws-platform-iac", clusterTags["project"])
	assert.Equal(t, "test", clusterTags["environment"])
	assert.Equal(t, "sre", clusterTags["team"])
	assert.Equal(t, "engineering", clusterTags["cost-center"])
}

func TestECSModule_EnforcesReadOnlyRootFilesystem(t *testing.T) {
	t.Parallel()

	terraformOptions := terraform.WithDefaultRetryableErrors(t, &terraform.Options{
		TerraformDir: "../modules/ecs",
		Vars: map[string]interface{}{
			"cluster_name":    "test-sec-cluster",
			"service_name":    "test-sec-service",
			"container_image": "nginx:latest",
			"container_port":  80,
			"desired_count":   1,
			"environment":     "test",
			"project":         "aws-platform-iac",
			"team":            "sre",
			"cost_center":     "engineering",
		},
	})

	defer terraform.Destroy(t, terraformOptions)
	terraform.InitAndApply(t, terraformOptions)

	taskDefJSON := terraform.Output(t, terraformOptions, "task_definition_json")
	assert.Contains(t, taskDefJSON, \`"readonlyRootFilesystem":true\`)
}
\`\`\`

Run the test — it must fail because the module does not exist yet:

\`\`\`bash
cd tests/
go test -v -run TestECSModule -timeout 30m
\`\`\`

Expected: compilation error or \`terraform init\` failure. This is the **red** phase.

### Step 3 — Implement the Minimal Module

Create the module skeleton with the required files:

\`\`\`
modules/ecs/
├── README.md
├── main.tf
├── variables.tf
├── outputs.tf
└── versions.tf
\`\`\`

Write only enough HCL to make the tests pass. Do not add features that are not tested.

**\`modules/ecs/versions.tf\`** — pin providers to exact patch:

\`\`\`hcl
terraform {
  required_version = ">= 1.6.0"

  required_providers {
    aws = {
      source  = "hashicorp/aws"
      version = "5.31.0"
    }
  }
}
\`\`\`

**\`modules/ecs/variables.tf\`** — declare only what the test uses:

\`\`\`hcl
variable "cluster_name" {
  type        = string
  description = "Name of the ECS cluster"
}

variable "environment" {
  type        = string
  description = "Deployment environment"
}

variable "project" {
  type        = string
  description = "Project name for tagging"
}

variable "team" {
  type        = string
  description = "Team name for tagging"
}

variable "cost_center" {
  type        = string
  description = "Cost center for tagging"
}
\`\`\`

Implement \`main.tf\` with the minimum resources. Ensure every resource includes the mandatory tags and uses managed IAM policies (never inline).

### Step 4 — Run Tests and Go Green

\`\`\`bash
cd tests/
go test -v -run TestECSModule_CreatesService -timeout 30m
\`\`\`

If the test passes, move to the next test case. If it fails, fix the module — not the test.

### Step 5 — Refactor

Once all tests are green:

1. Run \`terraform fmt -recursive modules/ecs/\`
2. Run \`terraform validate\` in the module directory
3. Run \`tflint --init && tflint\` for linting
4. Run \`tfsec modules/ecs/\` for security scanning
5. Run \`checkov -d modules/ecs/\` for compliance checks (SOC 2, ISO 27001 controls)
6. Generate docs: \`terraform-docs markdown table modules/ecs/ > modules/ecs/README.md\`

Do not change behavior during refactoring. Tests must stay green.

### Step 6 — Verify Coverage

Terraform does not have native coverage metrics. Coverage for modules is measured by:

- **Resource coverage**: every resource declared in \`main.tf\` is asserted in at least one test
- **Variable coverage**: every variable is exercised with at least one non-default value
- **Output coverage**: every output is read and validated in tests
- **Negative testing**: at least one test validates that invalid input is rejected via \`validation\` blocks

Document coverage in the module's \`README.md\` under a \`## Test Coverage\` section.

---

## Phase 2: Go Code TDD

### Step 1 — Read the Requirement

Identify the function or CLI command to implement. Pull context from the GitHub Issue.

### Step 2 — Write the Failing Table-Driven Test

Go tests are co-located with source files. For a function in \`cmd/provisioner/create.go\`, the test lives at \`cmd/provisioner/create_test.go\`.

**Example: TDD a cost tag validator**

File: \`cmd/cost-reporter/validator_test.go\`

\`\`\`go
package costreporter

import (
	"testing"
)

func TestValidateRequiredTags(t *testing.T) {
	t.Parallel()

	tests := []struct {
		name     string
		tags     map[string]string
		wantErr  bool
		errField string
	}{
		{
			name: "all required tags present",
			tags: map[string]string{
				"project":     "aws-platform-iac",
				"environment": "production",
				"team":        "sre",
				"cost-center": "engineering",
			},
			wantErr: false,
		},
		{
			name: "missing project tag",
			tags: map[string]string{
				"environment": "production",
				"team":        "sre",
				"cost-center": "engineering",
			},
			wantErr:  true,
			errField: "project",
		},
		{
			name: "missing cost-center tag",
			tags: map[string]string{
				"project":     "aws-platform-iac",
				"environment": "staging",
				"team":        "sre",
			},
			wantErr:  true,
			errField: "cost-center",
		},
		{
			name:     "empty tags",
			tags:     map[string]string{},
			wantErr:  true,
			errField: "project",
		},
		{
			name: "empty value for required tag",
			tags: map[string]string{
				"project":     "",
				"environment": "dev",
				"team":        "sre",
				"cost-center": "engineering",
			},
			wantErr:  true,
			errField: "project",
		},
	}

	for _, tt := range tests {
		t.Run(tt.name, func(t *testing.T) {
			t.Parallel()
			err := ValidateRequiredTags(tt.tags)
			if tt.wantErr {
				if err == nil {
					t.Fatalf("expected error for field %q, got nil", tt.errField)
				}
				tagErr, ok := err.(*MissingTagError)
				if !ok {
					t.Fatalf("expected *MissingTagError, got %T", err)
				}
				if tagErr.Field != tt.errField {
					t.Errorf("expected error field %q, got %q", tt.errField, tagErr.Field)
				}
			} else {
				if err != nil {
					t.Fatalf("unexpected error: %v", err)
				}
			}
		})
	}
}
\`\`\`

Run the test — it must fail:

\`\`\`bash
go test -v -run TestValidateRequiredTags ./cmd/cost-reporter/...
\`\`\`

Expected: compilation error because \`ValidateRequiredTags\` and \`MissingTagError\` do not exist. **Red.**

### Step 3 — Implement the Minimal Function

File: \`cmd/cost-reporter/validator.go\`

\`\`\`go
package costreporter

import "fmt"

var requiredTags = []string{"project", "environment", "team", "cost-center"}

type MissingTagError struct {
	Field string
}

func (e *MissingTagError) Error() string {
	return fmt.Sprintf("missing or empty required tag: %s", e.Field)
}

func ValidateRequiredTags(tags map[string]string) error {
	for _, tag := range requiredTags {
		val, ok := tags[tag]
		if !ok || val == "" {
			return &MissingTagError{Field: tag}
		}
	}
	return nil
}
\`\`\`

### Step 4 — Go Green

\`\`\`bash
go test -v -run TestValidateRequiredTags ./cmd/cost-reporter/...
\`\`\`

All five cases should pass.

### Step 5 — Refactor

1. Run \`gofmt -w cmd/cost-reporter/\`
2. Run \`golangci-lint run ./cmd/cost-reporter/...\`
3. Ensure the file stays under 250 lines
4. Verify naming: \`camelCase\` for variables, \`snake_case\` for file names

### Step 6 — Verify Coverage

\`\`\`bash
go test -coverprofile=coverage.out ./cmd/cost-reporter/...
go tool cover -func=coverage.out
\`\`\`

The output must show >= 70% coverage for the package. If not, add test cases — do not lower the threshold.

For the full project:

\`\`\`bash
go test -coverprofile=coverage.out ./...
go tool cover -func=coverage.out | grep total
\`\`\`

---

## Phase 3: Lambda Function TDD

Lambda functions in \`lambdas/\` follow the same cycle. The language determines the test framework:

### Go Lambdas (\`lambdas/go/\`)

Use the standard Go testing approach with table-driven tests. Mock AWS SDK calls using interfaces.

\`\`\`go
// lambdas/go/tag-enforcer/handler_test.go
func TestHandler_EnforcesTagCompliance(t *testing.T) {
	tests := []struct {
		name       string
		event      events.CloudWatchEvent
		wantAction string
	}{
		// table entries...
	}
	// ...
}
\`\`\`

### Python Lambdas (\`lambdas/python/\`)

Use \`pytest\` with \`moto\` for AWS mocking:

\`\`\`bash
cd lambdas/python/cost-alerter/
python -m pytest tests/ -v --cov=. --cov-fail-under=70
\`\`\`

Write the test in \`lambdas/python/cost-alerter/tests/test_handler.py\` before implementing \`handler.py\`.

---

## TDD Checklist

Use this checklist for every TDD cycle before opening a PR:

- [ ] Failing test written and committed (separate commit: \`test: add tests for <target>\`)
- [ ] Minimal implementation makes tests green (commit: \`feat: implement <target>\`)
- [ ] Refactoring complete with no behavior change (commit: \`refactor: clean up <target>\`)
- [ ] \`terraform fmt\` / \`gofmt\` passes
- [ ] \`tflint\` + \`tfsec\` clean (Terraform) or \`golangci-lint\` clean (Go)
- [ ] Coverage >= 70%
- [ ] Module \`README.md\` updated via \`terraform-docs\` (Terraform modules)
- [ ] All AWS resources include required tags: \`project\`, \`environment\`, \`team\`, \`cost-center\`
- [ ] No inline IAM policies — managed policies only
- [ ] SOC 2 / ISO 27001 controls validated (encryption, logging, access control)
- [ ] Commit messages follow conventional commits format
- [ ] File length under 250 lines

---

## Troubleshooting

### Slow Terraform Integration Tests

Terratest deploys real AWS resources. Expect 5–30 minutes per test depending on resource types.

**Mitigations:**

- Use \`t.Parallel()\` on every test function to run suites concurrently
- Use a dedicated AWS account for testing (never run Terratest against production)
- Set \`TF_VAR_environment=test\` to use smaller instance sizes
- Use \`terraform.WithDefaultRetryableErrors\` to handle eventual consistency
- For rapid iteration, use \`terraform plan\` assertions`,

  'plugin/codeforge-aws-platform-iac/skills/verify/SKILL.md': `---
name: verify
description: Run comprehensive verification — lint, security scan, tests, terraform validate, and tagging compliance checks across Terraform modules and Go tooling
arguments:
  - name: scope
    description: What to verify — a module name, directory path, or "all" for full verification
    required: false
    default: all
  - name: mode
    description: Verification mode — "full", "security-only", "lint-only", "test-only"
    required: false
    default: full
  - name: fix
    description: Attempt to auto-fix issues where possible (formatting, simple lint fixes)
    required: false
    default: false
tags:
  - verification
  - ci
  - quality-gate
  - terraform
  - security
  - compliance
---

# /verify — Comprehensive Verification Skill

Run all quality gates locally before pushing code. This skill orchestrates Terraform validation, linting, security scanning, Go/Python testing, and AWS resource tagging compliance in a single pass, producing a clear pass/fail report.

## Purpose

Every change to this infrastructure codebase must pass verification before it reaches a pull request. The \`/verify\` skill replicates the full CI pipeline defined in \`.github/workflows/\` locally, catching issues early and reducing review cycles. It enforces the standards documented in \`CLAUDE.md\` and \`.claude/rules/\`.

## When to Use

- Before opening or updating a pull request
- After modifying any Terraform module, Go tool, Python script, or Lambda function
- When reviewing someone else's branch locally
- As a final gate after resolving merge conflicts
- When onboarding to confirm your local toolchain is correctly configured

## Verification Pipeline

The skill executes checks in dependency order. A failure in an early phase still allows later phases to run so you get a complete picture, but the overall result is **FAIL** if any phase fails.

### Phase 1 — Formatting

Ensures all code matches the project's canonical formatting. No functional changes, purely cosmetic consistency.

**Terraform formatting:**

\`\`\`
terraform fmt -check -recursive modules/
terraform fmt -check -recursive environments/
\`\`\`

If \`--fix\` is set, run \`terraform fmt -recursive\` first to auto-correct, then re-check.

**Go formatting:**

\`\`\`
gofmt -l cmd/ scripts/ lambdas/ tests/
\`\`\`

Any files listed by \`gofmt -l\` are incorrectly formatted. With \`--fix\`, run \`gofmt -w\` on those files.

**Python formatting:**

\`\`\`
ruff format --check scripts/ lambdas/
\`\`\`

With \`--fix\`, run \`ruff format scripts/ lambdas/\` first.

### Phase 2 — Terraform Validation

Runs Terraform's built-in structural validation on every module and environment configuration.

**For each module in \`modules/\`:**

\`\`\`
cd modules/<module>
terraform init -backend=false
terraform validate
\`\`\`

**For each environment in \`environments/\`:**

\`\`\`
cd environments/<env>
terraform init -backend=false
terraform validate
\`\`\`

The \`-backend=false\` flag skips remote state configuration so validation works without AWS credentials for structural checks.

**Module structure check:**

Every directory under \`modules/\` must contain these files per project convention:

- \`README.md\`
- \`main.tf\`
- \`variables.tf\`
- \`outputs.tf\`
- \`versions.tf\`

Missing files are reported as failures.

### Phase 3 — Linting

Static analysis beyond formatting — catches misconfigurations, deprecated patterns, and style violations.

**Terraform linting with tflint:**

\`\`\`
tflint --init
tflint --recursive --config .tflint.hcl
\`\`\`

The \`.tflint.hcl\` config enables the AWS ruleset and project-specific rules.

**Go linting with golangci-lint:**

\`\`\`
golangci-lint run ./cmd/... ./scripts/... ./lambdas/... ./tests/...
\`\`\`

Uses the \`.golangci.yml\` configuration at the repo root.

**Python linting with ruff:**

\`\`\`
ruff check scripts/ lambdas/
\`\`\`

### Phase 4 — Security Scanning

Critical for SOC 2 and ISO 27001 compliance. Identifies security misconfigurations, exposed secrets, overly permissive IAM policies, and unencrypted resources.

**tfsec scan:**

\`\`\`
tfsec modules/ --format json --out /tmp/tfsec-modules.json
tfsec environments/ --format json --out /tmp/tfsec-environments.json
\`\`\`

Failures at HIGH or CRITICAL severity block the verification. MEDIUM findings are reported as warnings.

**checkov scan:**

\`\`\`
checkov -d modules/ --framework terraform --compact --quiet
checkov -d environments/ --framework terraform --compact --quiet
\`\`\`

**Inline IAM policy check:**

Scan all \`.tf\` files for \`aws_iam_role_policy\` resources with inline \`policy\` blocks. The project convention requires managed policies exclusively — any inline policy is a failure:

\`\`\`
grep -rn 'resource "aws_iam_role_policy"' modules/ environments/
\`\`\`

If matches are found, report each file and line number as a compliance violation.

**Secret detection:**

\`\`\`
grep -rn --include='*.tf' --include='*.go' --include='*.py' \\
  -E '(password|secret|api_key|access_key)\\s*=\\s*"[^"]+"' \\
  modules/ environments/ cmd/ scripts/ lambdas/
\`\`\`

Hardcoded secrets are always a critical failure.

### Phase 5 — Provider Version Pinning

All provider versions must be pinned to exact patch versions per project convention. Scan \`versions.tf\` files for violations:

**Valid:**
\`\`\`hcl
version = "= 5.31.0"
\`\`\`

**Invalid:**
\`\`\`hcl
version = "~> 5.31"
version = ">= 5.31.0"
version = "5.31.0"
\`\`\`

Report any \`versions.tf\` file that uses pessimistic, range, or unpinned version constraints.

### Phase 6 — Resource Tagging Compliance

Every AWS resource must include the required tags: \`project\`, \`environment\`, \`team\`, and \`cost-center\`. This phase scans all Terraform resource blocks for compliance.

**Check \`default_tags\` in provider configuration:**

Each environment's \`provider "aws"\` block in \`environments/<env>/main.tf\` should include:

\`\`\`hcl
default_tags {
  tags = {
    project      = "aws-platform-iac"
    environment  = "<env>"
    team         = "<team>"
    cost-center  = "<cost-center>"
  }
}
\`\`\`

**Check individual resources in modules:**

Resources that support tags should either rely on provider \`default_tags\` propagation or explicitly include the four required tag keys. Resources that accept a \`tags\` variable should have that variable defined in \`variables.tf\` with a sensible type constraint.

Report any resource that explicitly sets tags but omits one of the four required keys.

### Phase 7 — Unit Tests

**Go tests:**

\`\`\`
cd tests/
go test ./... -v -count=1 -timeout 10m
\`\`\`

\`\`\`
cd cmd/
go test ./... -v -count=1
\`\`\`

\`\`\`
cd lambdas/
go test ./... -v -count=1
\`\`\`

**Go test coverage:**

\`\`\`
go test ./... -coverprofile=coverage.out
go tool cover -func=coverage.out
\`\`\`

Coverage must meet or exceed the 70% threshold. Report per-package coverage and highlight any package below threshold.

**Python tests:**

\`\`\`
cd scripts/
python -m pytest --tb=short -q
\`\`\`

\`\`\`
cd lambdas/
python -m pytest --tb=short -q
\`\`\`

### Phase 8 — terraform-docs Freshness

Verify that \`README.md\` files in modules are up to date with their actual inputs/outputs:

\`\`\`
for module in modules/*/; do
  terraform-docs markdown table --output-check "$module"
done
\`\`\`

If \`--output-check\` fails, the README is stale and needs regeneration. With \`--fix\`, run \`terraform-docs markdown table --output-file README.md\` on each module.

### Phase 9 — File Length Check

Per project convention, no file should exceed 250 lines. Scan all source files:

\`\`\`
find modules/ environments/ cmd/ scripts/ lambdas/ \\
  -type f \\( -name '*.tf' -o -name '*.go' -o -name '*.py' \\) \\
  -exec awk 'END { if (NR > 250) print FILENAME ": " NR " lines" }' {} \\;
\`\`\`

Report each file exceeding the limit.

## Scope Options

### \`--module=<name>\` — Single Module

Restricts all checks to \`modules/<name>/\` and its corresponding tests in \`tests/\`:

\`\`\`
/verify --module=vpc
\`\`\`

Runs phases 1–9 scoped to \`modules/vpc/\` and \`tests/*vpc*\`.

### \`--full\` — Everything (Default)

Runs all phases across the entire repository. Equivalent to:

\`\`\`
/verify --scope=all --mode=full
\`\`\`

### \`--security-only\`

Runs only Phase 4 (security scanning) and Phase 5 (provider pinning) and Phase 6 (tagging compliance):

\`\`\`
/verify --mode=security-only
\`\`\`

Useful for quick compliance checks before touching \`environments/production/\`.

### \`--lint-only\`

Runs Phase 1 (formatting) and Phase 3 (linting) only:

\`\`\`
/verify --mode=lint-only
\`\`\`

### \`--test-only\`

Runs Phase 7 (unit tests) only:

\`\`\`
/verify --mode=test-only
\`\`\`

## Report Format

The skill produces a structured summary after all phases complete.

### Pass Example

\`\`\`
╔══════════════════════════════════════════════════╗
║           VERIFICATION REPORT                    ║
╠══════════════════════════════════════════════════╣
║ Phase 1  Formatting          ✅ PASS             ║
║ Phase 2  Terraform Validate  ✅ PASS             ║
║ Phase 3  Linting             ✅ PASS             ║
║ Phase 4  Security Scan       ✅ PASS             ║
║ Phase 5  Version Pinning     ✅ PASS             ║
║ Phase 6  Tagging Compliance  ✅ PASS             ║
║ Phase 7  Unit Tests          ✅ PASS (84% cov)   ║
║ Phase 8  Docs Freshness      ✅ PASS             ║
║ Phase 9  File Length          ✅ PASS             ║
╠══════════════════════════════════════════════════╣
║ RESULT: ✅ ALL CHECKS PASSED — Ready for PR      ║
╚══════════════════════════════════════════════════╝
\`\`\`

### Fail Example

\`\`\`
╔══════════════════════════════════════════════════╗
║           VERIFICATION REPORT                    ║
╠══════════════════════════════════════════════════╣
║ Phase 1  Formatting          ❌ FAIL             ║
║ Phase 2  Terraform Validate  ✅ PASS             ║
║ Phase 3  Linting             ⚠️  WARN (2 issues) ║
║ Phase 4  Security Scan       ❌ FAIL             ║
║ Phase 5  Version Pinning     ✅ PASS             ║
║ Phase 6  Tagging Compliance  ❌ FAIL             ║
║ Phase 7  Unit Tests          ✅ PASS (72% cov)   ║
║ Phase 8  Docs Freshness      ❌ FAIL             ║
║ Phase 9  File Length          ✅ PASS             ║
╠══════════════════════════════════════════════════╣
║ RESULT: ❌ 4 FAILURES — See details below        ║
╚══════════════════════════════════════════════════╝

─── Phase 1 Failures ──────────────────────────────
  modules/rds/main.tf — needs terraform fmt
  modules/rds/variables.tf — needs terraform fmt

─── Phase 4 Failures ──────────────────────────────
  [HIGH] modules/rds/main.tf:42
    aws_db_instance.main: storage not encrypted
    → Set storage_encrypted = true
    Ref: SOC 2 CC6.1, ISO 27001 A.10.1.1

  [HIGH] modules/ecs/iam.tf:18
    aws_iam_role_policy.task_inline: inline IAM policy
    → Convert to aws_iam_policy + aws_iam_role_policy_attachment
    Ref: Project convention — no inline IAM policies

─── Phase 6 Failures ──────────────────────────────
  modules/monitoring/main.tf:15
    aws_cloudwatch_dashboard.main: missing tag "cost-center"

─── Phase 8 Failures ──────────────────────────────
  modules/rds/README.md is stale
    → Run: terraform-docs markdown table --output-file README.md modules/rds/

─── Suggested Fix Command ─────────────────────────
  /verify --fix --module=rds
\`\`\`

### Detail Levels

- **PASS**: Phase name and green checkmark. No further detail needed.
- **WARN**: Phase name with warning indicator and count. Details listed in the summary section.
- **FAIL**: Phase name with red indicator. Full details including file, line number, description, and remediation guidance.

## Examples

### Verify a single module before committing

\`\`\`
/verify --module=vpc
\`\`\`

Runs all 9 phases scoped to \`modules/vpc/\`. Fast feedback loop during module development.

### Full verification before opening a PR

\`\`\`
/verify
\`\`\`

Runs everything. This mirrors what GitHub Actions will run, so if this passes locally, CI should pass too.

### Quick security check on production config

\`\`\`
/verify --scope=environments/production --mode=security-only
\`\`\`

Only runs tfsec, checkov, version pinning, and tagging compliance on the production environment. Use this before any change to \`environments/production/\` — a sensitive path that requires extra scrutiny per \`.claude/rules/\`.

### Auto-fix formatting and docs, then verify

\`\`\`
/verify --fix
\`\`\`

Runs \`terraform fmt\`, \`gofmt -w\`, \`ruff format\`, and \`terraform-docs\` to fix what it can, then runs the full verification to report remaining issues.

### Run only tests with coverage

\`\`\`
/verify --mode=test-only
\`\`\`

Executes Go and Python test suites, reports coverage per package, and flags any package below the 70% threshold.

## Exit Criteria

The verification is **PASS** (ready for PR) when all of the following are true:

1. All Terraform files pass \`terraform fmt -check\`
2. All Go files pass \`gofmt\` check
3. All Python files pass \`ruff format --check\`
4. \`terraform validate\` succeeds for every module and environment
5. \`tflint\` reports zero errors
6. \`golangci-lint\` reports zero errors
7. \`ruff check\` reports zero errors
8. \`tfsec\` reports zero HIGH or CRITICAL findings
9. \`checkov\` reports zero failures
10. No inline IAM policies exist anywhere in the codebase
11. No hardcoded secrets detected
12. All provider versions are pinned to exact patch
13. All AWS resources include required tags (project, environment, team, cost-center)
14. Go test coverage meets or exceeds 70%
15. All Go and Python tests pass
16. All module \`README.md\` files are current with terraform-docs output
17. No source file exceeds 250 lines

If any criterion fails, the overall result is **FAIL** and the report includes actionable remediation for every failure.

## Integration with CI

This skill mirrors the GitHub Actions pipeline stages: Lint → Security Scan → Unit Tests → Build. Running \`/verify\` locally before pushing ensures your PR will not be blocked by CI failures. The CI pipeline in \`.github/workflows/\` runs identical commands, so there should be no surprises.

## Related Files

- \`CLAUDE.md\` — Project-level standards and conventions
- \`.claude/rules/terraform.md\` — Terraform-specific rules
- \`.claude/rules/security.md\` — Security and compliance rules
- \`.claude/rules/go.md\` — Go coding standards
- \`.github/workflows/ci.yml\` — CI pipeline that mirrors this verification
- \`.tflint.hcl\` — tflint configuration
- \`.golangci.yml\` —`,

  'plugin/marketplace.json.example': `{
  "name": "codeforge-aws-platform-iac",
  "displayName": "CodeForge Terraform AWS Platform",
  "description": "Production-grade AWS infrastructure development with Terraform modules for VPC, ECS, RDS, and CloudWatch. Includes automated planning, Terratest TDD, security compliance review (SOC 2, ISO 27001), cost analysis, and CI/CD integration for GitHub Actions.",
  "version": "1.0.0",
  "author": "platform-team",
  "license": "MIT",
  "repository": "https://github.com/platform-team/codeforge-aws-platform-iac",
  "homepage": "https://github.com/platform-team/codeforge-aws-platform-iac#readme",
  "bugs": "https://github.com/platform-team/codeforge-aws-platform-iac/issues",
  "minClaudeCodeVersion": "1.0.0",
  "category": "DevOps",
  "subcategories": [
    "Infrastructure as Code",
    "Cloud Platform",
    "Security Compliance"
  ],
  "tags": [
    "terraform",
    "aws",
    "infrastructure",
    "devops",
    "iac",
    "ecs",
    "rds",
    "vpc",
    "cloudwatch",
    "eks",
    "helm",
    "terratest",
    "tfsec",
    "soc2",
    "iso27001",
    "go",
    "python",
    "github-actions"
  ],
  "skills": [
    {
      "slug": "plan",
      "displayName": "Infrastructure Plan",
      "description": "Generate phased implementation plans for Terraform modules with dependency ordering, blast radius analysis, and rollback strategies"
    },
    {
      "slug": "tdd",
      "displayName": "Terratest TDD",
      "description": "Write Terratest integration tests in Go before implementing Terraform modules, following red-green-refactor workflow"
    },
    {
      "slug": "code-review",
      "displayName": "IaC Security Review",
      "description": "Review Terraform code for security misconfigurations, SOC 2 / ISO 27001 compliance, cost optimization, and module best practices"
    },
    {
      "slug": "build-fix",
      "displayName": "Build & Apply Fix",
      "description": "Diagnose and resolve terraform plan/apply failures, provider errors, state drift, and CI pipeline issues"
    },
    {
      "slug": "verify",
      "displayName": "Verify Infrastructure",
      "description": "Run terraform validate, tflint, tfsec, checkov, and terraform-docs to verify module correctness and documentation"
    },
    {
      "slug": "phase",
      "displayName": "Playbook Phase",
      "description": "Execute structured development phases from the playbook: discover, plan, implement, verify, release"
    }
  ],
  "agents": [
    {
      "slug": "planner",
      "displayName": "Infrastructure Planner",
      "description": "Decomposes infrastructure requirements into ordered Terraform tasks with dependency graphs and environment promotion plans"
    },
    {
      "slug": "code-reviewer",
      "displayName": "IaC Code Reviewer",
      "description": "Reviews Terraform modules, Go tooling, and Python scripts for security, compliance, tagging policy, and coding standards"
    },
    {
      "slug": "architect",
      "displayName": "Platform Architect",
      "description": "Designs AWS architecture decisions, module interfaces, networking topology, and writes ADRs in docs/adr/"
    },
    {
      "slug": "tdd-guide",
      "displayName": "Terratest TDD Guide",
      "description": "Guides test-driven development of Terraform modules using Terratest in Go with 70% coverage targets"
    },
    {
      "slug": "build-error-resolver",
      "displayName": "Build Error Resolver",
      "description": "Resolves terraform plan/apply errors, GitHub Actions failures, Go build issues, and state lock conflicts"
    }
  ],
  "commands": [
    {
      "slug": "tf-plan",
      "displayName": "Terraform Plan",
      "description": "Run terraform fmt, validate, tflint, and plan for a target environment"
    },
    {
      "slug": "tf-test",
      "displayName": "Run Terratest",
      "description": "Execute Terratest integration tests for a specific module with go test"
    },
    {
      "slug": "tf-security",
      "displayName": "Security Scan",
      "description": "Run tfsec and checkov against modules with SOC 2 and ISO 27001 rule sets"
    },
    {
      "slug": "tf-docs",
      "displayName": "Generate Docs",
      "description": "Run terraform-docs to regenerate README.md for all modules"
    },
    {
      "slug": "cost-estimate",
      "displayName": "Cost Estimate",
      "description": "Generate infrastructure cost estimates using infracost for a target environment"
    }
  ],
  "configuration": {
    "aws_region": {
      "type": "string",
      "default": "us-east-1",
      "description": "Default AWS region for infrastructure operations"
    },
    "default_environment": {
      "type": "string",
      "default": "dev",
      "enum": ["dev", "staging", "production"],
      "description": "Default target environment for terraform commands"
    },
    "required_tags": {
      "type": "array",
      "default": ["project", "environment", "team", "cost-center"],
      "description": "Required AWS resource tags enforced during review"
    },
    "compliance_frameworks": {
      "type": "array",
      "default": ["soc2", "iso27001"],
      "description": "Compliance frameworks to validate against during security scans"
    },
    "coverage_threshold": {
      "type": "number",
      "default": 70,
      "description": "Minimum test coverage percentage for Go code and Terraform modules"
    }
  },
  "integrations": {
    "ticketSystem": "github-issues",
    "ci": "github-actions",
    "monitoring": ["cloudwatch", "prometheus", "grafana", "pagerduty"],
    "documentation": ["markdown", "confluence"],
    "communication": "slack"
  },
  "compatibility": {
    "terraform": ">=1.5.0",
    "go": ">=1.21",
    "python": ">=3.11",
    "aws-provider": ">=5.0.0"
  },
  "directories": {
    "modules": "modules/",
    "environments": "environments/",
    "tests": "tests/",
    "scripts": "scripts/",
    "lambdas": "lambdas/",
    "charts": "charts/",
    "docs": "docs/",
    "playbook": "playbook/",
    "plugin": "plugin/codeforge-aws-platform-iac/"
  },
  "screenshots": [
    {
      "url": "https://github.com/platform-team/codeforge-aws-platform-iac/raw/main/docs/images/plan-output.png",
      "caption": "Infrastructure planning with dependency graph generation"
    },
    {
      "url": "https://github.com/platform-team/codeforge-aws-platform-iac/raw/main/docs/images/security-review.png",
      "caption": "Automated SOC 2 and ISO 27001 compliance review"
    }
  ],
  "pricing": "free",
  "support": {
    "email": "platform-team@company.com",
    "slack": "#platform-engineering",
    "documentation": "https://github.com/platform-team/codeforge-aws-platform-iac/tree/main/docs"
  }
}`,

};

export { terraformDemoFileTree, terraformDemoFileContents };
